// g20 언어 - 영어,터키어,아랍어,러시아어,스페인어,프랑스,한국어,일본어,이탈리아어,힌디어,인도네시아어,독일어,중국어,포르투갈어
// 제공하는 다국어에 대한 폰트 고려되어있나 점검하자.

// 초기에 [캐나다어]는 영국영어 그대로 사용을 시작했다.

/**
 * 모달에서 cancel, close 두 텍스트중 선택시 고려해야할 사항.
 * cancel : 두버튼 중 하나가 네거티브인 경우, 혹은 행위에 대한 번복, 그 외에는 닫기.
 * close : 단독으로 존재하는 네거티브의 경우, 혹은 끄는 기능인 경우, 그 외에는 취소.
 */

/** DateText, CountUpDateText, translationIndex 세 파일이 번역 텍스트를 관리한다. */

module.exports.translationIndex = {
  categoryList: {
    data: {
      all: {
        context: "의류의 최상위 범주",
        l_kr: {
          nameForCatModal: "전체",
          groupName: undefined,
          itemLabelName: "전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "All",
          groupName: undefined,
          itemLabelName: "All",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "All",
          groupName: undefined,
          itemLabelName: "All",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "All",
          groupName: undefined,
          itemLabelName: "All",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Всё",
          groupName: undefined,
          itemLabelName: "Всё",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "すべて",
          groupName: undefined,
          itemLabelName: "すべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Tutte",
          groupName: undefined,
          itemLabelName: "Tutte",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Todo",
          groupName: undefined,
          itemLabelName: "Todo",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Alle",
          groupName: undefined,
          itemLabelName: "Alle",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "全部",
          groupName: undefined,
          itemLabelName: "全部",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Toutes",
          groupName: undefined,
          itemLabelName: "Toutes",
          itemSingleName: undefined
        }
      },
      outerweargrp: {
        context: "외출용 겉옷의 범주",
        l_kr: {
          nameForCatModal: "아우터",
          groupName: "아우터 전체",
          itemLabelName: "아우터 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Outerwear",
          groupName: "All Outerwear",
          itemLabelName: "All Outerwear",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Outerwear",
          groupName: "All Outerwear",
          itemLabelName: "All Outerwear",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Outerwear",
          groupName: "All Outerwear",
          itemLabelName: "All Outerwear",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Верхняя одежда",
          groupName: "Вся верхняя одежда",
          itemLabelName: "Вся верхняя одежда",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "アウター",
          groupName: "アウターすべて",
          itemLabelName: "アウターすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Capispalla",
          groupName: "Tutti i Capispalla",
          itemLabelName: "Tutti i Capispalla",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Prendas exteriores",
          groupName: "Todas las prendas exteriores",
          itemLabelName: "Todas las prendas exteriores",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Oberbekleidung",
          groupName: "Alle Oberbekleidung",
          itemLabelName: "Alle Oberbekleidung",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "外套",
          groupName: "全部外套",
          itemLabelName: "全部外套",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Vêtements d'extérieur",
          groupName: "Tous les vêtements d'extérieur",
          itemLabelName: "Tous les vêtements d'extérieur",
          itemSingleName: undefined
        }
      },
      jacketsgrp: {
        context: "허리 혹은 엉덩이까지 오는 길이의 겉옷의 범주",
        l_kr: {
          nameForCatModal: "재킷",
          groupName: "재킷 전체",
          itemLabelName: "재킷 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Jackets",
          groupName: "All Jackets",
          itemLabelName: "All Jackets",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Jackets",
          groupName: "All Jackets",
          itemLabelName: "All Jackets",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Jackets",
          groupName: "All Jackets",
          itemLabelName: "All Jackets",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Куртки",
          groupName: "Все куртки",
          itemLabelName: "Все куртки",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "ジャケット",
          groupName: "ジャケットすべて",
          itemLabelName: "ジャケットすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Giacche",
          groupName: "Tutte le Giacche",
          itemLabelName: "Tutte le Giacche",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Chaquetas",
          groupName: "Todas las chaquetas",
          itemLabelName: "Todas las chaquetas",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Jacken",
          groupName: "Alle Jacken",
          itemLabelName: "Alle Jacken",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "夹克",
          groupName: "全部夹克",
          itemLabelName: "全部夹克",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Vestes",
          groupName: "Toutes les vestes",
          itemLabelName: "Toutes les vestes",
          itemSingleName: undefined
        }
      },
      downjacketsgrp: {
        context: "충전재를 사용한 긴팔 혹은 민소매 재킷의 범주",
        l_kr: {
          nameForCatModal: "패딩 재킷 & 베스트",
          groupName: "패딩 재킷 & 베스트 전체",
          itemLabelName: "패딩 재킷 & 베스트 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Padded Jackets & Vests",
          groupName: "All Padded Jackets & Vests",
          itemLabelName: "All Padded Jackets & Vests",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Padded Jackets & Gilets",
          groupName: "All Padded Jackets & Gilets",
          itemLabelName: "All Padded Jackets & Gilets",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Padded Jackets & Vests",
          groupName: "All Padded Jackets & Vests",
          itemLabelName: "All Padded Jackets & Vests",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Пуховые куртки и жилеты",
          groupName: "Все пуховые куртки и жилеты",
          itemLabelName: "Все пуховые куртки и жилеты",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "パデッドジャケット＆ベスト",
          groupName: "パデッドジャケット＆ベストすべて",
          itemLabelName: "パデッドジャケット＆ベストすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Giacche e Gilet Imbottiti",
          groupName: "Tutte le Giacche e Gilet Imbottiti",
          itemLabelName: "Tutte le Giacche e Gilet Imbottiti",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Chaquetas y chalecos acolchados",
          groupName: "Todas las chaquetas y chalecos acolchados",
          itemLabelName: "Todas las chaquetas y chalecos acolchados",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Steppjacken & -Westen",
          groupName: "Alle Steppjacken & -Westen",
          itemLabelName: "Alle Steppjacken & -Westen",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "填充夹克&背心",
          groupName: "全部填充夹克&背心",
          itemLabelName: "全部填充夹克&背心",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Vestes et gilets rembourrés",
          groupName: "Toutes les vestes et gilets rembourrés",
          itemLabelName: "Toutes les vestes et gilets rembourrés",
          itemSingleName: undefined
        }
      },
      downjackets: {
        context: "충전재를 사용한 긴소매 재킷의 범주",
        l_kr: {
          nameForCatModal: "패딩 재킷",
          groupName: undefined,
          itemLabelName: "패딩 재킷",
          itemSingleName: "패딩 재킷"
        },
        l_us: {
          nameForCatModal: "Padded Jackets",
          groupName: undefined,
          itemLabelName: "Padded Jackets",
          itemSingleName: "Padded Jacket"
        },
        l_gb: {
          nameForCatModal: "Padded Jackets",
          groupName: undefined,
          itemLabelName: "Padded Jackets",
          itemSingleName: "Padded Jacket"
        },
        l_ca: {
          nameForCatModal: "Padded Jackets",
          groupName: undefined,
          itemLabelName: "Padded Jackets",
          itemSingleName: "Padded Jacket"
        },
        l_ru: {
          nameForCatModal: "Пуховые куртки",
          groupName: undefined,
          itemLabelName: "Пуховые куртки",
          itemSingleName: "Стёганая куртка"
        },
        l_jp: {
          nameForCatModal: "パデッドジャケット",
          groupName: undefined,
          itemLabelName: "パデッドジャケット",
          itemSingleName: "中綿ジャケット"
        },
        l_it: {
          nameForCatModal: "Giacche Imbottite",
          groupName: undefined,
          itemLabelName: "Giacche Imbottite",
          itemSingleName: "Giacca imbottita"
        },
        l_es: {
          nameForCatModal: "Chaquetas acolchadas",
          groupName: undefined,
          itemLabelName: "Chaquetas acolchadas",
          itemSingleName: "Chaqueta acolchada"
        },
        l_de: {
          nameForCatModal: "Steppjacken",
          groupName: undefined,
          itemLabelName: "Steppjacken",
          itemSingleName: "Steppjacke"
        },
        l_cn: {
          nameForCatModal: "填充夹克",
          groupName: undefined,
          itemLabelName: "填充夹克",
          itemSingleName: "羽绒服"
        },
        l_fr: {
          nameForCatModal: "Vestes rembourrées",
          groupName: undefined,
          itemLabelName: "Vestes rembourrées",
          itemSingleName: "Veste matelassée"
        }
      },
      downvests: {
        context: "충전재를 사용한 민소매 재킷의 범주",
        l_kr: {
          nameForCatModal: "패딩 베스트",
          groupName: undefined,
          itemLabelName: "패딩 베스트",
          itemSingleName: "패딩 베스트"
        },
        l_us: {
          nameForCatModal: "Padded Vests",
          groupName: undefined,
          itemLabelName: "Padded Vests",
          itemSingleName: "Padded Vest"
        },
        l_gb: {
          nameForCatModal: "Padded Gilets",
          groupName: undefined,
          itemLabelName: "Padded Gilets",
          itemSingleName: "Padded Vest"
        },
        l_ca: {
          nameForCatModal: "Padded Vests",
          groupName: undefined,
          itemLabelName: "Padded Vests",
          itemSingleName: "Padded Vest"
        },
        l_ru: {
          nameForCatModal: "Пуховые жилеты",
          groupName: undefined,
          itemLabelName: "Пуховые жилеты",
          itemSingleName: "Стёганый жилет"
        },
        l_jp: {
          nameForCatModal: "パデッドベスト",
          groupName: undefined,
          itemLabelName: "パデッドベスト",
          itemSingleName: "中綿ベスト"
        },
        l_it: {
          nameForCatModal: "Gilet Imbottiti",
          groupName: undefined,
          itemLabelName: "Gilet Imbottiti",
          itemSingleName: "Gilet imbottito"
        },
        l_es: {
          nameForCatModal: "Chalecos acolchados",
          groupName: undefined,
          itemLabelName: "Chalecos acolchados",
          itemSingleName: "Chaleco acolchado"
        },
        l_de: {
          nameForCatModal: "Steppwesten",
          groupName: undefined,
          itemLabelName: "Steppwesten",
          itemSingleName: "Steppweste"
        },
        l_cn: {
          nameForCatModal: "填充背心",
          groupName: undefined,
          itemLabelName: "填充背心",
          itemSingleName: "羽绒马甲"
        },
        l_fr: {
          nameForCatModal: "Gilets rembourrés",
          groupName: undefined,
          itemLabelName: "Gilets rembourrés",
          itemSingleName: "Gilet matelassé"
        }
      },
      blazers: {
        context: "비즈니스용 수트의 상의의 범주",
        l_kr: {
          nameForCatModal: "블레이저 (수트 재킷)",
          groupName: undefined,
          itemLabelName: "블레이저 (수트 재킷)",
          itemSingleName: "블레이저 (수트 재킷)"
        },
        l_us: {
          nameForCatModal: "Blazers (Suit Jackets)",
          groupName: undefined,
          itemLabelName: "Blazers (Suit Jackets)",
          itemSingleName: "Blazer (Suit Jacket)"
        },
        l_gb: {
          nameForCatModal: "Blazers (Suit Jackets)",
          groupName: undefined,
          itemLabelName: "Blazers (Suit Jackets)",
          itemSingleName: "Blazer (Suit Jacket)"
        },
        l_ca: {
          nameForCatModal: "Blazers (Suit Jackets)",
          groupName: undefined,
          itemLabelName: "Blazers (Suit Jackets)",
          itemSingleName: "Blazer (Suit Jacket)"
        },
        l_ru: {
          nameForCatModal: "Блейзеры (пиджаки)",
          groupName: undefined,
          itemLabelName: "Блейзеры (пиджаки)",
          itemSingleName: "Пиджак"
        },
        l_jp: {
          nameForCatModal: "ブレザー（スーツジャケット）",
          groupName: undefined,
          itemLabelName: "ブレザー（スーツジャケット）",
          itemSingleName: "ブレザー（スーツジャケット）"
        },
        l_it: {
          nameForCatModal: "Blazer (Giacche per Abito)",
          groupName: undefined,
          itemLabelName: "Blazer (Giacche per Abito)",
          itemSingleName: "Blazer (giacca da completo)"
        },
        l_es: {
          nameForCatModal: "Blazers (chaqueta de traje)",
          groupName: undefined,
          itemLabelName: "Blazers (chaqueta de traje)",
          itemSingleName: "Blazer (chaqueta de traje)"
        },
        l_de: {
          nameForCatModal: "Blazer (Anzugjacken)",
          groupName: undefined,
          itemLabelName: "Blazer (Anzugjacken)",
          itemSingleName: "Blazer (Sakko)"
        },
        l_cn: {
          nameForCatModal: "西装上衣",
          groupName: undefined,
          itemLabelName: "西装上衣",
          itemSingleName: "西装外套"
        },
        l_fr: {
          nameForCatModal: "Blazers (vestes de costume)",
          groupName: undefined,
          itemLabelName: "Blazers (vestes de costume)",
          itemSingleName: "Blazer (veste de costume)"
        }
      },
      furjacketsgrp: {
        context:
          "표면이 모피 (혹은 인조 플리스)로 만들어진 긴팔 혹은 민소매 재킷의 범주",
        l_kr: {
          nameForCatModal: "퍼 (플리스) 재킷 & 베스트",
          groupName: "퍼 (플리스) 재킷 & 베스트 전체",
          itemLabelName: "퍼 (플리스) 재킷 & 베스트 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Fur (Fleece) Jackets & Vests",
          groupName: "All Fur (Fleece) Jackets & Vests",
          itemLabelName: "All Fur (Fleece) Jackets & Vests",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Fur (Fleece) Jackets & Gilets",
          groupName: "All Fur (Fleece) Jackets & Gilets",
          itemLabelName: "All Fur (Fleece) Jackets & Gilets",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Fur (Fleece) Jackets & Vests",
          groupName: "All Fur (Fleece) Jackets & Vests",
          itemLabelName: "All Fur (Fleece) Jackets & Vests",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Меховые (флисовые) куртки и жилеты",
          groupName: "Все меховые (флисовые) куртки и жилеты",
          itemLabelName: "Все меховые (флисовые) куртки и жилеты",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "ファー（フリース）ジャケット＆ベスト",
          groupName: "ファー（フリース）ジャケット＆ベストすべて",
          itemLabelName: "ファー（フリース）ジャケット＆ベストすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Giacche e Gilet di Pelliccia (Pile)",
          groupName: "Tutte le Giacche e Gilet di Pelliccia (Pile)",
          itemLabelName: "Tutte le Giacche e Gilet di Pelliccia (Pile)",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Chaquetas y chalecos de pelo (polar)",
          groupName: "Todas las chaquetas y chalecos de pelo (polar)",
          itemLabelName: "Todas las chaquetas y chalecos de pelo (polar)",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Pelz (Fleece) Jacken & Westen",
          groupName: "Alle Pelz (Fleece) Jacken & Westen",
          itemLabelName: "Alle Pelz (Fleece) Jacken & Westen",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "皮草（摇粒绒）夹克&背心",
          groupName: "全部皮草（摇粒绒）夹克&背心",
          itemLabelName: "全部皮草（摇粒绒）夹克&背心",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Vestes et gilets en fourrure (polaire)",
          groupName: "Toutes les vestes et gilets en fourrure (polaire)",
          itemLabelName: "Toutes les vestes et gilets en fourrure (polaire)",
          itemSingleName: undefined
        }
      },
      furjackets: {
        context: "표면이 모피 (혹은 인조 플리스)로 만들어진 긴팔 재킷의 범주",
        l_kr: {
          nameForCatModal: "퍼 & 플리스 재킷",
          groupName: undefined,
          itemLabelName: "퍼 & 플리스 재킷",
          itemSingleName: "퍼 & 플리스 재킷"
        },
        l_us: {
          nameForCatModal: "Fur & Fleece Jackets",
          groupName: undefined,
          itemLabelName: "Fur & Fleece Jackets",
          itemSingleName: "Fur & Fleece Jacket"
        },
        l_gb: {
          nameForCatModal: "Fur & Fleece Jackets",
          groupName: undefined,
          itemLabelName: "Fur & Fleece Jackets",
          itemSingleName: "Fur & Fleece Jacket"
        },
        l_ca: {
          nameForCatModal: "Fur & Fleece Jackets",
          groupName: undefined,
          itemLabelName: "Fur & Fleece Jackets",
          itemSingleName: "Fur & Fleece Jacket"
        },
        l_ru: {
          nameForCatModal: "Меховые и флисовые куртки",
          groupName: undefined,
          itemLabelName: "Меховые и флисовые куртки",
          itemSingleName: "Куртка из меха и флиса"
        },
        l_jp: {
          nameForCatModal: "ファー＆フリースジャケット",
          groupName: undefined,
          itemLabelName: "ファー＆フリースジャケット",
          itemSingleName: "ファー＆フリースジャケット"
        },
        l_it: {
          nameForCatModal: "Giacche di Pelliccia e Pile",
          groupName: undefined,
          itemLabelName: "Giacche di Pelliccia e Pile",
          itemSingleName: "Giacca in pelliccia e pile"
        },
        l_es: {
          nameForCatModal: "Chaquetas de pelo y polar",
          groupName: undefined,
          itemLabelName: "Chaquetas de pelo y polar",
          itemSingleName: "Chaqueta de pelo y forro polar"
        },
        l_de: {
          nameForCatModal: "Pelz- & Fleecejacken",
          groupName: undefined,
          itemLabelName: "Pelz- & Fleecejacken",
          itemSingleName: "Fell- & Fleecejacke"
        },
        l_cn: {
          nameForCatModal: "皮草&摇粒绒夹克",
          groupName: undefined,
          itemLabelName: "皮草&摇粒绒夹克",
          itemSingleName: "毛绒/抓绒外套"
        },
        l_fr: {
          nameForCatModal: "Vestes en fourrure et polaire",
          groupName: undefined,
          itemLabelName: "Vestes en fourrure et polaire",
          itemSingleName: "Veste en fourrure et polaire"
        }
      },
      furvests: {
        context: "표면이 모피 (혹은 인조 플리스)로 만들어진 민소매 재킷의 범주",
        l_kr: {
          nameForCatModal: "퍼 & 플리스 베스트",
          groupName: undefined,
          itemLabelName: "퍼 & 플리스 베스트",
          itemSingleName: "퍼 & 플리스 베스트"
        },
        l_us: {
          nameForCatModal: "Fur & Fleece Vests",
          groupName: undefined,
          itemLabelName: "Fur & Fleece Vests",
          itemSingleName: "Fur & Fleece Vest"
        },
        l_gb: {
          nameForCatModal: "Fur & Fleece Gilets",
          groupName: undefined,
          itemLabelName: "Fur & Fleece Gilets",
          itemSingleName: "Fur & Fleece Vest"
        },
        l_ca: {
          nameForCatModal: "Fur & Fleece Vests",
          groupName: undefined,
          itemLabelName: "Fur & Fleece Vests",
          itemSingleName: "Fur & Fleece Vest"
        },
        l_ru: {
          nameForCatModal: "Меховые и флисовые жилеты",
          groupName: undefined,
          itemLabelName: "Меховые и флисовые жилеты",
          itemSingleName: "Жилетка из меха и флиса"
        },
        l_jp: {
          nameForCatModal: "ファー＆フリースベスト",
          groupName: undefined,
          itemLabelName: "ファー＆フリースベスト",
          itemSingleName: "ファー＆フリースベスト"
        },
        l_it: {
          nameForCatModal: "Gilet di Pelliccia e Pile",
          groupName: undefined,
          itemLabelName: "Gilet di Pelliccia e Pile",
          itemSingleName: "Gilet in pelliccia e pile"
        },
        l_es: {
          nameForCatModal: "Chalecos de pelo y polar",
          groupName: undefined,
          itemLabelName: "Chalecos de pelo y polar",
          itemSingleName: "Chaleco de pelo y forro polar"
        },
        l_de: {
          nameForCatModal: "Pelz- & Fleecewesten",
          groupName: undefined,
          itemLabelName: "Pelz- & Fleecewesten",
          itemSingleName: "Fell- & Fleeceweste"
        },
        l_cn: {
          nameForCatModal: "皮草&摇粒绒背心",
          groupName: undefined,
          itemLabelName: "皮草&摇粒绒背心",
          itemSingleName: "毛绒/抓绒马甲"
        },
        l_fr: {
          nameForCatModal: "Gilets en fourrure et polaire",
          groupName: undefined,
          itemLabelName: "Gilets en fourrure et polaire",
          itemSingleName: "Gilet en fourrure et polaire"
        }
      },
      leatherjackets: {
        context: "가죽 소재 재킷의 범주",
        l_kr: {
          nameForCatModal: "가죽 재킷",
          groupName: undefined,
          itemLabelName: "가죽 재킷",
          itemSingleName: "가죽 재킷"
        },
        l_us: {
          nameForCatModal: "Leather Jackets",
          groupName: undefined,
          itemLabelName: "Leather Jackets",
          itemSingleName: "Leather Jacket"
        },
        l_gb: {
          nameForCatModal: "Leather Jackets",
          groupName: undefined,
          itemLabelName: "Leather Jackets",
          itemSingleName: "Leather Jacket"
        },
        l_ca: {
          nameForCatModal: "Leather Jackets",
          groupName: undefined,
          itemLabelName: "Leather Jackets",
          itemSingleName: "Leather Jacket"
        },
        l_ru: {
          nameForCatModal: "Кожаные куртки",
          groupName: undefined,
          itemLabelName: "Кожаные куртки",
          itemSingleName: "Кожаная куртка"
        },
        l_jp: {
          nameForCatModal: "レザージャケット",
          groupName: undefined,
          itemLabelName: "レザージャケット",
          itemSingleName: "レザージャケット"
        },
        l_it: {
          nameForCatModal: "Giacche in Pelle",
          groupName: undefined,
          itemLabelName: "Giacche in Pelle",
          itemSingleName: "Giacca di pelle"
        },
        l_es: {
          nameForCatModal: "Chaquetas de cuero",
          groupName: undefined,
          itemLabelName: "Chaquetas de cuero",
          itemSingleName: "Chaqueta de cuero"
        },
        l_de: {
          nameForCatModal: "Lederjacken",
          groupName: undefined,
          itemLabelName: "Lederjacken",
          itemSingleName: "Lederjacke"
        },
        l_cn: {
          nameForCatModal: "皮夹克",
          groupName: undefined,
          itemLabelName: "皮夹克",
          itemSingleName: "皮夹克"
        },
        l_fr: {
          nameForCatModal: "Vestes en cuir",
          groupName: undefined,
          itemLabelName: "Vestes en cuir",
          itemSingleName: "Veste en cuir"
        }
      },
      denimjackets: {
        context: "데님 소재 재킷의 범주",
        l_kr: {
          nameForCatModal: "데님 재킷",
          groupName: undefined,
          itemLabelName: "데님 재킷",
          itemSingleName: "데님 재킷"
        },
        l_us: {
          nameForCatModal: "Denim Jackets",
          groupName: undefined,
          itemLabelName: "Denim Jackets",
          itemSingleName: "Denim Jacket"
        },
        l_gb: {
          nameForCatModal: "Denim Jackets",
          groupName: undefined,
          itemLabelName: "Denim Jackets",
          itemSingleName: "Denim Jacket"
        },
        l_ca: {
          nameForCatModal: "Denim Jackets",
          groupName: undefined,
          itemLabelName: "Denim Jackets",
          itemSingleName: "Denim Jacket"
        },
        l_ru: {
          nameForCatModal: "Джинсовые куртки",
          groupName: undefined,
          itemLabelName: "Джинсовые куртки",
          itemSingleName: "Джинсовая куртка"
        },
        l_jp: {
          nameForCatModal: "デニムジャケット",
          groupName: undefined,
          itemLabelName: "デニムジャケット",
          itemSingleName: "デニムジャケット"
        },
        l_it: {
          nameForCatModal: "Giacche in Denim",
          groupName: undefined,
          itemLabelName: "Giacche in Denim",
          itemSingleName: "Giacca di jeans"
        },
        l_es: {
          nameForCatModal: "Chaquetas vaqueras",
          groupName: undefined,
          itemLabelName: "Chaquetas vaqueras",
          itemSingleName: "Chaqueta vaquera"
        },
        l_de: {
          nameForCatModal: "Jeansjacken",
          groupName: undefined,
          itemLabelName: "Jeansjacken",
          itemSingleName: "Jeansjacke"
        },
        l_cn: {
          nameForCatModal: "牛仔夹克",
          groupName: undefined,
          itemLabelName: "牛仔夹克",
          itemSingleName: "牛仔夹克"
        },
        l_fr: {
          nameForCatModal: "Vestes en jean",
          groupName: undefined,
          itemLabelName: "Vestes en jean",
          itemSingleName: "Veste en jean"
        }
      },
      regularjacketsgrp: {
        context: "그외의 일반적인 긴팔 혹은 민소매 재킷의 범주",
        l_kr: {
          nameForCatModal: "기타 재킷 & 베스트",
          groupName: "기타 재킷 & 베스트 전체",
          itemLabelName: "일반 재킷 & 베스트 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Other Jackets & Vests",
          groupName: "All Other Jackets & Vests",
          itemLabelName: "All Regular Jackets & Vests",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Other Jackets & Gilets",
          groupName: "All Other Jackets & Gilets",
          itemLabelName: "All Regular Jackets & Gilets",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Other Jackets & Vests",
          groupName: "All Other Jackets & Vests",
          itemLabelName: "All Regular Jackets & Vests",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Другие куртки и жилеты",
          groupName: "Все другие куртки и жилеты",
          itemLabelName: "Все обычные куртки и жилеты",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "その他ジャケット＆ベスト",
          groupName: "その他ジャケット＆ベストすべて",
          itemLabelName: "一般ジャケット＆ベストすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Altre Giacche e Gilet",
          groupName: "Tutte le Altre Giacche e Gilet",
          itemLabelName: "Tutte le Giacche e Gilet Normale",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Otras chaquetas y chalecos",
          groupName: "Todas otras chaquetas y chalecos",
          itemLabelName: "Todas las chaquetas y chalecos normales",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Andere Jacken & Westen",
          groupName: "Alle anderen Jacken & Westen",
          itemLabelName: "Alle normalen Jacken & Westen",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "其他夹克&无袖夹克",
          groupName: "其他全部夹克&无袖夹克",
          itemLabelName: "全部一般夹克&无袖夹克",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Autres gilets et vestes",
          groupName: "Tous les autres gilets et vestes",
          itemLabelName: "Tous les gilets et vestes basiques",
          itemSingleName: undefined
        }
      },
      regularjackets: {
        context: "그외의 일반적인 긴소매 재킷의 범주",
        l_kr: {
          nameForCatModal: "기타 재킷",
          groupName: undefined,
          itemLabelName: "일반 재킷",
          itemSingleName: "재킷"
        },
        l_us: {
          nameForCatModal: "Other Jackets",
          groupName: undefined,
          itemLabelName: "Regular Jackets",
          itemSingleName: "Jacket"
        },
        l_gb: {
          nameForCatModal: "Other Jackets",
          groupName: undefined,
          itemLabelName: "Regular Jackets",
          itemSingleName: "Jacket"
        },
        l_ca: {
          nameForCatModal: "Other Jackets",
          groupName: undefined,
          itemLabelName: "Regular Jackets",
          itemSingleName: "Jacket"
        },
        l_ru: {
          nameForCatModal: "Другие куртки",
          groupName: undefined,
          itemLabelName: "Обычные куртки",
          itemSingleName: "Куртка"
        },
        l_jp: {
          nameForCatModal: "その他ジャケット",
          groupName: undefined,
          itemLabelName: "一般ジャケット",
          itemSingleName: "ジャケット"
        },
        l_it: {
          nameForCatModal: "Altre Giacche",
          groupName: undefined,
          itemLabelName: "Giacche Normale",
          itemSingleName: "Giacca"
        },
        l_es: {
          nameForCatModal: "Otras chaquetas",
          groupName: undefined,
          itemLabelName: "Chaquetas normales",
          itemSingleName: "Chaqueta"
        },
        l_de: {
          nameForCatModal: "Andere Jacken",
          groupName: undefined,
          itemLabelName: "Normale Jacken",
          itemSingleName: "Jacke"
        },
        l_cn: {
          nameForCatModal: "其他夹克",
          groupName: undefined,
          itemLabelName: "一般夹克",
          itemSingleName: "夹克"
        },
        l_fr: {
          nameForCatModal: "Autres vestes",
          groupName: undefined,
          itemLabelName: "Vestes basiques",
          itemSingleName: "Veste"
        }
      },
      regularvestjackets: {
        context: "그외의 일반적인 민소매 재킷의 범주",
        l_kr: {
          nameForCatModal: "기타 베스트",
          groupName: undefined,
          itemLabelName: "일반 베스트",
          itemSingleName: "베스트"
        },
        l_us: {
          nameForCatModal: "Other Vest Jackets",
          groupName: undefined,
          itemLabelName: "Regular Vest Jackets",
          itemSingleName: "Vest Jacket"
        },
        l_gb: {
          nameForCatModal: "Other Gilets",
          groupName: undefined,
          itemLabelName: "Regular Gilets",
          itemSingleName: "Vest Jacket"
        },
        l_ca: {
          nameForCatModal: "Other Vest Jackets",
          groupName: undefined,
          itemLabelName: "Regular Vest Jackets",
          itemSingleName: "Vest Jacket"
        },
        l_ru: {
          nameForCatModal: "Другие жилеты",
          groupName: undefined,
          itemLabelName: "Обычные жилеты",
          itemSingleName: "Жилет"
        },
        l_jp: {
          nameForCatModal: "その他ベストジャケット",
          groupName: undefined,
          itemLabelName: "一般ベストジャケット",
          itemSingleName: "ベスト"
        },
        l_it: {
          nameForCatModal: "Altri Gilet",
          groupName: undefined,
          itemLabelName: "Gilet Normale",
          itemSingleName: "Gilet"
        },
        l_es: {
          nameForCatModal: "Otros chalecos",
          groupName: undefined,
          itemLabelName: "Chalecos normales",
          itemSingleName: "Chaleco"
        },
        l_de: {
          nameForCatModal: "Andere Westen",
          groupName: undefined,
          itemLabelName: "Normale Westen",
          itemSingleName: "Weste"
        },
        l_cn: {
          nameForCatModal: "其他无袖夹克",
          groupName: undefined,
          itemLabelName: "一般无袖夹克",
          itemSingleName: "马甲"
        },
        l_fr: {
          nameForCatModal: "Autres gilets",
          groupName: undefined,
          itemLabelName: "Gilets basiques",
          itemSingleName: "Gilet"
        }
      },
      coatsgrp: {
        context: "엉덩이를 덮는 길이의 긴 겉옷의 범주",
        l_kr: {
          nameForCatModal: "코트",
          groupName: "코트 전체",
          itemLabelName: "코트 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Coats",
          groupName: "All Coats",
          itemLabelName: "All Coats",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Coats",
          groupName: "All Coats",
          itemLabelName: "All Coats",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Coats",
          groupName: "All Coats",
          itemLabelName: "All Coats",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Пальто",
          groupName: "Все пальто",
          itemLabelName: "Все пальто",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "コート",
          groupName: "コートすべて",
          itemLabelName: "コートすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Cappotti",
          groupName: "Tutti i Cappotti",
          itemLabelName: "Tutti i Cappotti",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Abrigos",
          groupName: "Todos los abrigos",
          itemLabelName: "Todos los abrigos",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Mäntel",
          groupName: "Alle Mäntel",
          itemLabelName: "Alle Mäntel",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "大衣",
          groupName: "全部大衣",
          itemLabelName: "全部大衣",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Manteaux",
          groupName: "Tous les manteaux",
          itemLabelName: "Tous les manteaux",
          itemSingleName: undefined
        }
      },
      downcoats: {
        context: "충전재를 사용한 코트의 범주",
        l_kr: {
          nameForCatModal: "패딩 코트",
          groupName: undefined,
          itemLabelName: "패딩 코트",
          itemSingleName: "패딩 코트"
        },
        l_us: {
          nameForCatModal: "Padded Coats",
          groupName: undefined,
          itemLabelName: "Padded Coats",
          itemSingleName: "Padded Coat"
        },
        l_gb: {
          nameForCatModal: "Padded Coats",
          groupName: undefined,
          itemLabelName: "Padded Coats",
          itemSingleName: "Padded Coat"
        },
        l_ca: {
          nameForCatModal: "Padded Coats",
          groupName: undefined,
          itemLabelName: "Padded Coats",
          itemSingleName: "Padded Coat"
        },
        l_ru: {
          nameForCatModal: "Пуховые пальто",
          groupName: undefined,
          itemLabelName: "Пуховые пальто",
          itemSingleName: "Стёганое пальто"
        },
        l_jp: {
          nameForCatModal: "パデッドコート",
          groupName: undefined,
          itemLabelName: "パデッドコート",
          itemSingleName: "中綿コート"
        },
        l_it: {
          nameForCatModal: "Cappotti imbottiti",
          groupName: undefined,
          itemLabelName: "Cappotti imbottiti",
          itemSingleName: "Cappotto imbottito"
        },
        l_es: {
          nameForCatModal: "Abrigos acolchados",
          groupName: undefined,
          itemLabelName: "Abrigos acolchados",
          itemSingleName: "Abrigo acolchado"
        },
        l_de: {
          nameForCatModal: "Steppmäntel",
          groupName: undefined,
          itemLabelName: "Steppmäntel",
          itemSingleName: "Steppmantel"
        },
        l_cn: {
          nameForCatModal: "填充大衣",
          groupName: undefined,
          itemLabelName: "填充大衣",
          itemSingleName: "羽绒大衣"
        },
        l_fr: {
          nameForCatModal: "Manteaux rembourrés",
          groupName: undefined,
          itemLabelName: "Manteaux rembourrés",
          itemSingleName: "Manteau matelassé"
        }
      },
      furcoats: {
        context: "표면이 모피 (혹은 인조 플리스)로 만들어진 코트의 범주 ",
        l_kr: {
          nameForCatModal: "퍼 & 플리스 코트",
          groupName: undefined,
          itemLabelName: "퍼 & 플리스 코트",
          itemSingleName: "퍼 & 플리스 코트"
        },
        l_us: {
          nameForCatModal: "Fur & Fleece Coats",
          groupName: undefined,
          itemLabelName: "Fur & Fleece Coats",
          itemSingleName: "Fur & Fleece Coat"
        },
        l_gb: {
          nameForCatModal: "Fur & Fleece Coats",
          groupName: undefined,
          itemLabelName: "Fur & Fleece Coats",
          itemSingleName: "Fur & Fleece Coat"
        },
        l_ca: {
          nameForCatModal: "Fur & Fleece Coats",
          groupName: undefined,
          itemLabelName: "Fur & Fleece Coats",
          itemSingleName: "Fur & Fleece Coat"
        },
        l_ru: {
          nameForCatModal: "Меховые и флисовые пальто",
          groupName: undefined,
          itemLabelName: "Меховые и флисовые пальто",
          itemSingleName: "Пальто из меха и флиса"
        },
        l_jp: {
          nameForCatModal: "ファー＆フリースコート",
          groupName: undefined,
          itemLabelName: "ファー＆フリースコート",
          itemSingleName: "ファー＆フリースコート"
        },
        l_it: {
          nameForCatModal: "Cappotti in Pelliccia e Pile",
          groupName: undefined,
          itemLabelName: "Cappotti in Pelliccia e Pile",
          itemSingleName: "Cappotto in pelliccia e pile"
        },
        l_es: {
          nameForCatModal: "Abrigos de pelo y vellón",
          groupName: undefined,
          itemLabelName: "Abrigos de pelo y vellón",
          itemSingleName: "Abrigo de pelo y forro polar"
        },
        l_de: {
          nameForCatModal: "Pelz- & Fleecemäntel",
          groupName: undefined,
          itemLabelName: "Pelz- & Fleecemäntel",
          itemSingleName: "Fell- & Fleecemantel"
        },
        l_cn: {
          nameForCatModal: "皮草&摇粒绒大衣",
          groupName: undefined,
          itemLabelName: "皮草&摇粒绒大衣",
          itemSingleName: "毛绒/抓绒大衣"
        },
        l_fr: {
          nameForCatModal: "Manteaux en fourrure et polaire",
          groupName: undefined,
          itemLabelName: "Manteaux en fourrure et polaire",
          itemSingleName: "Manteau en fourrure et polaire"
        }
      },
      leathercoats: {
        context: "가죽 소재 코트의 범주",
        l_kr: {
          nameForCatModal: "가죽 코트",
          groupName: undefined,
          itemLabelName: "가죽 코트",
          itemSingleName: "가죽 코트"
        },
        l_us: {
          nameForCatModal: "Leather Coats",
          groupName: undefined,
          itemLabelName: "Leather Coats",
          itemSingleName: "Leather Coat"
        },
        l_gb: {
          nameForCatModal: "Leather Coats",
          groupName: undefined,
          itemLabelName: "Leather Coats",
          itemSingleName: "Leather Coat"
        },
        l_ca: {
          nameForCatModal: "Leather Coats",
          groupName: undefined,
          itemLabelName: "Leather Coats",
          itemSingleName: "Leather Coat"
        },
        l_ru: {
          nameForCatModal: "Кожаные пальто",
          groupName: undefined,
          itemLabelName: "Кожаные пальто",
          itemSingleName: "Кожаное пальто"
        },
        l_jp: {
          nameForCatModal: "レザーコート",
          groupName: undefined,
          itemLabelName: "レザーコート",
          itemSingleName: "レザーコート"
        },
        l_it: {
          nameForCatModal: "Cappotti in Pelle",
          groupName: undefined,
          itemLabelName: "Cappotti in Pelle",
          itemSingleName: "Cappotto di pelle"
        },
        l_es: {
          nameForCatModal: "Abrigos de cuero",
          groupName: undefined,
          itemLabelName: "Abrigos de cuero",
          itemSingleName: "Abrigo de cuero"
        },
        l_de: {
          nameForCatModal: "Ledermäntel",
          groupName: undefined,
          itemLabelName: "Ledermäntel",
          itemSingleName: "Ledermantel"
        },
        l_cn: {
          nameForCatModal: "皮大衣",
          groupName: undefined,
          itemLabelName: "皮大衣",
          itemSingleName: "皮大衣"
        },
        l_fr: {
          nameForCatModal: "Manteaux en cuir",
          groupName: undefined,
          itemLabelName: "Manteaux en cuir",
          itemSingleName: "Manteau en cuir"
        }
      },
      regularcoats: {
        context: "그외의 일반적인 코트의 범주",
        l_kr: {
          nameForCatModal: "기타 코트",
          groupName: undefined,
          itemLabelName: "일반 코트",
          itemSingleName: "코트"
        },
        l_us: {
          nameForCatModal: "Other Coats",
          groupName: undefined,
          itemLabelName: "Regular Coats",
          itemSingleName: "Coat"
        },
        l_gb: {
          nameForCatModal: "Other Coats",
          groupName: undefined,
          itemLabelName: "Regular Coats",
          itemSingleName: "Coat"
        },
        l_ca: {
          nameForCatModal: "Other Coats",
          groupName: undefined,
          itemLabelName: "Regular Coats",
          itemSingleName: "Coat"
        },
        l_ru: {
          nameForCatModal: "Другие пальто",
          groupName: undefined,
          itemLabelName: "Обычные пальто",
          itemSingleName: "Пальто"
        },
        l_jp: {
          nameForCatModal: "その他コート",
          groupName: undefined,
          itemLabelName: "一般コート",
          itemSingleName: "コート"
        },
        l_it: {
          nameForCatModal: "Altri Cappotti",
          groupName: undefined,
          itemLabelName: "Cappotti Normale",
          itemSingleName: "Cappotto"
        },
        l_es: {
          nameForCatModal: "Otros abrigos",
          groupName: undefined,
          itemLabelName: "Abrigos normales",
          itemSingleName: "Abrigo"
        },
        l_de: {
          nameForCatModal: "Andere Mäntel",
          groupName: undefined,
          itemLabelName: "Normale Mäntel",
          itemSingleName: "Mantel"
        },
        l_cn: {
          nameForCatModal: "其他大衣",
          groupName: undefined,
          itemLabelName: "一般大衣",
          itemSingleName: "大衣"
        },
        l_fr: {
          nameForCatModal: "Autres manteaux",
          groupName: undefined,
          itemLabelName: "Manteaux basiques",
          itemSingleName: "Manteau"
        }
      },
      topsgrp: {
        context: "상반신에 착장하는 윗옷의 범주",
        l_kr: {
          nameForCatModal: "상의",
          groupName: "상의 전체",
          itemLabelName: "상의 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Tops",
          groupName: "All Tops",
          itemLabelName: "All Tops",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Tops",
          groupName: "All Tops",
          itemLabelName: "All Tops",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Tops",
          groupName: "All Tops",
          itemLabelName: "All Tops",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Топы",
          groupName: "Все топы",
          itemLabelName: "Все топы",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "トップス",
          groupName: "トップスすべて",
          itemLabelName: "トップスすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Top",
          groupName: "Tutti i Top",
          itemLabelName: "Tutti i Top",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Prendas superiores",
          groupName: "Todas las prendas superiores",
          itemLabelName: "Todas las prendas superiores",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Oberteile",
          groupName: "Alle Oberteile",
          itemLabelName: "Alle Oberteile",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "上装",
          groupName: "全部上装",
          itemLabelName: "全部上装",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Hauts",
          groupName: "Tous les hauts",
          itemLabelName: "Tous les hauts",
          itemSingleName: undefined
        }
      },
      knitweargrp: {
        context: "뜨개질로 만든 상의의 범주",
        l_kr: {
          nameForCatModal: "니트류",
          groupName: "니트류 전체",
          itemLabelName: "니트류 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Knitwear",
          groupName: "All Knitwear",
          itemLabelName: "All Knitwear",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Knitwear",
          groupName: "All Knitwear",
          itemLabelName: "All Knitwear",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Knitwear",
          groupName: "All Knitwear",
          itemLabelName: "All Knitwear",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Вязаные вещи",
          groupName: "Все вязаные вещи",
          itemLabelName: "Все вязаные вещи",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "ニット類",
          groupName: "ニット類すべて",
          itemLabelName: "ニット類すべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Abbigliamento a Maglia",
          groupName: "Tutto l'Abbigliamento a Maglia",
          itemLabelName: "Tutto l'Abbigliamento a Maglia",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Prendas de punto",
          groupName: "Todas las prendas de punto",
          itemLabelName: "Todas las prendas de punto",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Strickwaren",
          groupName: "Alle Strickwaren",
          itemLabelName: "Alle Strickwaren",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "针织衫类",
          groupName: "全部针织衫类",
          itemLabelName: "全部针织衫类",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Tricots",
          groupName: "Tous les tricots",
          itemLabelName: "Tous les tricots",
          itemSingleName: undefined
        }
      },
      sweaters: {
        context: "머리부터 뒤집어 써서 입는 형식의 니트류 범주",
        l_kr: {
          nameForCatModal: "스웨터",
          groupName: undefined,
          itemLabelName: "스웨터",
          itemSingleName: "스웨터"
        },
        l_us: {
          nameForCatModal: "Sweaters",
          groupName: undefined,
          itemLabelName: "Sweaters",
          itemSingleName: "Sweater"
        },
        l_gb: {
          nameForCatModal: "Jumpers",
          groupName: undefined,
          itemLabelName: "Jumpers",
          itemSingleName: "Sweater"
        },
        l_ca: {
          nameForCatModal: "Sweaters",
          groupName: undefined,
          itemLabelName: "Sweaters",
          itemSingleName: "Sweater"
        },
        l_ru: {
          nameForCatModal: "Свитеры",
          groupName: undefined,
          itemLabelName: "Свитеры",
          itemSingleName: "Свитер"
        },
        l_jp: {
          nameForCatModal: "セーター",
          groupName: undefined,
          itemLabelName: "セーター",
          itemSingleName: "セーター"
        },
        l_it: {
          nameForCatModal: "Maglioni",
          groupName: undefined,
          itemLabelName: "Maglioni",
          itemSingleName: "Maglione"
        },
        l_es: {
          nameForCatModal: "Suéteres",
          groupName: undefined,
          itemLabelName: "Suéteres",
          itemSingleName: "Suéter"
        },
        l_de: {
          nameForCatModal: "Pullover",
          groupName: undefined,
          itemLabelName: "Pullover",
          itemSingleName: "Pullover"
        },
        l_cn: {
          nameForCatModal: "毛衣",
          groupName: undefined,
          itemLabelName: "毛衣",
          itemSingleName: "毛衣"
        },
        l_fr: {
          nameForCatModal: "Pulls",
          groupName: undefined,
          itemLabelName: "Pulls",
          itemSingleName: "Pull"
        }
      },
      cardigans: {
        context: "뜨개질로 만든 앞이 트인 니트류의 범주",
        l_kr: {
          nameForCatModal: "카디건",
          groupName: undefined,
          itemLabelName: "카디건",
          itemSingleName: "카디건"
        },
        l_us: {
          nameForCatModal: "Cardigans",
          groupName: undefined,
          itemLabelName: "Cardigans",
          itemSingleName: "Cardigan"
        },
        l_gb: {
          nameForCatModal: "Cardigans",
          groupName: undefined,
          itemLabelName: "Cardigans",
          itemSingleName: "Cardigan"
        },
        l_ca: {
          nameForCatModal: "Cardigans",
          groupName: undefined,
          itemLabelName: "Cardigans",
          itemSingleName: "Cardigan"
        },
        l_ru: {
          nameForCatModal: "Кардиганы",
          groupName: undefined,
          itemLabelName: "Кардиганы",
          itemSingleName: "Кардиган"
        },
        l_jp: {
          nameForCatModal: "カーディガン",
          groupName: undefined,
          itemLabelName: "カーディガン",
          itemSingleName: "カーディガン"
        },
        l_it: {
          nameForCatModal: "Cardigan",
          groupName: undefined,
          itemLabelName: "Cardigan",
          itemSingleName: "Cardigan"
        },
        l_es: {
          nameForCatModal: "Cárdigans",
          groupName: undefined,
          itemLabelName: "Cárdigans",
          itemSingleName: "Cárdigan"
        },
        l_de: {
          nameForCatModal: "Strickjacken",
          groupName: undefined,
          itemLabelName: "Strickjacken",
          itemSingleName: "Cardigan"
        },
        l_cn: {
          nameForCatModal: "开衫",
          groupName: undefined,
          itemLabelName: "开衫",
          itemSingleName: "开衫"
        },
        l_fr: {
          nameForCatModal: "Cardigans",
          groupName: undefined,
          itemLabelName: "Cardigans",
          itemSingleName: "Cardigan"
        }
      },
      knitvests: {
        context: "소매가 없는 니트류의 범주",
        l_kr: {
          nameForCatModal: "니트 베스트",
          groupName: undefined,
          itemLabelName: "니트 베스트",
          itemSingleName: "니트 베스트"
        },
        l_us: {
          nameForCatModal: "Knit Vests",
          groupName: undefined,
          itemLabelName: "Knit Vests",
          itemSingleName: "Knit Vest"
        },
        l_gb: {
          nameForCatModal: "Sleeveless Jumpers",
          groupName: undefined,
          itemLabelName: "Sleeveless Jumpers",
          itemSingleName: "Knit Vest"
        },
        l_ca: {
          nameForCatModal: "Sweater Vests",
          groupName: undefined,
          itemLabelName: "Sweater Vests",
          itemSingleName: "Knit Vest"
        },
        l_ru: {
          nameForCatModal: "Вязаные жилеты",
          groupName: undefined,
          itemLabelName: "Вязаные жилеты",
          itemSingleName: "Вязаный жилет"
        },
        l_jp: {
          nameForCatModal: "ニットベスト",
          groupName: undefined,
          itemLabelName: "ニットベスト",
          itemSingleName: "ニットベスト"
        },
        l_it: {
          nameForCatModal: "Gilet a Maglia",
          groupName: undefined,
          itemLabelName: "Gilet a Maglia",
          itemSingleName: "Gilet a maglia"
        },
        l_es: {
          nameForCatModal: "Chalecos de punto",
          groupName: undefined,
          itemLabelName: "Chalecos de punto",
          itemSingleName: "Chaleco de punto"
        },
        l_de: {
          nameForCatModal: "Strickwesten",
          groupName: undefined,
          itemLabelName: "Strickwesten",
          itemSingleName: "Strickweste"
        },
        l_cn: {
          nameForCatModal: "针织背心",
          groupName: undefined,
          itemLabelName: "针织背心",
          itemSingleName: "针织马甲"
        },
        l_fr: {
          nameForCatModal: "Pulls sans manche",
          groupName: undefined,
          itemLabelName: "Pulls sans manche",
          itemSingleName: "Gilet en maille"
        }
      },
      poloshirtsgrp: {
        context: "칼라가 있는 긴소매 혹은 반소매 상의의 범주",
        l_kr: {
          nameForCatModal: "폴로 셔츠",
          groupName: "폴로 셔츠 전체",
          itemLabelName: "폴로 셔츠 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Polo Shirts",
          groupName: "All Polo Shirts",
          itemLabelName: "All Polo Shirts",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Polo Shirts",
          groupName: "All Polo Shirts",
          itemLabelName: "All Polo Shirts",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Polo Shirts",
          groupName: "All Polo Shirts",
          itemLabelName: "All Polo Shirts",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Рубашки поло",
          groupName: "Все рубашки поло",
          itemLabelName: "Все рубашки поло",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "ポロシャツ",
          groupName: "ポロシャツすべて",
          itemLabelName: "ポロシャツすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Polo",
          groupName: "Tutte le Polo",
          itemLabelName: "Tutte le Polo",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Polos",
          groupName: "Todos los polos",
          itemLabelName: "Todos los polos",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Poloshirts",
          groupName: "Alle Poloshirts",
          itemLabelName: "Alle Poloshirts",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "POLO衫",
          groupName: "全部POLO衫",
          itemLabelName: "全部POLO衫",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Polos",
          groupName: "Tous les polos",
          itemLabelName: "Tous les polos",
          itemSingleName: undefined
        }
      },
      longsleevepoloshirts: {
        context: "칼라가 있는 긴소매 상의의 범주",
        l_kr: {
          nameForCatModal: "긴팔 폴로 셔츠",
          groupName: undefined,
          itemLabelName: "긴팔 폴로 셔츠",
          itemSingleName: "긴팔 폴로 셔츠"
        },
        l_us: {
          nameForCatModal: "Long Sleeve Polo Shirts",
          groupName: undefined,
          itemLabelName: "Long Sleeve Polo Shirts",
          itemSingleName: "Long Sleeve Polo Shirt"
        },
        l_gb: {
          nameForCatModal: "Long Sleeve Polo Shirts",
          groupName: undefined,
          itemLabelName: "Long Sleeve Polo Shirts",
          itemSingleName: "Long Sleeve Polo Shirt"
        },
        l_ca: {
          nameForCatModal: "Long Sleeve Polo Shirts",
          groupName: undefined,
          itemLabelName: "Long Sleeve Polo Shirts",
          itemSingleName: "Long Sleeve Polo Shirt"
        },
        l_ru: {
          nameForCatModal: "Рубашки поло с длинным рукавом",
          groupName: undefined,
          itemLabelName: "Рубашки поло с длинным рукавом",
          itemSingleName: "Поло с длинным рукавом"
        },
        l_jp: {
          nameForCatModal: "長袖ポロシャツ",
          groupName: undefined,
          itemLabelName: "長袖ポロシャツ",
          itemSingleName: "長袖ポロシャツ"
        },
        l_it: {
          nameForCatModal: "Polo a Maniche Lunghe",
          groupName: undefined,
          itemLabelName: "Polo a Maniche Lunghe",
          itemSingleName: "Polo a maniche lunghe"
        },
        l_es: {
          nameForCatModal: "Polos manga larga",
          groupName: undefined,
          itemLabelName: "Polos manga larga",
          itemSingleName: "Polo de manga larga"
        },
        l_de: {
          nameForCatModal: "Langarm-Poloshirts",
          groupName: undefined,
          itemLabelName: "Langarm-Poloshirts",
          itemSingleName: "Langarm-Poloshirt"
        },
        l_cn: {
          nameForCatModal: "长袖POLO衫",
          groupName: undefined,
          itemLabelName: "长袖POLO衫",
          itemSingleName: "长袖POLO衫"
        },
        l_fr: {
          nameForCatModal: "Polos manches longues",
          groupName: undefined,
          itemLabelName: "Polos manches longues",
          itemSingleName: "Polo manches longues"
        }
      },
      shortsleevepoloshirts: {
        context: "칼라가 있는 반소매 상의의 범주",
        l_kr: {
          nameForCatModal: "폴로 셔츠 (반팔)",
          groupName: undefined,
          itemLabelName: "폴로 셔츠 (반팔)",
          itemSingleName: "폴로 셔츠"
        },
        l_us: {
          nameForCatModal: "Polo Shirts (Short Sleeve)",
          groupName: undefined,
          itemLabelName: "Polo Shirts (Short Sleeve)",
          itemSingleName: "Polo Shirt"
        },
        l_gb: {
          nameForCatModal: "Polo Shirts (Short Sleeve)",
          groupName: undefined,
          itemLabelName: "Polo Shirts (Short Sleeve)",
          itemSingleName: "Polo Shirt"
        },
        l_ca: {
          nameForCatModal: "Polo Shirts (Short Sleeve)",
          groupName: undefined,
          itemLabelName: "Polo Shirts (Short Sleeve)",
          itemSingleName: "Polo Shirt"
        },
        l_ru: {
          nameForCatModal: "Рубашки поло (с коротким рукавом)",
          groupName: undefined,
          itemLabelName: "Рубашки поло (с коротким рукавом)",
          itemSingleName: "Поло"
        },
        l_jp: {
          nameForCatModal: "ポロシャツ（半袖）",
          groupName: undefined,
          itemLabelName: "ポロシャツ（半袖）",
          itemSingleName: "ポロシャツ"
        },
        l_it: {
          nameForCatModal: "Polo (Maniche Corte)",
          groupName: undefined,
          itemLabelName: "Polo (Maniche Corte)",
          itemSingleName: "Polo"
        },
        l_es: {
          nameForCatModal: "Polos (manga corta)",
          groupName: undefined,
          itemLabelName: "Polos (manga corta)",
          itemSingleName: "Polo"
        },
        l_de: {
          nameForCatModal: "Poloshirts (kurzärmelig)",
          groupName: undefined,
          itemLabelName: "Poloshirts (kurzärmelig)",
          itemSingleName: "Poloshirt"
        },
        l_cn: {
          nameForCatModal: "POLO衫（短袖）",
          groupName: undefined,
          itemLabelName: "POLO衫（短袖）",
          itemSingleName: "POLO衫"
        },
        l_fr: {
          nameForCatModal: "Polos (manches courtes)",
          groupName: undefined,
          itemLabelName: "Polos (manches courtes)",
          itemSingleName: "Polo"
        }
      },
      tshirtsgrp: {
        context: "칼라가 없는 T자 모양의 긴소매 혹은 반소매 상의의 범주",
        l_kr: {
          nameForCatModal: "티셔츠",
          groupName: "티셔츠 전체",
          itemLabelName: "티셔츠 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "T-Shirts",
          groupName: "All T-Shirts",
          itemLabelName: "All T-Shirts",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "T-Shirts",
          groupName: "All T-Shirts",
          itemLabelName: "All T-Shirts",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "T-Shirts",
          groupName: "All T-Shirts",
          itemLabelName: "All T-Shirts",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Футболки",
          groupName: "Все футболки",
          itemLabelName: "Все футболки",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "Tシャツ",
          groupName: "Tシャツすべて",
          itemLabelName: "Tシャツすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Magliette",
          groupName: "Tutte le Magliette",
          itemLabelName: "Tutte le Magliette",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Camisetas",
          groupName: "Todas las camisetas",
          itemLabelName: "Todas las camisetas",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "T-Shirts",
          groupName: "Alle T-Shirts",
          itemLabelName: "Alle T-Shirts",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "T恤",
          groupName: "全部T恤",
          itemLabelName: "全部T恤",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "T-shirts",
          groupName: "Tous les T-shirts",
          itemLabelName: "Tous les T-shirts",
          itemSingleName: undefined
        }
      },
      longsleevetshirts: {
        context: "칼라가 없는 T자 모양의 긴소매 상의의 범주",
        l_kr: {
          nameForCatModal: "긴팔 티셔츠",
          groupName: undefined,
          itemLabelName: "긴팔 티셔츠",
          itemSingleName: "긴팔 티셔츠"
        },
        l_us: {
          nameForCatModal: "Long Sleeve T-Shirts",
          groupName: undefined,
          itemLabelName: "Long Sleeve T-Shirts",
          itemSingleName: "Long Sleeve T-Shirt"
        },
        l_gb: {
          nameForCatModal: "Long Sleeve T-Shirts",
          groupName: undefined,
          itemLabelName: "Long Sleeve T-Shirts",
          itemSingleName: "Long Sleeve T-Shirt"
        },
        l_ca: {
          nameForCatModal: "Long Sleeve T-Shirts",
          groupName: undefined,
          itemLabelName: "Long Sleeve T-Shirts",
          itemSingleName: "Long Sleeve T-Shirt"
        },
        l_ru: {
          nameForCatModal: "Футболки с длинным рукавом",
          groupName: undefined,
          itemLabelName: "Футболки с длинным рукавом",
          itemSingleName: "Футболка с длинным рукавом"
        },
        l_jp: {
          nameForCatModal: "長袖Tシャツ",
          groupName: undefined,
          itemLabelName: "長袖Tシャツ",
          itemSingleName: "長袖Tシャツ"
        },
        l_it: {
          nameForCatModal: "Magliette a Maniche Lunghe",
          groupName: undefined,
          itemLabelName: "Magliette a Maniche Lunghe",
          itemSingleName: "T-shirt a maniche lunghe"
        },
        l_es: {
          nameForCatModal: "Camisetas manga larga",
          groupName: undefined,
          itemLabelName: "Camisetas manga larga",
          itemSingleName: "Camiseta de manga larga"
        },
        l_de: {
          nameForCatModal: "Langarmshirts",
          groupName: undefined,
          itemLabelName: "Langarmshirts",
          itemSingleName: "Langarmshirt"
        },
        l_cn: {
          nameForCatModal: "长袖T恤",
          groupName: undefined,
          itemLabelName: "长袖T恤",
          itemSingleName: "长袖T恤"
        },
        l_fr: {
          nameForCatModal: "T-shirts manches longues",
          groupName: undefined,
          itemLabelName: "T-shirts manches longues",
          itemSingleName: "T-shirt manches longues"
        }
      },
      shortsleevetshirts: {
        context: "칼라가 없는 T자 모양의 반소매 상의의 범주",
        l_kr: {
          nameForCatModal: "티셔츠 (반팔)",
          groupName: undefined,
          itemLabelName: "티셔츠 (반팔)",
          itemSingleName: "티셔츠"
        },
        l_us: {
          nameForCatModal: "T-Shirts (Short Sleeve)",
          groupName: undefined,
          itemLabelName: "T-Shirts (Short Sleeve)",
          itemSingleName: "T-Shirt"
        },
        l_gb: {
          nameForCatModal: "(Short-Sleeved) T-Shirts",
          groupName: undefined,
          itemLabelName: "(Short-Sleeved) T-Shirts",
          itemSingleName: "T-Shirt"
        },
        l_ca: {
          nameForCatModal: "T-Shirts (Short Sleeve)",
          groupName: undefined,
          itemLabelName: "T-Shirts (Short Sleeve)",
          itemSingleName: "T-Shirt"
        },
        l_ru: {
          nameForCatModal: "Футболки (с коротким рукавом)",
          groupName: undefined,
          itemLabelName: "Футболки (с коротким рукавом)",
          itemSingleName: "Футболка"
        },
        l_jp: {
          nameForCatModal: "Tシャツ（半袖）",
          groupName: undefined,
          itemLabelName: "Tシャツ（半袖）",
          itemSingleName: "Tシャツ"
        },
        l_it: {
          nameForCatModal: "Magliette (Maniche Corte)",
          groupName: undefined,
          itemLabelName: "Magliette (Maniche Corte)",
          itemSingleName: "T-shirt"
        },
        l_es: {
          nameForCatModal: "Camisetas (manga corta)",
          groupName: undefined,
          itemLabelName: "Camisetas (manga corta)",
          itemSingleName: "Camiseta"
        },
        l_de: {
          nameForCatModal: "T-Shirts (kurzärmelig)",
          groupName: undefined,
          itemLabelName: "T-Shirts (kurzärmelig)",
          itemSingleName: "T-Shirt"
        },
        l_cn: {
          nameForCatModal: "T恤（短袖）",
          groupName: undefined,
          itemLabelName: "T恤（短袖）",
          itemSingleName: "T恤"
        },
        l_fr: {
          nameForCatModal: "T-shirts (manches courtes)",
          groupName: undefined,
          itemLabelName: "T-shirts (manches courtes)",
          itemSingleName: "T-shirt"
        }
      },
      tanks: {
        context: "소매가 없는 상의의 범주",
        l_kr: {
          nameForCatModal: "베스트 & 슬리브리스",
          groupName: undefined,
          itemLabelName: "베스트 & 슬리브리스",
          itemSingleName: "베스트 & 슬리브리스"
        },
        l_us: {
          nameForCatModal: "Vests & Tank Tops",
          groupName: undefined,
          itemLabelName: "Vests & Tank Tops",
          itemSingleName: "Vest & Tank Top"
        },
        l_gb: {
          nameForCatModal: "Sleeveless Tops & Waistcoats",
          groupName: undefined,
          itemLabelName: "Sleeveless Tops & Waistcoats",
          itemSingleName: "Vest & Tank Top"
        },
        l_ca: {
          nameForCatModal: "Vest tops & Sleeveless",
          groupName: undefined,
          itemLabelName: "Vest tops & Sleeveless",
          itemSingleName: "Vest & Tank Top"
        },
        l_ru: {
          nameForCatModal: "Майки",
          groupName: undefined,
          itemLabelName: "Майки",
          itemSingleName: "Жилет и майка"
        },
        l_jp: {
          nameForCatModal: "ベスト＆タンクトップ",
          groupName: undefined,
          itemLabelName: "ベスト＆タンクトップ",
          itemSingleName: "ベスト＆タンクトップ"
        },
        l_it: {
          nameForCatModal: "Gilet e Canottiere",
          groupName: undefined,
          itemLabelName: "Gilet e Canottiere",
          itemSingleName: "Gilet e canottiera"
        },
        l_es: {
          nameForCatModal: "Camisetas sin mangas",
          groupName: undefined,
          itemLabelName: "Camisetas sin mangas",
          itemSingleName: "Chaleco y camiseta de tirantes"
        },
        l_de: {
          nameForCatModal: "Westen & Tanktops",
          groupName: undefined,
          itemLabelName: "Westen & Tanktops",
          itemSingleName: "Weste & Tanktop"
        },
        l_cn: {
          nameForCatModal: "背心&吊带",
          groupName: undefined,
          itemLabelName: "背心&吊带",
          itemSingleName: "马甲和背心"
        },
        l_fr: {
          nameForCatModal: "Gilets et débardeurs",
          groupName: undefined,
          itemLabelName: "Gilets et débardeurs",
          itemSingleName: "Gilet et débardeur"
        }
      },
      shirts: {
        context: "앞이 트인 상의의 범주",
        l_kr: {
          nameForCatModal: "셔츠 & 블라우스",
          groupName: undefined,
          itemLabelName: "셔츠 & 블라우스",
          itemSingleName: "셔츠 & 블라우스"
        },
        l_us: {
          nameForCatModal: "Shirts & Blouses",
          groupName: undefined,
          itemLabelName: "Shirts & Blouses",
          itemSingleName: "Shirt & Blouse"
        },
        l_gb: {
          nameForCatModal: "Shirts & Blouses",
          groupName: undefined,
          itemLabelName: "Shirts & Blouses",
          itemSingleName: "Shirt & Blouse"
        },
        l_ca: {
          nameForCatModal: "Shirts & Blouses",
          groupName: undefined,
          itemLabelName: "Shirts & Blouses",
          itemSingleName: "Shirt & Blouse"
        },
        l_ru: {
          nameForCatModal: "Рубашки и блузки",
          groupName: undefined,
          itemLabelName: "Рубашки и блузки",
          itemSingleName: "Рубашка и блузка"
        },
        l_jp: {
          nameForCatModal: "シャツ＆ブラウス",
          groupName: undefined,
          itemLabelName: "シャツ＆ブラウス",
          itemSingleName: "シャツ＆ブラウス"
        },
        l_it: {
          nameForCatModal: "Camicie e Bluse",
          groupName: undefined,
          itemLabelName: "Camicie e Bluse",
          itemSingleName: "Camicia e camicetta"
        },
        l_es: {
          nameForCatModal: "Camisas y blusas",
          groupName: undefined,
          itemLabelName: "Camisas y blusas",
          itemSingleName: "Camisa y blusa"
        },
        l_de: {
          nameForCatModal: "Hemden & Blusen",
          groupName: undefined,
          itemLabelName: "Hemden & Blusen",
          itemSingleName: "Hemd & Bluse"
        },
        l_cn: {
          nameForCatModal: "衬衫&雪纺衫",
          groupName: undefined,
          itemLabelName: "衬衫&雪纺衫",
          itemSingleName: "衬衫和女衬衫"
        },
        l_fr: {
          nameForCatModal: "Chemises et blouses",
          groupName: undefined,
          itemLabelName: "Chemises et blouses",
          itemSingleName: "Chemise & blouse"
        }
      },
      sweatshirtsgrp: {
        context: "운동 목적의 상의의 범주",
        l_kr: {
          nameForCatModal: "후디 & 스웨트셔츠",
          groupName: "후디 & 스웨트셔츠 전체",
          itemLabelName: "후디 & 스웨트셔츠 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Sweatshirts & Hoodies",
          groupName: "All Sweatshirts & Hoodies",
          itemLabelName: "All Sweatshirts & Hoodies",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Sweatshirts & Hooded Top",
          groupName: "All Sweatshirts & Hooded Top",
          itemLabelName: "All Sweatshirts & Hooded Top",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Sweatshirts & Hoodies",
          groupName: "All Sweatshirts & Hoodies",
          itemLabelName: "All Sweatshirts & Hoodies",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Свитшоты и худи",
          groupName: "Все свитшоты и худи",
          itemLabelName: "Все свитшоты и худи",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "パーカー＆スウェットシャツ",
          groupName: "パーカー＆スウェットシャツすべて",
          itemLabelName: "パーカー＆スウェットシャツすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Felpe e Felpe con Cappuccio",
          groupName: "Tutte le Felpe e Felpe con Cappuccio",
          itemLabelName: "Tutte le Felpe e Felpe con Cappuccio",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Sudaderas sin y con capucha",
          groupName: "Todas las sudaderas sin y con capucha",
          itemLabelName: "Todas las sudaderas sin y con capucha",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Sweatshirts & Hoodies",
          groupName: "Alle Sweatshirts & Hoodies",
          itemLabelName: "Alle Sweatshirts & Hoodies",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "连帽卫衣&卫衣",
          groupName: "全部连帽卫衣&卫衣",
          itemLabelName: "全部连帽卫衣&卫衣",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Sweats et sweats à capuche",
          groupName: "Tous les sweats et sweats à capuche",
          itemLabelName: "Tous les sweats et sweats à capuche",
          itemSingleName: undefined
        }
      },
      sweatshirts: {
        context: "모자가 없는 운동용 상의의 범주",
        l_kr: {
          nameForCatModal: "스웨트셔츠",
          groupName: undefined,
          itemLabelName: "스웨트셔츠",
          itemSingleName: "스웨트셔츠"
        },
        l_us: {
          nameForCatModal: "Sweatshirts",
          groupName: undefined,
          itemLabelName: "Sweatshirts",
          itemSingleName: "Sweatshirt"
        },
        l_gb: {
          nameForCatModal: "Sweatshirts",
          groupName: undefined,
          itemLabelName: "Sweatshirts",
          itemSingleName: "Sweatshirt"
        },
        l_ca: {
          nameForCatModal: "Sweatshirts",
          groupName: undefined,
          itemLabelName: "Sweatshirts",
          itemSingleName: "Sweatshirt"
        },
        l_ru: {
          nameForCatModal: "Свитшоты",
          groupName: undefined,
          itemLabelName: "Свитшоты",
          itemSingleName: "Толстовка"
        },
        l_jp: {
          nameForCatModal: "スウェットシャツ",
          groupName: undefined,
          itemLabelName: "スウェットシャツ",
          itemSingleName: "スウェットシャツ"
        },
        l_it: {
          nameForCatModal: "Felpe",
          groupName: undefined,
          itemLabelName: "Felpe",
          itemSingleName: "Felpa"
        },
        l_es: {
          nameForCatModal: "Sudaderas",
          groupName: undefined,
          itemLabelName: "Sudaderas",
          itemSingleName: "Sudadera"
        },
        l_de: {
          nameForCatModal: "Sweatshirts",
          groupName: undefined,
          itemLabelName: "Sweatshirts",
          itemSingleName: "Sweatshirt"
        },
        l_cn: {
          nameForCatModal: "卫衣",
          groupName: undefined,
          itemLabelName: "卫衣",
          itemSingleName: "卫衣"
        },
        l_fr: {
          nameForCatModal: "Sweatshirts",
          groupName: undefined,
          itemLabelName: "Sweatshirts",
          itemSingleName: "Sweat-shirt"
        }
      },
      hoodies: {
        context: "모자가 달려있는 운동용 상의의 범주",
        l_kr: {
          nameForCatModal: "후드 스웨트셔츠",
          groupName: undefined,
          itemLabelName: "후드 스웨트셔츠",
          itemSingleName: "후드 스웨트셔츠"
        },
        l_us: {
          nameForCatModal: "Hoodies",
          groupName: undefined,
          itemLabelName: "Hoodies",
          itemSingleName: "Hoodie"
        },
        l_gb: {
          nameForCatModal: "Hooded Top",
          groupName: undefined,
          itemLabelName: "Hooded Top",
          itemSingleName: "Hoodie"
        },
        l_ca: {
          nameForCatModal: "Hoodies",
          groupName: undefined,
          itemLabelName: "Hoodies",
          itemSingleName: "Hoodie"
        },
        l_ru: {
          nameForCatModal: "Худи",
          groupName: undefined,
          itemLabelName: "Худи",
          itemSingleName: "Худи"
        },
        l_jp: {
          nameForCatModal: "パーカー",
          groupName: undefined,
          itemLabelName: "パーカー",
          itemSingleName: "フーディ"
        },
        l_it: {
          nameForCatModal: "Felpe con Cappuccio",
          groupName: undefined,
          itemLabelName: "Felpe con Cappuccio",
          itemSingleName: "Felpa con cappuccio"
        },
        l_es: {
          nameForCatModal: "Sudaderas con capucha",
          groupName: undefined,
          itemLabelName: "Sudaderas con capucha",
          itemSingleName: "Sudadera con capucha"
        },
        l_de: {
          nameForCatModal: "Hoodies",
          groupName: undefined,
          itemLabelName: "Hoodies",
          itemSingleName: "Kapuzenpullover"
        },
        l_cn: {
          nameForCatModal: "连帽卫衣",
          groupName: undefined,
          itemLabelName: "连帽卫衣",
          itemSingleName: "连帽卫衣"
        },
        l_fr: {
          nameForCatModal: "Sweats à capuche",
          groupName: undefined,
          itemLabelName: "Sweats à capuche",
          itemSingleName: "Sweat à capuche"
        }
      },
      bottomsgrp: {
        context: "하반신에 착장하는 의류의 범주",
        l_kr: {
          nameForCatModal: "하의",
          groupName: "하의 전체",
          itemLabelName: "하의 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Bottoms",
          groupName: "All Bottoms",
          itemLabelName: "All Bottoms",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Bottoms",
          groupName: "All Bottoms",
          itemLabelName: "All Bottoms",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Bottoms",
          groupName: "All Bottoms",
          itemLabelName: "All Bottoms",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Брюки и юбки",
          groupName: "Все брюки и юбки",
          itemLabelName: "Все брюки и юбки",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "ボトムス",
          groupName: "ボトムスすべて",
          itemLabelName: "ボトムスすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Gonne e Pantaloni",
          groupName: "Tutte le Gonne e Pantaloni",
          itemLabelName: "Tutte le Gonne e Pantaloni",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Prendas inferiores",
          groupName: "Todas las prendas inferiores",
          itemLabelName: "Todas las prendas inferiores",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Unterteile",
          groupName: "Alle Unterteile",
          itemLabelName: "Alle Unterteile",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "下装",
          groupName: "全部下装",
          itemLabelName: "全部下装",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Pantalons et jupes",
          groupName: "Tous les pantalons et jupes",
          itemLabelName: "Tous les pantalons et jupes",
          itemSingleName: undefined
        }
      },
      pantsgrp: {
        context: "양쪽으로 다리가 들어갈 수 있는 구조의 하의의 범주",
        l_kr: {
          nameForCatModal: "바지",
          groupName: "바지 전체",
          itemLabelName: "바지 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Pants",
          groupName: "All Pants",
          itemLabelName: "All Pants",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Trousers",
          groupName: "All Trousers",
          itemLabelName: "All Trousers",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Pants",
          groupName: "All Pants",
          itemLabelName: "All Pants",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Брюки",
          groupName: "Все брюки",
          itemLabelName: "Все брюки",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "パンツ",
          groupName: "パンツすべて",
          itemLabelName: "パンツすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Pantaloni",
          groupName: "Tutti i Pantaloni",
          itemLabelName: "Tutti i Pantaloni",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Pantalones",
          groupName: "Todos los pantalones",
          itemLabelName: "Todos los pantalones",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Hosen",
          groupName: "Alle Hosen",
          itemLabelName: "Alle Hosen",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "裤子",
          groupName: "全部裤子",
          itemLabelName: "全部裤子",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Pantalons",
          groupName: "Tous les pantalons",
          itemLabelName: "Tous les pantalons",
          itemSingleName: undefined
        }
      },
      dresspants: {
        context: "비즈니스용 수트의 바지의 범주",
        l_kr: {
          nameForCatModal: "슬랙스 (정장 바지)",
          groupName: undefined,
          itemLabelName: "슬랙스 (정장 바지)",
          itemSingleName: "슬랙스 (정장 바지)"
        },
        l_us: {
          nameForCatModal: "Tailored Pants (Slacks)",
          groupName: undefined,
          itemLabelName: "Tailored Pants (Slacks)",
          itemSingleName: "Tailored Pants (Slacks)"
        },
        l_gb: {
          nameForCatModal: "Tailored Trousers",
          groupName: undefined,
          itemLabelName: "Tailored Trousers",
          itemSingleName: "Tailored Pants (Slacks)"
        },
        l_ca: {
          nameForCatModal: "Suit Pants (Slacks)",
          groupName: undefined,
          itemLabelName: "Suit Pants (Slacks)",
          itemSingleName: "Tailored Pants (Slacks)"
        },
        l_ru: {
          nameForCatModal: "Строгие брюки",
          groupName: undefined,
          itemLabelName: "Строгие брюки",
          itemSingleName: "Классические брюки"
        },
        l_jp: {
          nameForCatModal: "スラックス（パンツスーツ）",
          groupName: undefined,
          itemLabelName: "スラックス（パンツスーツ）",
          itemSingleName: "スラックス（スーツパンツ）"
        },
        l_it: {
          nameForCatModal: "Pantaloni Eleganti",
          groupName: undefined,
          itemLabelName: "Pantaloni Eleganti",
          itemSingleName: "Pantaloni sartoriali"
        },
        l_es: {
          nameForCatModal: "Pantalones de vestir",
          groupName: undefined,
          itemLabelName: "Pantalones de vestir",
          itemSingleName: "Pantalones de vestir"
        },
        l_de: {
          nameForCatModal: "Slacks",
          groupName: undefined,
          itemLabelName: "Slacks",
          itemSingleName: "Anzughose"
        },
        l_cn: {
          nameForCatModal: "西装裤",
          groupName: undefined,
          itemLabelName: "西装裤",
          itemSingleName: "西装裤"
        },
        l_fr: {
          nameForCatModal: "Pantalons de costume",
          groupName: undefined,
          itemLabelName: "Pantalons de costume",
          itemSingleName: "Pantalon habillé"
        }
      },
      jeans: {
        context: "데님 소재 바지의 범주",
        l_kr: {
          nameForCatModal: "청바지",
          groupName: undefined,
          itemLabelName: "청바지",
          itemSingleName: "청바지"
        },
        l_us: {
          nameForCatModal: "Jeans",
          groupName: undefined,
          itemLabelName: "Jeans",
          itemSingleName: "Jeans"
        },
        l_gb: {
          nameForCatModal: "Jeans",
          groupName: undefined,
          itemLabelName: "Jeans",
          itemSingleName: "Jeans"
        },
        l_ca: {
          nameForCatModal: "Jeans",
          groupName: undefined,
          itemLabelName: "Jeans",
          itemSingleName: "Jeans"
        },
        l_ru: {
          nameForCatModal: "Джинсы",
          groupName: undefined,
          itemLabelName: "Джинсы",
          itemSingleName: "Джинсы"
        },
        l_jp: {
          nameForCatModal: "ジーンズ",
          groupName: undefined,
          itemLabelName: "ジーンズ",
          itemSingleName: "ジーンズ"
        },
        l_it: {
          nameForCatModal: "Jeans",
          groupName: undefined,
          itemLabelName: "Jeans",
          itemSingleName: "Jeans"
        },
        l_es: {
          nameForCatModal: "Vaqueros",
          groupName: undefined,
          itemLabelName: "Vaqueros",
          itemSingleName: "Vaqueros"
        },
        l_de: {
          nameForCatModal: "Jeans",
          groupName: undefined,
          itemLabelName: "Jeans",
          itemSingleName: "Jeans"
        },
        l_cn: {
          nameForCatModal: "牛仔裤",
          groupName: undefined,
          itemLabelName: "牛仔裤",
          itemSingleName: "牛仔裤"
        },
        l_fr: {
          nameForCatModal: "Jeans",
          groupName: undefined,
          itemLabelName: "Jeans",
          itemSingleName: "Jean"
        }
      },
      leggingsgrp: {
        context: "발 부분이 없는 타이츠 모양의 바지의 범주",
        l_kr: {
          nameForCatModal: "레깅스",
          groupName: "레깅스 전체",
          itemLabelName: "레깅스 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Leggings & Shorts",
          groupName: "All Leggings & Shorts",
          itemLabelName: "All Leggings & Shorts",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Leggings & Shorts",
          groupName: "All Leggings & Shorts",
          itemLabelName: "All Leggings & Shorts",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Leggings & Shorts",
          groupName: "All Leggings & Shorts",
          itemLabelName: "All Leggings & Shorts",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Леггинсы",
          groupName: "Все леггинсы",
          itemLabelName: "Все леггинсы",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "レギンス＆ショーツ",
          groupName: "レギンス＆ショーツすべて",
          itemLabelName: "レギンス＆ショーツすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Leggings",
          groupName: "Tutti i Leggings",
          itemLabelName: "Tutti i Leggings",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Leggings",
          groupName: "Todos los leggings",
          itemLabelName: "Todos los leggings",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Leggings & Kurze Hosen",
          groupName: "Alle Leggins & Kurze Hosen",
          itemLabelName: "Alle Leggins & Kurze Hosen",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "打底裤&打底短裤",
          groupName: "全部打底裤&打底短裤",
          itemLabelName: "全部打底裤&打底短裤",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Leggings et shorts",
          groupName: "Tous les leggings et shorts",
          itemLabelName: "Tous les leggings et shorts",
          itemSingleName: undefined
        }
      },
      leggings: {
        context: "발 부분이 없는 타이츠 모양의 아랫단이 긴 바지의 범주",
        l_kr: {
          nameForCatModal: "레깅스",
          groupName: undefined,
          itemLabelName: "레깅스",
          itemSingleName: "레깅스"
        },
        l_us: {
          nameForCatModal: "Leggings",
          groupName: undefined,
          itemLabelName: "Leggings",
          itemSingleName: "Leggings"
        },
        l_gb: {
          nameForCatModal: "Leggings",
          groupName: undefined,
          itemLabelName: "Leggings",
          itemSingleName: "Leggings"
        },
        l_ca: {
          nameForCatModal: "Leggings",
          groupName: undefined,
          itemLabelName: "Leggings",
          itemSingleName: "Leggings"
        },
        l_ru: {
          nameForCatModal: "Леггинсы",
          groupName: undefined,
          itemLabelName: "Леггинсы",
          itemSingleName: "Леггинсы"
        },
        l_jp: {
          nameForCatModal: "レギンス",
          groupName: undefined,
          itemLabelName: "レギンス",
          itemSingleName: "レギンス"
        },
        l_it: {
          nameForCatModal: "Leggings",
          groupName: undefined,
          itemLabelName: "Leggings",
          itemSingleName: "Leggings"
        },
        l_es: {
          nameForCatModal: "Leggings",
          groupName: undefined,
          itemLabelName: "Leggings",
          itemSingleName: "Leggings"
        },
        l_de: {
          nameForCatModal: "Leggings",
          groupName: undefined,
          itemLabelName: "Leggings",
          itemSingleName: "Leggings"
        },
        l_cn: {
          nameForCatModal: "打底裤",
          groupName: undefined,
          itemLabelName: "打底裤",
          itemSingleName: "紧身裤"
        },
        l_fr: {
          nameForCatModal: "Leggings",
          groupName: undefined,
          itemLabelName: "Leggings",
          itemSingleName: "Leggings"
        }
      },
      leggingsshorts: {
        context: "발 부분이 없는 타이츠 모양의 아랫단이 짧은 바지의 범주",
        l_kr: {
          nameForCatModal: "바이커 쇼츠 (레깅스 쇼츠)",
          groupName: undefined,
          itemLabelName: "바이커 쇼츠 (레깅스 쇼츠)",
          itemSingleName: "레깅스 쇼츠"
        },
        l_us: {
          nameForCatModal: "Bike Shorts",
          groupName: undefined,
          itemLabelName: "Bike Shorts",
          itemSingleName: "Bike Shorts"
        },
        l_gb: {
          nameForCatModal: "Cycling Shorts",
          groupName: undefined,
          itemLabelName: "Cycling Shorts",
          itemSingleName: "Bike Shorts"
        },
        l_ca: {
          nameForCatModal: "Bike Shorts",
          groupName: undefined,
          itemLabelName: "Bike Shorts",
          itemSingleName: "Bike Shorts"
        },
        l_ru: {
          nameForCatModal: "Велосипедки",
          groupName: undefined,
          itemLabelName: "Велосипедки",
          itemSingleName: "Велосипедки"
        },
        l_jp: {
          nameForCatModal: "バイカーショーツ",
          groupName: undefined,
          itemLabelName: "バイカーショーツ",
          itemSingleName: "バイクショーツ"
        },
        l_it: {
          nameForCatModal: "Leggings Corti",
          groupName: undefined,
          itemLabelName: "Leggings Corti",
          itemSingleName: "Pantaloncini da bici"
        },
        l_es: {
          nameForCatModal: "Leggings cortos",
          groupName: undefined,
          itemLabelName: "Leggings cortos",
          itemSingleName: "Pantalones cortos de ciclista"
        },
        l_de: {
          nameForCatModal: "Radlerhosen",
          groupName: undefined,
          itemLabelName: "Radlerhosen",
          itemSingleName: "Radlerhose"
        },
        l_cn: {
          nameForCatModal: "打底短裤",
          groupName: undefined,
          itemLabelName: "打底短裤",
          itemSingleName: "骑行短裤"
        },
        l_fr: {
          nameForCatModal: "Biker shorts",
          groupName: undefined,
          itemLabelName: "Biker shorts",
          itemSingleName: "Short cycliste"
        }
      },
      trainingpantsgrp: {
        context: "운동 목적의 바지의 범주",
        l_kr: {
          nameForCatModal: "트레이닝 팬츠",
          groupName: "트레이닝 팬츠 전체",
          itemLabelName: "트레이닝 팬츠 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Track Pants & Shorts",
          groupName: "All Track Pants & Shorts",
          itemLabelName: "All Track Pants & Shorts",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Joggers & Shorts",
          groupName: "All Joggers & Shorts",
          itemLabelName: "All Joggers & Shorts",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Track Pants & Shorts",
          groupName: "All Track Pants & Shorts",
          itemLabelName: "All Track Pants & Shorts",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Спортивные брюки и шорты",
          groupName: "Все спортивные брюки и шорты",
          itemLabelName: "Все спортивные брюки и шорты",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "トレーニングパンツ＆ショーツ",
          groupName: "トレーニングパンツ＆ショーツすべて",
          itemLabelName: "トレーニングパンツ＆ショーツすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Pantaloni e Pantaloncini Sportivi",
          groupName: "Tutti i Pantaloni e Pantaloncini Sportivi",
          itemLabelName: "Tutti i Pantaloni e Pantaloncini Sportivi",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Pantalones deportivos largos y cortos",
          groupName: "Todos los pantalones deportivos largos y cortos",
          itemLabelName: "Todos los pantalones deportivos largos y cortos",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Trainingshosen & Sportshorts",
          groupName: "Alle Trainingshosen & Sportshorts",
          itemLabelName: "Alle Trainingshosen & Sportshorts",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "运动裤&运动短裤",
          groupName: "全部运动裤&运动短裤",
          itemLabelName: "全部运动裤&运动短裤",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Pantalons et shorts de sport",
          groupName: "Tous les pantalons et shorts de sport",
          itemLabelName: "Tous les pantalons et shorts de sport",
          itemSingleName: undefined
        }
      },
      trainingpants: {
        context: "운동 목적의 아랫단이 긴 바지의 범주",
        l_kr: {
          nameForCatModal: "트레이닝 팬츠",
          groupName: undefined,
          itemLabelName: "트레이닝 팬츠",
          itemSingleName: "트레이닝 팬츠"
        },
        l_us: {
          nameForCatModal: "Track Pants",
          groupName: undefined,
          itemLabelName: "Track Pants",
          itemSingleName: "Track Pants"
        },
        l_gb: {
          nameForCatModal: "Joggers",
          groupName: undefined,
          itemLabelName: "Joggers",
          itemSingleName: "Track Pants"
        },
        l_ca: {
          nameForCatModal: "Track Pants",
          groupName: undefined,
          itemLabelName: "Track Pants",
          itemSingleName: "Track Pants"
        },
        l_ru: {
          nameForCatModal: "Спортивные брюки",
          groupName: undefined,
          itemLabelName: "Спортивные брюки",
          itemSingleName: "Спортивные штаны"
        },
        l_jp: {
          nameForCatModal: "トレーニングパンツ",
          groupName: undefined,
          itemLabelName: "トレーニングパンツ",
          itemSingleName: "トラックパンツ"
        },
        l_it: {
          nameForCatModal: "Pantaloni Sportivi",
          groupName: undefined,
          itemLabelName: "Pantaloni Sportivi",
          itemSingleName: "Pantaloni da allenamento"
        },
        l_es: {
          nameForCatModal: "Pantalones deportivos",
          groupName: undefined,
          itemLabelName: "Pantalones deportivos",
          itemSingleName: "Pantalones de chándal"
        },
        l_de: {
          nameForCatModal: "Trainingshosen",
          groupName: undefined,
          itemLabelName: "Trainingshosen",
          itemSingleName: "Jogginghose"
        },
        l_cn: {
          nameForCatModal: "运动裤",
          groupName: undefined,
          itemLabelName: "运动裤",
          itemSingleName: "运动裤"
        },
        l_fr: {
          nameForCatModal: "Pantalons de sport",
          groupName: undefined,
          itemLabelName: "Pantalons de sport",
          itemSingleName: "Pantalon de survêtement"
        }
      },
      trainingshorts: {
        context: "운동 목적의 아랫단이 짧은 바지의 범주",
        l_kr: {
          nameForCatModal: "트레이닝 반바지",
          groupName: undefined,
          itemLabelName: "트레이닝 반바지",
          itemSingleName: "트레이닝 반바지"
        },
        l_us: {
          nameForCatModal: "Track Shorts",
          groupName: undefined,
          itemLabelName: "Track Shorts",
          itemSingleName: "Track Shorts"
        },
        l_gb: {
          nameForCatModal: "Running Shorts",
          groupName: undefined,
          itemLabelName: "Running Shorts",
          itemSingleName: "Track Shorts"
        },
        l_ca: {
          nameForCatModal: "Track Shorts",
          groupName: undefined,
          itemLabelName: "Track Shorts",
          itemSingleName: "Track Shorts"
        },
        l_ru: {
          nameForCatModal: "Спортивные шорты",
          groupName: undefined,
          itemLabelName: "Спортивные шорты",
          itemSingleName: "Спортивные шорты"
        },
        l_jp: {
          nameForCatModal: "トレーニングハーフパンツ",
          groupName: undefined,
          itemLabelName: "トレーニングハーフパンツ",
          itemSingleName: "トラックショーツ"
        },
        l_it: {
          nameForCatModal: "Pantaloncini Sportivi",
          groupName: undefined,
          itemLabelName: "Pantaloncini Sportivi",
          itemSingleName: "Pantaloncini da allenamento"
        },
        l_es: {
          nameForCatModal: "Pantalones cortos deportivos",
          groupName: undefined,
          itemLabelName: "Pantalones cortos deportivos",
          itemSingleName: "Pantalones cortos de chándal"
        },
        l_de: {
          nameForCatModal: "Sportshorts",
          groupName: undefined,
          itemLabelName: "Sportshorts",
          itemSingleName: "Jogging-Shorts"
        },
        l_cn: {
          nameForCatModal: "运动短裤",
          groupName: undefined,
          itemLabelName: "运动短裤",
          itemSingleName: "运动短裤"
        },
        l_fr: {
          nameForCatModal: "Shorts de sport",
          groupName: undefined,
          itemLabelName: "Shorts de sport",
          itemSingleName: "Short de jogging"
        }
      },
      regularpantsgrp: {
        context: "그외의 일반적인 바지의 범주",
        l_kr: {
          nameForCatModal: "기타 바지",
          groupName: "기타 바지 전체",
          itemLabelName: "일반 바지 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Other Pants",
          groupName: "All Other Pants",
          itemLabelName: "All Regular Pants",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Other Trousers",
          groupName: "All Other Trousers",
          itemLabelName: "All Regular Trousers",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Other Pants",
          groupName: "All Other Pants",
          itemLabelName: "All Regular Pants",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Другие брюки",
          groupName: "Все другие брюки",
          itemLabelName: "Все обычные брюки",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "その他パンツ",
          groupName: "その他パンツすべて",
          itemLabelName: "一般パンツすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Altri Pantaloni",
          groupName: "Tutti gli Altri Pantaloni",
          itemLabelName: "Tutti i Pantaloni Normale",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Otros pantalones",
          groupName: "Todos otros Pantalones",
          itemLabelName: "Todos los pantalones normales",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Andere Hosen",
          groupName: "Alle anderen Hosen",
          itemLabelName: "Alle normalen Hosen",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "其他裤子",
          groupName: "其他全部裤子",
          itemLabelName: "全部一般裤子",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Autres pantalons",
          groupName: "Tous les autres pantalons",
          itemLabelName: "Tous les pantalons basiques",
          itemSingleName: undefined
        }
      },
      regularpants: {
        context: "그외의 일반적인 아랫단이 긴 바지의 범주",
        l_kr: {
          nameForCatModal: "기타 바지",
          groupName: undefined,
          itemLabelName: "일반 바지",
          itemSingleName: "바지"
        },
        l_us: {
          nameForCatModal: "Other Pants",
          groupName: undefined,
          itemLabelName: "Regular Pants",
          itemSingleName: "Pants"
        },
        l_gb: {
          nameForCatModal: "Other Trousers",
          groupName: undefined,
          itemLabelName: "Regular Trousers",
          itemSingleName: "Pants"
        },
        l_ca: {
          nameForCatModal: "Other Pants",
          groupName: undefined,
          itemLabelName: "Regular Pants",
          itemSingleName: "Pants"
        },
        l_ru: {
          nameForCatModal: "Другие брюки",
          groupName: undefined,
          itemLabelName: "Обычные брюки",
          itemSingleName: "Брюки"
        },
        l_jp: {
          nameForCatModal: "その他パンツ",
          groupName: undefined,
          itemLabelName: "一般パンツ",
          itemSingleName: "パンツ"
        },
        l_it: {
          nameForCatModal: "Altri Pantaloni",
          groupName: undefined,
          itemLabelName: "Pantaloni Normale",
          itemSingleName: "Pantaloni"
        },
        l_es: {
          nameForCatModal: "Otros pantalones",
          groupName: undefined,
          itemLabelName: "Pantalones normales",
          itemSingleName: "Pantalones"
        },
        l_de: {
          nameForCatModal: "Andere Hosen",
          groupName: undefined,
          itemLabelName: "Normale Hosen",
          itemSingleName: "Hose"
        },
        l_cn: {
          nameForCatModal: "其他裤子",
          groupName: undefined,
          itemLabelName: "一般裤子",
          itemSingleName: "裤子"
        },
        l_fr: {
          nameForCatModal: "Autres pantalons",
          groupName: undefined,
          itemLabelName: "Pantalons basiques",
          itemSingleName: "Pantalon"
        }
      },
      regularshorts: {
        context: "그외의 일반적인 아랫단이 짧은 바지의 범주",
        l_kr: {
          nameForCatModal: "기타 반바지",
          groupName: undefined,
          itemLabelName: "일반 반바지",
          itemSingleName: "반바지"
        },
        l_us: {
          nameForCatModal: "Other Shorts",
          groupName: undefined,
          itemLabelName: "Regular Shorts",
          itemSingleName: "Shorts"
        },
        l_gb: {
          nameForCatModal: "Other Shorts",
          groupName: undefined,
          itemLabelName: "Regular Shorts",
          itemSingleName: "Shorts"
        },
        l_ca: {
          nameForCatModal: "Other Shorts",
          groupName: undefined,
          itemLabelName: "Regular Shorts",
          itemSingleName: "Shorts"
        },
        l_ru: {
          nameForCatModal: "Другие шорты",
          groupName: undefined,
          itemLabelName: "Обычные шорты",
          itemSingleName: "Шорты"
        },
        l_jp: {
          nameForCatModal: "その他ハーフパンツ",
          groupName: undefined,
          itemLabelName: "一般ハーフパンツ",
          itemSingleName: "ショートパンツ"
        },
        l_it: {
          nameForCatModal: "Altri Pantaloncini",
          groupName: undefined,
          itemLabelName: "Pantaloncini Normale",
          itemSingleName: "Pantaloncini"
        },
        l_es: {
          nameForCatModal: "Otros pantalones cortos",
          groupName: undefined,
          itemLabelName: "Pantalones cortos normales",
          itemSingleName: "Pantalones cortos"
        },
        l_de: {
          nameForCatModal: "Andere kurze Hosen",
          groupName: undefined,
          itemLabelName: "Normale kurze Hosen",
          itemSingleName: "Shorts"
        },
        l_cn: {
          nameForCatModal: "其他短裤",
          groupName: undefined,
          itemLabelName: "一般短裤",
          itemSingleName: "短裤"
        },
        l_fr: {
          nameForCatModal: "Autres shorts",
          groupName: undefined,
          itemLabelName: "Shorts basiques",
          itemSingleName: "Shorts"
        }
      },
      skirtsgrp: {
        context: "허리에 걸쳐 하반신을 덮는 원통형 의류의 범주",
        l_kr: {
          nameForCatModal: "스커트",
          groupName: "스커트 전체",
          itemLabelName: "스커트 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Skirts",
          groupName: "All Skirts",
          itemLabelName: "All Skirts",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Skirts",
          groupName: "All Skirts",
          itemLabelName: "All Skirts",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Skirts",
          groupName: "All Skirts",
          itemLabelName: "All Skirts",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Юбки",
          groupName: "Все юбки",
          itemLabelName: "Все юбки",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "スカート",
          groupName: "スカートすべて",
          itemLabelName: "スカートすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Gonne",
          groupName: "Tutte le Gonne",
          itemLabelName: "Tutte le Gonne",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Faldas",
          groupName: "Todas las faldas",
          itemLabelName: "Todas las faldas",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Röcke",
          groupName: "Alle Röcke",
          itemLabelName: "Alle Röcke",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "裙子",
          groupName: "全部裙子",
          itemLabelName: "全部裙子",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Jupes",
          groupName: "Toutes les jupes",
          itemLabelName: "Toutes les jupes",
          itemSingleName: undefined
        }
      },
      regularshortskirts: {
        context: "무릎 위 길이의 치마의 범주",
        l_kr: {
          nameForCatModal: "스커트 (무릎 위)",
          groupName: undefined,
          itemLabelName: "스커트 (무릎 위)",
          itemSingleName: "스커트"
        },
        l_us: {
          nameForCatModal: "Skirts (Above the Knee)",
          groupName: undefined,
          itemLabelName: "Skirts (Above the Knee)",
          itemSingleName: "Skirt"
        },
        l_gb: {
          nameForCatModal: "Skirts (Above the Knee)",
          groupName: undefined,
          itemLabelName: "Skirts (Above the Knee)",
          itemSingleName: "Skirt"
        },
        l_ca: {
          nameForCatModal: "Skirts (Above the Knee)",
          groupName: undefined,
          itemLabelName: "Skirts (Above the Knee)",
          itemSingleName: "Skirt"
        },
        l_ru: {
          nameForCatModal: "Юбки (выше колена)",
          groupName: undefined,
          itemLabelName: "Юбки (выше колена)",
          itemSingleName: "Юбка"
        },
        l_jp: {
          nameForCatModal: "スカート（膝上）",
          groupName: undefined,
          itemLabelName: "スカート（膝上）",
          itemSingleName: "スカート"
        },
        l_it: {
          nameForCatModal: "Gonne (Sopra il Ginocchio)",
          groupName: undefined,
          itemLabelName: "Gonne (Sopra il Ginocchio)",
          itemSingleName: "Gonna"
        },
        l_es: {
          nameForCatModal: "Faldas (por encima de la rodilla)",
          groupName: undefined,
          itemLabelName: "Faldas (por encima de la rodilla)",
          itemSingleName: "Falda"
        },
        l_de: {
          nameForCatModal: "Röcke (oberhalb der Knie)",
          groupName: undefined,
          itemLabelName: "Röcke (oberhalb der Knie)",
          itemSingleName: "Rock"
        },
        l_cn: {
          nameForCatModal: "裙子（膝盖以上）",
          groupName: undefined,
          itemLabelName: "裙子（膝盖以上）",
          itemSingleName: "裙子"
        },
        l_fr: {
          nameForCatModal: "Jupes (au-dessus du genou)",
          groupName: undefined,
          itemLabelName: "Jupes (au-dessus du genou)",
          itemSingleName: "Jupe"
        }
      },
      regularlongskirts: {
        context: "무릎을 덮는 길이의 치마의 범주",
        l_kr: {
          nameForCatModal: "스커트 (무릎 아래)",
          groupName: undefined,
          itemLabelName: "스커트 (무릎 아래)",
          itemSingleName: "스커트"
        },
        l_us: {
          nameForCatModal: "Skirts (Below the Knee)",
          groupName: undefined,
          itemLabelName: "Skirts (Below the Knee)",
          itemSingleName: "Skirt"
        },
        l_gb: {
          nameForCatModal: "Skirts (Below the Knee)",
          groupName: undefined,
          itemLabelName: "Skirts (Below the Knee)",
          itemSingleName: "Skirt"
        },
        l_ca: {
          nameForCatModal: "Skirts (Below the Knee)",
          groupName: undefined,
          itemLabelName: "Skirts (Below the Knee)",
          itemSingleName: "Skirt"
        },
        l_ru: {
          nameForCatModal: "Юбки (ниже колена)",
          groupName: undefined,
          itemLabelName: "Юбки (ниже колена)",
          itemSingleName: "Юбка"
        },
        l_jp: {
          nameForCatModal: "スカート（膝下）",
          groupName: undefined,
          itemLabelName: "スカート（膝下）",
          itemSingleName: "スカート"
        },
        l_it: {
          nameForCatModal: "Gonne (Sotto il Ginocchio)",
          groupName: undefined,
          itemLabelName: "Gonne (Sotto il Ginocchio)",
          itemSingleName: "Gonna"
        },
        l_es: {
          nameForCatModal: "Faldas (por debajo de la rodilla)",
          groupName: undefined,
          itemLabelName: "Faldas (por debajo de la rodilla)",
          itemSingleName: "Falda"
        },
        l_de: {
          nameForCatModal: "Röcke (unterhalb der Knie)",
          groupName: undefined,
          itemLabelName: "Röcke (unterhalb der Knie)",
          itemSingleName: "Rock"
        },
        l_cn: {
          nameForCatModal: "裙子（膝盖以下）",
          groupName: undefined,
          itemLabelName: "裙子（膝盖以下）",
          itemSingleName: "裙子"
        },
        l_fr: {
          nameForCatModal: "Jupes (sous le genou)",
          groupName: undefined,
          itemLabelName: "Jupes (sous le genou)",
          itemSingleName: "Jupe"
        }
      },
      allinonesgrp: {
        context: "상반신과 하반신을 모두 덮는 의류의 범주",
        l_kr: {
          nameForCatModal: "올인원",
          groupName: "올인원 전체",
          itemLabelName: "올인원 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "All-In-Ones",
          groupName: "All All-In-Ones",
          itemLabelName: "All All-In-Ones",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "All-In-Ones",
          groupName: "All All-In-Ones",
          itemLabelName: "All All-In-Ones",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "All-In-Ones",
          groupName: "All All-In-Ones",
          itemLabelName: "All All-In-Ones",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Цельная одежда",
          groupName: "Вся цельная одежда",
          itemLabelName: "Вся цельная одежда",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "オールインワン＆ワンピース",
          groupName: "オールインワン＆ワンピースすべて",
          itemLabelName: "オールインワン＆ワンピースすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Vestiti Interi",
          groupName: "Tutti i Vestiti Interi",
          itemLabelName: "Tutti i Vestiti Interi",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Monos y vestidos",
          groupName: "Todos los monos y vestidos",
          itemLabelName: "Todos los monos y vestidos",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Einteiler & Kleider",
          groupName: "Alle Einteiler & Kleider",
          itemLabelName: "Alle Einteiler & Kleider",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "连衣裙&连体裤",
          groupName: "全部连衣裙&连体裤",
          itemLabelName: "全部连衣裙&连体裤",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Robes et combinaisons",
          groupName: "Toutes les robes et combinaisons",
          itemLabelName: "Toutes les robes et combinaisons",
          itemSingleName: undefined
        }
      },
      regulardresses: {
        context: "상의와 치마가 분리되지 않은 의류의 범주",
        l_kr: {
          nameForCatModal: "원피스",
          groupName: undefined,
          itemLabelName: "원피스",
          itemSingleName: "원피스"
        },
        l_us: {
          nameForCatModal: "Dresses",
          groupName: undefined,
          itemLabelName: "Dresses",
          itemSingleName: "Dress"
        },
        l_gb: {
          nameForCatModal: "Dresses",
          groupName: undefined,
          itemLabelName: "Dresses",
          itemSingleName: "Dress"
        },
        l_ca: {
          nameForCatModal: "Dresses",
          groupName: undefined,
          itemLabelName: "Dresses",
          itemSingleName: "Dress"
        },
        l_ru: {
          nameForCatModal: "Платья",
          groupName: undefined,
          itemLabelName: "Платья",
          itemSingleName: "Платье"
        },
        l_jp: {
          nameForCatModal: "ワンピース",
          groupName: undefined,
          itemLabelName: "ワンピース",
          itemSingleName: "ワンピース"
        },
        l_it: {
          nameForCatModal: "Vestiti",
          groupName: undefined,
          itemLabelName: "Vestiti",
          itemSingleName: "Vestito"
        },
        l_es: {
          nameForCatModal: "Vestidos",
          groupName: undefined,
          itemLabelName: "Vestidos",
          itemSingleName: "Vestido"
        },
        l_de: {
          nameForCatModal: "Kleider",
          groupName: undefined,
          itemLabelName: "Kleider",
          itemSingleName: "Kleid"
        },
        l_cn: {
          nameForCatModal: "连衣裙",
          groupName: undefined,
          itemLabelName: "连衣裙",
          itemSingleName: "连衣裙"
        },
        l_fr: {
          nameForCatModal: "Robes",
          groupName: undefined,
          itemLabelName: "Robes",
          itemSingleName: "Robe"
        }
      },
      regularjumpsuits: {
        context: "상의와 바지가 분리되지 않은 의류의 범주",
        l_kr: {
          nameForCatModal: "점프수트",
          groupName: undefined,
          itemLabelName: "점프수트",
          itemSingleName: "점프수트"
        },
        l_us: {
          nameForCatModal: "Jumpsuits",
          groupName: undefined,
          itemLabelName: "Jumpsuits",
          itemSingleName: "Jumpsuit"
        },
        l_gb: {
          nameForCatModal: "Jumpsuits",
          groupName: undefined,
          itemLabelName: "Jumpsuits",
          itemSingleName: "Jumpsuit"
        },
        l_ca: {
          nameForCatModal: "Jumpsuits",
          groupName: undefined,
          itemLabelName: "Jumpsuits",
          itemSingleName: "Jumpsuit"
        },
        l_ru: {
          nameForCatModal: "Комбинезоны",
          groupName: undefined,
          itemLabelName: "Комбинезоны",
          itemSingleName: "Комбинезон"
        },
        l_jp: {
          nameForCatModal: "ジャンプスーツ＆オーバーオール",
          groupName: undefined,
          itemLabelName: "ジャンプスーツ＆オーバーオール",
          itemSingleName: "ジャンプスーツ"
        },
        l_it: {
          nameForCatModal: "Tute",
          groupName: undefined,
          itemLabelName: "Tute",
          itemSingleName: "Tuta intera"
        },
        l_es: {
          nameForCatModal: "Monos",
          groupName: undefined,
          itemLabelName: "Monos",
          itemSingleName: "Mono"
        },
        l_de: {
          nameForCatModal: "Jumpsuits",
          groupName: undefined,
          itemLabelName: "Jumpsuits",
          itemSingleName: "Overall"
        },
        l_cn: {
          nameForCatModal: "连体裤&背带裤",
          groupName: undefined,
          itemLabelName: "连体裤&背带裤",
          itemSingleName: "连体裤"
        },
        l_fr: {
          nameForCatModal: "Combinaisons et salopettes",
          groupName: undefined,
          itemLabelName: "Combinaisons et salopettes",
          itemSingleName: "Combinaison"
        }
      },
      footweargrp: {
        context: "가죽 등으로 만든 발을 보호하는 장신구의 범주",
        l_kr: {
          nameForCatModal: "신발류",
          groupName: "신발류 전체",
          itemLabelName: "신발류 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Footwear",
          groupName: "All Footwear",
          itemLabelName: "All Footwear",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Footwear",
          groupName: "All Footwear",
          itemLabelName: "All Footwear",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Footwear",
          groupName: "All Footwear",
          itemLabelName: "All Footwear",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Обувь",
          groupName: "Вся обувь",
          itemLabelName: "Вся обувь",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "靴類",
          groupName: "靴類すべて",
          itemLabelName: "靴類すべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Calzature",
          groupName: "Tutte le Calzature",
          itemLabelName: "Tutte le Calzature",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Calzados",
          groupName: "Todos los calzados",
          itemLabelName: "Todos los calzados",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Schuhe",
          groupName: "Alle Schuhe",
          itemLabelName: "Alle Schuhe",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "鞋类",
          groupName: "全部鞋类",
          itemLabelName: "全部鞋类",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Chaussures",
          groupName: "Toutes les chaussures",
          itemLabelName: "Toutes les chaussures",
          itemSingleName: undefined
        }
      },
      sneakersgrp: {
        context: "(비격식의) 비즈니스용 구두 이외의 신발류의 범주",
        l_kr: {
          nameForCatModal: "(캐주얼) 스니커즈, 부츠",
          groupName: "(캐주얼) 스니커즈, 부츠 전체",
          itemLabelName: "(캐주얼) 스니커즈, 부츠 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "(Casual) Sneakers, Boots",
          groupName: "All (Casual) Sneakers, Boots",
          itemLabelName: "All (Casual) Sneakers, Boots",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "(Casual) Trainers, Boots",
          groupName: "All (Casual) Trainers, Boots",
          itemLabelName: "All (Casual) Trainers, Boots",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "(Casual) Sneakers, Boots",
          groupName: "All (Casual) Sneakers, Boots",
          itemLabelName: "All (Casual) Sneakers, Boots",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "(Повседневные) Кроссовки, ботинки",
          groupName: "Все кроссовки и ботинки (Повседневные)",
          itemLabelName: "Все кроссовки и ботинки (Повседневные)",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "（カジュアル）スニーカーズ、ブーツ",
          groupName: "（カジュアル）スニーカーズ、ブーツすべて",
          itemLabelName: "（カジュアル）スニーカーズ、ブーツすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Sneakers, Stivali (Casual)",
          groupName: "Tutte le Sneakers, Stivali (Casual)",
          itemLabelName: "Tutte le Sneakers, Stivali (Casual)",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Zapatillas, Botas (casuales)",
          groupName: "Todas las Zapatillas, Botas (casuales)",
          itemLabelName: "Todas las Zapatillas, Botas (casuales)",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "(Freizeit-) Turnschuhe, Stiefel",
          groupName: "Alle (Freizeit-) Turnschuhe, Stiefel",
          itemLabelName: "Alle (Freizeit-) Turnschuhe, Stiefel",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "（休闲）运动鞋，靴子",
          groupName: "全部（休闲）运动鞋，靴子",
          itemLabelName: "全部（休闲）运动鞋，靴子",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Baskets, bottes (décontracté)",
          groupName: "Tous les baskets, bottes (décontracté)",
          itemLabelName: "Tous les baskets, bottes (décontracté)",
          itemSingleName: undefined
        }
      },
      lowtops: {
        context: "발목아래 길이의 스니커즈의 범주",
        l_kr: {
          nameForCatModal: "로우 탑",
          groupName: undefined,
          itemLabelName: "로우 탑",
          itemSingleName: "로우 탑"
        },
        l_us: {
          nameForCatModal: "Low-Tops",
          groupName: undefined,
          itemLabelName: "Low-Tops",
          itemSingleName: "Low-Tops"
        },
        l_gb: {
          nameForCatModal: "Low-Tops",
          groupName: undefined,
          itemLabelName: "Low-Tops",
          itemSingleName: "Low-Tops"
        },
        l_ca: {
          nameForCatModal: "Low-Tops",
          groupName: undefined,
          itemLabelName: "Low-Tops",
          itemSingleName: "Low-Tops"
        },
        l_ru: {
          nameForCatModal: "Низкие кроссовки",
          groupName: undefined,
          itemLabelName: "Низкие кроссовки",
          itemSingleName: "Низкие кеды"
        },
        l_jp: {
          nameForCatModal: "ロートップ",
          groupName: undefined,
          itemLabelName: "ロートップ",
          itemSingleName: "ローカットスニーカー"
        },
        l_it: {
          nameForCatModal: "Scarpe Basse",
          groupName: undefined,
          itemLabelName: "Scarpe Basse",
          itemSingleName: "Scarpe basse"
        },
        l_es: {
          nameForCatModal: "Zapatillas bajas",
          groupName: undefined,
          itemLabelName: "Zapatillas bajas",
          itemSingleName: "Zapatillas bajas"
        },
        l_de: {
          nameForCatModal: "Low-Top",
          groupName: undefined,
          itemLabelName: "Low-Top",
          itemSingleName: "Low-Tops"
        },
        l_cn: {
          nameForCatModal: "低帮鞋",
          groupName: undefined,
          itemLabelName: "低帮鞋",
          itemSingleName: "低帮鞋"
        },
        l_fr: {
          nameForCatModal: "Baskets basses",
          groupName: undefined,
          itemLabelName: "Baskets basses",
          itemSingleName: "Baskets basses"
        }
      },
      hightops: {
        context: "발목을 올라오는 스니커즈의 범주",
        l_kr: {
          nameForCatModal: "하이 탑",
          groupName: undefined,
          itemLabelName: "하이 탑",
          itemSingleName: "하이 탑"
        },
        l_us: {
          nameForCatModal: "High-Tops",
          groupName: undefined,
          itemLabelName: "High-Tops",
          itemSingleName: "High-Tops"
        },
        l_gb: {
          nameForCatModal: "High-Tops",
          groupName: undefined,
          itemLabelName: "High-Tops",
          itemSingleName: "High-Tops"
        },
        l_ca: {
          nameForCatModal: "High-Tops",
          groupName: undefined,
          itemLabelName: "High-Tops",
          itemSingleName: "High-Tops"
        },
        l_ru: {
          nameForCatModal: "Высокие кроссовки",
          groupName: undefined,
          itemLabelName: "Высокие кроссовки",
          itemSingleName: "Высокие кеды"
        },
        l_jp: {
          nameForCatModal: "ハイトップ",
          groupName: undefined,
          itemLabelName: "ハイトップ",
          itemSingleName: "ハイカットスニーカー"
        },
        l_it: {
          nameForCatModal: "Scarpe Alte",
          groupName: undefined,
          itemLabelName: "Scarpe Alte",
          itemSingleName: "Scarpe alte"
        },
        l_es: {
          nameForCatModal: "Zapatillas altas",
          groupName: undefined,
          itemLabelName: "Zapatillas altas",
          itemSingleName: "Zapatillas altas"
        },
        l_de: {
          nameForCatModal: "High-Top",
          groupName: undefined,
          itemLabelName: "High-Top",
          itemSingleName: "High-Tops"
        },
        l_cn: {
          nameForCatModal: "高帮鞋",
          groupName: undefined,
          itemLabelName: "高帮鞋",
          itemSingleName: "高帮鞋"
        },
        l_fr: {
          nameForCatModal: "Baskets montantes",
          groupName: undefined,
          itemLabelName: "Baskets montantes",
          itemSingleName: "Baskets montantes"
        }
      },
      sandals: {
        context: "발등이 노출되는 스니커즈의 범주",
        l_kr: {
          nameForCatModal: "샌들 & 슬리퍼",
          groupName: undefined,
          itemLabelName: "샌들 & 슬리퍼",
          itemSingleName: "샌들 & 슬리퍼"
        },
        l_us: {
          nameForCatModal: "Sandals",
          groupName: undefined,
          itemLabelName: "Sandals",
          itemSingleName: "Sandals"
        },
        l_gb: {
          nameForCatModal: "Sandals",
          groupName: undefined,
          itemLabelName: "Sandals",
          itemSingleName: "Sandals"
        },
        l_ca: {
          nameForCatModal: "Sandals",
          groupName: undefined,
          itemLabelName: "Sandals",
          itemSingleName: "Sandals"
        },
        l_ru: {
          nameForCatModal: "Сандалии и шлепанцы",
          groupName: undefined,
          itemLabelName: "Сандалии и шлепанцы",
          itemSingleName: "Сандалии и шлёпанцы"
        },
        l_jp: {
          nameForCatModal: "サンダル＆スリッパ",
          groupName: undefined,
          itemLabelName: "サンダル＆スリッパ",
          itemSingleName: "サンダル＆スリッパ"
        },
        l_it: {
          nameForCatModal: "Sandali",
          groupName: undefined,
          itemLabelName: "Sandali",
          itemSingleName: "Sandali e ciabatte"
        },
        l_es: {
          nameForCatModal: "Sandalias",
          groupName: undefined,
          itemLabelName: "Sandalias",
          itemSingleName: "Sandalias y chanclas"
        },
        l_de: {
          nameForCatModal: "Sandalen & Slides",
          groupName: undefined,
          itemLabelName: "Sandalen & Slides",
          itemSingleName: "Sandalen & Hausschuhe"
        },
        l_cn: {
          nameForCatModal: "凉鞋&拖鞋",
          groupName: undefined,
          itemLabelName: "凉鞋&拖鞋",
          itemSingleName: "凉鞋和拖鞋"
        },
        l_fr: {
          nameForCatModal: "Sandales",
          groupName: undefined,
          itemLabelName: "Sandales",
          itemSingleName: "Sandales & chaussons"
        }
      },
      shoesgrp: {
        context: "(격식있는) 비즈니스용 수트와 함께 신는 신발류의 범주",
        l_kr: {
          nameForCatModal: "(포멀) 구두, 부츠",
          groupName: "(포멀) 구두, 부츠 전체",
          itemLabelName: "(포멀) 구두, 부츠 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "(Formal) Shoes, Boots",
          groupName: "All (Formal) Shoes, Boots",
          itemLabelName: "All (Formal) Shoes, Boots",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "(Formal) Dress Shoes, Boots",
          groupName: "All (Formal) Dress Shoes, Boots",
          itemLabelName: "All (Formal) Dress Shoes, Boots",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "(Formal) Dress Shoes, Boots",
          groupName: "All (Formal) Dress Shoes, Boots",
          itemLabelName: "All (Formal) Dress Shoes, Boots",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "(Официальные) Туфли, ботинки",
          groupName: "Все туфли и ботинки (Официальные)",
          itemLabelName: "Все туфли и ботинки (Официальные)",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "（フォーマル）ドレスシューズ、ブーツ",
          groupName: "（フォーマル）ドレスシューズ、ブーツすべて",
          itemLabelName: "（フォーマル）ドレスシューズ、ブーツすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Scarpe, Stivali (Formali)",
          groupName: "Tutte le Scarpe, Stivali (Formali)",
          itemLabelName: "Tutte le Scarpe, Stivali (Formali)",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Zapatos, Botas (formales)",
          groupName: "Todos los Zapatos, Botas (formales)",
          itemLabelName: "Todos los Zapatos, Botas (formales)",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "(Geschäfts-) Schuhe, Stiefel",
          groupName: "Alle (Geschäfts-) Schuhe, Stiefel",
          itemLabelName: "Alle (Geschäfts-) Schuhe, Stiefel",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "（正装）皮鞋，靴子",
          groupName: "全部（正装）皮鞋，靴子",
          itemLabelName: "全部（正装）皮鞋，靴子",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Chaussures de ville, bottes (formel)",
          groupName: "Toutes les chaussures de ville, bottes (formel)",
          itemLabelName: "Toutes les chaussures de ville, bottes (formel)",
          itemSingleName: undefined
        }
      },
      boots: {
        context: "발목을 덮는 구두의 범주",
        l_kr: {
          nameForCatModal: "부츠",
          groupName: undefined,
          itemLabelName: "부츠",
          itemSingleName: "부츠"
        },
        l_us: {
          nameForCatModal: "Boots",
          groupName: undefined,
          itemLabelName: "Boots",
          itemSingleName: "Boots"
        },
        l_gb: {
          nameForCatModal: "Boots",
          groupName: undefined,
          itemLabelName: "Boots",
          itemSingleName: "Boots"
        },
        l_ca: {
          nameForCatModal: "Boots",
          groupName: undefined,
          itemLabelName: "Boots",
          itemSingleName: "Boots"
        },
        l_ru: {
          nameForCatModal: "Сапоги",
          groupName: undefined,
          itemLabelName: "Сапоги",
          itemSingleName: "Ботинки"
        },
        l_jp: {
          nameForCatModal: "ブーツ",
          groupName: undefined,
          itemLabelName: "ブーツ",
          itemSingleName: "ブーツ"
        },
        l_it: {
          nameForCatModal: "Stivali",
          groupName: undefined,
          itemLabelName: "Stivali",
          itemSingleName: "Stivali"
        },
        l_es: {
          nameForCatModal: "Botas",
          groupName: undefined,
          itemLabelName: "Botas",
          itemSingleName: "Botas"
        },
        l_de: {
          nameForCatModal: "Stiefel",
          groupName: undefined,
          itemLabelName: "Stiefel",
          itemSingleName: "Stiefel"
        },
        l_cn: {
          nameForCatModal: "靴子",
          groupName: undefined,
          itemLabelName: "靴子",
          itemSingleName: "靴子"
        },
        l_fr: {
          nameForCatModal: "Bottes",
          groupName: undefined,
          itemLabelName: "Bottes",
          itemSingleName: "Bottes"
        }
      },
      shoes: {
        context: "발목아래 길이의 구두의 범주",
        l_kr: {
          nameForCatModal: "구두 & 힐",
          groupName: undefined,
          itemLabelName: "구두 & 힐",
          itemSingleName: "구두"
        },
        l_us: {
          nameForCatModal: "Dress Shoes & Heels",
          groupName: undefined,
          itemLabelName: "Dress Shoes & Heels",
          itemSingleName: "Shoes"
        },
        l_gb: {
          nameForCatModal: "Dress Shoes & Heels",
          groupName: undefined,
          itemLabelName: "Dress Shoes & Heels",
          itemSingleName: "Shoes"
        },
        l_ca: {
          nameForCatModal: "Dress Shoes & Heels",
          groupName: undefined,
          itemLabelName: "Dress Shoes & Heels",
          itemSingleName: "Shoes"
        },
        l_ru: {
          nameForCatModal: "Туфли и каблуки",
          groupName: undefined,
          itemLabelName: "Туфли и каблуки",
          itemSingleName: "Туфли"
        },
        l_jp: {
          nameForCatModal: "ドレスシューズ＆パンプス",
          groupName: undefined,
          itemLabelName: "ドレスシューズ＆パンプス",
          itemSingleName: "革靴"
        },
        l_it: {
          nameForCatModal: "Scarpe Eleganti e Tacchi Alti",
          groupName: undefined,
          itemLabelName: "Scarpe Eleganti e Tacchi Alti",
          itemSingleName: "Scarpe"
        },
        l_es: {
          nameForCatModal: "Zapatos de vestir y tacones",
          groupName: undefined,
          itemLabelName: "Zapatos de vestir y tacones",
          itemSingleName: "Zapatos"
        },
        l_de: {
          nameForCatModal: "Anzugschuhe & Pumps",
          groupName: undefined,
          itemLabelName: "Anzugschuhe & Pumps",
          itemSingleName: "Schuhe"
        },
        l_cn: {
          nameForCatModal: "皮鞋&高跟鞋",
          groupName: undefined,
          itemLabelName: "皮鞋&高跟鞋",
          itemSingleName: "皮鞋"
        },
        l_fr: {
          nameForCatModal: "Chaussures de ville et talons",
          groupName: undefined,
          itemLabelName: "Chaussures de ville et talons",
          itemSingleName: "Chaussures"
        }
      },
      accsgrp: {
        context: "의류, 신발류 이외의 장신구의 범주",
        l_kr: {
          nameForCatModal: "액세서리",
          groupName: "액세서리 전체",
          itemLabelName: "액세서리 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Accessories",
          groupName: "All Accessories",
          itemLabelName: "All Accessories",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Accessories",
          groupName: "All Accessories",
          itemLabelName: "All Accessories",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Accessories",
          groupName: "All Accessories",
          itemLabelName: "All Accessories",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Аксессуары",
          groupName: "Все аксессуары",
          itemLabelName: "Все аксессуары",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "アクセサリー",
          groupName: "アクセサリーすべて",
          itemLabelName: "アクセサリーすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Accessori",
          groupName: "Tutti gli Accessori",
          itemLabelName: "Tutti gli Accessori",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Accesorios",
          groupName: "Todos los accesorios",
          itemLabelName: "Todos los accesorios",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Accessoires",
          groupName: "Alle Accessoires",
          itemLabelName: "Alle Accessoires",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "配饰",
          groupName: "全部配饰",
          itemLabelName: "全部配饰",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Accessoires",
          groupName: "Tous les accessoires",
          itemLabelName: "Tous les accessoires",
          itemSingleName: undefined
        }
      },
      bags: {
        context: "가방",
        l_kr: {
          nameForCatModal: "가방",
          groupName: undefined,
          itemLabelName: "가방",
          itemSingleName: "가방"
        },
        l_us: {
          nameForCatModal: "Bags",
          groupName: undefined,
          itemLabelName: "Bags",
          itemSingleName: "Bag"
        },
        l_gb: {
          nameForCatModal: "Bags",
          groupName: undefined,
          itemLabelName: "Bags",
          itemSingleName: "Bag"
        },
        l_ca: {
          nameForCatModal: "Bags",
          groupName: undefined,
          itemLabelName: "Bags",
          itemSingleName: "Bag"
        },
        l_ru: {
          nameForCatModal: "Сумки",
          groupName: undefined,
          itemLabelName: "Сумки",
          itemSingleName: "Сумка"
        },
        l_jp: {
          nameForCatModal: "バッグ",
          groupName: undefined,
          itemLabelName: "バッグ",
          itemSingleName: "バッグ"
        },
        l_it: {
          nameForCatModal: "Borse",
          groupName: undefined,
          itemLabelName: "Borse",
          itemSingleName: "Borsa"
        },
        l_es: {
          nameForCatModal: "Bolsos",
          groupName: undefined,
          itemLabelName: "Bolsos",
          itemSingleName: "Bolso"
        },
        l_de: {
          nameForCatModal: "Taschen",
          groupName: undefined,
          itemLabelName: "Taschen",
          itemSingleName: "Tasche"
        },
        l_cn: {
          nameForCatModal: "包",
          groupName: undefined,
          itemLabelName: "包",
          itemSingleName: "包"
        },
        l_fr: {
          nameForCatModal: "Sacs",
          groupName: undefined,
          itemLabelName: "Sacs",
          itemSingleName: "Sac"
        }
      },
      watches: {
        context: "시계",
        l_kr: {
          nameForCatModal: "시계",
          groupName: undefined,
          itemLabelName: "시계",
          itemSingleName: "시계"
        },
        l_us: {
          nameForCatModal: "Watches",
          groupName: undefined,
          itemLabelName: "Watches",
          itemSingleName: "Watch"
        },
        l_gb: {
          nameForCatModal: "Watches",
          groupName: undefined,
          itemLabelName: "Watches",
          itemSingleName: "Watch"
        },
        l_ca: {
          nameForCatModal: "Watches",
          groupName: undefined,
          itemLabelName: "Watches",
          itemSingleName: "Watch"
        },
        l_ru: {
          nameForCatModal: "Часы",
          groupName: undefined,
          itemLabelName: "Часы",
          itemSingleName: "Часы"
        },
        l_jp: {
          nameForCatModal: "腕時計",
          groupName: undefined,
          itemLabelName: "腕時計",
          itemSingleName: "腕時計"
        },
        l_it: {
          nameForCatModal: "Orologi",
          groupName: undefined,
          itemLabelName: "Orologi",
          itemSingleName: "Orologio"
        },
        l_es: {
          nameForCatModal: "Relojes",
          groupName: undefined,
          itemLabelName: "Relojes",
          itemSingleName: "Reloj"
        },
        l_de: {
          nameForCatModal: "Uhren",
          groupName: undefined,
          itemLabelName: "Uhren",
          itemSingleName: "Uhr"
        },
        l_cn: {
          nameForCatModal: "手表",
          groupName: undefined,
          itemLabelName: "手表",
          itemSingleName: "手表"
        },
        l_fr: {
          nameForCatModal: "Montres",
          groupName: undefined,
          itemLabelName: "Montres",
          itemSingleName: "Montre"
        }
      },
      headwear: {
        context: "머리에 두르는 액세서리의 범주",
        l_kr: {
          nameForCatModal: "모자류",
          groupName: undefined,
          itemLabelName: "모자류",
          itemSingleName: "모자"
        },
        l_us: {
          nameForCatModal: "Headwear",
          groupName: undefined,
          itemLabelName: "Headwear",
          itemSingleName: "Hat"
        },
        l_gb: {
          nameForCatModal: "Headwear",
          groupName: undefined,
          itemLabelName: "Headwear",
          itemSingleName: "Hat"
        },
        l_ca: {
          nameForCatModal: "Headwear",
          groupName: undefined,
          itemLabelName: "Headwear",
          itemSingleName: "Hat"
        },
        l_ru: {
          nameForCatModal: "Головные уборы",
          groupName: undefined,
          itemLabelName: "Головные уборы",
          itemSingleName: "Головной убор"
        },
        l_jp: {
          nameForCatModal: "帽子類",
          groupName: undefined,
          itemLabelName: "帽子類",
          itemSingleName: "帽子"
        },
        l_it: {
          nameForCatModal: "Copricapi",
          groupName: undefined,
          itemLabelName: "Copricapi",
          itemSingleName: "Cappello"
        },
        l_es: {
          nameForCatModal: "Sombreros y gorras",
          groupName: undefined,
          itemLabelName: "Sombreros y gorras",
          itemSingleName: "Sombrero"
        },
        l_de: {
          nameForCatModal: "Kopfbedeckungen",
          groupName: undefined,
          itemLabelName: "Kopfbedeckungen",
          itemSingleName: "Kopfbedeckung"
        },
        l_cn: {
          nameForCatModal: "帽子类",
          groupName: undefined,
          itemLabelName: "帽子类",
          itemSingleName: "帽子"
        },
        l_fr: {
          nameForCatModal: "Chapeaux et bonnets",
          groupName: undefined,
          itemLabelName: "Chapeaux et bonnets",
          itemSingleName: "Chapeau"
        }
      },
      scarfs: {
        context: "스카프, 목도리",
        l_kr: {
          nameForCatModal: "스카프 & 목도리",
          groupName: undefined,
          itemLabelName: "스카프 & 목도리",
          itemSingleName: "스카프 & 목도리"
        },
        l_us: {
          nameForCatModal: "Scarfs",
          groupName: undefined,
          itemLabelName: "Scarfs",
          itemSingleName: "Scarf"
        },
        l_gb: {
          nameForCatModal: "Scarves",
          groupName: undefined,
          itemLabelName: "Scarves",
          itemSingleName: "Scarf"
        },
        l_ca: {
          nameForCatModal: "Scarves",
          groupName: undefined,
          itemLabelName: "Scarves",
          itemSingleName: "Scarf"
        },
        l_ru: {
          nameForCatModal: "Шарфы",
          groupName: undefined,
          itemLabelName: "Шарфы",
          itemSingleName: "Шарф"
        },
        l_jp: {
          nameForCatModal: "スカーフ＆マフラー",
          groupName: undefined,
          itemLabelName: "スカーフ＆マフラー",
          itemSingleName: "スカーフ＆マフラー"
        },
        l_it: {
          nameForCatModal: "Sciarpe",
          groupName: undefined,
          itemLabelName: "Sciarpe",
          itemSingleName: "Sciarpa"
        },
        l_es: {
          nameForCatModal: "Pañuelos y bufandas",
          groupName: undefined,
          itemLabelName: "Pañuelos y bufandas",
          itemSingleName: "Bufanda"
        },
        l_de: {
          nameForCatModal: "Schals",
          groupName: undefined,
          itemLabelName: "Schals",
          itemSingleName: "Schal"
        },
        l_cn: {
          nameForCatModal: "围巾",
          groupName: undefined,
          itemLabelName: "围巾",
          itemSingleName: "围巾"
        },
        l_fr: {
          nameForCatModal: "Écharpes",
          groupName: undefined,
          itemLabelName: "Écharpes",
          itemSingleName: "Écharpe"
        }
      },
      ties: {
        context: "타이",
        l_kr: {
          nameForCatModal: "타이",
          groupName: undefined,
          itemLabelName: "타이",
          itemSingleName: "타이"
        },
        l_us: {
          nameForCatModal: "Ties",
          groupName: undefined,
          itemLabelName: "Ties",
          itemSingleName: "Tie"
        },
        l_gb: {
          nameForCatModal: "Ties",
          groupName: undefined,
          itemLabelName: "Ties",
          itemSingleName: "Tie"
        },
        l_ca: {
          nameForCatModal: "Ties",
          groupName: undefined,
          itemLabelName: "Ties",
          itemSingleName: "Tie"
        },
        l_ru: {
          nameForCatModal: "Галстуки",
          groupName: undefined,
          itemLabelName: "Галстуки",
          itemSingleName: "Галстук"
        },
        l_jp: {
          nameForCatModal: "ネクタイ",
          groupName: undefined,
          itemLabelName: "ネクタイ",
          itemSingleName: "ネクタイ"
        },
        l_it: {
          nameForCatModal: "Cravatte",
          groupName: undefined,
          itemLabelName: "Cravatte",
          itemSingleName: "Cravatta"
        },
        l_es: {
          nameForCatModal: "Corbatas",
          groupName: undefined,
          itemLabelName: "Corbatas",
          itemSingleName: "Corbata"
        },
        l_de: {
          nameForCatModal: "Krawatten",
          groupName: undefined,
          itemLabelName: "Krawatten",
          itemSingleName: "Krawatte"
        },
        l_cn: {
          nameForCatModal: "领带",
          groupName: undefined,
          itemLabelName: "领带",
          itemSingleName: "领带"
        },
        l_fr: {
          nameForCatModal: "Cravates",
          groupName: undefined,
          itemLabelName: "Cravates",
          itemSingleName: "Cravate"
        }
      },
      jewelrygrp: {
        context: "귀금속이나 보석으로 만들어진 액세서리의 범주",
        l_kr: {
          nameForCatModal: "주얼리",
          groupName: "주얼리 전체",
          itemLabelName: "주얼리 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Jewelry",
          groupName: "All Jewelry",
          itemLabelName: "All Jewelry",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Jewellery",
          groupName: "All Jewellery",
          itemLabelName: "All Jewellery",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Jewelry",
          groupName: "All Jewelry",
          itemLabelName: "All Jewelry",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Ювелирные украшения",
          groupName: "Все ювелирные украшения",
          itemLabelName: "Все ювелирные украшения",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "ジュエリー",
          groupName: "ジュエリーすべて",
          itemLabelName: "ジュエリーすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Gioielli",
          groupName: "Tutti i Gioielli",
          itemLabelName: "Tutti i Gioielli",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Joyas",
          groupName: "Todas las joyas",
          itemLabelName: "Todas las joyas",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Schmuck",
          groupName: "Alle Schmuck",
          itemLabelName: "Alle Schmuck",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "珠宝",
          groupName: "全部珠宝",
          itemLabelName: "全部珠宝",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Bijoux",
          groupName: "Tous les bijoux",
          itemLabelName: "Tous les bijoux",
          itemSingleName: undefined
        }
      },
      rings: {
        context: "반지",
        l_kr: {
          nameForCatModal: "반지",
          groupName: undefined,
          itemLabelName: "반지",
          itemSingleName: "반지"
        },
        l_us: {
          nameForCatModal: "Rings",
          groupName: undefined,
          itemLabelName: "Rings",
          itemSingleName: "Ring"
        },
        l_gb: {
          nameForCatModal: "Rings",
          groupName: undefined,
          itemLabelName: "Rings",
          itemSingleName: "Ring"
        },
        l_ca: {
          nameForCatModal: "Rings",
          groupName: undefined,
          itemLabelName: "Rings",
          itemSingleName: "Ring"
        },
        l_ru: {
          nameForCatModal: "Кольца",
          groupName: undefined,
          itemLabelName: "Кольца",
          itemSingleName: "Кольцо"
        },
        l_jp: {
          nameForCatModal: "指輪",
          groupName: undefined,
          itemLabelName: "指輪",
          itemSingleName: "指輪"
        },
        l_it: {
          nameForCatModal: "Anelli",
          groupName: undefined,
          itemLabelName: "Anelli",
          itemSingleName: "Anello"
        },
        l_es: {
          nameForCatModal: "Anillos",
          groupName: undefined,
          itemLabelName: "Anillos",
          itemSingleName: "Anillo"
        },
        l_de: {
          nameForCatModal: "Ringe",
          groupName: undefined,
          itemLabelName: "Ringe",
          itemSingleName: "Ring"
        },
        l_cn: {
          nameForCatModal: "戒指",
          groupName: undefined,
          itemLabelName: "戒指",
          itemSingleName: "戒指"
        },
        l_fr: {
          nameForCatModal: "Bagues",
          groupName: undefined,
          itemLabelName: "Bagues",
          itemSingleName: "Bague"
        }
      },
      bracelets: {
        context: "팔찌",
        l_kr: {
          nameForCatModal: "팔찌",
          groupName: undefined,
          itemLabelName: "팔찌",
          itemSingleName: "팔찌"
        },
        l_us: {
          nameForCatModal: "Bracelets",
          groupName: undefined,
          itemLabelName: "Bracelets",
          itemSingleName: "Bracelet"
        },
        l_gb: {
          nameForCatModal: "Bracelets",
          groupName: undefined,
          itemLabelName: "Bracelets",
          itemSingleName: "Bracelet"
        },
        l_ca: {
          nameForCatModal: "Bracelets",
          groupName: undefined,
          itemLabelName: "Bracelets",
          itemSingleName: "Bracelet"
        },
        l_ru: {
          nameForCatModal: "Браслеты",
          groupName: undefined,
          itemLabelName: "Браслеты",
          itemSingleName: "Браслет"
        },
        l_jp: {
          nameForCatModal: "ブレスレット",
          groupName: undefined,
          itemLabelName: "ブレスレット",
          itemSingleName: "ブレスレット"
        },
        l_it: {
          nameForCatModal: "Braccialetti",
          groupName: undefined,
          itemLabelName: "Braccialetti",
          itemSingleName: "Bracciale"
        },
        l_es: {
          nameForCatModal: "Pulseras",
          groupName: undefined,
          itemLabelName: "Pulseras",
          itemSingleName: "Pulsera"
        },
        l_de: {
          nameForCatModal: "Armbänder",
          groupName: undefined,
          itemLabelName: "Armbänder",
          itemSingleName: "Armband"
        },
        l_cn: {
          nameForCatModal: "手链",
          groupName: undefined,
          itemLabelName: "手链",
          itemSingleName: "手链"
        },
        l_fr: {
          nameForCatModal: "Bracelets",
          groupName: undefined,
          itemLabelName: "Bracelets",
          itemSingleName: "Bracelet"
        }
      },
      necklaces: {
        context: "목걸이",
        l_kr: {
          nameForCatModal: "목걸이",
          groupName: undefined,
          itemLabelName: "목걸이",
          itemSingleName: "목걸이"
        },
        l_us: {
          nameForCatModal: "Necklaces",
          groupName: undefined,
          itemLabelName: "Necklaces",
          itemSingleName: "Necklace"
        },
        l_gb: {
          nameForCatModal: "Necklaces",
          groupName: undefined,
          itemLabelName: "Necklaces",
          itemSingleName: "Necklace"
        },
        l_ca: {
          nameForCatModal: "Necklaces",
          groupName: undefined,
          itemLabelName: "Necklaces",
          itemSingleName: "Necklace"
        },
        l_ru: {
          nameForCatModal: "Колье",
          groupName: undefined,
          itemLabelName: "Колье",
          itemSingleName: "Ожерелье"
        },
        l_jp: {
          nameForCatModal: "ネックレス",
          groupName: undefined,
          itemLabelName: "ネックレス",
          itemSingleName: "ネックレス"
        },
        l_it: {
          nameForCatModal: "Collane",
          groupName: undefined,
          itemLabelName: "Collane",
          itemSingleName: "Collana"
        },
        l_es: {
          nameForCatModal: "Collares",
          groupName: undefined,
          itemLabelName: "Collares",
          itemSingleName: "Collar"
        },
        l_de: {
          nameForCatModal: "Halsketten",
          groupName: undefined,
          itemLabelName: "Halsketten",
          itemSingleName: "Halskette"
        },
        l_cn: {
          nameForCatModal: "项链",
          groupName: undefined,
          itemLabelName: "项链",
          itemSingleName: "项链"
        },
        l_fr: {
          nameForCatModal: "Colliers",
          groupName: undefined,
          itemLabelName: "Colliers",
          itemSingleName: "Collier"
        }
      },
      earrings: {
        context: "귀걸이",
        l_kr: {
          nameForCatModal: "귀걸이",
          groupName: undefined,
          itemLabelName: "귀걸이",
          itemSingleName: "귀걸이"
        },
        l_us: {
          nameForCatModal: "Earrings",
          groupName: undefined,
          itemLabelName: "Earrings",
          itemSingleName: "Earrings"
        },
        l_gb: {
          nameForCatModal: "Earrings",
          groupName: undefined,
          itemLabelName: "Earrings",
          itemSingleName: "Earrings"
        },
        l_ca: {
          nameForCatModal: "Earrings",
          groupName: undefined,
          itemLabelName: "Earrings",
          itemSingleName: "Earrings"
        },
        l_ru: {
          nameForCatModal: "Серьги",
          groupName: undefined,
          itemLabelName: "Серьги",
          itemSingleName: "Серьги"
        },
        l_jp: {
          nameForCatModal: "イヤリング",
          groupName: undefined,
          itemLabelName: "イヤリング",
          itemSingleName: "イヤリング"
        },
        l_it: {
          nameForCatModal: "Orecchini",
          groupName: undefined,
          itemLabelName: "Orecchini",
          itemSingleName: "Orecchini"
        },
        l_es: {
          nameForCatModal: "Pendientes",
          groupName: undefined,
          itemLabelName: "Pendientes",
          itemSingleName: "Pendientes"
        },
        l_de: {
          nameForCatModal: "Ohrringe",
          groupName: undefined,
          itemLabelName: "Ohrringe",
          itemSingleName: "Ohrringe"
        },
        l_cn: {
          nameForCatModal: "耳环",
          groupName: undefined,
          itemLabelName: "耳环",
          itemSingleName: "耳环"
        },
        l_fr: {
          nameForCatModal: "Boucles d'oreilles",
          groupName: undefined,
          itemLabelName: "Boucles d'oreilles",
          itemSingleName: "Boucles d’oreilles"
        }
      },
      regularjewelry: {
        context: "그외의 일반적인 주얼리의 범주",
        l_kr: {
          nameForCatModal: "기타 주얼리",
          groupName: undefined,
          itemLabelName: "일반 주얼리",
          itemSingleName: "주얼리"
        },
        l_us: {
          nameForCatModal: "Other Jewelry",
          groupName: undefined,
          itemLabelName: "Regular Jewelry",
          itemSingleName: "Jewelry"
        },
        l_gb: {
          nameForCatModal: "Other Jewellery",
          groupName: undefined,
          itemLabelName: "Regular Jewellery",
          itemSingleName: "Jewelry"
        },
        l_ca: {
          nameForCatModal: "Other Jewelry",
          groupName: undefined,
          itemLabelName: "Regular Jewelry",
          itemSingleName: "Jewelry"
        },
        l_ru: {
          nameForCatModal: "Другие ювелирные украшения",
          groupName: undefined,
          itemLabelName: "Обычные ювелирные украшения",
          itemSingleName: "Ювелирные изделия"
        },
        l_jp: {
          nameForCatModal: "その他ジュエリー",
          groupName: undefined,
          itemLabelName: "一般ジュエリー",
          itemSingleName: "ジュエリー"
        },
        l_it: {
          nameForCatModal: "Altri Gioielli",
          groupName: undefined,
          itemLabelName: "Gioielli Normale",
          itemSingleName: "Gioielli"
        },
        l_es: {
          nameForCatModal: "Otras joyas",
          groupName: undefined,
          itemLabelName: "Joyas normales",
          itemSingleName: "Joyería"
        },
        l_de: {
          nameForCatModal: "Anderer Schmuck",
          groupName: undefined,
          itemLabelName: "Normaler Schmuck",
          itemSingleName: "Schmuck"
        },
        l_cn: {
          nameForCatModal: "其他珠宝",
          groupName: undefined,
          itemLabelName: "一般珠宝",
          itemSingleName: "珠宝"
        },
        l_fr: {
          nameForCatModal: "Autres bijoux",
          groupName: undefined,
          itemLabelName: "Bijoux basiques",
          itemSingleName: "Bijoux"
        }
      },
      legweargrp: {
        context: "발과 다리를 감싸는 의류의 범주",
        l_kr: {
          nameForCatModal: "양말류",
          groupName: "양말류 전체",
          itemLabelName: "양말류 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Hosiery",
          groupName: "All Hosiery",
          itemLabelName: "All Hosiery",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Hosiery",
          groupName: "All Hosiery",
          itemLabelName: "All Hosiery",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Hosiery",
          groupName: "All Hosiery",
          itemLabelName: "All Hosiery",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Чулочно-носочные изделия",
          groupName: "Все чулочно-носочные изделия",
          itemLabelName: "Все чулочно-носочные изделия",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "レッグウェア",
          groupName: "レッグウェアすべて",
          itemLabelName: "レッグウェアすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Calze",
          groupName: "Tutte le Calze",
          itemLabelName: "Tutte le Calze",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Medias y calcetines",
          groupName: "Todas las medias y calcetines",
          itemLabelName: "Todas las medias y calcetines",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Strumpfwaren",
          groupName: "Alle Strumpfwaren",
          itemLabelName: "Alle Strumpfwaren",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "袜类",
          groupName: "全部袜类",
          itemLabelName: "全部袜类",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Chaussettes et bas",
          groupName: "Toutes les chaussettes et bas",
          itemLabelName: "Toutes les chaussettes et bas",
          itemSingleName: undefined
        }
      },
      socks: {
        context: "양말",
        l_kr: {
          nameForCatModal: "양말",
          groupName: undefined,
          itemLabelName: "양말",
          itemSingleName: "양말"
        },
        l_us: {
          nameForCatModal: "Socks",
          groupName: undefined,
          itemLabelName: "Socks",
          itemSingleName: "Socks"
        },
        l_gb: {
          nameForCatModal: "Socks",
          groupName: undefined,
          itemLabelName: "Socks",
          itemSingleName: "Socks"
        },
        l_ca: {
          nameForCatModal: "Socks",
          groupName: undefined,
          itemLabelName: "Socks",
          itemSingleName: "Socks"
        },
        l_ru: {
          nameForCatModal: "Носки",
          groupName: undefined,
          itemLabelName: "Носки",
          itemSingleName: "Носки"
        },
        l_jp: {
          nameForCatModal: "靴下",
          groupName: undefined,
          itemLabelName: "靴下",
          itemSingleName: "靴下"
        },
        l_it: {
          nameForCatModal: "Calzini",
          groupName: undefined,
          itemLabelName: "Calzini",
          itemSingleName: "Calzini"
        },
        l_es: {
          nameForCatModal: "Calcetines",
          groupName: undefined,
          itemLabelName: "Calcetines",
          itemSingleName: "Calcetines"
        },
        l_de: {
          nameForCatModal: "Socken",
          groupName: undefined,
          itemLabelName: "Socken",
          itemSingleName: "Socken"
        },
        l_cn: {
          nameForCatModal: "袜子",
          groupName: undefined,
          itemLabelName: "袜子",
          itemSingleName: "袜子"
        },
        l_fr: {
          nameForCatModal: "Chaussettes",
          groupName: undefined,
          itemLabelName: "Chaussettes",
          itemSingleName: "Chaussettes"
        }
      },
      stockings: {
        context: "스타킹",
        l_kr: {
          nameForCatModal: "스타킹",
          groupName: undefined,
          itemLabelName: "스타킹",
          itemSingleName: "스타킹"
        },
        l_us: {
          nameForCatModal: "Stockings",
          groupName: undefined,
          itemLabelName: "Stockings",
          itemSingleName: "Stockings"
        },
        l_gb: {
          nameForCatModal: "Stockings",
          groupName: undefined,
          itemLabelName: "Stockings",
          itemSingleName: "Stockings"
        },
        l_ca: {
          nameForCatModal: "Stockings",
          groupName: undefined,
          itemLabelName: "Stockings",
          itemSingleName: "Stockings"
        },
        l_ru: {
          nameForCatModal: "Чулки",
          groupName: undefined,
          itemLabelName: "Чулки",
          itemSingleName: "Чулки"
        },
        l_jp: {
          nameForCatModal: "ストッキング",
          groupName: undefined,
          itemLabelName: "ストッキング",
          itemSingleName: "ストッキング"
        },
        l_it: {
          nameForCatModal: "Calze",
          groupName: undefined,
          itemLabelName: "Calze",
          itemSingleName: "Calze"
        },
        l_es: {
          nameForCatModal: "Medias",
          groupName: undefined,
          itemLabelName: "Medias",
          itemSingleName: "Medias"
        },
        l_de: {
          nameForCatModal: "Strümpfe",
          groupName: undefined,
          itemLabelName: "Strümpfe",
          itemSingleName: "Strümpfe"
        },
        l_cn: {
          nameForCatModal: "丝袜",
          groupName: undefined,
          itemLabelName: "丝袜",
          itemSingleName: "丝袜"
        },
        l_fr: {
          nameForCatModal: "Bas",
          groupName: undefined,
          itemLabelName: "Bas",
          itemSingleName: "Bas"
        }
      },
      eyeweargrp: {
        context: "안겅, 선글라스",
        l_kr: {
          nameForCatModal: "아이웨어",
          groupName: "아이웨어 전체",
          itemLabelName: "아이웨어 전체",
          itemSingleName: undefined
        },
        l_us: {
          nameForCatModal: "Eyewear",
          groupName: "All Eyewear",
          itemLabelName: "All Eyewear",
          itemSingleName: undefined
        },
        l_gb: {
          nameForCatModal: "Eyewear",
          groupName: "All Eyewear",
          itemLabelName: "All Eyewear",
          itemSingleName: undefined
        },
        l_ca: {
          nameForCatModal: "Eyewear",
          groupName: "All Eyewear",
          itemLabelName: "All Eyewear",
          itemSingleName: undefined
        },
        l_ru: {
          nameForCatModal: "Очки",
          groupName: "Все очки",
          itemLabelName: "Все очки",
          itemSingleName: undefined
        },
        l_jp: {
          nameForCatModal: "アイウェア",
          groupName: "アイウェアすべて",
          itemLabelName: "アイウェアすべて",
          itemSingleName: undefined
        },
        l_it: {
          nameForCatModal: "Occhiali",
          groupName: "Tutti gli Occhiali",
          itemLabelName: "Tutti gli Occhiali",
          itemSingleName: undefined
        },
        l_es: {
          nameForCatModal: "Gafas",
          groupName: "Todas las gafas",
          itemLabelName: "Todas las gafas",
          itemSingleName: undefined
        },
        l_de: {
          nameForCatModal: "Eyewear",
          groupName: "Alle Eyewear",
          itemLabelName: "Alle Eyewear",
          itemSingleName: undefined
        },
        l_cn: {
          nameForCatModal: "眼镜类",
          groupName: "全部眼镜类",
          itemLabelName: "全部眼镜类",
          itemSingleName: undefined
        },
        l_fr: {
          nameForCatModal: "Lunettes",
          groupName: "Toutes les lunettes",
          itemLabelName: "Toutes les lunettes",
          itemSingleName: undefined
        }
      },
      glasses: {
        context: "안경",
        l_kr: {
          nameForCatModal: "안경",
          groupName: undefined,
          itemLabelName: "안경",
          itemSingleName: "안경"
        },
        l_us: {
          nameForCatModal: "Glasses",
          groupName: undefined,
          itemLabelName: "Glasses",
          itemSingleName: "Glasses"
        },
        l_gb: {
          nameForCatModal: "Glasses",
          groupName: undefined,
          itemLabelName: "Glasses",
          itemSingleName: "Glasses"
        },
        l_ca: {
          nameForCatModal: "Glasses",
          groupName: undefined,
          itemLabelName: "Glasses",
          itemSingleName: "Glasses"
        },
        l_ru: {
          nameForCatModal: "Очки для зрения",
          groupName: undefined,
          itemLabelName: "Очки для зрения",
          itemSingleName: "Очки"
        },
        l_jp: {
          nameForCatModal: "メガネ",
          groupName: undefined,
          itemLabelName: "メガネ",
          itemSingleName: "眼鏡"
        },
        l_it: {
          nameForCatModal: "Occhiali",
          groupName: undefined,
          itemLabelName: "Occhiali",
          itemSingleName: "Occhiali"
        },
        l_es: {
          nameForCatModal: "Gafas",
          groupName: undefined,
          itemLabelName: "Gafas",
          itemSingleName: "Gafas"
        },
        l_de: {
          nameForCatModal: "Brillen",
          groupName: undefined,
          itemLabelName: "Brillen",
          itemSingleName: "Brille"
        },
        l_cn: {
          nameForCatModal: "眼镜",
          groupName: undefined,
          itemLabelName: "眼镜",
          itemSingleName: "眼镜"
        },
        l_fr: {
          nameForCatModal: "Lunettes",
          groupName: undefined,
          itemLabelName: "Lunettes",
          itemSingleName: "Lunettes"
        }
      },
      sunglasses: {
        context: "선글라스",
        l_kr: {
          nameForCatModal: "선글라스",
          groupName: undefined,
          itemLabelName: "선글라스",
          itemSingleName: "선글라스"
        },
        l_us: {
          nameForCatModal: "Sunglasses",
          groupName: undefined,
          itemLabelName: "Sunglasses",
          itemSingleName: "Sunglasses"
        },
        l_gb: {
          nameForCatModal: "Sunglasses",
          groupName: undefined,
          itemLabelName: "Sunglasses",
          itemSingleName: "Sunglasses"
        },
        l_ca: {
          nameForCatModal: "Sunglasses",
          groupName: undefined,
          itemLabelName: "Sunglasses",
          itemSingleName: "Sunglasses"
        },
        l_ru: {
          nameForCatModal: "Солнцезащитные очки",
          groupName: undefined,
          itemLabelName: "Солнцезащитные очки",
          itemSingleName: "Солнцезащитные очки"
        },
        l_jp: {
          nameForCatModal: "サングラス",
          groupName: undefined,
          itemLabelName: "サングラス",
          itemSingleName: "サングラス"
        },
        l_it: {
          nameForCatModal: "Occhiali da Sole",
          groupName: undefined,
          itemLabelName: "Occhiali da Sole",
          itemSingleName: "Occhiali da sole"
        },
        l_es: {
          nameForCatModal: "Gafas de sol",
          groupName: undefined,
          itemLabelName: "Gafas de sol",
          itemSingleName: "Gafas de sol"
        },
        l_de: {
          nameForCatModal: "Sonnenbrillen",
          groupName: undefined,
          itemLabelName: "Sonnenbrillen",
          itemSingleName: "Sonnenbrille"
        },
        l_cn: {
          nameForCatModal: "墨镜",
          groupName: undefined,
          itemLabelName: "墨镜",
          itemSingleName: "太阳镜"
        },
        l_fr: {
          nameForCatModal: "Lunettes de soleil",
          groupName: undefined,
          itemLabelName: "Lunettes de soleil",
          itemSingleName: "Lunettes de soleil"
        }
      },
      belts: {
        context: "벨트",
        l_kr: {
          nameForCatModal: "벨트",
          groupName: undefined,
          itemLabelName: "벨트",
          itemSingleName: "벨트"
        },
        l_us: {
          nameForCatModal: "Belts",
          groupName: undefined,
          itemLabelName: "Belts",
          itemSingleName: "Belt"
        },
        l_gb: {
          nameForCatModal: "Belts",
          groupName: undefined,
          itemLabelName: "Belts",
          itemSingleName: "Belt"
        },
        l_ca: {
          nameForCatModal: "Belts",
          groupName: undefined,
          itemLabelName: "Belts",
          itemSingleName: "Belt"
        },
        l_ru: {
          nameForCatModal: "Ремни",
          groupName: undefined,
          itemLabelName: "Ремни",
          itemSingleName: "Ремень"
        },
        l_jp: {
          nameForCatModal: "ベルト",
          groupName: undefined,
          itemLabelName: "ベルト",
          itemSingleName: "ベルト"
        },
        l_it: {
          nameForCatModal: "Cinture",
          groupName: undefined,
          itemLabelName: "Cinture",
          itemSingleName: "Cintura"
        },
        l_es: {
          nameForCatModal: "Cinturones",
          groupName: undefined,
          itemLabelName: "Cinturones",
          itemSingleName: "Cinturón"
        },
        l_de: {
          nameForCatModal: "Gürtel",
          groupName: undefined,
          itemLabelName: "Gürtel",
          itemSingleName: "Gürtel"
        },
        l_cn: {
          nameForCatModal: "腰带",
          groupName: undefined,
          itemLabelName: "腰带",
          itemSingleName: "皮带"
        },
        l_fr: {
          nameForCatModal: "Ceintures",
          groupName: undefined,
          itemLabelName: "Ceintures",
          itemSingleName: "Ceinture"
        }
      },
      gloves: {
        context: "장갑",
        l_kr: {
          nameForCatModal: "장갑",
          groupName: undefined,
          itemLabelName: "장갑",
          itemSingleName: "장갑"
        },
        l_us: {
          nameForCatModal: "Gloves",
          groupName: undefined,
          itemLabelName: "Gloves",
          itemSingleName: "Gloves"
        },
        l_gb: {
          nameForCatModal: "Gloves",
          groupName: undefined,
          itemLabelName: "Gloves",
          itemSingleName: "Gloves"
        },
        l_ca: {
          nameForCatModal: "Gloves",
          groupName: undefined,
          itemLabelName: "Gloves",
          itemSingleName: "Gloves"
        },
        l_ru: {
          nameForCatModal: "Перчатки",
          groupName: undefined,
          itemLabelName: "Перчатки",
          itemSingleName: "Перчатки"
        },
        l_jp: {
          nameForCatModal: "手袋",
          groupName: undefined,
          itemLabelName: "手袋",
          itemSingleName: "手袋"
        },
        l_it: {
          nameForCatModal: "Guanti",
          groupName: undefined,
          itemLabelName: "Guanti",
          itemSingleName: "Guanti"
        },
        l_es: {
          nameForCatModal: "Guantes",
          groupName: undefined,
          itemLabelName: "Guantes",
          itemSingleName: "Guantes"
        },
        l_de: {
          nameForCatModal: "Handschuhe",
          groupName: undefined,
          itemLabelName: "Handschuhe",
          itemSingleName: "Handschuhe"
        },
        l_cn: {
          nameForCatModal: "手套",
          groupName: undefined,
          itemLabelName: "手套",
          itemSingleName: "手套"
        },
        l_fr: {
          nameForCatModal: "Gants",
          groupName: undefined,
          itemLabelName: "Gants",
          itemSingleName: "Gants"
        }
      },
      regularaccs: {
        context: "그외의 일반적인 액세서리의 범주",
        l_kr: {
          nameForCatModal: "기타 액세서리",
          groupName: undefined,
          itemLabelName: "일반 액세서리",
          itemSingleName: "액세서리"
        },
        l_us: {
          nameForCatModal: "Other Accessories",
          groupName: undefined,
          itemLabelName: "Regular Accessories",
          itemSingleName: "Accessory"
        },
        l_gb: {
          nameForCatModal: "Other Accessories",
          groupName: undefined,
          itemLabelName: "Regular Accessories",
          itemSingleName: "Accessory"
        },
        l_ca: {
          nameForCatModal: "Other Accessories",
          groupName: undefined,
          itemLabelName: "Regular Accessories",
          itemSingleName: "Accessory"
        },
        l_ru: {
          nameForCatModal: "Другие аксессуары",
          groupName: undefined,
          itemLabelName: "Обычные аксессуары",
          itemSingleName: "Аксессуар"
        },
        l_jp: {
          nameForCatModal: "その他アクセサリー",
          groupName: undefined,
          itemLabelName: "一般アクセサリー",
          itemSingleName: "アクセサリー"
        },
        l_it: {
          nameForCatModal: "Altri Accessori",
          groupName: undefined,
          itemLabelName: "Accessori Normale",
          itemSingleName: "Accessorio"
        },
        l_es: {
          nameForCatModal: "Otros accesorios",
          groupName: undefined,
          itemLabelName: "Accesorios normales",
          itemSingleName: "Accesorio"
        },
        l_de: {
          nameForCatModal: "Andere Accessoires",
          groupName: undefined,
          itemLabelName: "Normale Accessoires",
          itemSingleName: "Accessoire"
        },
        l_cn: {
          nameForCatModal: "其他配饰",
          groupName: undefined,
          itemLabelName: "一般配饰",
          itemSingleName: "配饰"
        },
        l_fr: {
          nameForCatModal: "Autres accessoires",
          groupName: undefined,
          itemLabelName: "Accessoires basiques",
          itemSingleName: "Accessoire"
        }
      }
    }
  },
  wordColor_black: {
    text: {
      temp_comment: "",
      l_kr: "블랙",
      l_us: "Black",
      l_gb: "Black",
      l_ca: "Black",
      l_ru: "Черный",
      l_jp: "ブラック",
      l_it: "Nero",
      l_es: "Negro",
      l_de: "Schwarz",
      l_cn: "黑色",
      l_fr: "Noir"
    }
  },
  wordColor_white: {
    text: {
      temp_comment: "",
      l_kr: "화이트",
      l_us: "White",
      l_gb: "White",
      l_ca: "White",
      l_ru: "Белый",
      l_jp: "ホワイト",
      l_it: "Bianco",
      l_es: "Blanco",
      l_de: "Weiß",
      l_cn: "白色",
      l_fr: "Blanc"
    }
  },
  wordColor_gray: {
    text: {
      temp_comment: "",
      l_kr: "그레이",
      l_us: "Gray",
      l_gb: "Grey",
      l_ca: "Grey",
      l_ru: "Серый",
      l_jp: "グレー",
      l_it: "Grigio",
      l_es: "Gris",
      l_de: "Grau",
      l_cn: "灰色",
      l_fr: "Gris"
    }
  },
  wordColor_blue: {
    text: {
      temp_comment: "",
      l_kr: "블루",
      l_us: "Blue",
      l_gb: "Blue",
      l_ca: "Blue",
      l_ru: "Синий",
      l_jp: "ブルー",
      l_it: "Blu",
      l_es: "Azul",
      l_de: "Blau",
      l_cn: "蓝色",
      l_fr: "Bleu"
    }
  },
  wordColor_navy: {
    text: {
      temp_comment: "",
      l_kr: "네이비",
      l_us: "Navy Blue",
      l_gb: "Navy Blue",
      l_ca: "Navy Blue",
      l_ru: "Тёмно-синий",
      l_jp: "ネイビー",
      l_it: "Blu marino",
      l_es: "Azul marino",
      l_de: "Marineblau",
      l_cn: "深蓝色",
      l_fr: "Bleu marine"
    }
  },
  wordColor_burgundy: {
    text: {
      temp_comment: "",
      l_kr: "버건디",
      l_us: "Burgundy",
      l_gb: "Burgundy",
      l_ca: "Burgundy",
      l_ru: "Бордовый",
      l_jp: "バーガンディー",
      l_it: "Bordeaux",
      l_es: "Borgoña",
      l_de: "Burgunderrot",
      l_cn: "酒红色",
      l_fr: "Bourgogne"
    }
  },
  wordColor_red: {
    text: {
      temp_comment: "",
      l_kr: "레드",
      l_us: "Red",
      l_gb: "Red",
      l_ca: "Red",
      l_ru: "Красный",
      l_jp: "レッド",
      l_it: "Rosso",
      l_es: "Rojo",
      l_de: "Rot",
      l_cn: "红色",
      l_fr: "Rouge"
    }
  },
  wordColor_orange: {
    text: {
      temp_comment: "",
      l_kr: "오렌지",
      l_us: "Orange",
      l_gb: "Orange",
      l_ca: "Orange",
      l_ru: "Оранжевый",
      l_jp: "オレンジ",
      l_it: "Arancione",
      l_es: "Naranja",
      l_de: "Orange",
      l_cn: "橙色",
      l_fr: "Orange"
    }
  },
  wordColor_pink: {
    text: {
      temp_comment: "",
      l_kr: "핑크",
      l_us: "Pink",
      l_gb: "Pink",
      l_ca: "Pink",
      l_ru: "Розовый",
      l_jp: "ピンク",
      l_it: "Rosa",
      l_es: "Rosa",
      l_de: "Rosa",
      l_cn: "粉色",
      l_fr: "Rose"
    }
  },
  wordColor_green: {
    text: {
      temp_comment: "",
      l_kr: "그린",
      l_us: "Green",
      l_gb: "Green",
      l_ca: "Green",
      l_ru: "Зелёный",
      l_jp: "グリーン",
      l_it: "Verde",
      l_es: "Verde",
      l_de: "Grün",
      l_cn: "绿色",
      l_fr: "Vert"
    }
  },
  wordColor_brown: {
    text: {
      temp_comment: "",
      l_kr: "브라운",
      l_us: "Brown",
      l_gb: "Brown",
      l_ca: "Brown",
      l_ru: "Коричневый",
      l_jp: "ブラウン",
      l_it: "Marrone",
      l_es: "Marrón",
      l_de: "Braun",
      l_cn: "棕色",
      l_fr: "Brun"
    }
  },
  wordColor_beige: {
    text: {
      temp_comment: "",
      l_kr: "베이지",
      l_us: "Beige",
      l_gb: "Beige",
      l_ca: "Beige",
      l_ru: "Бежевый",
      l_jp: "ベージュ",
      l_it: "Beige",
      l_es: "Beige",
      l_de: "Beige",
      l_cn: "浅褐色",
      l_fr: "Beige"
    }
  },
  wordColor_purple: {
    text: {
      temp_comment: "",
      l_kr: "퍼플",
      l_us: "Purple",
      l_gb: "Purple",
      l_ca: "Purple",
      l_ru: "Фиолетовый",
      l_jp: "パープル",
      l_it: "Viola",
      l_es: "Púrpura",
      l_de: "Violett",
      l_cn: "紫色",
      l_fr: "Violet"
    }
  },
  wordColor_yellow: {
    text: {
      temp_comment: "",
      l_kr: "옐로우",
      l_us: "Yellow",
      l_gb: "Yellow",
      l_ca: "Yellow",
      l_ru: "Желтый",
      l_jp: "イエロー",
      l_it: "Giallo",
      l_es: "Amarillo",
      l_de: "Gelb",
      l_cn: "黄色",
      l_fr: "Jaune"
    }
  },
  wordColor_ivory: {
    text: {
      temp_comment: "",
      l_kr: "아이보리",
      l_us: "Ivory",
      l_gb: "Ivory",
      l_ca: "Ivory",
      l_ru: "Кремовый",
      l_jp: "アイボリー",
      l_it: "Avorio",
      l_es: "Marfil",
      l_de: "Elfenbeinfarbig",
      l_cn: "象牙白",
      l_fr: "Ivoire"
    }
  },
  wordColor_lightgreen: {
    text: {
      temp_comment: "",
      l_kr: "연두",
      l_us: "Light Green",
      l_gb: "Light Green",
      l_ca: "Light Green",
      l_ru: "Светло-зелёный",
      l_jp: "ライトグリーン",
      l_it: "Verde chiaro",
      l_es: "Verde claro",
      l_de: "Hellgrün",
      l_cn: "豆绿色",
      l_fr: "Vert clair"
    }
  },
  wordColor_mint: {
    text: {
      temp_comment: "",
      l_kr: "민트",
      l_us: "Mint",
      l_gb: "Mint",
      l_ca: "Mint",
      l_ru: "Мята",
      l_jp: "ミント",
      l_it: "Menta",
      l_es: "Menta",
      l_de: "Minzgrün",
      l_cn: "薄荷色",
      l_fr: "Menthe"
    }
  },
  wordColor_khaki: {
    text: {
      temp_comment: "",
      l_kr: "카키",
      l_us: "Khaki",
      l_gb: "Khaki",
      l_ca: "Khaki",
      l_ru: "Хаки",
      l_jp: "カーキ",
      l_it: "Kaki",
      l_es: "Caqui",
      l_de: "Khaki",
      l_cn: "卡其色",
      l_fr: "Kaki"
    }
  },
  wordColor_olivegreen: {
    text: {
      temp_comment: "",
      l_kr: "올리브 그린",
      l_us: "Olive Green",
      l_gb: "Olive Green",
      l_ca: "Olive Green",
      l_ru: "Оливково-зелёный",
      l_jp: "オリーブグリーン",
      l_it: "Verde Oliva",
      l_es: "Verde oliva",
      l_de: "Olivgrün",
      l_cn: "橄榄绿",
      l_fr: "Vert olive"
    }
  },
  wordColor_skyblue: {
    text: {
      temp_comment: "",
      l_kr: "스카이 블루",
      l_us: "Sky Blue",
      l_gb: "Sky Blue",
      l_ca: "Sky Blue",
      l_ru: "Небесно-голубой",
      l_jp: "スカイブルー",
      l_it: "Celeste",
      l_es: "Azul cielo",
      l_de: "Himmelblau",
      l_cn: "天蓝色",
      l_fr: "Bleu ciel"
    }
  },
  wordColor_darkgray: {
    text: {
      temp_comment: "",
      l_kr: "다크 그레이",
      l_us: "Dark Gray",
      l_gb: "Dark Grey",
      l_ca: "Dark Grey",
      l_ru: "Тёмно-серый",
      l_jp: "ダークグレー",
      l_it: "Grigio scuro",
      l_es: "Gris oscuro",
      l_de: "Dunkelgrau",
      l_cn: "深灰色",
      l_fr: "Gris foncé"
    }
  },
  wordColor_coral: {
    text: {
      temp_comment: "",
      l_kr: "코랄",
      l_us: "Coral",
      l_gb: "Coral",
      l_ca: "Coral",
      l_ru: "Коралловый",
      l_jp: "コーラル",
      l_it: "Corallo",
      l_es: "Coral",
      l_de: "Korallenrot",
      l_cn: "珊瑚色",
      l_fr: "Corail"
    }
  },
  wordColor_lavender: {
    text: {
      temp_comment: "",
      l_kr: "라벤더",
      l_us: "Lavender",
      l_gb: "Lavender",
      l_ca: "Lavender",
      l_ru: "Бледно-лиловый",
      l_jp: "ラベンダー",
      l_it: "Lavanda",
      l_es: "Lavanda",
      l_de: "Lila",
      l_cn: "薰衣草",
      l_fr: "Lavande"
    }
  },
  btnSelect_location: {
    text: {
      temp_comment: "",
      l_kr: "위치",
      l_us: "Location",
      l_gb: "Location",
      l_ca: "Location",
      l_ru: "Страна",
      l_jp: "場所",
      l_it: "Località",
      l_es: "Ubicación",
      l_de: "Ort",
      l_cn: "位置",
      l_fr: "Pays"
    }
  },
  titleModal_category: {
    text: {
      temp_comment: "",
      l_kr: "카테고리",
      l_us: "Category",
      l_gb: "Category",
      l_ca: "Category",
      l_ru: "Категория",
      l_jp: "カテゴリー",
      l_it: "Categoria",
      l_es: "Categoría",
      l_de: "Kategorie",
      l_cn: "分类",
      l_fr: "Catégorie"
    }
  },
  btnCategoryDemoForItemDetail: {
    text: {
      temp_comment: "",
      l_kr: "카테고리",
      l_us: "Category",
      l_gb: "Category",
      l_ca: "Category",
      l_ru: "Категория",
      l_jp: "カテゴリー",
      l_it: "Categoria",
      l_es: "Categoría",
      l_de: "Kategorie",
      l_cn: "分类",
      l_fr: "Catégorie"
    }
  },
  btnSelect_category: {
    text: {
      temp_comment: "",
      l_kr: "카테고리",
      l_us: "Category",
      l_gb: "Category",
      l_ca: "Category",
      l_ru: "Категория",
      l_jp: "カテゴリー",
      l_it: "Categoria",
      l_es: "Categoría",
      l_de: "Kategorie",
      l_cn: "分类",
      l_fr: "Catégorie"
    }
  },
  titleModal_brand: {
    text: {
      temp_comment: "",
      l_kr: "브랜드",
      l_us: "Brand",
      l_gb: "Brand",
      l_ca: "Brand",
      l_ru: "Бренд",
      l_jp: "ブランド",
      l_it: "Marca",
      l_es: "Marca",
      l_de: "Marke",
      l_cn: "品牌",
      l_fr: "Marque"
    }
  },
  btnBrandDemoForItemDetail: {
    text: {
      temp_comment: "",
      l_kr: "브랜드",
      l_us: "Brand",
      l_gb: "Brand",
      l_ca: "Brand",
      l_ru: "Бренд",
      l_jp: "ブランド",
      l_it: "Marca",
      l_es: "Marca",
      l_de: "Marke",
      l_cn: "品牌",
      l_fr: "Marque"
    }
  },
  btnSelect_brand: {
    text: {
      temp_comment: "",
      l_kr: "브랜드",
      l_us: "Brand",
      l_gb: "Brand",
      l_ca: "Brand",
      l_ru: "Бренд",
      l_jp: "ブランド",
      l_it: "Marca",
      l_es: "Marca",
      l_de: "Marke",
      l_cn: "品牌",
      l_fr: "Marque"
    }
  },
  titleModal_color: {
    text: {
      temp_comment: "",
      l_kr: "색상",
      l_us: "Color",
      l_gb: "Colour",
      l_ca: "Colour",
      l_ru: "Цвет",
      l_jp: "カラー",
      l_it: "Colore",
      l_es: "Color",
      l_de: "Farbe",
      l_cn: "颜色",
      l_fr: "Couleur"
    }
  },
  btnSelect_color: {
    text: {
      temp_comment: "",
      l_kr: "색상",
      l_us: "Color",
      l_gb: "Colour",
      l_ca: "Colour",
      l_ru: "Цвет",
      l_jp: "カラー",
      l_it: "Colore",
      l_es: "Color",
      l_de: "Farbe",
      l_cn: "颜色",
      l_fr: "Couleur"
    }
  },
  titleModal_hash: {
    text: {
      temp_comment: "",
      l_kr: "해시태그",
      l_us: "Hashtag",
      l_gb: "Hashtag",
      l_ca: "Hashtag",
      l_ru: "Хэштег",
      l_jp: "ハッシュタグ",
      l_it: "Hashtag",
      l_es: "Hashtag",
      l_de: "Hashtag",
      l_cn: "话题标签",
      l_fr: "Hashtag"
    }
  },
  btnSelect_hash: {
    text: {
      temp_comment: "",
      l_kr: "해시태그",
      l_us: "Hashtag",
      l_gb: "Hashtag",
      l_ca: "Hashtag",
      l_ru: "Хэштег",
      l_jp: "ハッシュタグ",
      l_it: "Hashtag",
      l_es: "Hashtag",
      l_de: "Hashtag",
      l_cn: "话题标签",
      l_fr: "Hashtag"
    }
  },
  wordNullDate: {
    text: {
      temp_comment: "",
      l_kr: "날짜",
      l_us: "Date",
      l_gb: "Date",
      l_ca: "Date",
      l_ru: "Дата",
      l_jp: "日付",
      l_it: "Data",
      l_es: "Fecha",
      l_de: "Datum",
      l_cn: "日期",
      l_fr: "Date"
    }
  },
  btnCommonContained_loginRecommend: {
    text: {
      temp_comment: "",
      l_kr: "로그인 / 회원가입",
      l_us: "Log In / Sign Up",
      l_gb: "Log In / Sign Up",
      l_ca: "Log In / Sign Up",
      l_ru: "Войти / Зарегистрироваться",
      l_jp: "ログイン／新規登録",
      l_it: "Accedi / Registrati",
      l_es: "Iniciar sesión / Registrarse",
      l_de: "Anmelden / Registrieren",
      l_cn: "登录/注册",
      l_fr: "Connexion / Inscription"
    }
  },
  btnModal_ok: {
    text: {
      temp_comment: "",
      l_kr: "확인",
      l_us: "OK",
      l_gb: "OK",
      l_ca: "OK",
      l_ru: "OK",
      l_jp: "OK",
      l_it: "OK",
      l_es: "Aceptar",
      l_de: "OK",
      l_cn: "确定",
      l_fr: "OK"
    }
  },
  btnModal_cancel: {
    text: {
      temp_comment: "",
      l_kr: "취소",
      l_us: "Cancel",
      l_gb: "Cancel",
      l_ca: "Cancel",
      l_ru: "Отмена",
      l_jp: "キャンセル",
      l_it: "Annulla",
      l_es: "Cancelar",
      l_de: "Abbrechen",
      l_cn: "取消",
      l_fr: "Annuler"
    }
  },
  btnPanelToggle_cancel: {
    text: {
      temp_comment: "",
      l_kr: "취소",
      l_us: "Cancel",
      l_gb: "Cancel",
      l_ca: "Cancel",
      l_ru: "Отмена",
      l_jp: "キャンセル",
      l_it: "Annulla",
      l_es: "Cancelar",
      l_de: "Abbrechen",
      l_cn: "取消",
      l_fr: "Annuler"
    }
  },
  btnModal_close: {
    text: {
      temp_comment: "",
      l_kr: "닫기",
      l_us: "Close",
      l_gb: "Close",
      l_ca: "Close",
      l_ru: "Закрыть",
      l_jp: "閉じる",
      l_it: "Chiudi",
      l_es: "Cerrar",
      l_de: "Schließen",
      l_cn: "关闭",
      l_fr: "Fermer"
    }
  },
  btnModal_submit: {
    text: {
      temp_comment: "",
      l_kr: "제출",
      l_us: "Submit",
      l_gb: "Submit",
      l_ca: "Submit",
      l_ru: "Отправить",
      l_jp: "送信",
      l_it: "Invia",
      l_es: "Enviar",
      l_de: "Senden",
      l_cn: "提交",
      l_fr: "Envoyer"
    }
  },
  btnModal_delete: {
    text: {
      temp_comment: "",
      l_kr: "삭제",
      l_us: "Delete",
      l_gb: "Delete",
      l_ca: "Delete",
      l_ru: "Удалить",
      l_jp: "削除",
      l_it: "Elimina",
      l_es: "Eliminar",
      l_de: "Löschen",
      l_cn: "删除",
      l_fr: "Supprimer"
    }
  },
  btnModal_next: {
    text: {
      temp_comment: "",
      l_kr: "다음",
      l_us: "Next",
      l_gb: "Next",
      l_ca: "Next",
      l_ru: "Далее",
      l_jp: "次へ",
      l_it: "Avanti",
      l_es: "Siguiente",
      l_de: "Weiter",
      l_cn: "下一步",
      l_fr: "Suivant"
    }
  },
  btnModal_back: {
    text: {
      temp_comment: "",
      l_kr: "뒤로가기",
      l_us: "Back",
      l_gb: "Back",
      l_ca: "Back",
      l_ru: "Назад",
      l_jp: "戻る",
      l_it: "Indietro",
      l_es: "Atrás",
      l_de: "Zurück",
      l_cn: "返回",
      l_fr: "Retour"
    }
  },
  msg_unknownBrand: {
    text: {
      temp_comment: "",
      l_kr: "알 수 없는 브랜드입니다.",
      l_us: "Unknown brand.",
      l_gb: "Unknown brand.",
      l_ca: "Unknown brand.",
      l_ru: "Неизвестный бренд.",
      l_jp: "不明のブランドです。",
      l_it: "Marca sconosciuta.",
      l_es: "Marca desconocida.",
      l_de: "Unbekannte Marke.",
      l_cn: "未知品牌。",
      l_fr: "Marque inconnue."
    }
  },
  msg_helperBrandInputGuide: {
    text: {
      temp_comment: "",
      l_kr: "문자(a-z), 숫자(0-9) 및 공백만 입력할 수 있습니다.",
      l_us: "Only letters(a-z), numbers(0-9), and spaces can be entered.",
      l_gb: "Only letters(a-z), numbers(0-9), and spaces can be entered.",
      l_ca: "Only letters(a-z), numbers(0-9), and spaces can be entered.",
      l_ru: "Можно вводить только буквы английского алфавита (a–z), цифры (0–9) и пробелы.",
      l_jp: "文字（a-z）、数字（0-9）および空白のみ入力することができます。",
      l_it: "Si possono inserire solo lettere (a-z), numeri (0-9) e spazi.",
      l_es: "Solo puede ingresar letras (a-z), números (0-9) y espacios.",
      l_de: "Es können nur Buchstaben (a-z), Zahlen (0-9) und Leerzeichen eingegeben werden.",
      l_cn: "仅可输入英文字母（a-z），数字（0-9）以及空格。",
      l_fr: "Seules les lettres (a-z), les chiffres (0-9) et les espaces peuvent être saisis."
    }
  },
  btnList_settings: {
    text: {
      temp_comment: "",
      l_kr: "설정",
      l_us: "Settings",
      l_gb: "Settings",
      l_ca: "Settings",
      l_ru: "Настройки",
      l_jp: "設定",
      l_it: "Impostazioni",
      l_es: "Configuración",
      l_de: "Einstellungen",
      l_cn: "设置",
      l_fr: "Paramètres"
    }
  },
  btnList_membership: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative에 대하여",
      l_us: "About Maunent Creative",
      l_gb: "About Maunent Creative",
      l_ca: "About Maunent Creative",
      l_ru: "Подробнее о Maunent Creative",
      l_jp: "Maunent Creativeについて",
      l_it: "Informazioni su Maunent Creative",
      l_es: "Acerca de Maunent Creative",
      l_de: "Über Maunent Creative",
      l_cn: "关于Maunent Creative",
      l_fr: "A propos de Maunent Creative"
    }
  },
  btnList_copyLink: {
    text: {
      temp_comment: "",
      l_kr: "링크 복사",
      l_us: "Copy Link",
      l_gb: "Copy Link",
      l_ca: "Copy Link",
      l_ru: "Копировать ссылку",
      l_jp: "リンクをコピー",
      l_it: "Copia link",
      l_es: "Copiar enlace",
      l_de: "Link kopieren",
      l_cn: "复制链接",
      l_fr: "Copier le lien"
    }
  },
  btnList_logOut: {
    text: {
      temp_comment: "",
      l_kr: "로그아웃",
      l_us: "Log Out",
      l_gb: "Log Out",
      l_ca: "Log Out",
      l_ru: "Выйти",
      l_jp: "ログアウト",
      l_it: "Esci",
      l_es: "Cerrar sesión",
      l_de: "Abmelden",
      l_cn: "退出",
      l_fr: "Se déconnecter"
    }
  },
  btnList_logOutAllDevice: {
    text: {
      temp_comment: "",
      l_kr: "모든 기기에서 로그아웃",
      l_us: "Log Out of All Devices",
      l_gb: "Log Out of All Devices",
      l_ca: "Log Out of All Devices",
      l_ru: "Выйти на всех устройствах",
      l_jp: "すべての機器でログアウト",
      l_it: "Esci da tutti i dispositivi",
      l_es: "Cerrar sesión en todos los dispositivos",
      l_de: "Von allen Geräten abmelden",
      l_cn: "退出所有设备",
      l_fr: "Se déconnecter de tous les appareils"
    }
  },
  msg_copyLink: {
    text: {
      temp_comment: "",
      l_kr: "링크가 복사되었습니다!",
      l_us: "Link copied!",
      l_gb: "Link copied!",
      l_ca: "Link copied!",
      l_ru: "Ссылка скопирована!",
      l_jp: "リンクをコピーしました！",
      l_it: "Link copiato!",
      l_es: "¡Enlace copiado!",
      l_de: "Link kopiert!",
      l_cn: "链接已复制！",
      l_fr: "Lien copié !"
    }
  },
  msg_copyLinkShareMsg: {
    text: {
      temp_comment: "",
      l_kr: "스타일을 공유하고 <@무료 멤버십 쿠폰|@|coupon@>을 받아보세요.",
      l_us: "Share your style and get <@free membership coupons|@|coupon@>.",
      l_gb: "Share your style and get <@free membership coupons|@|coupon@>.",
      l_ca: "Share your style and get <@free membership coupons|@|coupon@>.",
      l_ru: "Поделитесь своим стилем и получите <@бесплатные купоны на членство|@|coupon@>.",
      l_jp: "あなたのスタイルをシェアして<@無料メンバーシップクーポン|@|coupon@>をゲット！",
      l_it: "Condividi il tuo stile e ottieni <@coupon gratuiti per l'abbonamento|@|coupon@>.",
      l_es: "Comparte tu estilo y obtén <@cupones de membresía gratis|@|coupon@>.",
      l_de: "Teile deinen Style und erhalte <@kostenlose Mitgliedschafts-Gutscheine|@|coupon@>.",
      l_cn: "分享你的穿搭即可获得<@免费会员优惠券|@|coupon@>。",
      l_fr: "Partagez votre style et obtenez des <@coupons d'adhésion gratuits|@|coupon@>."
    }
  },
  msg_copyLinkShareMsg2: {
    text: {
      temp_comment: "",
      l_kr: "(이 링크를 통해 가입한 신규 회원은 자동으로 회원님의 팔로워가 됩니다.)",
      l_us: "(New members who sign up through this link will automatically become your followers.)",
      l_gb: "(New members who sign up through this link will automatically become your followers.)",
      l_ca: "(New members who sign up through this link will automatically become your followers.)",
      l_ru: "(Новые пользователи, зарегистрировавшиеся по этой ссылке, автоматически станут вашими подписчиками.)",
      l_jp: "(このリンクから登録した新規会員は自動的にあなたのフォロワーになります。)",
      l_it: "(I nuovi membri che si registrano tramite questo link diventeranno automaticamente tuoi follower.)",
      l_es: "(Los nuevos miembros que se registren a través de este enlace se convertirán automáticamente en tus seguidores.)",
      l_de: "(Neue Mitglieder, die sich über diesen Link anmelden, werden automatisch zu Ihren Followern.)",
      l_cn: "(通过此链接注册的新用户将自动成为您的粉丝。)",
      l_fr: "(Les nouveaux membres qui s'inscrivent via ce lien deviendront automatiquement vos abonnés.)"
    }
  },
  msg_copyLinkShareMsgWithoutFunc: {
    text: {
      temp_comment: "",
      l_kr: "스타일을 공유하고 무료 멤버십 쿠폰을 받아보세요.",
      l_us: "Share your style and get free membership coupons.",
      l_gb: "Share your style and get free membership coupons.",
      l_ca: "Share your style and get free membership coupons.",
      l_ru: "Поделитесь своим стилем и получите бесплатные купоны на членство.",
      l_jp: "あなたのスタイルをシェアして無料メンバーシップクーポンをゲット！",
      l_it: "Condividi il tuo stile e ottieni coupon gratuiti per l'abbonamento.",
      l_es: "Comparte tu estilo y obtén cupones de membresía gratis.",
      l_de: "Teile deinen Style und erhalte kostenlose Mitgliedschafts-Gutscheine.",
      l_cn: "分享你的穿搭即可获得免费会员优惠券。",
      l_fr: "Partagez votre style et obtenez des coupons d'adhésion gratuits."
    }
  },
  titleModal_settings: {
    text: {
      temp_comment: "",
      l_kr: "설정",
      l_us: "Settings",
      l_gb: "Settings",
      l_ca: "Settings",
      l_ru: "Настройки",
      l_jp: "設定",
      l_it: "Impostazioni",
      l_es: "Configuración",
      l_de: "Einstellungen",
      l_cn: "设置",
      l_fr: "Paramètres"
    }
  },
  btnList_changeUsername: {
    text: {
      temp_comment: "",
      l_kr: "사용자 이름 변경",
      l_us: "Change Username",
      l_gb: "Change Username",
      l_ca: "Change Username",
      l_ru: "Изменить имя пользователя",
      l_jp: "ユーザーネームを変更",
      l_it: "Modifica il nome utente",
      l_es: "Cambiar nombre de usuario",
      l_de: "Benutzernamen ändern",
      l_cn: "更改用户名",
      l_fr: "Modifier le nom d’utilisateur"
    }
  },
  btnList_changeProfileImg: {
    text: {
      temp_comment: "",
      l_kr: "프로필 사진 변경",
      l_us: "Change Profile Photo",
      l_gb: "Change Profile Photo",
      l_ca: "Change Profile Photo",
      l_ru: "Сменить фото профиля",
      l_jp: "プロフィール写真を変更",
      l_it: "Cambia l'immagine del profilo",
      l_es: "Cambiar foto del perfil",
      l_de: "Profilbild ändern",
      l_cn: "更换头像",
      l_fr: "Modifier la photo de profil"
    }
  },
  btnList_changePassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호 변경",
      l_us: "Change Password",
      l_gb: "Change Password",
      l_ca: "Change Password",
      l_ru: "Изменить пароль",
      l_jp: "パスワードを変更",
      l_it: "Modifica password",
      l_es: "Cambiar contraseña",
      l_de: "Passwort ändern",
      l_cn: "更改密码",
      l_fr: "Modifier le mot de passe"
    }
  },
  btnList_itemVisibility: {
    text: {
      temp_comment: "",
      l_kr: "아이템 공개 설정",
      l_us: "Item visibility",
      l_gb: "Item visibility",
      l_ca: "Item visibility",
      l_ru: "Настройка видимости",
      l_jp: "アイテム公開設定",
      l_it: "Visibilità articoli",
      l_es: "Visibilidad de artículos",
      l_de: "Sichtbarkeit der Artikel",
      l_cn: "物品公开设置",
      l_fr: "Visibilité des articles"
    }
  },
  msg_nowPublic: {
    text: {
      temp_comment: "",
      l_kr: "공개됨",
      l_us: "Set to public",
      l_gb: "Set to public",
      l_ca: "Set to public",
      l_ru: "Открыто",
      l_jp: "公開中",
      l_it: "Impostato su pubblico",
      l_es: "Configurado como público",
      l_de: "Auf öffentlich gesetzt",
      l_cn: "已设为公开",
      l_fr: "Défini en public"
    }
  },
  msg_nowPrivate: {
    text: {
      temp_comment: "",
      l_kr: "비공개됨",
      l_us: "Set to private",
      l_gb: "Set to private",
      l_ca: "Set to private",
      l_ru: "Скрыто",
      l_jp: "非公開中",
      l_it: "Impostato su privato",
      l_es: "Configurado como privado",
      l_de: "Auf privat gesetzt",
      l_cn: "已设为私密",
      l_fr: "Défini en privé"
    }
  },
  btnList_deleteAccount: {
    text: {
      temp_comment: "",
      l_kr: "계정 삭제",
      l_us: "Delete Account",
      l_gb: "Delete Account",
      l_ca: "Delete Account",
      l_ru: "Удалить аккаунт",
      l_jp: "アカウントの削除",
      l_it: "Elimina l'account",
      l_es: "Eliminar cuenta",
      l_de: "Konto löschen",
      l_cn: "移除账户",
      l_fr: "Supprimer le compte"
    }
  },
  titleModal_deleteAccount: {
    text: {
      temp_comment: "",
      l_kr: "계정 삭제",
      l_us: "Delete Account",
      l_gb: "Delete Account",
      l_ca: "Delete Account",
      l_ru: "Удалить аккаунт",
      l_jp: "アカウントの削除",
      l_it: "Elimina l'account",
      l_es: "Eliminar cuenta",
      l_de: "Konto löschen",
      l_cn: "移除账户",
      l_fr: "Supprimer le compte"
    }
  },
  msg_delAccountChkbox1st: {
    text: {
      temp_comment: "",
      l_kr: "계정을 삭제하기 위해서는 Maunent Creative 구독을 해지해야 합니다.",
      l_us: "You must cancel your Maunent Creative subscription to delete your account.",
      l_gb: "You must cancel your Maunent Creative subscription to delete your account.",
      l_ca: "You must cancel your Maunent Creative subscription to delete your account.",
      l_ru: "Чтобы удалить свой аккаунт, вы должны отменить подписку на Maunent Creative.",
      l_jp: "アカウントを削除するためには、Maunent Creativeのサブスクリプションを解約してください。",
      l_it: "Devi annullare il tuo abbonamento a Maunent Creative per eliminare il tuo account.",
      l_es: "Para cancelar su cuenta debe cancelar su suscripción a Maunent Creative.",
      l_de: "Du musst dein Maunent Creative-Abonnement kündigen, um dein Konto zu löschen.",
      l_cn: "若要删除账户需取消Maunent Creative订阅。",
      l_fr: "Vous devez annuler votre abonnement à Maunent Creative pour supprimer votre compte."
    }
  },
  msg_delAccountChkbox2nd: {
    text: {
      temp_comment: "",
      l_kr: "만약 계정 삭제 신청 후 30일 이내에 다시 로그인하면, 계정 삭제 요청이 자동으로 취소됩니다.",
      l_us: "If you log in again within 30 days after applying for the deletion of your account, your account deletion request will be automatically canceled.",
      l_gb: "If you log in again within 30 days after applying for the deletion of your account, your account deletion request will be automatically cancelled.",
      l_ca: "If you log in again within 30 days after applying for the deletion of your account, your account deletion request will be automatically cancelled.",
      l_ru: "Если вы снова войдете в систему в течение 30 дней после запроса на удаление аккаунта, ваш запрос на удаление аккаунта будет автоматически отменен.",
      l_jp: "アカウント削除申請をしたあとでも、30日以内に再ログインすれば、アカウント削除リクエストが自動的に取り消されます。",
      l_it: "Se accedi nuovamente entro 30 giorni dalla richiesta di cancellazione del tuo account, la tua richiesta di eliminazione dell'account verrà annullata automaticamente.",
      l_es: "Si vuelve a iniciar su sesión dentro de los 30 días posteriores a la solicitud de eliminación de su cuenta, su solicitud de eliminación de cuenta será cancelada automáticamente.",
      l_de: "Wenn du dich innerhalb von 30 Tagen nach Beantragung der Löschung deines Kontos erneut anmeldest, wird deine Kontolöschungsanfrage automatisch storniert.",
      l_cn: "若在申请删除账户后30天以内重新登录，账户删除申请将自动取消。",
      l_fr: "Si vous vous reconnectez dans les 30 jours suivant la demande de suppression de votre compte, celle-ci sera automatiquement annulée."
    }
  },
  msg_delAccountChkbox3rd: {
    text: {
      temp_comment: "",
      l_kr: "계정 삭제 시, 계정의 데이터를 복구할 수 없습니다.",
      l_us: "When you delete your account, the data in the account cannot be recovered.",
      l_gb: "When you delete your account, the data in the account cannot be recovered.",
      l_ca: "When you delete your account, the data in the account cannot be recovered.",
      l_ru: "При удалении аккаунта данные аккаунта не восстанавливаются.",
      l_jp: "アカウント削除時、アカウントのデータは復旧することができません。",
      l_it: "Quando elimini il tuo account, i dati dell'account non possono essere recuperati.",
      l_es: "Al eliminar su cuenta, los datos de la cuenta no podrán ser recuperados.",
      l_de: "Wenn du dein Konto löschst, können die Daten im Konto nicht wiederhergestellt werden.",
      l_cn: "账户删除后，账户数据将无法恢复。",
      l_fr: "Lorsque vous supprimez votre compte, les données qu'il contient ne peuvent pas être récupérées."
    }
  },
  msg_helperLaunchCodeInput: {
    text: {
      temp_comment: "",
      l_kr: "삭제를 확인하려면 입력창에 “<<launchCode>>”라는 문구를 입력하십시오.",
      l_us: "To confirm deletion, type “<<launchCode>>” into the input field.",
      l_gb: "To confirm deletion, type “<<launchCode>>” into the input field.",
      l_ca: "To confirm deletion, type “<<launchCode>>” into the input field.",
      l_ru: "Чтобы подтвердить удаление, введите в поле ввода фразу “<<launchCode>>”.",
      l_jp: "削除を確認するには、入力ウィンドウに「<<launchCode>>」という文字を入力してください。",
      l_it: "Per confermare l'eliminazione, digita “<<launchCode>>” nella casella.",
      l_es: "Escriba “<<launchCode>>” en el campo de entrada para confirmar la eliminación.",
      l_de: "Um den Löschvorgang zu bestätigen, gib den „<<launchCode>>“ in das Eingabefeld ein.",
      l_cn: "若想确认删除，请在输入框输入<<launchCode>>。",
      l_fr: "Pour confirmer la suppression, tapez « <<launchCode>> » dans le champ de saisie."
    }
  },
  btnModal_deleteAccount: {
    text: {
      temp_comment: "",
      l_kr: "계정 삭제",
      l_us: "Delete Account",
      l_gb: "Delete Account",
      l_ca: "Delete Account",
      l_ru: "Удалить аккаунт",
      l_jp: "アカウントの削除",
      l_it: "Elimina l'account",
      l_es: "Eliminar cuenta",
      l_de: "Konto löschen",
      l_cn: "移除账户",
      l_fr: "Supprimer le compte"
    }
  },
  msg_paidUserDoesntQuit: {
    text: {
      temp_comment: "",
      l_kr: "계정을 삭제하기 위해서는 Maunent Creative 구독을 해지해야 합니다.",
      l_us: "You must cancel your Maunent Creative subscription to delete your account.",
      l_gb: "You must cancel your Maunent Creative subscription to delete your account.",
      l_ca: "You must cancel your Maunent Creative subscription to delete your account.",
      l_ru: "Чтобы удалить свой аккаунт вы должны отменить подписку на Maunent Creative.",
      l_jp: "アカウントを削除するためには、Maunent Creativeのサブスクリプションを解約してください。",
      l_it: "Devi annullare il tuo abbonamento a Maunent Creative per eliminare il tuo account.",
      l_es: "Cancele su suscripción a Maunent Creative para eliminar su cuenta.",
      l_de: "Du musst dein Maunent Creative-Abonnement kündigen, um dein Konto zu löschen.",
      l_cn: "若要删除账户需取消Maunent Creative订阅。",
      l_fr: "Vous devez annuler votre abonnement à Maunent Creative pour supprimer votre compte."
    }
  },
  msg_accountDeletionCompleted: {
    text: {
      temp_comment: "",
      l_kr: "귀하의 계정 삭제 요청이 접수되었습니다.",
      l_us: "Your account deletion request has been received.",
      l_gb: "Your account deletion request has been received.",
      l_ca: "Your account deletion request has been received.",
      l_ru: "Мы получили ваш запрос на удаление аккаунта.",
      l_jp: "あなたのアカウント削除リクエストが受付けされました。",
      l_it: "La tua richiesta di annullamento dell'account è stata ricevuta.",
      l_es: "Su solicitud de eliminación de cuenta ha sido recibida.",
      l_de: "Deine Anfrage zur Kontolöschung ist eingegangen.",
      l_cn: "您删除账户的申请已被接受。",
      l_fr: "La demande de suppression de votre compte a été reçue."
    }
  },
  btnList_uploadItem: {
    text: {
      temp_comment: "",
      l_kr: "아이템 업로드",
      l_us: "Upload Item",
      l_gb: "Upload Item",
      l_ca: "Upload Item",
      l_ru: "Загрузить вещь",
      l_jp: "アイテムアップロード",
      l_it: "Carica Articolo",
      l_es: "Cargar artículo",
      l_de: "Artikel hochladen",
      l_cn: "上传物品",
      l_fr: "Téléverser l'objet"
    }
  },
  btnCommonContained_uploadItemForOutfitUpload: {
    text: {
      temp_comment: "",
      l_kr: "아이템 업로드",
      l_us: "Upload Item",
      l_gb: "Upload Item",
      l_ca: "Upload Item",
      l_ru: "Загрузить вещь",
      l_jp: "アイテムアップロード",
      l_it: "Carica Articolo",
      l_es: "Cargar artículo",
      l_de: "Artikel hochladen",
      l_cn: "上传物品",
      l_fr: "Téléverser l'objet"
    }
  },
  btnList_deleteItem: {
    text: {
      temp_comment: "",
      l_kr: "아이템 삭제",
      l_us: "Delete Item",
      l_gb: "Delete Item",
      l_ca: "Delete Item",
      l_ru: "Удалить вещь",
      l_jp: "アイテム削除",
      l_it: "Elimina Articolo",
      l_es: "Borrar artículo",
      l_de: "Artikel löschen",
      l_cn: "删除物品",
      l_fr: "Supprimer l'objet"
    }
  },
  titleModal_scoreDetail: {
    text: {
      temp_comment: "",
      l_kr: "평점",
      l_us: "Scores",
      l_gb: "Scores",
      l_ca: "Scores",
      l_ru: "Баллы",
      l_jp: "スコア",
      l_it: "Punteggi",
      l_es: "Puntuaciones",
      l_de: "Punkte",
      l_cn: "评分",
      l_fr: "Évaluation"
    }
  },
  btnList_downloadImage: {
    text: {
      temp_comment: "",
      l_kr: "이미지 다운로드",
      l_us: "Download Image",
      l_gb: "Download Image",
      l_ca: "Download Image",
      l_ru: "Скачать изображение",
      l_jp: "画像をダウンロード",
      l_it: "Scarica l'immagine",
      l_es: "Descargar imagen",
      l_de: "Bild herunterladen",
      l_cn: "下载照片",
      l_fr: "Télécharger l'image"
    }
  },
  btnList_editOutfit: {
    text: {
      temp_comment: "",
      l_kr: "아웃핏 수정",
      l_us: "Edit Outfit",
      l_gb: "Edit Outfit",
      l_ca: "Edit Outfit",
      l_ru: "Редактировать аутфит",
      l_jp: "コーデ編集",
      l_it: "Modifica Outfit",
      l_es: "Editar outfit",
      l_de: "Outfit bearbeiten",
      l_cn: "编辑穿搭",
      l_fr: "Modifier la tenue"
    }
  },
  btnList_deleteOutfit: {
    text: {
      temp_comment: "",
      l_kr: "아웃핏 삭제",
      l_us: "Delete Outfit",
      l_gb: "Delete Outfit",
      l_ca: "Delete Outfit",
      l_ru: "Удалить аутфит",
      l_jp: "コーデ削除",
      l_it: "Elimina Outfit",
      l_es: "Borrar outfit",
      l_de: "Outfit löschen",
      l_cn: "删除穿搭",
      l_fr: "Supprimer la tenue"
    }
  },
  titleModal_deleteOutfit: {
    text: {
      temp_comment: "",
      l_kr: "아웃핏 삭제",
      l_us: "Delete Outfit",
      l_gb: "Delete Outfit",
      l_ca: "Delete Outfit",
      l_ru: "Удалить аутфит",
      l_jp: "コーデ削除",
      l_it: "Elimina Outfit",
      l_es: "Borrar outfit",
      l_de: "Outfit löschen",
      l_cn: "删除穿搭",
      l_fr: "Supprimer la tenue"
    }
  },
  msg_deleteOutfit: {
    text: {
      temp_comment: "",
      l_kr: "정말 이 아웃핏을 삭제하시겠습니까?",
      l_us: "Are you sure you want to delete this outfit?",
      l_gb: "Are you sure you want to delete this outfit?",
      l_ca: "Are you sure you want to delete this outfit?",
      l_ru: "Вы уверены, что хотите удалить этот аутфит?",
      l_jp: "本当にこのコーデを削除しますか？",
      l_it: "Sei sicuro di voler eliminare questo outfit?",
      l_es: "¿Está seguro de eliminar este outfit?",
      l_de: "Möchtest du dieses Outfit wirklich löschen?",
      l_cn: "您确定要删除此穿搭吗？",
      l_fr: "Êtes-vous sûr de vouloir supprimer cette tenue ?"
    }
  },
  titleModal_deleteItem: {
    text: {
      temp_comment: "",
      l_kr: "아이템 삭제",
      l_us: "Delete Item",
      l_gb: "Delete Item",
      l_ca: "Delete Item",
      l_ru: "Удалить вещь",
      l_jp: "アイテム削除",
      l_it: "Elimina Articolo",
      l_es: "Borrar artículo",
      l_de: "Artikel löschen",
      l_cn: "删除物品",
      l_fr: "Supprimer l'objet"
    }
  },
  msg_deleteItem: {
    text: {
      temp_comment: "",
      l_kr: "정말 이 아이템을 삭제하시겠습니까?",
      l_us: "Are you sure you want to delete this item?",
      l_gb: "Are you sure you want to delete this item?",
      l_ca: "Are you sure you want to delete this item?",
      l_ru: "Вы уверены, что хотите удалить эту вещь?",
      l_jp: "本当にこのアイテムを削除しますか？",
      l_it: "Sei sicuro di voler eliminare questo articolo?",
      l_es: "¿Está seguro de eliminar este artículo?",
      l_de: "Möchtest du diesen Artikel wirklich löschen?",
      l_cn: "您确定要删除此物品吗？",
      l_fr: "Êtes-vous sûr de vouloir supprimer cet objet ?"
    }
  },
  wordPlaceholder_email: {
    text: {
      temp_comment: "",
      l_kr: "이메일",
      l_us: "Email",
      l_gb: "Email",
      l_ca: "Email",
      l_ru: "Электронная почта",
      l_jp: "メールアドレス",
      l_it: "E-mail",
      l_es: "Correo electrónico",
      l_de: "E-Mail",
      l_cn: "邮箱",
      l_fr: "E-mail"
    }
  },
  wordPlaceholder_password: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호",
      l_us: "Password",
      l_gb: "Password",
      l_ca: "Password",
      l_ru: "Пароль",
      l_jp: "パスワード",
      l_it: "Password",
      l_es: "Contraseña",
      l_de: "Passwort",
      l_cn: "密码",
      l_fr: "Mot de passe"
    }
  },
  wordPlaceholder_confirmPassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호 다시 입력",
      l_us: "Confirm Password",
      l_gb: "Confirm Password",
      l_ca: "Confirm Password",
      l_ru: "Подтвердить пароль",
      l_jp: "パスワードを確認",
      l_it: "Conferma la password",
      l_es: "Confirma la contraseña",
      l_de: "Passwort bestätigen",
      l_cn: "确认密码",
      l_fr: "Confirmer le mot de passe"
    }
  },
  wordPlaceholder_newPassword: {
    text: {
      temp_comment: "",
      l_kr: "새 비밀번호",
      l_us: "New Password",
      l_gb: "New Password",
      l_ca: "New Password",
      l_ru: "Новый пароль",
      l_jp: "新しいパスワード",
      l_it: "Nuova password",
      l_es: "Nueva contraseña",
      l_de: "Neues Passwort",
      l_cn: "新密码",
      l_fr: "Nouveau mot de passe"
    }
  },
  wordPlaceholder_confirmNewPassword: {
    text: {
      temp_comment: "",
      l_kr: "새 비밀번호 다시 입력",
      l_us: "Confirm New Password",
      l_gb: "Confirm New Password",
      l_ca: "Confirm New Password",
      l_ru: "Подтвердите новый пароль",
      l_jp: "新しいパスワードを確認",
      l_it: "Conferma nuova password",
      l_es: "Confirmar nueva contraseña",
      l_de: "Neues Passwort bestätigen",
      l_cn: "再次输入新密码",
      l_fr: "Confirmer le nouveau mot de passe"
    }
  },
  wordPlaceholder_username: {
    text: {
      temp_comment: "",
      l_kr: "사용자 이름",
      l_us: "Username",
      l_gb: "Username",
      l_ca: "Username",
      l_ru: "Имя пользователя",
      l_jp: "ユーザーネーム",
      l_it: "Nome utente",
      l_es: "Nombre de usuario",
      l_de: "Benutzername",
      l_cn: "用户名",
      l_fr: "Nom d’utilisateur"
    }
  },
  wordPlaceholder_birthday: {
    text: {
      temp_comment: "",
      l_kr: "생년월일",
      l_us: "Date of birth",
      l_gb: "Date of birth",
      l_ca: "Date of birth",
      l_ru: "Дата рождения",
      l_jp: "生年月日",
      l_it: "Data di nascita",
      l_es: "Fecha de nacimiento",
      l_de: "Geburtsdatum",
      l_cn: "出生日期",
      l_fr: "Date de naissance"
    }
  },
  wordPlaceholder_verificationCode: {
    text: {
      temp_comment: "",
      l_kr: "인증 코드",
      l_us: "Confirmation Code",
      l_gb: "Confirmation Code",
      l_ca: "Confirmation Code",
      l_ru: "Код подтверждения",
      l_jp: "認証コード",
      l_it: "Codice di conferma",
      l_es: "Código de confirmación",
      l_de: "Bestätigungscode",
      l_cn: "验证码",
      l_fr: "Code de confirmation"
    }
  },
  msg_helperUsername: {
    text: {
      temp_comment: "",
      l_kr: "사용자 이름은 영숫자(a-z, 0-9), 밑줄(_) 또는 대시(-)만 포함해야 하며, 최소한 하나의 문자나 숫자를 포함해야 합니다.",
      l_us: "Usernames must contain only alphanumeric characters (a-z, 0-9), underscores (_), or hyphens (-), and include at least one letter or number.",
      l_gb: "Usernames must contain only alphanumeric characters (a-z, 0-9), underscores (_), or hyphens (-), and include at least one letter or number.",
      l_ca: "Usernames must contain only alphanumeric characters (a-z, 0-9), underscores (_), or hyphens (-), and include at least one letter or number.",
      l_ru: "Имя пользователя должно содержать только буквенно-цифровые символы (a-z, 0-9), подчеркивания (_) или дефисы (-), и включать как минимум одну букву или цифру.",
      l_jp: "ユーザーネームは英数字(a-z, 0-9)、アンダースコア(_)、ハイフン(-)のみを含み、少なくとも1つの文字または数字を含む必要があります。",
      l_it: "Il nome utente deve contenere solo caratteri alfanumerici (a-z, 0-9), trattini bassi (_) o trattini (-), e includere almeno una lettera o un numero.",
      l_es: "El nombre de usuario debe contener solo caracteres alfanuméricos (a-z, 0-9), guiones bajos (_) o guiones (-), e incluir al menos una letra o número.",
      l_de: "Der Benutzername darf nur alphanumerische Zeichen (a-z, 0-9), Unterstriche (_) oder Bindestriche (-) enthalten und muss mindestens einen Buchstaben oder eine Zahl beinhalten.",
      l_cn: "用户名必须只包含字母数字字符（a-z，0-9）、下划线（_）或连字符（-），并且至少包含一个字母或数字。",
      l_fr: "Le nom d'utilisateur doit contenir uniquement des caractères alphanumériques (a-z, 0-9), des traits de soulignement (_) ou des tirets (-), et inclure au moins une lettre ou un chiffre."
    }
  },
  msg_helperPrivateInfo: {
    text: {
      temp_comment: "",
      l_kr: "개인 정보는 다른 사람에게 노출되지 않습니다. 오직 맞춤형 콘텐츠 추천을 위해서만 사용됩니다.",
      l_us: "Your private information will not be revealed to others. It is only used to recommend content to you.",
      l_gb: "Your private information will not be revealed to others. It is only used to recommend content to you.",
      l_ca: "Your private information will not be revealed to others. It is only used to recommend content to you.",
      l_ru: "Ваша личная информация не будет раскрыта другим лицам. Она будет использоваться только для того, чтобы рекомендовать вам контент.",
      l_jp: "個人情報は外部に漏れることはなく、最適なコンテンツをお届けするためだけに利用されます。",
      l_it: "Le tue informazioni private non verranno rivelate a terzi. Sono utilizzate solo per consigliarti i contenuti.",
      l_es: "Su información personal no será revelada a otros. Solo se utilizará para recomendarle los contenidos.",
      l_de: "Deine privaten Informationen werden nicht an andere weitergegeben. Sie werden nur verwendet, um dir Inhalte zu empfehlen.",
      l_cn: "个人信息将只用于为您推荐信息，且不会泄露。",
      l_fr: "Vos informations privées ne seront pas divulguées à d'autres personnes. Elles ne sont utilisées que pour vous recommander du contenu."
    }
  },
  msg_warningSignUp1st: {
    text: {
      temp_comment: "",
      l_kr: "회원가입 시 실수로 잘못된 계정 정보를 입력하게 된다면, 부정확한 통계 데이터를 받게 될 수 있습니다.",
      l_us: "If you accidentally enter incorrect account information when signing up, you may receive inaccurate statistical data.",
      l_gb: "If you accidentally enter incorrect account information when signing up, you may receive inaccurate statistical data.",
      l_ca: "If you accidentally enter incorrect account information when signing up, you may receive inaccurate statistical data.",
      l_ru: "Если во время регистрации аккаунта вы случайно введете неверные данные, вы можете получить неточные статистические данные.",
      l_jp: "会員登録時に誤ったアカウント情報を入力してしまった場合、不正確な統計データを受け取ることがあります。",
      l_it: "Se inserisci accidentalmente informazioni errate sull'account quando ti iscrivi, potresti ricevere dati statistici inesatti.",
      l_es: "Si ingresa por error información personal incorrecta al registrarse, puede recibir datos estadísticos inexactos.",
      l_de: "Wenn du bei der Registrierung versehentlich falsche Kontoinformationen eingibst, erhältst du möglicherweise ungenaue statistische Daten.",
      l_cn: "如果在注册时因失误输入错误账户信息，收到的统计数据将不准确。",
      l_fr: "Si vous saisissez accidentellement des informations de compte incorrectes lors de votre inscription, vous risquez de recevoir des données statistiques inexactes."
    }
  },
  msg_warningSignUp2nd: {
    text: {
      temp_comment: "",
      l_kr: "회원가입 후에는 사용자 정보를 변경할 수 없습니다.",
      l_us: "User information cannot be changed after signing up.",
      l_gb: "User information cannot be changed after signing up.",
      l_ca: "User information cannot be changed after signing up.",
      l_ru: "Информация о пользователе не может быть изменена после регистрации.",
      l_jp: "会員登録後には、ユーザー情報を変更することはできません。",
      l_it: "I dati dell'utente non possono essere cambiati dopo l'iscrizione.",
      l_es: "No puede modificar los datos personales después de terminar su registración.",
      l_de: "Benutzerinformationen können nach der Registrierung nicht mehr geändert werden.",
      l_cn: "注册后无法更改用户信息。",
      l_fr: "Les informations de l'utilisateur ne peuvent pas être modifiées après l'inscription."
    }
  },
  msg_helperVerificationCode: {
    text: {
      temp_comment: "",
      l_kr: "<<email>> 주소로 전송된 인증 코드를 입력하세요.",
      l_us: "Enter the confirmation code we sent to <<email>>.",
      l_gb: "Enter the confirmation code we sent to <<email>>.",
      l_ca: "Enter the confirmation code we sent to <<email>>.",
      l_ru: "Введите код подтверждения, который мы отправили на электронный адрес <<email>>.",
      l_jp: "<<email>>に送信された認証コードを入力してください。",
      l_it: "Inserisci il codice di conferma che abbiamo inviato a <<email>>.",
      l_es: "Introduce el código de confirmación que hemos enviado a <<email>>.",
      l_de: "Gib den Bestätigungscode ein, den wir an <<email>> gesendet haben.",
      l_cn: "请输入 <<email>> 收到的验证码。",
      l_fr: "Entrez le code de confirmation que nous avons envoyé à <<email>>."
    }
  },
  wordSexUserInfo_null: {
    text: {
      temp_comment: "",
      l_kr: "성별",
      l_us: "Sex",
      l_gb: "Sex",
      l_ca: "Sex",
      l_ru: "Пол",
      l_jp: "性別",
      l_it: "Sesso",
      l_es: "Sexo",
      l_de: "Geschlecht",
      l_cn: "性别",
      l_fr: "Sexe"
    }
  },
  wordSexUserInfo_male: {
    text: {
      temp_comment: "",
      l_kr: "남성",
      l_us: "Male",
      l_gb: "Male",
      l_ca: "Male",
      l_ru: "Мужской",
      l_jp: "男性",
      l_it: "Uomo",
      l_es: "Hombre",
      l_de: "Männlich",
      l_cn: "男",
      l_fr: "Homme"
    }
  },
  btnSelect_maleGroup: {
    text: {
      temp_comment: "",
      l_kr: "남성",
      l_us: "Men",
      l_gb: "Men",
      l_ca: "Men",
      l_ru: "Мужчины",
      l_jp: "男性",
      l_it: "Uomini",
      l_es: "Hombres",
      l_de: "Männer",
      l_cn: "男性",
      l_fr: "Hommes"
    }
  },
  btnSelect_maleSignUp: {
    text: {
      temp_comment: "",
      l_kr: "남성",
      l_us: "Male",
      l_gb: "Male",
      l_ca: "Male",
      l_ru: "Мужской",
      l_jp: "男性",
      l_it: "Uomo",
      l_es: "Hombre",
      l_de: "Männlich",
      l_cn: "男",
      l_fr: "Homme"
    }
  },
  wordSexUserInfo_female: {
    text: {
      temp_comment: "",
      l_kr: "여성",
      l_us: "Female",
      l_gb: "Female",
      l_ca: "Female",
      l_ru: "Женский",
      l_jp: "女性",
      l_it: "Donna",
      l_es: "Mujer",
      l_de: "Weiblich",
      l_cn: "女",
      l_fr: "Femme"
    }
  },
  btnSelect_femaleGroup: {
    text: {
      temp_comment: "",
      l_kr: "여성",
      l_us: "Women",
      l_gb: "Women",
      l_ca: "Women",
      l_ru: "Женщины",
      l_jp: "女性",
      l_it: "Donne",
      l_es: "Mujeres",
      l_de: "Frauen",
      l_cn: "女性",
      l_fr: "Femmes"
    }
  },
  btnSelect_femaleSignUp: {
    text: {
      temp_comment: "",
      l_kr: "여성",
      l_us: "Female",
      l_gb: "Female",
      l_ca: "Female",
      l_ru: "Женский",
      l_jp: "女性",
      l_it: "Donna",
      l_es: "Mujer",
      l_de: "Weiblich",
      l_cn: "女",
      l_fr: "Femme"
    }
  },
  wordLoc_empty: {
    text: {
      temp_comment: "",
      l_kr: "위치",
      l_us: "Location",
      l_gb: "Location",
      l_ca: "Location",
      l_ru: "Страна",
      l_jp: "場所",
      l_it: "Località",
      l_es: "Ubicación",
      l_de: "Ort",
      l_cn: "位置",
      l_fr: "Pays"
    }
  },
  // 혹시 하단표현 어색하다면 "글로벌"도 고려해보자.
  // wordLoc_global: {
  //   text: {
  //     temp_comment: "",
  //     l_kr: "글로벌",
  //     l_us: "Global",
  //     l_gb: "Global",
  //     l_ca: "Global",
  //     l_ru: "Глобальный",
  //     l_jp: "グローバル",
  //     l_it: "Globale",
  //     l_es: "Global",
  //     l_de: "Global",
  //     l_cn: "全球",
  //     l_fr: "Global"
  //   }
  // },
  wordLoc_global: {
    text: {
      temp_comment: "",
      l_kr: "전 세계",
      l_us: "Worldwide",
      l_gb: "Worldwide",
      l_ca: "Worldwide",
      l_ru: "Весь мир",
      l_jp: "全世界",
      l_it: "Mondiale",
      l_es: "Mundial",
      l_de: "Weltweit",
      l_cn: "全球",
      l_fr: "Mondial"
    }
  },
  wordLoc_US: {
    text: {
      temp_comment: "",
      l_kr: "미국",
      l_us: "United States",
      l_gb: "United States",
      l_ca: "United States",
      l_ru: "США",
      l_jp: "アメリカ",
      l_it: "Stati Uniti",
      l_es: "Estados Unidos",
      l_de: "USA",
      l_cn: "美国",
      l_fr: "États-Unis"
    }
  },
  wordLoc_RU: {
    text: {
      temp_comment: "",
      l_kr: "러시아",
      l_us: "Russia",
      l_gb: "Russia",
      l_ca: "Russia",
      l_ru: "Россия",
      l_jp: "ロシア",
      l_it: "Russia",
      l_es: "Rusia",
      l_de: "Russland",
      l_cn: "俄罗斯",
      l_fr: "Russie"
    }
  },
  wordLoc_JP: {
    text: {
      temp_comment: "",
      l_kr: "일본",
      l_us: "Japan",
      l_gb: "Japan",
      l_ca: "Japan",
      l_ru: "Япония",
      l_jp: "日本",
      l_it: "Giappone",
      l_es: "Japón",
      l_de: "Japan",
      l_cn: "日本",
      l_fr: "Japon"
    }
  },
  wordLoc_GB: {
    text: {
      temp_comment: "",
      l_kr: "영국",
      l_us: "United Kingdom",
      l_gb: "United Kingdom",
      l_ca: "United Kingdom",
      l_ru: "Великобритания",
      l_jp: "イギリス",
      l_it: "Regno Unito",
      l_es: "Reino Unido",
      l_de: "Großbritannien",
      l_cn: "英国",
      l_fr: "Royaume-Uni"
    }
  },
  wordLoc_DE: {
    text: {
      temp_comment: "",
      l_kr: "독일",
      l_us: "Germany",
      l_gb: "Germany",
      l_ca: "Germany",
      l_ru: "Германия",
      l_jp: "ドイツ",
      l_it: "Germania",
      l_es: "Alemania",
      l_de: "Deutschland",
      l_cn: "德国",
      l_fr: "Allemagne"
    }
  },
  wordLoc_IT: {
    text: {
      temp_comment: "",
      l_kr: "이탈리아",
      l_us: "Italy",
      l_gb: "Italy",
      l_ca: "Italy",
      l_ru: "Италия",
      l_jp: "イタリア",
      l_it: "Italia",
      l_es: "Italia",
      l_de: "Italien",
      l_cn: "意大利",
      l_fr: "Italie"
    }
  },
  wordLoc_FR: {
    text: {
      temp_comment: "",
      l_kr: "프랑스",
      l_us: "France",
      l_gb: "France",
      l_ca: "France",
      l_ru: "Франция",
      l_jp: "フランス",
      l_it: "Francia",
      l_es: "Francia",
      l_de: "Frankreich",
      l_cn: "法国",
      l_fr: "France"
    }
  },
  wordLoc_ES: {
    text: {
      temp_comment: "",
      l_kr: "스페인",
      l_us: "Spain",
      l_gb: "Spain",
      l_ca: "Spain",
      l_ru: "Испания",
      l_jp: "スペイン",
      l_it: "Spagna",
      l_es: "España",
      l_de: "Spanien",
      l_cn: "西班牙",
      l_fr: "Espagne"
    }
  },
  wordLoc_KR: {
    text: {
      temp_comment: "",
      l_kr: "한국",
      l_us: "South Korea",
      l_gb: "South Korea",
      l_ca: "South Korea",
      l_ru: "Южная Корея",
      l_jp: "韓国",
      l_it: "Corea del Sud",
      l_es: "Corea del Sur",
      l_de: "Südkorea",
      l_cn: "韩国",
      l_fr: "Corée du Sud"
    }
  },
  wordLoc_CA: {
    text: {
      temp_comment: "",
      l_kr: "캐나다",
      l_us: "Canada",
      l_gb: "Canada",
      l_ca: "Canada",
      l_ru: "Канада",
      l_jp: "カナダ",
      l_it: "Canada",
      l_es: "Canadá",
      l_de: "Kanada",
      l_cn: "加拿大",
      l_fr: "Canada"
    }
  },
  wordLoc_CN: {
    text: {
      temp_comment: "",
      l_kr: "중국",
      l_us: "China",
      l_gb: "China",
      l_ca: "China",
      l_ru: "Китай",
      l_jp: "中国",
      l_it: "Cina",
      l_es: "China",
      l_de: "China",
      l_cn: "中国",
      l_fr: "Chine"
    }
  },
  btnHeader_lookbook: {
    text: {
      temp_comment: "",
      l_kr: "룩북",
      l_us: "Lookbook",
      l_gb: "Lookbook",
      l_ca: "Lookbook",
      l_ru: "Лукбук",
      l_jp: "ルックブック",
      l_it: "Lookbook",
      l_es: "Lookbook",
      l_de: "Lookbook",
      l_cn: "穿搭集",
      l_fr: "Lookbook"
    }
  },
  // // 나중에 사용할수도 있어서 냅둠
  // btnHeader_explore: {
  //   text: {
  //     temp_comment: "",
  //     l_kr: "탐색",
  //     l_us: "Explore",
  //     l_gb: "Explore",
  //     l_ca: "Explore",
  //     l_ru: "Смотреть",
  //     l_jp: "発見",
  //     l_it: "Esplora",
  //     l_es: "Explorar",
  //     l_de: "Entdecken",
  //     l_cn: "探索",
  //     l_fr: "Découvrir"
  //   }
  // },
  btnHeader_rank: {
    text: {
      temp_comment: "",
      l_kr: "랭킹",
      l_us: "Rankings",
      l_gb: "Rankings",
      l_ca: "Rankings",
      l_ru: "Рейтинги",
      l_jp: "ランキング",
      l_it: "Classifiche",
      l_es: "Rankings",
      l_de: "Ranglisten",
      l_cn: "排名",
      l_fr: "Classements"
    }
  },
  btnHeader_search: {
    text: {
      temp_comment: "",
      l_kr: "검색",
      l_us: "Search",
      l_gb: "Search",
      l_ca: "Search",
      l_ru: "Поиск",
      l_jp: "検索",
      l_it: "Cerca",
      l_es: "Búsqueda",
      l_de: "Suche",
      l_cn: "搜索",
      l_fr: "Recherche"
    }
  },
  btnHeader_upload: {
    text: {
      temp_comment: "",
      l_kr: "업로드",
      l_us: "Upload",
      l_gb: "Upload",
      l_ca: "Upload",
      l_ru: "Загрузить",
      l_jp: "アップロード",
      l_it: "Carica",
      l_es: "Cargar",
      l_de: "Hochladen",
      l_cn: "上传",
      l_fr: "Téléverser"
    }
  },
  btnHeader_portfolio: {
    text: {
      temp_comment: "",
      l_kr: "포트폴리오",
      l_us: "Portfolio",
      l_gb: "Portfolio",
      l_ca: "Portfolio",
      l_ru: "Портфолио",
      l_jp: "ポートフォリオ",
      l_it: "Portfolio",
      l_es: "Portfolio",
      l_de: "Portfolio",
      l_cn: "穿搭日记",
      l_fr: "Portfolio"
    }
  },
  btnHeader_about: {
    text: {
      temp_comment: "",
      l_kr: "서비스 소개",
      l_us: "About",
      l_gb: "About",
      l_ca: "About",
      l_ru: "О сервисе",
      l_jp: "サービス紹介",
      l_it: "Chi siamo",
      l_es: "Acerca de",
      l_de: "Über uns",
      l_cn: "服务介绍",
      l_fr: "À propos"
    }
  },
  btnHeader_explorer: {
    text: {
      temp_comment: "",
      l_kr: "둘러보기",
      l_us: "Explore",
      l_gb: "Explore",
      l_ca: "Explore",
      l_ru: "Обзор",
      l_jp: "見る",
      l_it: "Esplora",
      l_es: "Explorar",
      l_de: "Entdecken",
      l_cn: "浏览",
      l_fr: "Explorer"
    }
  },
  btnHeader_login: {
    text: {
      temp_comment: "",
      l_kr: "로그인 / 회원가입",
      l_us: "Log In / Sign Up",
      l_gb: "Log In / Sign Up",
      l_ca: "Log In / Sign Up",
      l_ru: "Войти / Зарегистрироваться",
      l_jp: "ログイン／新規登録",
      l_it: "Accedi / Registrati",
      l_es: "Iniciar sesión / Registrarse",
      l_de: "Anmelden / Registrieren",
      l_cn: "登录/注册",
      l_fr: "Connexion / Inscription"
    }
  },
  btnSelect_timeRange: {
    text: {
      temp_comment: "",
      l_kr: "날짜",
      l_us: "Date",
      l_gb: "Date",
      l_ca: "Date",
      l_ru: "Дата",
      l_jp: "日付",
      l_it: "Data",
      l_es: "Fecha",
      l_de: "Datum",
      l_cn: "日期",
      l_fr: "Date"
    }
  },
  titleModal_followingList: {
    text: {
      temp_comment: "",
      l_kr: "팔로잉 <<percent>>",
      l_us: "Following <<percent>>",
      l_gb: "Following <<percent>>",
      l_ca: "Following <<percent>>",
      l_ru: "Подписки <<percent>>",
      l_jp: "フォロー中 <<percent>>",
      l_it: "Chi segui <<percent>>",
      l_es: "Siguiendo <<percent>>",
      l_de: "Abonniert <<percent>>",
      l_cn: "关注 <<percent>>",
      l_fr: "Abonnements <<percent>>"
    }
  },
  titleModal_followerList: {
    text: {
      temp_comment: "",
      l_kr: "팔로워",
      l_us: "Followers",
      l_gb: "Followers",
      l_ca: "Followers",
      l_ru: "Подписчики",
      l_jp: "フォロワー",
      l_it: "Follower",
      l_es: "Seguidores",
      l_de: "Abonnenten",
      l_cn: "粉丝",
      l_fr: "Abonnés"
    }
  },
  btnFollowNum_following: {
    text: {
      temp_comment: "",
      l_kr: "팔로우 <<count>>",
      l_us: "<<count>> following",
      l_gb: "<<count>> following",
      l_ca: "<<count>> following",
      l_ru: "<<count>> подписок",
      l_jp: "フォロー中<<count>>人",
      l_it: "<<count>> seguiti",
      l_es: "<<count>> seguidos",
      l_de: "<<count>> abonniert",
      l_cn: "<<count>>关注",
      l_fr: "<<count>> abonnements"
    }
  },
  btnFollowNum_follower: {
    text: {
      temp_comment: "",
      l_kr: "팔로워 <<count>>",
      l_us: "<<count>> followers",
      l_gb: "<<count>> followers",
      l_ca: "<<count>> followers",
      l_ru: "<<count>> подписчиков",
      l_jp: "フォロワー<<count>>人",
      l_it: "<<count>> follower",
      l_es: "<<count>> seguidores",
      l_de: "<<count>> Abonnenten",
      l_cn: "<<count>>粉丝",
      l_fr: "<<count>> abonnés"
    }
  },
  btnCommonContained_followRecommend: {
    text: {
      temp_comment: "",
      l_kr: "팔로우하기",
      l_us: "Follow",
      l_gb: "Follow",
      l_ca: "Follow",
      l_ru: "Подписаться",
      l_jp: "フォローする",
      l_it: "Segui",
      l_es: "Seguir",
      l_de: "Abonnieren",
      l_cn: "关注",
      l_fr: "S’abonner"
    }
  },
  btnCommonContained_unfollow: {
    text: {
      temp_comment: "",
      l_kr: "팔로잉중",
      l_us: "Following",
      l_gb: "Following",
      l_ca: "Following",
      l_ru: "Подписки",
      l_jp: "フォロー中",
      l_it: "Segui già",
      l_es: "Siguiendo",
      l_de: "Abonniert",
      l_cn: "已关注",
      l_fr: "Abonné(e)"
    }
  },
  btnCommonContained_uploadOutfit: {
    text: {
      temp_comment: "",
      l_kr: "업로드",
      l_us: "Upload",
      l_gb: "Upload",
      l_ca: "Upload",
      l_ru: "Загрузить",
      l_jp: "アップロード",
      l_it: "Carica",
      l_es: "Cargar",
      l_de: "Hochladen",
      l_cn: "上传",
      l_fr: "Téléverser"
    }
  },
  btnTab_outfits: {
    text: {
      temp_comment: "",
      l_kr: "아웃핏",
      l_us: "Outfits",
      l_gb: "Outfits",
      l_ca: "Outfits",
      l_ru: "Аутфиты",
      l_jp: "コーデ",
      l_it: "Outfit",
      l_es: "Outfits",
      l_de: "Outfits",
      l_cn: "穿搭",
      l_fr: "Tenues"
    }
  },
  btnTab_bookmarked: {
    text: {
      temp_comment: "",
      l_kr: "컬렉션",
      l_us: "Collection",
      l_gb: "Collection",
      l_ca: "Collection",
      l_ru: "Коллекция",
      l_jp: "コレクション",
      l_it: "Collezione",
      l_es: "Colección",
      l_de: "Kollektion",
      l_cn: "我的合集",
      l_fr: "Collection"
    }
  },
  btnTab_items: {
    text: {
      temp_comment: "",
      l_kr: "아이템",
      l_us: "Items",
      l_gb: "Items",
      l_ca: "Items",
      l_ru: "Вещи",
      l_jp: "アイテム",
      l_it: "Articoli",
      l_es: "Artículos",
      l_de: "Artikel",
      l_cn: "物品",
      l_fr: "Objets"
    }
  },
  btnTab_allOutfits: {
    text: {
      temp_comment: "",
      l_kr: "전체",
      l_us: "All",
      l_gb: "All",
      l_ca: "All",
      l_ru: "Все",
      l_jp: "すべて",
      l_it: "Tutti",
      l_es: "Todos",
      l_de: "Alle",
      l_cn: "全部",
      l_fr: "Tous"
    }
  },
  btnTab_picks: {
    text: {
      temp_comment: "",
      l_kr: "페이버릿",
      l_us: "Favorites",
      l_gb: "Favorites",
      l_ca: "Favorites",
      l_ru: "Избранное",
      l_jp: "お気に入り",
      l_it: "Preferiti",
      l_es: "Favoritos",
      l_de: "Favoriten",
      l_cn: "收藏",
      l_fr: "Favoris"
    }
  },
  btnTab_others: {
    text: {
      temp_comment: "",
      l_kr: "기타",
      l_us: "Other",
      l_gb: "Other",
      l_ca: "Other",
      l_ru: "Другое",
      l_jp: "その他",
      l_it: "Altro",
      l_es: "Otra",
      l_de: "Sonstiges",
      l_cn: "其他",
      l_fr: "Autre"
    }
  },
  btnExitItemDeleteMode: {
    text: {
      temp_comment: "",
      l_kr: "완료",
      l_us: "Done",
      l_gb: "Done",
      l_ca: "Done",
      l_ru: "Готово",
      l_jp: "完了",
      l_it: "Fine",
      l_es: "OK",
      l_de: "Fertig",
      l_cn: "完成",
      l_fr: "OK"
    }
  },
  msg_emptyListMyItem: {
    text: {
      temp_comment: "",
      l_kr: "업로드된 아이템이 없습니다.",
      l_us: "No items have been uploaded yet.",
      l_gb: "No items have been uploaded yet.",
      l_ca: "No items have been uploaded yet.",
      l_ru: "Ни одна вещь еще не загружена.",
      l_jp: "アップロードされたアイテムがありません。",
      l_it: "Non è stato ancora caricato nessun articolo.",
      l_es: "No hay artículo cargado.",
      l_de: "Es wurden noch keine Artikel hochgeladen.",
      l_cn: "没有上传的物品。",
      l_fr: "Aucun objet n'a encore été téléversé."
    }
  },
  msg_userDoesntExist: {
    text: {
      temp_comment: "",
      l_kr: "이 사용자는 존재하지 않습니다.",
      l_us: "This user does not exist.",
      l_gb: "This user does not exist.",
      l_ca: "This user does not exist.",
      l_ru: "Такого пользователя не существует.",
      l_jp: "このユーザーは存在しませんす。",
      l_it: "Questo utente non esiste.",
      l_es: "Este usuario no existe.",
      l_de: "Dieser Benutzer existiert nicht.",
      l_cn: "该用户不存在。",
      l_fr: "Cet utilisateur n'existe pas."
    }
  },
  titleSection_items: {
    text: {
      temp_comment: "",
      l_kr: "아이템",
      l_us: "Items",
      l_gb: "Items",
      l_ca: "Items",
      l_ru: "Вещи",
      l_jp: "アイテム",
      l_it: "Articoli",
      l_es: "Artículos",
      l_de: "Artikel",
      l_cn: "物品",
      l_fr: "Objets"
    }
  },
  titleSection_outfits: {
    text: {
      temp_comment: "",
      l_kr: "아웃핏",
      l_us: "Outfits",
      l_gb: "Outfits",
      l_ca: "Outfits",
      l_ru: "Аутфиты",
      l_jp: "コーデ",
      l_it: "Outfit",
      l_es: "Outfits",
      l_de: "Outfits",
      l_cn: "穿搭",
      l_fr: "Tenues"
    }
  },
  msg_commonNetworkError: {
    text: {
      temp_comment: "",
      l_kr: "오류가 발생했습니다. 나중에 다시 시도해보세요.",
      l_us: "An error has occurred. Please try again later.",
      l_gb: "An error has occurred. Please try again later.",
      l_ca: "An error has occurred. Please try again later.",
      l_ru: "Произошла ошибка. Попробуйте еще раз позже.",
      l_jp: "エラーが発生しました。しばらくしてからもう一度お試しください。",
      l_it: "Si è verificato un errore. Riprova più tardi.",
      l_es: "Se ha producido un error. Vuelve a intentarlo más tarde.",
      l_de: "Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.",
      l_cn: "啊哦，出错了~请稍后再试试呗。",
      l_fr: "Une erreur s’est produite. Réessayez plus tard."
    }
  },
  msg_bookmarkLimit: {
    text: {
      temp_comment: "",
      l_kr: "무제한으로 저장하기 위해 Maunent Creative를 시작하세요.",
      l_us: "Start Maunent Creative to save unlimited outfits.",
      l_gb: "Start Maunent Creative to save unlimited outfits.",
      l_ca: "Start Maunent Creative to save unlimited outfits.",
      l_ru: "Подключите Maunent Creative для безлимитного сохранения",
      l_jp: "無制限に保存するためにMaunent Creativeを始めましょう。",
      l_it: "Abbonarsi a Maunent Creative per salvare outfit illimitati.",
      l_es: "Inicie Maunent Creative para guardar outfits ilimitados.",
      l_de: "Melde dich bei Maunent Creative an, um unbegrenzt zu speichern.",
      l_cn: "升级至Maunent Creative，即可享受无限保存功能。",
      l_fr: "Passez à Maunent Creative pour sauvegarder sans limite."
    }
  },
  msg_createFolderLimit: {
    text: {
      temp_comment: "",
      l_kr: "무제한으로 폴더를 생성하기 위해 Maunent Creative를 시작하세요.",
      l_us: "Start Maunent Creative to create unlimited folders.",
      l_gb: "Start Maunent Creative to create unlimited folders.",
      l_ca: "Start Maunent Creative to create unlimited folders.",
      l_ru: "Подключите Maunent Creative, чтобы создавать неограниченное количество папок.",
      l_jp: "無制限にフォルダを作成するためにMaunent Creativeを始めましょう。",
      l_it: "Abbonati a Maunent Creative per creare cartelle illimitate.",
      l_es: "Inicie Maunent Creative para crear carpetas ilimitadas.",
      l_de: "Melde dich bei Maunent Creative an, um unbegrenzt Ordner zu erstellen.",
      l_cn: "升级至Maunent Creative，即可享受无限创建文件夹功能。",
      l_fr: "Passez à Maunent Creative pour créer des dossiers sans limite."
    }
  },
  msg_outfitNotExist: {
    text: {
      temp_comment: "",
      l_kr: "존재하지 않는 아웃핏입니다.",
      l_us: "This outfit does not exist.",
      l_gb: "This outfit does not exist.",
      l_ca: "This outfit does not exist.",
      l_ru: "Этого аутфита не существует.",
      l_jp: "存在しないコーデです。",
      l_it: "Questo outfit non esiste.",
      l_es: "Este outfit no existe.",
      l_de: "Dieses Outfit existiert nicht.",
      l_cn: "穿搭不存在。",
      l_fr: "Cette tenue n'existe pas."
    }
  },
  titlePanel_changePassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호 변경",
      l_us: "Change Password",
      l_gb: "Change Password",
      l_ca: "Change Password",
      l_ru: "Изменить пароль",
      l_jp: "パスワードを変更",
      l_it: "Modifica password",
      l_es: "Cambiar contraseña",
      l_de: "Passwort ändern",
      l_cn: "更改密码",
      l_fr: "Modifier le mot de passe"
    }
  },
  msg_passwordChanged: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호가 변경되었습니다.",
      l_us: "Password changed.",
      l_gb: "Password changed.",
      l_ca: "Password changed.",
      l_ru: "Пароль изменен.",
      l_jp: "パスワードが変更されました。",
      l_it: "Password modificata.",
      l_es: "Se ha cambiado la contraseña.",
      l_de: "Passwort geändert.",
      l_cn: "密码更改成功。",
      l_fr: "Mot de passe changé."
    }
  },
  msg_enterPassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호를 입력하세요.",
      l_us: "Please enter your password.",
      l_gb: "Please enter your password.",
      l_ca: "Please enter your password.",
      l_ru: "Пожалуйста, введите ваш пароль.",
      l_jp: "パスワードを入力してください。",
      l_it: "Inserisci la tua password.",
      l_es: "Por favor, ingrese su contraseña.",
      l_de: "Bitte Passwort eingeben.",
      l_cn: "请输入您的密码。",
      l_fr: "Veuillez saisir votre mot de passe."
    }
  },
  msg_enterNewPassword: {
    text: {
      temp_comment: "",
      l_kr: "새로운 비밀번호를 입력하세요.",
      l_us: "Please enter new password.",
      l_gb: "Please enter new password.",
      l_ca: "Please enter new password.",
      l_ru: "Пожалуйста, введите новый пароль.",
      l_jp: "新しいパスワードを入力してください。",
      l_it: "Inserisci la nuova password.",
      l_es: "Por favor, ingrese su nueva contraseña.",
      l_de: "Bitte neues Passwort eingeben.",
      l_cn: "请输入新密码。",
      l_fr: "Veuillez saisir un nouveau mot de passe."
    }
  },
  msg_matchBothPassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호가 일치하지 않습니다.",
      l_us: "Please make sure both passwords match.",
      l_gb: "Please make sure both passwords match.",
      l_ca: "Please make sure both passwords match.",
      l_ru: "Убедитесь, что пароли совпадают.",
      l_jp: "一致するパスワードを入力してください。",
      l_it: "Assicurati che entrambe le password corrispondano.",
      l_es: "Asegúrate de que ambas contraseñas coincidan.",
      l_de: "Bitte stelle sicher, dass beide Passwörter übereinstimmen.",
      l_cn: "请确保两次密码输入一致。",
      l_fr: "Vérifiez que les deux mots de passe correspondent."
    }
  },
  msg_wrongCurrentPassword: {
    text: {
      temp_comment: "",
      l_kr: "이전 비밀번호가 잘못 입력되었습니다. 다시 입력해주세요.",
      l_us: "Your old password was entered incorrectly. Please enter it again.",
      l_gb: "Your old password was entered incorrectly. Please enter it again.",
      l_ca: "Your old password was entered incorrectly. Please enter it again.",
      l_ru: "Вы неправильно ввели свой старый пароль. Введите его еще раз.",
      l_jp: "旧パスワードが間違っています。もう一度入力してください。",
      l_it: "La tua password precedente è stata inserita in modo non corretto. Inseriscila di nuovo.",
      l_es: "La contraseña antigua que has introducido es incorrecta. Vuelve a intentarlo.",
      l_de: "Dein altes Passwort wurde nicht richtig eingegeben. Bitte gib es erneut ein.",
      l_cn: "旧密码输入错误，请重新输入。",
      l_fr: "L’ancien mot de passe saisi est incorrect. Veuillez recommencer."
    }
  },
  msg_newPasswordMustNew: {
    text: {
      temp_comment: "",
      l_kr: "현재 비밀번호와 다른 새 비밀번호를 만드세요.",
      l_us: "Create a new password that isn't your current password.",
      l_gb: "Create a new password that isn't your current password.",
      l_ca: "Create a new password that isn't your current password.",
      l_ru: "Создайте новый пароль, не являющийся идентичным вашему нынешнему паролю.",
      l_jp: "現在のパスワードとは異なるパスワードを作成してください。",
      l_it: "Crea una nuova password diversa dalla tua password attuale.",
      l_es: "Crea una contraseña nueva que no sea tu contraseña actual.",
      l_de: "Erstelle ein neues Passwort, das sich von deinem derzeitigen Passwort unterscheidet.",
      l_cn: "创建与当前密码不同的新密码。",
      l_fr: "Créez un nouveau mot de passe différent du mot de passe actuel."
    }
  },
  msg_passwordChangeRequestExceeded: {
    text: {
      temp_comment: "",
      l_kr: "최대 비밀번호 변경 요청 횟수를 초과하였습니다.",
      l_us: "You have exceeded the maximum number of password change requests.",
      l_gb: "You have exceeded the maximum number of password change requests.",
      l_ca: "You have exceeded the maximum number of password change requests.",
      l_ru: "Вы превысили максимальное количество запросов на смену пароля.",
      l_jp: "パスワードの最大変更リクエスト回数を超過しました。",
      l_it: "Hai superato il numero massimo di richieste di cambio password.",
      l_es: "Ha excedido el número máximo de solicitud de cambio de contraseña.",
      l_de: "Du hast die maximale Anzahl an Passwortänderungsanfragen überschritten.",
      l_cn: "已超过最多密码更改次数。",
      l_fr: "Vous avez dépassé le nombre maximal de demandes de modification du mot de passe."
    }
  },
  btnPanel_changePassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호 변경",
      l_us: "Change Password",
      l_gb: "Change Password",
      l_ca: "Change Password",
      l_ru: "Изменить пароль",
      l_jp: "パスワードを変更",
      l_it: "Modifica password",
      l_es: "Cambiar contraseña",
      l_de: "Passwort ändern",
      l_cn: "更改密码",
      l_fr: "Modifier le mot de passe"
    }
  },
  titlePanel_changeUsername: {
    text: {
      temp_comment: "",
      l_kr: "사용자 이름 변경",
      l_us: "Change Username",
      l_gb: "Change Username",
      l_ca: "Change Username",
      l_ru: "Изменить имя пользователя",
      l_jp: "ユーザーネームを変更",
      l_it: "Modifica il nome utente",
      l_es: "Cambiar nombre de usuario",
      l_de: "Benutzernamen ändern",
      l_cn: "更改用户名",
      l_fr: "Modifier le nom d’utilisateur"
    }
  },
  msg_enterNewUsername: {
    text: {
      temp_comment: "",
      l_kr: "새로운 사용자 이름을 입력하세요.",
      l_us: "Please enter a new username.",
      l_gb: "Please enter a new username.",
      l_ca: "Please enter a new username.",
      l_ru: "Пожалуйста, введите новое имя пользователя.",
      l_jp: "新しいユーザーネームを入力してください。",
      l_it: "Inserisci un nuovo nome utente.",
      l_es: "Por favor, ingrese nuevo nombre de usuario.",
      l_de: "Bitte gib einen neuen Benutzernamen ein.",
      l_cn: "请输入新用户名。",
      l_fr: "Veuillez saisir un nouveau nom d'utilisateur."
    }
  },
  msg_usernameExist: {
    text: {
      temp_comment: "",
      l_kr: "이미 존재하는 사용자 이름입니다.",
      l_us: "That username already exists.",
      l_gb: "That username already exists.",
      l_ca: "That username already exists.",
      l_ru: "Это имя пользователя уже существует.",
      l_jp: "すでに存在するユーザーネームです。",
      l_it: "Questo nome utente esiste già.",
      l_es: "Este nombre de usuario ya existe.",
      l_de: "Dieser Benutzername existiert bereits.",
      l_cn: "用户名已存在。",
      l_fr: "Ce nom d'utilisateur existe déjà."
    }
  },
  msg_usernameChanged: {
    text: {
      temp_comment: "",
      l_kr: "사용자 이름이 변경되었습니다.",
      l_us: "Your username has been changed.",
      l_gb: "Your username has been changed.",
      l_ca: "Your username has been changed.",
      l_ru: "Ваше имя пользователя изменено.",
      l_jp: "ユーザーネームが変更されました。",
      l_it: "Il tuo nome utente è stato cambiato.",
      l_es: "El nombre de usuario ha sido modificado.",
      l_de: "Dein Benutzername wurde geändert.",
      l_cn: "用户名已更改。",
      l_fr: "Votre nom d'utilisateur a été modifié."
    }
  },
  msg_usernameTooLong: {
    text: {
      temp_comment: "",
      l_kr: "사용자 이름은 <<characterLength>>글자를 초과할 수 없습니다.",
      l_us: "Username cannot exceed <<characterLength>> characters.",
      l_gb: "Username cannot exceed <<characterLength>> characters.",
      l_ca: "Username cannot exceed <<characterLength>> characters.",
      l_ru: "Имя пользователя не может превышать <<characterLength>> символов.",
      l_jp: "ユーザーネームは<<characterLength>>文字以内で作成してください。",
      l_it: "Il nome utente non può superare i <<characterLength>> caratteri.",
      l_es: "El nombre de usuario no puede superar más de <<characterLength>> caracteres.",
      l_de: "Der Benutzername darf <<characterLength>> Zeichen nicht überschreiten.",
      l_cn: "用户名不可超过<<characterLength>>字。",
      l_fr: "Le nom d'utilisateur ne peut dépasser <<characterLength>> caractères."
    }
  },
  btnPanel_changeUsername: {
    text: {
      temp_comment: "",
      l_kr: "사용자 이름 변경",
      l_us: "Change Username",
      l_gb: "Change Username",
      l_ca: "Change Username",
      l_ru: "Изменить имя пользователя",
      l_jp: "ユーザーネームを変更",
      l_it: "Modifica il nome utente",
      l_es: "Cambiar nombre de usuario",
      l_de: "Benutzernamen ändern",
      l_cn: "更改用户名",
      l_fr: "Modifier le nom d’utilisateur"
    }
  },
  titlePanel_resetPassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호 초기화",
      l_us: "Reset Password",
      l_gb: "Reset Password",
      l_ca: "Reset Password",
      l_ru: "Сбросить пароль",
      l_jp: "パスワードをリセット",
      l_it: "Reimposta password",
      l_es: "Cambiar la contraseña",
      l_de: "Passwort zurücksetzen",
      l_cn: "重置密码",
      l_fr: "Réinitialiser le mot de passe"
    }
  },
  btnPanel_resetPassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호 초기화",
      l_us: "Reset Password",
      l_gb: "Reset Password",
      l_ca: "Reset Password",
      l_ru: "Сбросить пароль",
      l_jp: "パスワードをリセット",
      l_it: "Reimposta password",
      l_es: "Cambiar la contraseña",
      l_de: "Passwort zurücksetzen",
      l_cn: "重置密码",
      l_fr: "Réinitialiser le mot de passe"
    }
  },
  msg_enterEmail: {
    text: {
      temp_comment: "",
      l_kr: "이메일을 입력하세요.",
      l_us: "Please enter your email.",
      l_gb: "Please enter your email.",
      l_ca: "Please enter your email.",
      l_ru: "Пожалуйста, введите ваш электронный адрес.",
      l_jp: "メールアドレスを入力してください。",
      l_it: "Inserisci il tuo indirizzo e-mail.",
      l_es: "Por favor, ingrese su email.",
      l_de: "Bitte gib deine E-Mail-Adresse ein.",
      l_cn: "请输入邮件。",
      l_fr: "Veuillez saisir votre adresse e-mail."
    }
  },
  msg_enterValidEmail: {
    text: {
      temp_comment: "",
      l_kr: "올바른 이메일 주소를 입력하세요.",
      l_us: "Please enter a valid email address.",
      l_gb: "Please enter a valid email address.",
      l_ca: "Please enter a valid email address.",
      l_ru: "Введите действительный электронный адрес.",
      l_jp: "有効なメールアドレスを入力してください。",
      l_it: "Inserisci un indirizzo e-mail valido.",
      l_es: "Introduce una dirección de correo electrónico válida.",
      l_de: "Bitte gib eine gültige E-Mail-Adresse ein.",
      l_cn: "请输入有效邮箱。",
      l_fr: "Veuillez entrer une adresse e-mail valide."
    }
  },
  msg_emailNotRegistered: {
    text: {
      temp_comment: "",
      l_kr: "입력한 이메일 주소와 일치하는 계정이 없습니다.",
      l_us: "The email you've entered doesn't match any account.",
      l_gb: "The email you've entered doesn't match any account.",
      l_ca: "The email you've entered doesn't match any account.",
      l_ru: "Указанный электронный адрес не связан ни с одним из действующих аккаунтов.",
      l_jp: "入力されたメールアドレスはアカウントと一致しません。",
      l_it: "L'e-mail che hai inserito non corrisponde a nessun account.",
      l_es: "El correo electrónico que has introducido no coincide con ninguna cuenta.",
      l_de: "Die von dir eingegebene E-Mail-Adresse kann keinem Konto zugeordnet werden.",
      l_cn: "找不到与输入的邮箱对应的账户。",
      l_fr: "L’adresse e-mail que vous avez entrée ne correspond à aucun compte."
    }
  },
  msg_passwordResetRequestExceeded: {
    text: {
      temp_comment: "",
      l_kr: "최대 비밀번호 재발급 요청 횟수를 초과하였습니다.",
      l_us: "You have exceeded the maximum number of password reset requests.",
      l_gb: "You have exceeded the maximum number of password reset requests.",
      l_ca: "You have exceeded the maximum number of password reset requests.",
      l_ru: "Вы превысили максимальное количество запросов на сброс пароля.",
      l_jp: "パスワードの最大再発行リクエスト回数を超過しました。",
      l_it: "Hai superato il numero massimo di richieste di reimpostazione della password.",
      l_es: "Ha excedido el número máximo de solicitud de restablecimiento de contraseña.",
      l_de: "Du hast die maximale Anzahl an Anfragen zum Zurücksetzen des Passworts überschritten.",
      l_cn: "已超过最多密码重发申请次数。",
      l_fr: "Vous avez dépassé le nombre maximal de demandes de modification du mot de passe."
    }
  },
  msg_enterVerificationCode: {
    text: {
      temp_comment: "",
      l_kr: "<<email>> 주소로 전송된 인증 코드를 입력하세요.",
      l_us: "Enter the confirmation code we sent to <<email>>.",
      l_gb: "Enter the confirmation code we sent to <<email>>.",
      l_ca: "Enter the confirmation code we sent to <<email>>.",
      l_ru: "Введите код подтверждения, который мы отправили на электронный адрес <<email>>.",
      l_jp: "<<email>>に送信された認証コードを入力してください。",
      l_it: "Inserisci il codice di conferma che abbiamo inviato a <<email>>.",
      l_es: "Introduce el código de confirmación que hemos enviado a <<email>>.",
      l_de: "Gib den Bestätigungscode ein, den wir an <<email>> gesendet haben.",
      l_cn: "请输入<<email>>收到的验证码。",
      l_fr: "Entrez le code de confirmation que nous avons envoyé à <<email>>."
    }
  },
  msg_enterVorrectVeriCode: {
    text: {
      temp_comment: "",
      l_kr: "인증 코드가 일치하지 않습니다. 다시 시도해주세요.",
      l_us: "Confirmation code doesn’t match. Please try again.",
      l_gb: "Confirmation code doesn’t match. Please try again.",
      l_ca: "Confirmation code doesn’t match. Please try again.",
      l_ru: "Код подтверждения не совпадает. Пожалуйста, попробуйте еще раз.",
      l_jp: "認証コードが一致しません。もう一度お試しください。",
      l_it: "Il codice di conferma non corrisponde. Riprova.",
      l_es: "El código de confirmación no coincide. Inténtelo de nuevo.",
      l_de: "Der Bestätigungscode stimmt nicht überein. Bitte versuche es erneut.",
      l_cn: "验证码不一致。请重新输入。",
      l_fr: "Le code de confirmation ne correspond pas. Veuillez réessayer."
    }
  },
  btnPanel_submitResetPassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호 초기화",
      l_us: "Reset Password",
      l_gb: "Reset Password",
      l_ca: "Reset Password",
      l_ru: "Сбросить пароль",
      l_jp: "パスワードをリセット",
      l_it: "Reimposta password",
      l_es: "Cambiar la contraseña",
      l_de: "Passwort zurücksetzen",
      l_cn: "重置密码",
      l_fr: "Réinitialiser le mot de passe"
    }
  },
  btnPanelToggle_goLogIn: {
    text: {
      temp_comment: "",
      l_kr: "로그인",
      l_us: "Log In",
      l_gb: "Log In",
      l_ca: "Log In",
      l_ru: "Войти",
      l_jp: "ログイン",
      l_it: "Accedi",
      l_es: "Iniciar sesión",
      l_de: "Anmelden",
      l_cn: "登录",
      l_fr: "Connexion"
    }
  },
  titlePanel_logIn: {
    text: {
      temp_comment: "",
      l_kr: "로그인",
      l_us: "Log In",
      l_gb: "Log In",
      l_ca: "Log In",
      l_ru: "Вход",
      l_jp: "ログイン",
      l_it: "Accedi",
      l_es: "Iniciar sesión",
      l_de: "Anmelden",
      l_cn: "登录",
      l_fr: "Connexion"
    }
  },
  msg_enterEmailAndPassword: {
    text: {
      temp_comment: "",
      l_kr: "이메일과 비밀번호를 입력하세요.",
      l_us: "Please enter your email and password.",
      l_gb: "Please enter your email and password.",
      l_ca: "Please enter your email and password.",
      l_ru: "Пожалуйста, введите ваш электронный адрес и пароль.",
      l_jp: "メールアドレスとパスワードを入力してください。",
      l_it: "Inserisci il tuo indirizzo e-mail e la tua password.",
      l_es: "Por favor ingrese su email y contraseña.",
      l_de: "Bitte gib deine E-Mail und dein Passwort ein.",
      l_cn: "请输入邮件与密码。",
      l_fr: "Veuillez saisir votre adresse e-mail et votre mot de passe."
    }
  },
  msg_wrongEmailOrPassword: {
    text: {
      temp_comment: "",
      l_kr: "입력된 비밀번호가 올바르지 않습니다. 다시 시도하세요.",
      l_us: "The password you entered is incorrect. Please try again.",
      l_gb: "The password you entered is incorrect. Please try again.",
      l_ca: "The password you entered is incorrect. Please try again.",
      l_ru: "Введен неверный пароль. Попробуйте ещё раз.",
      l_jp: "入力されたパスワードは正しくありません。もう一度入力してください。",
      l_it: "La password inserita non è corretta. Riprova.",
      l_es: "La contraseña que has escrito no es correcta. Vuelve a intentarlo.",
      l_de: "Das von dir eingegebene Passwort stimmt nicht. Bitte versuche es noch einmal.",
      l_cn: "密码错误，请重新输入。",
      l_fr: "Le mot de passe que vous avez entré est incorrect. Veuillez réessayer."
    }
  },
  msg_pwFormatGuide: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호는 8자 이상으로 설정해 주세요.",
      l_us: "Use at least 8 characters for your password.",
      l_gb: "Use at least 8 characters for your password.",
      l_ca: "Use at least 8 characters for your password.",
      l_ru: "Используйте не менее 8 символов для пароля.",
      l_jp: "パスワードは8文字以上で設定してください。",
      l_it: "Usa almeno 8 caratteri per la tua password.",
      l_es: "Usa al menos 8 caracteres para tu contraseña.",
      l_de: "Verwenden Sie mindestens 8 Zeichen für Ihr Passwort.",
      l_cn: "请使用至少8个字符作为您的密码。",
      l_fr: "Utilisez au moins 8 caractères pour votre mot de passe."
    }
  },
  msg_accountActivated: {
    text: {
      temp_comment: "",
      l_kr: "돌아오신 것을 환영합니다. 계정이 재활성화되었습니다.",
      l_us: "Welcome back. Your account has been reactivated.",
      l_gb: "Welcome back. Your account has been reactivated.",
      l_ca: "Welcome back. Your account has been reactivated.",
      l_ru: "Рады видеть вас снова! Ваш аккаунт повторно активирован.",
      l_jp: "おかえりなさい！アカウントが再開されました。",
      l_it: "Bentornato. Il tuo account è stato riattivato.",
      l_es: "Bienvenido de nuevo. Hemos reactivado tu cuenta.",
      l_de: "Willkommen zurück. Dein Konto wurde reaktiviert.",
      l_cn: "欢迎回来，你的账户已重新激活。",
      l_fr: "Bon retour à toi. Votre compte a été réactivé."
    }
  },
  btnPanel_cognitoLogIn: {
    text: {
      temp_comment: "",
      l_kr: "로그인",
      l_us: "Log In",
      l_gb: "Log In",
      l_ca: "Log In",
      l_ru: "Войти",
      l_jp: "ログイン",
      l_it: "Accedi",
      l_es: "Iniciar sesión",
      l_de: "Anmelden",
      l_cn: "登录",
      l_fr: "Connexion"
    }
  },
  btnForgotPassword: {
    text: {
      temp_comment: "",
      l_kr: "비밀번호를 잊으셨나요?",
      l_us: "Forgot password?",
      l_gb: "Forgot password?",
      l_ca: "Forgot password?",
      l_ru: "Забыли пароль?",
      l_jp: "パスワードを忘れた場合",
      l_it: "Password dimenticata?",
      l_es: "¿Has olvidado la contraseña?",
      l_de: "Passwort vergessen?",
      l_cn: "忘记密码了？",
      l_fr: "Mot de passe oublié ?"
    }
  },
  btnPanelToggle_goSignUp: {
    text: {
      temp_comment: "",
      l_kr: "가입하기",
      l_us: "Sign Up",
      l_gb: "Sign Up",
      l_ca: "Sign Up",
      l_ru: "Регистрация",
      l_jp: "登録する",
      l_it: "Registrati",
      l_es: "Crear cuenta",
      l_de: "Registrieren",
      l_cn: "注册",
      l_fr: "Inscription"
    }
  },
  titlePanel_signUp: {
    text: {
      temp_comment: "",
      l_kr: "가입하기",
      l_us: "Sign Up",
      l_gb: "Sign Up",
      l_ca: "Sign Up",
      l_ru: "Регистрация",
      l_jp: "登録する",
      l_it: "Registrati",
      l_es: "Crear cuenta",
      l_de: "Registrieren",
      l_cn: "注册",
      l_fr: "Inscription"
    }
  },
  msg_agreeTermsAndPolicyChkbox: {
    text: {
      temp_comment: "",
      l_kr: "나는 <@이용약관|@|terms@> 및 <@개인정보처리방침|@|privacy@>에 동의합니다.",
      l_us: "I agree to the <@Terms of Use|@|terms@> and <@Privacy Policy|@|privacy@>.",
      l_gb: "I agree to the <@Terms of Use|@|terms@> and <@Privacy Policy|@|privacy@>.",
      l_ca: "I agree to the <@Terms of Use|@|terms@> and <@Privacy Policy|@|privacy@>.",
      l_ru: "Я согласен с <@Условиями использования|@|terms@> и <@Политикой конфиденциальности|@|privacy@>.",
      l_jp: "<@利用規約|@|terms@>と<@プライバシーポリシー|@|privacy@>に同意します。",
      l_it: "Accetto le <@Condizioni d'uso|@|terms@> e l'<@Informativa sulla privacy|@|privacy@>.",
      l_es: "Acepto las <@Condiciones de uso|@|terms@> y la <@Política de privacidad|@|privacy@>.",
      l_de: "Ich stimme den <@Nutzungsbedingungen|@|terms@> und der <@Datenschutzrichtlinie|@|privacy@> zu.",
      l_cn: "我同意<@使用条款|@|terms@>和<@隐私权政策|@|privacy@>。",
      l_fr: "J'accepte les <@Conditions d'utilisation|@|terms@> et la <@Politique de confidentialité|@|privacy@>."
    }
  },
  msg_alreadyRegisteredUser: {
    text: {
      temp_comment: "",
      l_kr: "이미 등록된 이메일 주소입니다.",
      l_us: "This e-mail address is already registered.",
      l_gb: "This e-mail address is already registered.",
      l_ca: "This e-mail address is already registered.",
      l_ru: "Этот электронный адрес уже зарегистрирован.",
      l_jp: "登録済みのメールアドレスです。",
      l_it: "Questo indirizzo e-mail è già registrato.",
      l_es: "Este email ya está registrado.",
      l_de: "Diese E-Mail-Adresse ist bereits registriert.",
      l_cn: "邮件已注册。",
      l_fr: "Cette adresse e-mail est déjà enregistrée."
    }
  },
  msg_registeredUserInGoogle: {
    text: {
      temp_comment: "",
      l_kr: "Google 로그인으로 가입된 계정입니다. Google 로그인을 통해 로그인해주세요.",
      l_us: "This account was created with Google Sign-In. Please log in with Google.",
      l_gb: "This account was created with Google Sign-In. Please sign in with Google.",
      l_ca: "This account was created with Google Sign-In. Please sign in with Google.",
      l_ru: "Этот аккаунт был создан через Google. Пожалуйста, войдите через Google.",
      l_jp: "このアカウントはGoogleログインで登録されています。Googleログインからログインしてください。",
      l_it: "Questo account è stato creato con Google. Accedi con Google.",
      l_es: "Esta cuenta fue creada con Google. Inicia sesión con Google.",
      l_de: "Dieses Konto wurde mit Google erstellt. Bitte melde dich mit Google an.",
      l_cn: "该账户通过 Google 登录注册。请使用 Google 登录。",
      l_fr: "Ce compte a été créé avec Google. Veuillez vous connecter avec Google."
    }
  },
  msg_signUpCompleted: {
    text: {
      temp_comment: "",
      l_kr: "Maunent에 오신 것을 환영합니다",
      l_us: "Welcome to Maunent",
      l_gb: "Welcome to Maunent",
      l_ca: "Welcome to Maunent",
      l_ru: "Добро пожаловать в Maunent!",
      l_jp: "Maunentへようこそ",
      l_it: "Ti diamo il benvenuto su Maunent",
      l_es: "Te damos la bienvenida a Maunent",
      l_de: "Willkommen bei Maunent",
      l_cn: "欢迎加入Maunent",
      l_fr: "Bienvenue sur Maunent"
    }
  },
  msg_unavailableUsername: {
    text: {
      temp_comment: "",
      l_kr: "사용할 수 없는 사용자 이름입니다. 다른 이름을 사용하세요.",
      l_us: "This username isn't available. Please try another.",
      l_gb: "This username isn't available. Please try another.",
      l_ca: "This username isn't available. Please try another.",
      l_ru: "Это имя пользователя уже занято. Попробуйте другое.",
      l_jp: "このユーザーネームは使用できません。別のユーザーネームを選択してください。",
      l_it: "Questo nome utente non è disponibile. Prova con un altro.",
      l_es: "Este nombre de usuario no está disponible. Prueba otro.",
      l_de: "Dieser Benutzername ist nicht verfügbar. Bitte probiere einen anderen aus.",
      l_cn: "这个用户名用不了，换一个试试呗。",
      l_fr: "Ce nom d’utilisateur n’est pas disponible. Veuillez en choisir un autre."
    }
  },
  msg_codeValidationReqExceeded: {
    text: {
      temp_comment: "",
      l_kr: "코드 인증 횟수를 초과하였습니다.",
      l_us: "You have exceeded the maximum number of code confirmations.",
      l_gb: "You have exceeded the maximum number of code confirmations.",
      l_ca: "You have exceeded the maximum number of code confirmations.",
      l_ru: "Вы превысили максимальное количество подтверждений кода.",
      l_jp: "コード認証回数を超過しました。",
      l_it: "Hai superato il numero massimo di codice di conferma.",
      l_es: "Ha excedido el número máximo de confirmación de código.",
      l_de: "Du hast die maximale Anzahl an Codebestätigungen überschritten.",
      l_cn: "验证码输入次数已达上限。",
      l_fr: "Vous avez dépassé le nombre maximal de confirmations du code."
    }
  },
  btnPanel_signUp: {
    text: {
      temp_comment: "",
      l_kr: "다음",
      l_us: "Next",
      l_gb: "Next",
      l_ca: "Next",
      l_ru: "Далее",
      l_jp: "次へ",
      l_it: "Avanti",
      l_es: "Siguiente",
      l_de: "Weiter",
      l_cn: "下一步",
      l_fr: "Suivant"
    }
  },
  btnPanel_submitSignUp: {
    text: {
      temp_comment: "",
      l_kr: "가입하기",
      l_us: "Sign Up",
      l_gb: "Sign Up",
      l_ca: "Sign Up",
      l_ru: "Зарегистрироваться",
      l_jp: "登録する",
      l_it: "Registrati",
      l_es: "Crear cuenta",
      l_de: "Registrieren",
      l_cn: "注册",
      l_fr: "Inscription"
    }
  },
  titleImgUpload_outfit: {
    text: {
      temp_comment: "",
      l_kr: "아웃핏 업로드",
      l_us: "Upload Outfit",
      l_gb: "Upload Outfit",
      l_ca: "Upload Outfit",
      l_ru: "Загрузить аутфит",
      l_jp: "コーデアップロード",
      l_it: "Carica Outfit",
      l_es: "Cargar Outfit",
      l_de: "Outfit hochladen",
      l_cn: "上传穿搭",
      l_fr: "Téléverser la tenue"
    }
  },
  titleImgUpload_item: {
    text: {
      temp_comment: "",
      l_kr: "아이템 업로드",
      l_us: "Upload Item",
      l_gb: "Upload Item",
      l_ca: "Upload Item",
      l_ru: "Загрузить вещь",
      l_jp: "アイテムアップロード",
      l_it: "Carica Articolo",
      l_es: "Cargar Artículo",
      l_de: "Artikel hochladen",
      l_cn: "上传物品",
      l_fr: "Téléverser l'objet"
    }
  },
  titleImgUpload_profile: {
    text: {
      temp_comment: "",
      l_kr: "프로필 사진 변경",
      l_us: "Change Profile Photo",
      l_gb: "Change Profile Photo",
      l_ca: "Change Profile Photo",
      l_ru: "Сменить фото профиля",
      l_jp: "プロフィール写真を変更",
      l_it: "Cambia l'immagine del profilo",
      l_es: "Cambiar foto del perfil",
      l_de: "Profilbild ändern",
      l_cn: "更换头像",
      l_fr: "Modifier la photo de profil"
    }
  },
  msg_selectCategory: {
    text: {
      temp_comment: "",
      l_kr: "카테고리를 선택하세요.",
      l_us: "Select a category.",
      l_gb: "Select a category.",
      l_ca: "Select a category.",
      l_ru: "Пожалуйста, выберите категорию.",
      l_jp: "カテゴリーを選択してください。",
      l_it: "Seleziona una categoria.",
      l_es: "Seleccione una categoría.",
      l_de: "Wähle eine Kategorie.",
      l_cn: "请选择分类。",
      l_fr: "Sélectionner une catégorie."
    }
  },
  msg_enterBrand: {
    text: {
      temp_comment: "",
      l_kr: "브랜드를 입력하세요.",
      l_us: "Please enter a brand name.",
      l_gb: "Please enter a brand name.",
      l_ca: "Please enter a brand name.",
      l_ru: "Пожалуйста, введите название бренда.",
      l_jp: "ブランドを入力してください。",
      l_it: "Inserisci un nome della marca.",
      l_es: "Por favor ingrese el nombre de la marca.",
      l_de: "Bitte gib einen Markennamen ein.",
      l_cn: "请输入品牌。",
      l_fr: "Veuillez saisir un nom de marque."
    }
  },
  msg_imageTooSmall: {
    text: {
      temp_comment: "",
      l_kr: "사진이 너무 작습니다.",
      l_us: "This photo is too small.",
      l_gb: "This photo is too small.",
      l_ca: "This photo is too small.",
      l_ru: "Это фото слишком маленькое.",
      l_jp: "写真が小さすぎます。",
      l_it: "Questa foto è troppo piccola.",
      l_es: "Esta foto es muy pequeña.",
      l_de: "Dieses Foto ist zu klein.",
      l_cn: "照片过小。",
      l_fr: "Cette photo est trop petite."
    }
  },
  msg_croppedImgTooSmall: {
    text: {
      temp_comment: "",
      l_kr: "잘라낸 이미지가 너무 작습니다.",
      l_us: "Cropped image is too small.",
      l_gb: "Cropped image is too small.",
      l_ca: "Cropped image is too small.",
      l_ru: "Обрезанное изображение слишком маленькое.",
      l_jp: "切り取った画像が小さすぎます。",
      l_it: "L'immagine ritagliata è troppo piccola.",
      l_es: "La imagen editada es muy pequeña.",
      l_de: "Das zugeschnittene Bild ist zu klein.",
      l_cn: "剪切照片过小。",
      l_fr: "L'image recadrée est trop petite."
    }
  },
  msg_wrongImgFormat: {
    text: {
      temp_comment: "",
      l_kr: "허용되지 않는 이미지 타입입니다.",
      l_us: "The image file type is not supported.",
      l_gb: "The image file type is not supported.",
      l_ca: "The image file type is not supported.",
      l_ru: "Тип файла изображения не поддерживается.",
      l_jp: "許可されない画像タイプです。",
      l_it: "Il tipo di file dell'immagine non è supportato.",
      l_es: "El tipo de archivo de imagen no es compatible.",
      l_de: "Dieser Bilddateityp wird nicht unterstützt.",
      l_cn: "不支持此照片格式。",
      l_fr: "Le type de fichier image n'est pas pris en charge."
    }
  },
  msg_dragSticker: {
    text: {
      temp_comment: "",
      l_kr: "스티커를 드래그하세요.",
      l_us: "Drag this sticker.",
      l_gb: "Drag this sticker.",
      l_ca: "Drag this sticker.",
      l_ru: "Перетащите наклейку.",
      l_jp: "ステッカーをドラッグしてください。",
      l_it: "Trascina questo adesivo.",
      l_es: "Arrastre esta pegatina.",
      l_de: "Diesen Sticker ziehen.",
      l_cn: "请拖拽贴纸。",
      l_fr: "Déplacer cet autocollant."
    }
  },
  btnTab_selectedItems: {
    text: {
      temp_comment: "",
      l_kr: "선택한 아이템",
      l_us: "Selected Items",
      l_gb: "Selected Items",
      l_ca: "Selected Items",
      l_ru: "Выбранные вещи",
      l_jp: "選択したアイテム",
      l_it: "Articoli Selezionati",
      l_es: "Artículos seleccionados",
      l_de: "Ausgewählte Artikel",
      l_cn: "已选物品",
      l_fr: "Objets sélectionnés"
    }
  },
  btnTab_myItems: {
    text: {
      temp_comment: "",
      l_kr: "나의 아이템",
      l_us: "My Items",
      l_gb: "My Items",
      l_ca: "My Items",
      l_ru: "Мои вещи",
      l_jp: "マイアイテム",
      l_it: "I Miei Articoli",
      l_es: "Mis artículos",
      l_de: "Meine Artikel",
      l_cn: "我的物品",
      l_fr: "Mes objets"
    }
  },
  btnCommonContained_demoButton: {
    text: {
      temp_comment: "",
      l_kr: "팔로우하기",
      l_us: "Follow",
      l_gb: "Follow",
      l_ca: "Follow",
      l_ru: "Подписаться",
      l_jp: "フォローする",
      l_it: "Segui",
      l_es: "Seguir",
      l_de: "Abonnieren",
      l_cn: "关注",
      l_fr: "S’abonner"
    }
  },
  msg_enterCatAndBrand: {
    text: {
      temp_comment: "",
      l_kr: "카테고리와 브랜드를 입력해야 합니다.",
      l_us: "Category and brand name must be entered.",
      l_gb: "Category and brand name must be entered.",
      l_ca: "Category and brand name must be entered.",
      l_ru: "Необходимо ввести категорию и бренд.",
      l_jp: "カテゴリーとブランドを入力してください。",
      l_it: "La categoria e il nome della marca devono essere inseriti.",
      l_es: "Tiene que ingresar la categoría y marca.",
      l_de: "Kategorie und Markenname müssen eingegeben werden.",
      l_cn: "请输入分类与品牌。",
      l_fr: "La catégorie et le nom de la marque doivent être saisis."
    }
  },
  msg_outfitUploadError: {
    text: {
      temp_comment: "",
      l_kr: "업로드에 실패했습니다.",
      l_us: "Upload failed.",
      l_gb: "Upload failed.",
      l_ca: "Upload failed.",
      l_ru: "Загрузка не удалась.",
      l_jp: "アップロードに失敗しました。",
      l_it: "Caricamento fallito.",
      l_es: "Carga fallida.",
      l_de: "Upload fehlgeschlagen.",
      l_cn: "上传失败。",
      l_fr: "Echec du téléversement."
    }
  },
  titlePageError: {
    text: {
      temp_comment: "",
      l_kr: "",
      l_us: "",
      l_gb: "",
      l_ca: "",
      l_ru: "",
      l_jp: "",
      l_it: "",
      l_es: "",
      l_de: "",
      l_cn: "",
      l_fr: ""
    }
  },
  msg_pageError: {
    text: {
      temp_comment: "",
      l_kr: "잘못된 링크이거나 페이지가 삭제되었습니다.",
      l_us: "The link you followed may be broken, or the page may have been removed.",
      l_gb: "The link you followed may be broken, or the page may have been removed.",
      l_ca: "The link you followed may be broken, or the page may have been removed.",
      l_ru: "Возможно, вы воспользовались недействительной ссылкой или страница была удалена.",
      l_jp: "リンクに問題があるか、ページが削除された可能性があります。",
      l_it: "È possibile che il link che hai seguito sia corrotto o che la Pagina sia stata rimossa.",
      l_es: "Es posible que el enlace que has seguido sea incorrecto o que se haya eliminado la página.",
      l_de: "Entweder funktioniert der von dir angeklickte Link nicht oder die Seite wurde entfernt.",
      l_cn: "你点击的链接可能已损坏，或页面已被移除。",
      l_fr: "Le lien que vous avez suivi est peut-être rompu, ou la page a été supprimée."
    }
  },
  msg_nowMaintenance: {
    text: {
      temp_comment: "",
      l_kr: "잠시 점검 중입니다.",
      l_us: "We are under maintenance.",
      l_gb: "We are under maintenance.",
      l_ca: "We are under maintenance.",
      l_ru: "Находится на техническом обслуживании.",
      l_jp: "しばらく点検中です。",
      l_it: "Manutenzione in corso.",
      l_es: "Estamos en mantenimiento.",
      l_de: "Zurzeit in Bearbeitung.",
      l_cn: "系统维护中。",
      l_fr: "Nous sommes en cours de maintenance."
    }
  },
  msg_thxWaiting: {
    text: {
      temp_comment: "",
      l_kr: "기다려 주셔서 감사합니다.",
      l_us: "Thank you for your patience.",
      l_gb: "Thank you for your patience.",
      l_ca: "Thank you for your patience.",
      l_ru: "Спасибо за ожидание.",
      l_jp: "お待ちいただきありがとうございます。",
      l_it: "Grazie per la tua pazienza.",
      l_es: "Gracias por su paciencia.",
      l_de: "Vielen Dank für deine Geduld.",
      l_cn: "感谢您的等待。",
      l_fr: "Merci de votre patience."
    }
  },
  msg_emptyListSearch: {
    text: {
      temp_comment: "",
      l_kr: "검색 결과가 없습니다.",
      l_us: "No results found.",
      l_gb: "No results found.",
      l_ca: "No results found.",
      l_ru: "Ничего не найдено.",
      l_jp: "一致する結果はありませんでした。",
      l_it: "Nessun risultato trovato.",
      l_es: "No se han encontrado resultados.",
      l_de: "Keine Ergebnisse gefunden.",
      l_cn: "找不到任何结果。",
      l_fr: "Aucun résultat."
    }
  },
  msg_emptyListBookmark: {
    text: {
      temp_comment: "",
      l_kr: "다시 보고 싶은 아웃핏을 저장하세요. ",
      l_us: "Save outfits that you want to see again.",
      l_gb: "Save outfits that you want to see again.",
      l_ca: "Save outfits that you want to see again.",
      l_ru: "Сохраните аутфиты, которые хотите увидеть снова.",
      l_jp: "もう一度見たいコーデを保存してください。",
      l_it: "Salva gli outfit che vuoi vedere di nuovo.",
      l_es: "Guarde los outfit que desea volver a verlos.",
      l_de: "Speichere Outfits, die du wiedersehen möchtest.",
      l_cn: "请保存您想下次重看的穿搭。",
      l_fr: "Enregistrez les tenues que vous voulez revoir."
    }
  },
  msg_emptyListPick: {
    text: {
      temp_comment: "",
      l_kr: "나의 아웃핏 중 특별한 것들을 이곳에 저장하세요.",
      l_us: "Create an archive of your signature looks.",
      l_gb: "Create an archive of your signature looks.",
      l_ca: "Create an archive of your signature looks.",
      l_ru: "Создайте архив ваших фирменных образов.",
      l_jp: "お気に入りのコーデをここに保存しましょう。",
      l_it: "Crea un archivio dei tuoi look distintivi.",
      l_es: "Crea un archivo de tus looks característicos.",
      l_de: "Erstellen Sie ein Archiv Ihrer charakteristischen Looks.",
      l_cn: "将您特别的穿搭保存在这里。",
      l_fr: "Créez une archive de vos looks signature"
    }
  },
  msg_emptyListMyOutfit: {
    text: {
      temp_comment: "",
      l_kr: "나의 첫번째 아웃핏을 업로드하세요.",
      l_us: "Upload your first outfit.",
      l_gb: "Upload your first outfit.",
      l_ca: "Upload your first outfit.",
      l_ru: "Загрузите свой первый аутфит.",
      l_jp: "最初のコーデをアップロードしてください。",
      l_it: "Carica il tuo primo outfit.",
      l_es: "Cargue su primer outfit.",
      l_de: "Lade dein erstes Outfit hoch.",
      l_cn: "请上传您的第一个穿搭。",
      l_fr: "Téléversez votre première tenue."
    }
  },
  msg_emptyListLookbook: {
    text: {
      temp_comment: "",
      l_kr: "Maunent에서 영감을 주는 사람들을 팔로우하세요.",
      l_us: "Follow people on Maunent who inspire you.",
      l_gb: "Follow people on Maunent who inspire you.",
      l_ca: "Follow people on Maunent who inspire you.",
      l_ru: "Подпиши́тесь за людьми на Maunent, которые вас вдохновляют.",
      l_jp: "Maunentでインスピレーションを与えてくれる人たちをフォローしてください。",
      l_it: "Segui le persone su Maunent che ti ispirano.",
      l_es: "Siga a las personas quienes le inspiren en Maunent.",
      l_de: "Folge Benutzern auf Maunent, die dich inspirieren.",
      l_cn: "请在Maunent关注给您灵感的人。",
      l_fr: "Suivez les personnes qui vous inspirent sur Maunent."
    }
  },
  msg_PWARecommendation: {
    text: {
      temp_comment: "",
      l_kr: "이 웹사이트를 앱처럼 홈 화면에 설치하세요!",
      l_us: "Install this website on your home screen like an app!",
      l_gb: "Install this website on your home screen like an app!",
      l_ca: "Install this website on your home screen like an app!",
      l_ru: "Установите этот сайт на главный экран как приложение!",
      l_jp: "このウェブサイトをアプリのようにホーム画面にインストールしてください！",
      l_it: "Installa questo sito web sulla tua schermata iniziale come un'app!",
      l_es: "¡Instala este sitio web en tu pantalla de inicio como una aplicación!",
      l_de: "Installieren Sie diese Website wie eine App auf Ihrem Startbildschirm!",
      l_cn: "将此网站安装到您的主屏幕上，就像一个应用程序！",
      l_fr: "Installez ce site web sur votre écran d'accueil comme une application !"
    }
  },
  msg_installStep1: {
    text: {
      temp_comment: "",
      l_kr: "1) Safari 브라우저에서 “공유하기” 버튼을 누르세요.",
      l_us: "1) Press the “Share” button in your Safari browser.",
      l_gb: "1) Press the “Share” button in your Safari browser.",
      l_ca: "1) Press the “Share” button in your Safari browser.",
      l_ru: "1) Нажмите кнопку «Поделиться» в браузере Safari.",
      l_jp: "1）Safariブラウザで「共有する」ボタンを押してください。",
      l_it: "1) Premi il pulsante “Condividi” nel browser Safari.",
      l_es: "1) Pulse el botón “Compartir” en su navegador Safari.",
      l_de: "1) Drücken Sie in Ihrem Safari-Browser die Schaltfläche „Teilen“.",
      l_cn: "1）单击Safari浏览器中的“共享”按钮。",
      l_fr: "1) Appuyez sur le bouton « Partager » dans votre navigateur Safari."
    }
  },
  msg_installStep2: {
    text: {
      temp_comment: "",
      l_kr: "2) “홈 화면에 추가” 버튼을 누르세요.",
      l_us: "2) Press “Add to Home Screen”.",
      l_gb: "2) Press “Add to Home Screen”.",
      l_ca: "2) Press “Add to Home Screen”.",
      l_ru: "2) Нажмите «На экран “Домой”».",
      l_jp: "2）「ホーム画面に追加」ボタンを押してください。",
      l_it: "2) Premi “Aggiungi alla schermata Home”.",
      l_es: "2) Pulse “Añadir a pantalla de inicio”.",
      l_de: "2) Drücken Sie „Zum Home-Bildschirm“.",
      l_cn: "2）请点击“添加到主屏幕”。",
      l_fr: "2) Appuyez sur « Sur l'écran d'accueil »."
    }
  },
  msg_recommendChromeBrowser: {
    text: {
      temp_comment: "",
      l_kr: "최적의 사용 경험을 위해 Chrome 브라우저 사용을 권장합니다.",
      l_us: "For the best user experience, we recommend using Chrome browser.",
      l_gb: "For the best user experience, we recommend using Chrome browser.",
      l_ca: "For the best user experience, we recommend using Chrome browser.",
      l_ru: "Для оптимального пользовательского опыта рекомендуем использовать браузер Chrome.",
      l_jp: "最適なユーザー体験のため、Chrome ブラウザのご使用をお勧めします。",
      l_it: "Per un'esperienza utente ottimale, si consiglia di utilizzare il browser Chrome.",
      l_es: "Para una mejor experiencia de usuario, recomendamos usar el navegador Chrome.",
      l_de: "Für die beste Nutzererfahrung empfehlen wir die Verwendung des Chrome-Browsers.",
      l_cn: "为获得最佳用户体验，建议使用Chrome浏览器。",
      l_fr: "Pour une expérience utilisateur optimale, nous recommandons l'utilisation du navigateur Chrome."
    }
  },
  btnSnackbar_PWAInstall: {
    text: {
      temp_comment: "",
      l_kr: "설치하기",
      l_us: "Install",
      l_gb: "Install",
      l_ca: "Install",
      l_ru: "Установить",
      l_jp: "インストール",
      l_it: "Installa",
      l_es: "Instalar",
      l_de: "Installieren",
      l_cn: "安装",
      l_fr: "Installer"
    }
  },
  btnSnackbar_PWAInstallLater: {
    text: {
      temp_comment: "",
      l_kr: "나중에",
      l_us: "Not now",
      l_gb: "Not now",
      l_ca: "Not now",
      l_ru: "Не сейчас",
      l_jp: "後で",
      l_it: "Non ora",
      l_es: "Ahora no",
      l_de: "Jetzt nicht",
      l_cn: "以后再说",
      l_fr: "Plus tard"
    }
  },
  btnSnackbar_gotIt: {
    text: {
      temp_comment: "",
      l_kr: "알겠습니다",
      l_us: "Got it",
      l_gb: "Got it",
      l_ca: "Got it",
      l_ru: "Понятно",
      l_jp: "Okay",
      l_it: "Ok",
      l_es: "De acuerdo",
      l_de: "Verstanden",
      l_cn: "知道了",
      l_fr: "OK"
    }
  },
  titleSection_membership: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative",
      l_us: "Maunent Creative",
      l_gb: "Maunent Creative",
      l_ca: "Maunent Creative",
      l_ru: "Maunent Creative",
      l_jp: "Maunent Creative",
      l_it: "Maunent Creative",
      l_es: "Maunent Creative",
      l_de: "Maunent Creative",
      l_cn: "Maunent Creative",
      l_fr: "Maunent Creative"
    }
  },
  membTableElem_outfitJournalPlan: {
    text: {
      temp_comment: "",
      l_kr: "아웃핏 일기장",
      l_us: "Outfit Journal",
      l_gb: "Outfit Journal",
      l_ca: "Outfit Journal",
      l_ru: "Дневник Аутфитов",
      l_jp: "コーデ日記",
      l_it: "Diario Outfit",
      l_es: "Diario de Outfits",
      l_de: "Outfit-Tagebuch",
      l_cn: "穿搭日记",
      l_fr: "Journal de Tenues"
    }
  },
  membTableElem_maunentCreative: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative",
      l_us: "Maunent Creative",
      l_gb: "Maunent Creative",
      l_ca: "Maunent Creative",
      l_ru: "Maunent Creative",
      l_jp: "Maunent Creative",
      l_it: "Maunent Creative",
      l_es: "Maunent Creative",
      l_de: "Maunent Creative",
      l_cn: "Maunent Creative",
      l_fr: "Maunent Creative"
    }
  },
  membTableElem_voteSubmission: {
    text: {
      temp_comment: "",
      l_kr: "투표 등록",
      l_us: "Poll Creation",
      l_gb: "Poll Creation",
      l_ca: "Poll Creation",
      l_ru: "Создание опросов",
      l_jp: "投票作成",
      l_it: "Creazione Sondaggi",
      l_es: "Creación de Encuestas",
      l_de: "Umfrageerstellung",
      l_cn: "创建投票",
      l_fr: "Création de Sondages"
    }
  },
  membTableElem_voteSubmissionForFree: {
    text: {
      temp_comment: "",
      l_kr: "월 1회",
      l_us: "1 time/month",
      l_gb: "1 time/month",
      l_ca: "1 time/month",
      l_ru: "1 раз/месяц",
      l_jp: "月1回",
      l_it: "1 volta/mese",
      l_es: "1 vez/mes",
      l_de: "1 Mal/Monat",
      l_cn: "每月1次",
      l_fr: "1 fois/mois"
    }
  },
  membTableElem_voteSubmissionForMember: {
    text: {
      temp_comment: "",
      l_kr: "월 5회",
      l_us: "5 times/month",
      l_gb: "5 times/month",
      l_ca: "5 times/month",
      l_ru: "5 раз/месяц",
      l_jp: "月5回",
      l_it: "5 volte/mese",
      l_es: "5 veces/mes",
      l_de: "5 Mal/Monat",
      l_cn: "每月5次",
      l_fr: "5 fois/mois"
    }
  },
  membTableElem_voteSubmissionForMember2: {
    text: {
      temp_comment: "",
      l_kr: "(쿠폰 사용 시 무제한)",
      l_us: "(Unlimited with coupon)",
      l_gb: "(Unlimited with coupon)",
      l_ca: "(Unlimited with coupon)",
      l_ru: "(Неограниченно с купоном)",
      l_jp: "(クーポン使用時は無制限)",
      l_it: "(Illimitato con coupon)",
      l_es: "(Ilimitado con cupón)",
      l_de: "(Unbegrenzt mit Gutschein)",
      l_cn: "(使用优惠券无限制)",
      l_fr: "(Illimité avec coupon)"
    }
  },
  membTableElem_collectionSaves: {
    text: {
      temp_comment: "",
      l_kr: "컬렉션 저장",
      l_us: "Collection Saves",
      l_gb: "Collection Saves",
      l_ca: "Collection Saves",
      l_ru: "Сохранение коллекций",
      l_jp: "コレクション保存",
      l_it: "Salvataggio collezioni",
      l_es: "Guardar colecciones",
      l_de: "Sammlungen speichern",
      l_cn: "合集保存",
      l_fr: "Enregistrement de collections"
    }
  },
  membTableElem_collectionSavesForFree: {
    text: {
      temp_comment: "",
      l_kr: "최대 20개",
      l_us: "Up to 20 items",
      l_gb: "Up to 20 items",
      l_ca: "Up to 20 items",
      l_ru: "До 20 элементов",
      l_jp: "最大20個",
      l_it: "Fino a 20 elementi",
      l_es: "Hasta 20 elementos",
      l_de: "Bis zu 20 Elemente",
      l_cn: "最多20个",
      l_fr: "Jusqu'à 20 éléments"
    }
  },
  membTableElem_collectionSavesForMember: {
    text: {
      temp_comment: "",
      l_kr: "무제한",
      l_us: "Unlimited",
      l_gb: "Unlimited",
      l_ca: "Unlimited",
      l_ru: "Неограниченно",
      l_jp: "無制限",
      l_it: "Illimitato",
      l_es: "Ilimitado",
      l_de: "Unbegrenzt",
      l_cn: "无限制",
      l_fr: "Illimité"
    }
  },
  membTableElem_collectionFolders: {
    text: {
      temp_comment: "",
      l_kr: "컬렉션 폴더 생성",
      l_us: "Collection Folders",
      l_gb: "Collection Folders",
      l_ca: "Collection Folders",
      l_ru: "Папки коллекций",
      l_jp: "コレクションフォルダ",
      l_it: "Cartelle collezioni",
      l_es: "Carpetas de colecciones",
      l_de: "Sammlungsordner",
      l_cn: "合集文件夹",
      l_fr: "Dossiers de collections"
    }
  },
  membTableElem_collectionFoldersForFree: {
    text: {
      temp_comment: "",
      l_kr: "1개",
      l_us: "1 folder",
      l_gb: "1 folder",
      l_ca: "1 folder",
      l_ru: "1 папка",
      l_jp: "1個",
      l_it: "1 cartella",
      l_es: "1 carpeta",
      l_de: "1 Ordner",
      l_cn: "1个",
      l_fr: "1 dossier"
    }
  },
  membTableElem_collectionFoldersForMember: {
    text: {
      temp_comment: "",
      l_kr: "무제한",
      l_us: "Unlimited",
      l_gb: "Unlimited",
      l_ca: "Unlimited",
      l_ru: "Неограниченно",
      l_jp: "無制限",
      l_it: "Illimitato",
      l_es: "Ilimitado",
      l_de: "Unbegrenzt",
      l_cn: "无限制",
      l_fr: "Illimité"
    }
  },
  membTableElem_favoriteSaves: {
    text: {
      temp_comment: "",
      l_kr: "페이버릿 저장",
      l_us: "Favorite Saves",
      l_gb: "Favourite Saves",
      l_ca: "Favorite Saves",
      l_ru: "Сохранение избранного",
      l_jp: "お気に入り保存",
      l_it: "Salvataggio preferiti",
      l_es: "Guardar favoritos",
      l_de: "Favoriten speichern",
      l_cn: "收藏保存",
      l_fr: "Enregistrement de favoris"
    }
  },
  membTableElem_favoriteSavesForFree: {
    text: {
      temp_comment: "",
      l_kr: "무제한",
      l_us: "Unlimited",
      l_gb: "Unlimited",
      l_ca: "Unlimited",
      l_ru: "Неограниченно",
      l_jp: "無制限",
      l_it: "Illimitato",
      l_es: "Ilimitado",
      l_de: "Unbegrenzt",
      l_cn: "无限制",
      l_fr: "Illimité"
    }
  },
  membTableElem_favoriteSavesForMember: {
    text: {
      temp_comment: "",
      l_kr: "무제한",
      l_us: "Unlimited",
      l_gb: "Unlimited",
      l_ca: "Unlimited",
      l_ru: "Неограниченно",
      l_jp: "無制限",
      l_it: "Illimitato",
      l_es: "Ilimitado",
      l_de: "Unbegrenzt",
      l_cn: "无限制",
      l_fr: "Illimité"
    }
  },
  membTableElem_FavoriteFolders: {
    text: {
      temp_comment: "",
      l_kr: "페이버릿 폴더 생성",
      l_us: "Favorite Folders",
      l_gb: "Favourite Folders",
      l_ca: "Favorite Folders",
      l_ru: "Папки избранного",
      l_jp: "お気に入りフォルダ",
      l_it: "Cartelle preferiti",
      l_es: "Carpetas de favoritos",
      l_de: "Favoritenordner",
      l_cn: "收藏文件夹",
      l_fr: "Dossiers de favoris"
    }
  },
  membTableElem_FavoriteFoldersForFree: {
    text: {
      temp_comment: "",
      l_kr: "2개",
      l_us: "2 folders",
      l_gb: "2 folders",
      l_ca: "2 folders",
      l_ru: "2 папки",
      l_jp: "2個",
      l_it: "2 cartelle",
      l_es: "2 carpetas",
      l_de: "2 Ordner",
      l_cn: "2个",
      l_fr: "2 dossiers"
    }
  },
  membTableElem_FavoriteFoldersForMember: {
    text: {
      temp_comment: "",
      l_kr: "무제한",
      l_us: "Unlimited",
      l_gb: "Unlimited",
      l_ca: "Unlimited",
      l_ru: "Неограниченно",
      l_jp: "無制限",
      l_it: "Illimitato",
      l_es: "Ilimitado",
      l_de: "Unbegrenzt",
      l_cn: "无限制",
      l_fr: "Illimité"
    }
  },
  membTableElem_VoteHistoryAccess: {
    text: {
      temp_comment: "",
      l_kr: "나의 투표기록 열람",
      l_us: "Vote History Access",
      l_gb: "Vote History Access",
      l_ca: "Vote History Access",
      l_ru: "Доступ к истории голосований",
      l_jp: "投票履歴の閲覧",
      l_it: "Accesso cronologia voti",
      l_es: "Acceso al historial de votos",
      l_de: "Zugriff auf Abstimmungsverlauf",
      l_cn: "投票记录查看",
      l_fr: "Accès à l'historique des votes"
    }
  },
  membTableElem_VoteHistoryAccessForFree: {
    text: {
      temp_comment: "",
      l_kr: "✗",
      l_us: "✗",
      l_gb: "✗",
      l_ca: "✗",
      l_ru: "✗",
      l_jp: "✗",
      l_it: "✗",
      l_es: "✗",
      l_de: "✗",
      l_cn: "✗",
      l_fr: "✗"
    }
  },
  membTableElem_VoteHistoryAccessForMember: {
    text: {
      temp_comment: "",
      l_kr: "✓",
      l_us: "✓",
      l_gb: "✓",
      l_ca: "✓",
      l_ru: "✓",
      l_jp: "✓",
      l_it: "✓",
      l_es: "✓",
      l_de: "✓",
      l_cn: "✓",
      l_fr: "✓"
    }
  },
  membTableElem_searchResults: {
    text: {
      temp_comment: "",
      l_kr: "검색 결과",
      l_us: "Search Results",
      l_gb: "Search Results",
      l_ca: "Search Results",
      l_ru: "Результаты поиска",
      l_jp: "検索結果",
      l_it: "Risultati di ricerca",
      l_es: "Resultados de búsqueda",
      l_de: "Suchergebnisse",
      l_cn: "搜索结果",
      l_fr: "Résultats de recherche"
    }
  },
  membTableElem_searchResultsForFree: {
    text: {
      temp_comment: "",
      l_kr: "제한적",
      l_us: "Limited",
      l_gb: "Limited",
      l_ca: "Limited",
      l_ru: "Ограничено",
      l_jp: "制限あり",
      l_it: "Limitato",
      l_es: "Limitado",
      l_de: "Begrenzt",
      l_cn: "受限",
      l_fr: "Limité"
    }
  },
  membTableElem_searchResultsForMember: {
    text: {
      temp_comment: "",
      l_kr: "전체 결과 확인",
      l_us: "Full access",
      l_gb: "Full access",
      l_ca: "Full access",
      l_ru: "Полный доступ",
      l_jp: "全結果閲覧",
      l_it: "Accesso completo",
      l_es: "Acceso completo",
      l_de: "Vollzugriff",
      l_cn: "完整访问",
      l_fr: "Accès complet"
    }
  },
  wordMembershipPrice: {
    text: {
      temp_comment: "",
      l_kr: "<<kr_won>>원",
      l_us: "US$<<us_dollar>>",
      l_gb: "US$<<us_dollar>>",
      l_ca: "US$<<us_dollar>>",
      l_ru: "US$<<us_dollar>>",
      l_jp: "US$<<us_dollar>>",
      l_it: "US$<<us_dollar>>",
      l_es: "US$<<us_dollar>>",
      l_de: "US$<<us_dollar>>",
      l_cn: "US$<<us_dollar>>",
      l_fr: "US$<<us_dollar>>"
    }
  },
  wordMembershipBillingPeriod: {
    text: {
      temp_comment: "",
      l_kr: "/월",
      l_us: "/month",
      l_gb: "/month",
      l_ca: "/month",
      l_ru: "/месяц",
      l_jp: "／月",
      l_it: "/mese",
      l_es: "/mes",
      l_de: "/Monat",
      l_cn: "/月",
      l_fr: "/mois"
    }
  },
  msg_membershipBillingDesc: {
    text: {
      temp_comment: "",
      l_kr: "언제든 취소 가능 • 부가세 포함",
      l_us: "Cancel anytime • Includes VAT",
      l_gb: "Cancel anytime • Includes VAT",
      l_ca: "Cancel anytime • Includes VAT",
      l_ru: "Отказаться от подписки можно в любой момент • С учетом НДС",
      l_jp: "いつでも解約可能 • 消費税が含まれています。",
      l_it: "Possibilità di annullare in qualsiasi momento • IVA inclusa",
      l_es: "Posibilidad de cancelar en cualquier momento • IVA incluido",
      l_de: "Jederzeit kündbar • Einschließlich MwSt.",
      l_cn: "随时取消 • 已含增值税",
      l_fr: "Annulation possible à tout moment • TVA incluse"
    }
  },
  btnCommonContained_startFreeTrial: {
    text: {
      temp_comment: "",
      l_kr: "<<duration>>일간 무료 체험하기",
      l_us: "Try it free for <<duration>> days",
      l_gb: "Try it free for <<duration>> days",
      l_ca: "Try it free for <<duration>> days",
      l_ru: "Попробовать бесплатно в течение <<duration>> дней",
      l_jp: "<<duration>>日間無料体験",
      l_it: "Prova gratis per <<duration>> giorni",
      l_es: "Probar <<duration>> días gratis",
      l_de: "<<duration>> Tage lang kostenlos testen",
      l_cn: "免费体验<<duration>>日",
      l_fr: "Essayer gratuitement pendant <<duration>> jours"
    }
  },
  btnCommonContained_manageFreeTrial: {
    text: {
      temp_comment: "",
      l_kr: "무료 체험 관리",
      l_us: "Manage Free Trial",
      l_gb: "Manage Free Trial",
      l_ca: "Manage Free Trial",
      l_ru: "Управление бесплатной пробной версией",
      l_jp: "無料体験管理",
      l_it: "Gestisci Periodo di Prova Gratis",
      l_es: "Administrar prueba gratuita",
      l_de: "Kostenlose Testversion verwalten",
      l_cn: "管理免费体验",
      l_fr: "Gérer l'essai gratuit"
    }
  },
  btnCommonContained_startMembership: {
    text: {
      temp_comment: "",
      l_kr: "시작하기",
      l_us: "Get started",
      l_gb: "Get started",
      l_ca: "Get started",
      l_ru: "Начать",
      l_jp: "開始する",
      l_it: "Inizia",
      l_es: "Iniciar",
      l_de: "Jetzt loslegen",
      l_cn: "开始",
      l_fr: "Commencer"
    }
  },
  btnCommonContained_manageMembership: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative 관리",
      l_us: "Manage Maunent Creative",
      l_gb: "Manage Maunent Creative",
      l_ca: "Manage Maunent Creative",
      l_ru: "Управление Maunent Creative",
      l_jp: "Maunent Creative管理",
      l_it: "Gestisci Maunent Creative",
      l_es: "Administrar Maunent Creative",
      l_de: "Maunent Creative verwalten",
      l_cn: "管理Maunent Creative",
      l_fr: "Gérer Maunent Creative"
    }
  },
  btnCommonContained_freeTrialSubmit: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative 무료 체험 시작",
      l_us: "Try Maunent Creative free",
      l_gb: "Try Maunent Creative free",
      l_ca: "Try Maunent Creative free",
      l_ru: "Попробовать Maunent Creative бесплатно",
      l_jp: "Maunent Creative無料体験開始",
      l_it: "Prova Maunent Creative gratis",
      l_es: "Iniciar Maunent Creative gratuito",
      l_de: "Maunent Creative kostenlos testen",
      l_cn: "开始免费体验Maunent Creative",
      l_fr: "Essayer gratuitement Maunent Creative"
    }
  },
  msg_freeTrialDesc: {
    text: {
      temp_comment: "",
      l_kr: "결제 정보는 필요하지 않습니다. ",
      l_us: "No payment information is required.",
      l_gb: "No payment information is required.",
      l_ca: "No payment information is required.",
      l_ru: "Платежная информация не требуется.",
      l_jp: "決済情報は必要ありません。",
      l_it: "Non sono richieste informazioni per il pagamento.",
      l_es: "No se requiere información de pago.",
      l_de: "Es sind keine Zahlungsinformationen erforderlich.",
      l_cn: "无需付款信息。",
      l_fr: "Aucune information de paiement n'est exigée."
    }
  },
  btnCommonContained_unsubscribeMembership: {
    text: {
      temp_comment: "",
      l_kr: "구독 해지",
      l_us: "Unsubscribe",
      l_gb: "Unsubscribe",
      l_ca: "Unsubscribe",
      l_ru: "Отписаться",
      l_jp: "サブスクリプション解約",
      l_it: "Disiscriviti",
      l_es: "Cancelar suscripción",
      l_de: "Abbestellen",
      l_cn: "取消订阅",
      l_fr: "Se désabonner"
    }
  },
  btnCommonContained_refund: {
    text: {
      temp_comment: "",
      l_kr: "환불 요청",
      l_us: "Request a refund",
      l_gb: "Request a refund",
      l_ca: "Request a refund",
      l_ru: "Запросить возврат средств",
      l_jp: "返金をリクエストする",
      l_it: "Richiedere un rimborso",
      l_es: "Solicitar un reembolso",
      l_de: "Eine Rückerstattung beantragen",
      l_cn: "请求退款",
      l_fr: "Demander un remboursement"
    }
  },
  wordMembershipDate_membershipEndDate: {
    text: {
      temp_comment: "",
      l_kr: "종료일",
      l_us: "End date",
      l_gb: "End date",
      l_ca: "End date",
      l_ru: "Дата окончания",
      l_jp: "終了日",
      l_it: "Data di fine",
      l_es: "Fecha de finalización",
      l_de: "Enddatum",
      l_cn: "结束日期",
      l_fr: "Date de fin"
    }
  },
  wordMembershipDate_subAvailableDate: {
    text: {
      temp_comment: "",
      l_kr: "재가입 가능일",
      l_us: "Eligible re-subscription date",
      l_gb: "Eligible re-subscription date",
      l_ca: "Eligible re-subscription date",
      l_ru: "Дата повторной подписки",
      l_jp: "再登録可能な日付",
      l_it: "Data idonea per la ri-iscrizione",
      l_es: "Fecha elegible para la re-suscripción",
      l_de: "Zulässiges Wiederanmeldedatum",
      l_cn: "符合条件的重新订阅日期",
      l_fr: "Date éligible à la réinscription"
    }
  },
  wordMembershipDate_membershipNextBillingDate: {
    text: {
      temp_comment: "",
      l_kr: "다음 결제 예정일",
      l_us: "Next billing date",
      l_gb: "Next billing date",
      l_ca: "Next billing date",
      l_ru: "Дата следующей оплаты",
      l_jp: "次回の決済予定日",
      l_it: "Prossima data di pagamento",
      l_es: "Siguiente fecha de facturación",
      l_de: "Nächstes Abrechnungsdatum",
      l_cn: "下次预计付款日期",
      l_fr: "Prochaine date de facturation"
    }
  },
  msg_membershipPaused: {
    text: {
      temp_comment: "",
      l_kr: "현재 구독 정지 상태입니다.",
      l_us: "Your subscription is currently suspended.",
      l_gb: "Your subscription is currently suspended.",
      l_ca: "Your subscription is currently suspended.",
      l_ru: "В настоящее время ваша подписка приостановлена.",
      l_jp: "現在、サブスクリプション停止状態です。",
      l_it: "Il tuo abbonamento è attualmente sospeso.",
      l_es: "Su suscripción está suspendida actualmente.",
      l_de: "Dein Abonnement ist derzeit ausgesetzt.",
      l_cn: "目前为订阅停止状态。",
      l_fr: "Votre abonnement est actuellement en cours."
    }
  },
  wordMembershipDate_freeTrialStartDate: {
    text: {
      temp_comment: "",
      l_kr: "무료 체험 시작일",
      l_us: "Start date of free trial",
      l_gb: "Start date of free trial",
      l_ca: "Start date of free trial",
      l_ru: "Дата начала бесплатного пробного периода",
      l_jp: "無料体験開始日",
      l_it: "Data d'inizio del periodo di prova gratuito",
      l_es: "Fecha de inicio de la prueba gratuita",
      l_de: "Startdatum der kostenlosen Testversion",
      l_cn: "免费体验开始日期",
      l_fr: "Date de début de l'essai gratuit"
    }
  },
  wordMembershipDate_freeTrialEndDate: {
    text: {
      temp_comment: "",
      l_kr: "무료 체험 종료일",
      l_us: "End date of free trial",
      l_gb: "End date of free trial",
      l_ca: "End date of free trial",
      l_ru: "Дата окончания бесплатного пробного периода",
      l_jp: "無料体験終了日",
      l_it: "Data di fine del periodo di prova gratuito",
      l_es: "Fecha de finalización de la prueba gratuita",
      l_de: "Enddatum der kostenlosen Testversion",
      l_cn: "免费体验结束日期",
      l_fr: "Date de fin de l'essai gratuit"
    }
  },
  titleSection_faq: {
    text: {
      temp_comment: "",
      l_kr: "FAQ",
      l_us: "FAQ",
      l_gb: "FAQ",
      l_ca: "FAQ",
      l_ru: "FAQ",
      l_jp: "よくあるご質問",
      l_it: "FAQ",
      l_es: "Preguntas frecuentes",
      l_de: "Häufig gestellte Fragen",
      l_cn: "FAQ",
      l_fr: "FAQ"
    }
  },
  // msg_faqQuestion1: {
  //   text: {
  //     temp_comment: "",
  //     l_kr: "무료 평가판이 종료되면 비용을 지불해야 하나요?",
  //     l_us: "Do I have to pay when the free trial ends?",
  //     l_gb: "Do I have to pay when the free trial ends?",
  //     l_ca: "Do I have to pay when the free trial ends?",
  //     l_ru: "Нужно ли платить по окончании бесплатного пробного периода?",
  //     l_jp: "無料評価版が終了したら、費用を支払わなければいけないのですか？",
  //     l_it: "Devo pagare una volta terminata la prova gratuita?",
  //     l_es: "¿Tengo que pagar cuando finalice la prueba gratuita?",
  //     l_de: "Muss ich bezahlen, wenn die kostenlose Testversion endet?",
  //     l_cn: "免费体验结束后是否需要付费？",
  //     l_fr: "Dois-je payer lorsque l'essai gratuit s'achève ?"
  //   }
  // },
  // msg_faqAnswer1: {
  //   text: {
  //     temp_comment: "",
  //     l_kr: "아니요. 무료 체험 기간이 종료되면 Maunent Creative는 자동으로 구독이 취소됩니다. 무료 체험을 시작할 때 결제 정보가 필요하지 않습니다.",
  //     l_us: "No. At the end of the free trial period, your subscription to Maunent Creative is automatically canceled. No payment information is required to start free trial.",
  //     l_gb: "No. At the end of the free trial period, your subscription to Maunent Creative is automatically canceled. No payment information is required to start free trial.",
  //     l_ca: "No. At the end of the free trial period, your subscription to Maunent Creative is automatically canceled. No payment information is required to start free trial.",
  //     l_ru: "Нет. По окончании бесплатного пробного периода ваша подписка на Maunent Creative автоматически отменяется. Для того чтобы начать бесплатную пробную версию платежная информация не требуется.",
  //     l_jp: "いいえ。無料体験期間が終了したら、Maunent Creativeは自動的にサブスクリプションが取り消されます。無料体験を開始する際、決済情報は不要です。",
  //     l_it: "No. Alla fine del periodo di prova gratuita, il tuo abbonamento a Maunent Creative viene interrotto in automatico. Non è richiesta alcuna informazione di pagamento per iniziare la prova gratuita.",
  //     l_es: "No. Al finalizar el período de prueba gratuita, su suscripción a Maunent Creative se cancelará automáticamente. No se requiere información de pago para iniciar la prueba gratuita.",
  //     l_de: "Nein. Am Ende der kostenlosen Probezeit wird dein Abonnement von Maunent Creative automatisch gekündigt. Es sind keine Zahlungsinformationen erforderlich, um die kostenlose Testversion zu starten.",
  //     l_cn: "不。免费体验期间结束后Maunent Creative订阅将自动取消。在开始免费体验时无需输入付款信息。",
  //     l_fr: "Non. À la fin de la période d'essai gratuit, votre abonnement à Maunent Creative est automatiquement annulé. Aucune information de paiement n'est requise pour commencer l'essai gratuit."
  //   }
  // },
  // msg_faqQuestion2: {
  //   text: {
  //     temp_comment: "",
  //     l_kr: "무료 체험 사용 기간은 며칠입니까?",
  //     l_us: "How long is the free trial period?",
  //     l_gb: "How long is the free trial period?",
  //     l_ca: "How long is the free trial period?",
  //     l_ru: "Сколько дней длится бесплатный пробный период?",
  //     l_jp: "無料体験使用期間は何日ですか？",
  //     l_it: "Quanto dura il periodo di prova gratuita?",
  //     l_es: "¿Cuánto dura el período de prueba gratuita?",
  //     l_de: "Wie lange dauert die kostenlose Probezeit?",
  //     l_cn: "免费体验使用时间是几天？",
  //     l_fr: "Quelle est la durée de la période d'essai gratuite ?"
  //   }
  // },
  // msg_faqAnswer2: {
  //   text: {
  //     temp_comment: "",
  //     l_kr: "Maunent Creative의 무료 체험 사용 기간은 <<duration>>일입니다.",
  //     l_us: "The free Maunent Creative trial lasts for <<duration>> days.",
  //     l_gb: "The free Maunent Creative trial lasts for <<duration>> days.",
  //     l_ca: "The free Maunent Creative trial lasts for <<duration>> days.",
  //     l_ru: "Бесплатный пробный период Maunent Creative длится <<duration>> дней.",
  //     l_jp: "Maunent Creativeの無料体験使用期間は、<<duration>>日です。",
  //     l_it: "La prova gratuita di Maunent Creative dura <<duration>> giorni.",
  //     l_es: "El período de prueba gratuita de Maunent Creative es de <<duration>> días.",
  //     l_de: "Die kostenlose Testversion von Maunent Creative dauert <<duration>> Tage.",
  //     l_cn: "Maunent Creative免费体验时间是<<duration>>日。",
  //     l_fr: "L'essai gratuit de Maunent Creative dure <<duration>> jours."
  //   }
  // },
  msg_faqQuestion3: {
    text: {
      temp_comment: "",
      l_kr: "언제든지 취소할 수 있습니까?",
      l_us: "Can I cancel at any time?",
      l_gb: "Can I cancel at any time?",
      l_ca: "Can I cancel at any time?",
      l_ru: "Могу ли я сделать отмену в любое время?",
      l_jp: "いつでも取り消すことができますか？",
      l_it: "Posso annullarla in qualsiasi momento?",
      l_es: "¿Puedo cancelar en cualquier momento?",
      l_de: "Kann ich jederzeit kündigen?",
      l_cn: "是否可以随时取消？",
      l_fr: "Puis-je annuler à tout moment ?"
    }
  },
  msg_faqAnswer3: {
    text: {
      temp_comment: "",
      l_kr: "물론입니다. 위약금 없이 언제든지 취소할 수 있습니다.",
      l_us: "Yes, absolutely. You can cancel at any time without penalty.",
      l_gb: "Yes, absolutely. You can cancel at any time without penalty.",
      l_ca: "Yes, absolutely. You can cancel at any time without penalty.",
      l_ru: "Да, конечно. Вы можете сделать отмену в любое время без штрафных санкций.",
      l_jp: "もちろんです。違約金なしにいつでも取り消すことができます。",
      l_it: "Sì, certamente. Puoi annullare in qualsiasi momento senza alcuna penale.",
      l_es: "Sí, absolutamente. Puede cancelar en cualquier momento sin penalización.",
      l_de: "Ja absolut. Du kannst jederzeit ohne Konsequenzen kündigen.",
      l_cn: "当然。无需违约金，可随时取消。",
      l_fr: "Oui, absolument. Vous pouvez annuler à tout moment sans pénalité."
    }
  },
  msg_faqQuestion4: {
    text: {
      temp_comment: "",
      l_kr: "환불 정책에 대해 알려주세요.",
      l_us: "Can you tell me about the refund policy?",
      l_gb: "Can you tell me about the refund policy?",
      l_ca: "Can you tell me about the refund policy?",
      l_ru: "Можете рассказать о политике возврата средств?",
      l_jp: "返金ポリシーについて教えてください。",
      l_it: "Puoi spiegarmi la politica di rimborso?",
      l_es: "¿Puede informarme sobre la política de reembolso?",
      l_de: "Können Sie mir die Rückerstattungsrichtlinie erklären?",
      l_cn: "请告诉我退款政策。",
      l_fr: "Pouvez-vous m’expliquer la politique de remboursement ?"
    }
  },
  msg_faqAnswer4: {
    text: {
      temp_comment: "",
      l_kr: "결제 승인 시점 이후 Maunent Creative를 이용한 이력이 없는 구독회원이 결제일로부터 7일 이내에 환불을 요청할 경우 전액 환불이 가능합니다.",
      l_us: "If a subscribed member has not used Maunent Creative after the payment has been approved, a full refund is available within 7 days from the payment date upon request.",
      l_gb: "If a subscribed member has not used Maunent Creative after the payment has been approved, a full refund is available within 7 days from the payment date upon request.",
      l_ca: "If a subscribed member has not used Maunent Creative after the payment has been approved, a full refund is available within 7 days from the payment date upon request.",
      l_ru: "Если подписчик не использовал Maunent Creative после подтверждения платежа, он может запросить полный возврат средств в течение 7 дней с даты оплаты.",
      l_jp: "決済承認後にMaunent Creativeを利用していないサブスクリプション会員は、決済日から7日以内にリクエストした場合、全額返金を受けることができます。",
      l_it: "Se un abbonato non ha utilizzato Maunent Creative dopo l’approvazione del pagamento, può richiedere un rimborso completo entro 7 giorni dalla data del pagamento.",
      l_es: "Si el suscriptor no ha utilizado Maunent Creative después de la aprobación del pago, puede solicitar un reembolso completo dentro de los 7 días posteriores a la fecha de pago.",
      l_de: "Wenn ein Abonnent Maunent Creative nach der Zahlungsbestätigung nicht genutzt hat, kann er innerhalb von 7 Tagen ab dem Zahlungsdatum eine vollständige Rückerstattung beantragen.",
      l_cn: "如果订阅会员在支付确认后未使用Maunent Creative，可在支付之日起7天内申请全额退款。",
      l_fr: "Si l’abonné n’a pas utilisé Maunent Creative après la confirmation du paiement, il peut demander un remboursement intégral dans les 7 jours suivant la date de paiement."
    }
  },
  titleModal_unsubscribe: {
    text: {
      temp_comment: "",
      l_kr: "구독 해지",
      l_us: "Unsubscribe",
      l_gb: "Unsubscribe",
      l_ca: "Unsubscribe",
      l_ru: "Отписаться",
      l_jp: "サブスクリプション解約",
      l_it: "Disiscriviti",
      l_es: "Cancelar suscripción",
      l_de: "Abbestellen",
      l_cn: "取消订阅",
      l_fr: "Se désabonner"
    }
  },
  msg_unsubscribeMembership: {
    text: {
      temp_comment: "",
      l_kr: "정말 Maunent Creative 구독을 해지하시겠습니까?",
      l_us: "Are you sure you want to cancel your Maunent Creative subscription?",
      l_gb: "Are you sure you want to cancel your Maunent Creative subscription?",
      l_ca: "Are you sure you want to cancel your Maunent Creative subscription?",
      l_ru: "Вы уверены, что хотите отменить подписку на Maunent Creative?",
      l_jp: "本当にMaunent Creativeのサブスクリプションを解約しますか？",
      l_it: "Sei sicuro di voler annullare il tuo abbonamento a Maunent Creative?",
      l_es: "¿Está seguro de que quiere cancelar su suscripción a Maunent Creative?",
      l_de: "Möchtest du dein Maunent Creative-Abonnement wirklich kündigen?",
      l_cn: "您确定要取消Maunent Creative订阅吗？",
      l_fr: "Êtes-vous sûr de vouloir annuler votre abonnement à Maunent Creative ?"
    }
  },
  btnModal_unsubscribe: {
    text: {
      temp_comment: "",
      l_kr: "구독 해지",
      l_us: "Unsubscribe",
      l_gb: "Unsubscribe",
      l_ca: "Unsubscribe",
      l_ru: "Отписаться",
      l_jp: "サブスクリプション解約",
      l_it: "Disiscriviti",
      l_es: "Cancelar suscripción",
      l_de: "Abbestellen",
      l_cn: "取消订阅",
      l_fr: "Se désabonner"
    }
  },
  titleModal_refund: {
    text: {
      temp_comment: "",
      l_kr: "환불",
      l_us: "Refund",
      l_gb: "Refund",
      l_ca: "Refund",
      l_ru: "Возврат",
      l_jp: "返金",
      l_it: "Rimborso",
      l_es: "Reembolso",
      l_de: "Rückerstattung",
      l_cn: "退款",
      l_fr: "Remboursement"
    }
  },
  msg_refund: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative 환불을 요청하시겠습니까? 환불이 승인되면 Maunent Creative를 이용하실 수 없게 되며, 환불 승인 후 7일 동안 다시 가입하실 수 없습니다. 환불 승인을 받은 후 7일이 경과하면 다시 Maunent Creative에 가입하실 수 있습니다.",
      l_us: "Are you sure you want to request a refund for Maunent Creative? If your refund is approved, Maunent Creative will no longer be available, and you cannot sign up again for 7 days. After 7 days from the time the refund is approved, you can re-register for Maunent Creative.",
      l_gb: "Are you sure you want to request a refund for Maunent Creative? If your refund is approved, Maunent Creative will no longer be available, and you cannot sign up again for 7 days. After 7 days from the time the refund is approved, you can re-register for Maunent Creative.",
      l_ca: "Are you sure you want to request a refund for Maunent Creative? If your refund is approved, Maunent Creative will no longer be available, and you cannot sign up again for 7 days. After 7 days from the time the refund is approved, you can re-register for Maunent Creative.",
      l_ru: "Вы действительно хотите запросить возврат средств для Maunent Creative? Если ваш возврат будет одобрен, доступ к Maunent Creative будет закрыт, и вы не сможете зарегистрироваться снова в течение 7 дней. После 7 дней с момента одобрения возврата вы сможете заново зарегистрироваться на Maunent Creative.",
      l_jp: "Maunent Creativeの払い戻しをリクエストしますか？払い戻しが承認された場合、Maunent Creativeを利用できなくなり、払い戻しが承認されてから7日間は再登録できません。払い戻しが承認されてから7日後に再度Maunent Creativeに登録することができます。",
      l_it: "Sei sicuro di voler richiedere un rimborso per Maunent Creative? Se il tuo rimborso viene approvato, Maunent Creative non sarà più disponibile e non potrai registrarti di nuovo per 7 giorni. Dopo 7 giorni dall'approvazione del rimborso, puoi registrarti nuovamente a Maunent Creative.",
      l_es: "¿Está seguro de que desea solicitar un reembolso para Maunent Creative? Si se aprueba su reembolso, Maunent Creative ya no estará disponible y no podrá volver a registrarse durante 7 días. Después de los 7 días desde el momento en que se aprueba el reembolso, puede volver a registrarse en Maunent Creative.",
      l_de: "Sind Sie sicher, dass Sie eine Rückerstattung für Maunent Creative beantragen möchten? Wenn Ihre Rückerstattung genehmigt wird, steht Maunent Creative nicht mehr zur Verfügung und Sie können es für 7 Tage nicht erneut starten. Nach 7 Tagen ab dem Zeitpunkt der Rückerstattungsgenehmigung können Sie Maunent Creative wieder starten.",
      l_cn: "您确定要请求退还Maunent Creative吗？如果您的退款获得批准，您将无法再使用Maunent Creative，且在退款获得批准后的7天内无法再次注册。退款获得批准后7天后，您可以再次注册Maunent Creative。",
      l_fr: "Êtes-vous sûr de vouloir demander un remboursement pour Maunent Creative ? Si votre remboursement est approuvé, Maunent Creative ne sera plus disponible et vous ne pourrez pas vous réinscrire pendant 7 jours. Après 7 jours à compter du moment où le remboursement est approuvé, vous pourrez vous réinscrire à Maunent Creative."
    }
  },
  btnModal_refund: {
    text: {
      temp_comment: "",
      l_kr: "환불 요청",
      l_us: "Request a refund",
      l_gb: "Request a refund",
      l_ca: "Request a refund",
      l_ru: "Запросить возврат средств",
      l_jp: "返金をリクエストする",
      l_it: "Richiedere un rimborso",
      l_es: "Solicitar un reembolso",
      l_de: "Eine Rückerstattung beantragen",
      l_cn: "请求退款",
      l_fr: "Demander un remboursement"
    }
  },
  btnCommonContained_membershipRecommend: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative에 대하여",
      l_us: "About Maunent Creative",
      l_gb: "About Maunent Creative",
      l_ca: "About Maunent Creative",
      l_ru: "Подробнее о Maunent Creative",
      l_jp: "Maunent Creativeについて",
      l_it: "Informazioni su Maunent Creative",
      l_es: "Acerca de Maunent Creative",
      l_de: "Über Maunent Creative",
      l_cn: "关于Maunent Creative",
      l_fr: "A propos de Maunent Creative"
    }
  },
  msg_registrationCompleted: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative에 성공적으로 가입했습니다.",
      l_us: "You have successfully signed up for Maunent Creative.",
      l_gb: "You have successfully signed up for Maunent Creative.",
      l_ca: "You have successfully signed up for Maunent Creative.",
      l_ru: "Вы успешно зарегистрировались в Maunent Creative.",
      l_jp: "Maunent Creativeへの登録に成功しました。",
      l_it: "Ti sei iscritto con successo a Maunent Creative.",
      l_es: "Se ha registrado con éxito en Maunent Creative.",
      l_de: "Du hast dich erfolgreich bei Maunent Creative angemeldet.",
      l_cn: "已成功加入Maunent Creative。",
      l_fr: "Vous avez signé avec succès pour Maunent Creative."
    }
  },
  msg_paypalRequestError: {
    text: {
      temp_comment: "",
      l_kr: "페이팔 서버가 현재 요청을 처리할 수 없습니다. 잠시 후 다시 시도하세요.",
      l_us: "PayPal server is currently unable to handle this request. Please try again.",
      l_gb: "PayPal server is currently unable to handle this request. Please try again.",
      l_ca: "PayPal server is currently unable to handle this request. Please try again.",
      l_ru: "В настоящее время сервер PayPal не может обработать ваш запрос. Пожалуйста, попробуйте еще раз.",
      l_jp: "PayPalサーバーは現在、リクエストを処理することができません。しばらくしてからもう一度お試しください。",
      l_it: "Il server PayPal al momento non può gestire questa richiesta. Riprova.",
      l_es: "El servidor de PayPal no puede manejar esta solicitud actualmente. Inténtelo de nuevo.",
      l_de: "Der PayPal-Server kann diese Anfrage derzeit nicht verarbeiten. Bitte versuche es erneut.",
      l_cn: "Paypal服务器无法处理目前申请。请稍后重试。",
      l_fr: "Le serveur de PayPal est actuellement incapable de traiter cette demande. Veuilez réessayer."
    }
  },
  msg_paypalPaymentError: {
    text: {
      temp_comment: "",
      l_kr: "페이팔 서버가 현재 결제 요청을 처리할 수 없습니다. 잠시 후 다시 시도하세요.",
      l_us: "PayPal server is currently unable to process your payment request. Please try again.",
      l_gb: "PayPal server is currently unable to process your payment request. Please try again.",
      l_ca: "PayPal server is currently unable to process your payment request. Please try again.",
      l_ru: "В настоящее время сервер PayPal не может обработать ваш платежный запрос. Пожалуйста, попробуйте еще раз.",
      l_jp: "PayPalサーバーは現在、決済リクエストを処理することができません。しばらくしてからもう一度お試しください。",
      l_it: "Il server PayPal al momento non può elaborare la tua richiesta di pagamento. Riprova.",
      l_es: "El servidor de PayPal no puede procesar su solicitud de pago actualmente. Inténtelo de nuevo.",
      l_de: "Der PayPal-Server kann deine Zahlungsanfrage derzeit nicht verarbeiten. Bitte versuche es erneut.",
      l_cn: "Paypal服务器目前无法处理付款申请。请稍后重试。",
      l_fr: "Le serveur de PayPal est actuellement incapable de traiter votre demande de paiement. Veuilez réessayer."
    }
  },
  msg_portoneServerError: {
    text: {
      temp_comment: "",
      l_kr: "결제사(PG)의 서버가 현재 요청을 처리할 수 없습니다. 잠시 후 다시 시도하세요.",
      l_us: "Payment Gateway server is currently unable to handle this request. Please try again.",
      l_gb: "Payment Gateway server is currently unable to handle this request. Please try again.",
      l_ca: "Payment Gateway server is currently unable to handle this request. Please try again.",
      l_ru: "Сервер платежного шлюза в настоящее время не может обработать этот запрос. Пожалуйста, попробуйте еще раз.",
      l_jp: "現在、決済ゲートウェイサーバーはこの要求を処理できません。もう一度お試しください。",
      l_it: "Il server del gateway di pagamento non è attualmente in grado di gestire questa richiesta. Si prega di riprovare.",
      l_es: "El servidor de la pasarela de pago no puede procesar esta solicitud en este momento. Por favor, inténtelo de nuevo.",
      l_de: "Der Payment-Gateway-Server kann diese Anfrage derzeit nicht verarbeiten. Bitte versuchen Sie es erneut.",
      l_cn: "支付网关服务器当前无法处理此请求。请重试。",
      l_fr: "Le serveur de la passerelle de paiement ne peut actuellement pas traiter cette demande. Veuillez réessayer."
    }
  },
  msg_notRegisteredMember: {
    text: {
      temp_comment: "",
      l_kr: "현재 회원님은 Maunent Creative 회원이 아닙니다.",
      l_us: "Currently, you are not a Maunent Creative member.",
      l_gb: "Currently, you are not a Maunent Creative member.",
      l_ca: "Currently, you are not a Maunent Creative member.",
      l_ru: "В настоящее время вы не являетесь членом Maunent Creative.",
      l_jp: "現在、Maunent Creativeの会員登録がされておりません。",
      l_it: "Attualmente non sei un membro di Maunent Creative.",
      l_es: "Actualmente Usted no es miembro de Maunent Creative.",
      l_de: "Du bist derzeit kein Maunent Creative-Mitglied.",
      l_cn: "您目前不是Maunent Creative会员。",
      l_fr: "Vous n'êtes actuellement pas un membre de Maunent Creative."
    }
  },
  msg_alreadyUnsubscribed: {
    text: {
      temp_comment: "",
      l_kr: "이미 구독 해지 처리가 완료되었습니다.",
      l_us: "You have already unsubscribed.",
      l_gb: "You have already unsubscribed.",
      l_ca: "You have already unsubscribed.",
      l_ru: "Вы уже отписались.",
      l_jp: "すでにサブスクリプションの解約処理は完了しています。",
      l_it: "Hai già annullato la tua iscrizione.",
      l_es: "Su suscripción ya ha sida cancelada.",
      l_de: "Du hast dich bereits abgemeldet.",
      l_cn: "已完成取消订阅处理。",
      l_fr: "Vous êtes déjà désabonné."
    }
  },
  msg_cannotStartFreeTrial: {
    text: {
      temp_comment: "",
      l_kr: "무료 체험을 시작하실 수 없는 회원입니다.",
      l_us: "You cannot start the free trial.",
      l_gb: "You cannot start the free trial.",
      l_ca: "You cannot start the free trial.",
      l_ru: "Вы не можете начать бесплатную пробную версию.",
      l_jp: "無料体験を開始することができない会員です。",
      l_it: "Non puoi iniziare la prova gratuita.",
      l_es: "No puede iniciar la prueba gratuita.",
      l_de: "Du kannst die kostenlose Testversion nicht starten.",
      l_cn: "您不是可以免费体验的用户。",
      l_fr: "Vous ne pouvez démarrer l'essai gratuit."
    }
  },
  msg_nowInFreeTrial: {
    text: {
      temp_comment: "",
      l_kr: "이미 무료 체험이 진행 중입니다.",
      l_us: "Already free trial is in progress.",
      l_gb: "Already free trial is in progress.",
      l_ca: "Already free trial is in progress.",
      l_ru: "Бесплатная пробная версия уже запущена.",
      l_jp: "すでに無料体験が進行中です。",
      l_it: "La prova gratuita è già in corso.",
      l_es: "La prueba gratuita ya está en marcha.",
      l_de: "Eine kostenlose Testversion hat bereits begonnen.",
      l_cn: "免费体验正在进行。",
      l_fr: "L'essai gratuit est déjà en cours."
    }
  },
  msg_accountWillDeletedSoon: {
    text: {
      temp_comment: "",
      l_kr: "현재 계정 삭제가 진행 중입니다.",
      l_us: "You are currently in the process of deleting an account.",
      l_gb: "You are currently in the process of deleting an account.",
      l_ca: "You are currently in the process of deleting an account.",
      l_ru: "Вы находитесь в процессе удаления аккаунта.",
      l_jp: "現在、アカウントの削除手続きが進行中です。",
      l_it: "Stai per eliminare un account.",
      l_es: "Actualmente su cuenta está en proceso de eliminación.",
      l_de: "Du bist gerade dabei, ein Konto zu löschen.",
      l_cn: "目前您的账户正在删除中。",
      l_fr: "Vous êtes en train de supprimer un compte."
    }
  },
  msg_alreadyMember: {
    text: {
      temp_comment: "",
      l_kr: "회원님은 이미 Maunent Creative 회원입니다.",
      l_us: "You are already a Maunent Creative member.",
      l_gb: "You are already a Maunent Creative member.",
      l_ca: "You are already a Maunent Creative member.",
      l_ru: "Вы уже являетесь членом Maunent Creative.",
      l_jp: "すでにMaunent Creativeの会員です。",
      l_it: "Sei già membro di Maunent Creative.",
      l_es: "Usted ya es miembro de Maunent Creative.",
      l_de: "Du bist bereits Mitglied bei Maunent Creative.",
      l_cn: "你已加入Maunent Creative会员。",
      l_fr: "Vous êtes déjà membre de Maunent Creative."
    }
  },
  msg_nonPayingUser: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative에 가입하지 않은 사용자는 환불 처리가 불가능합니다.",
      l_us: "We cannot process a refund for users who have not subscribed to Maunent Creative.",
      l_gb: "We cannot process a refund for users who have not subscribed to Maunent Creative.",
      l_ca: "We cannot process a refund for users who have not subscribed to Maunent Creative.",
      l_ru: "Мы не можем обработать возврат средств для пользователей, которые не подписались на Maunent Creative.",
      l_jp: "Maunent Creativeに加入していないユーザーは、払い戻し処理ができません。",
      l_it: "Non possiamo elaborare un rimborso per gli utenti che non si sono abbonati a Maunent Creative.",
      l_es: "No podemos procesar un reembolso para los usuarios que no se hayan suscrito a Maunent Creative.",
      l_de: "Wir können keine Rückerstattung für Benutzer, die nicht Maunent Creative abonniert haben, bearbeiten.",
      l_cn: "对于未订阅Maunent Creative的用户，我们无法处理退款。",
      l_fr: "Nous ne pouvons pas traiter un remboursement pour les utilisateurs qui ne se sont pas abonnés à Maunent Creative."
    }
  },
  msg_refundExfired: {
    text: {
      temp_comment: "",
      l_kr: "죄송합니다만, 결제한지 7일이 지난 이후에 환불을 요청하신 경우 Maunent Creative의 환불이 불가능합니다. 결제 후 7일 이내에 환불 요청을 해야합니다.",
      l_us: "We're sorry, but we cannot process your refund request for Maunent Creative as it has been over 7 days since your payment for the subscription. Please note that refund requests are only accepted within 7 days of payment.",
      l_gb: "We're sorry, but we cannot process your refund request for Maunent Creative as it has been over 7 days since your payment for the subscription. Please note that refund requests are only accepted within 7 days of payment.",
      l_ca: "We're sorry, but we cannot process your refund request for Maunent Creative as it has been over 7 days since your payment for the subscription. Please note that refund requests are only accepted within 7 days of payment.",
      l_ru: "К сожалению, мы не можем обработать ваш запрос на возврат средств за Maunent Creative, так как прошло более 7 дней с момента оплаты подписки. Обратите внимание, что запросы на возврат принимаются только в течение 7 дней после оплаты.",
      l_jp: "申し訳ございませんが、お支払いから7日以上経ったMaunent Creativeの返金リクエストはお受けできません。支払いから7日以内のみ返金リクエストを受け付けています。",
      l_it: "Ci dispiace, ma non possiamo elaborare la tua richiesta di rimborso per Maunent Creative poiché sono trascorsi più di 7 giorni dal pagamento dell'abbonamento. Si prega di notare che le richieste di rimborso vengono accettate solo entro 7 giorni dal pagamento.",
      l_es: "Lo sentimos, pero no podemos procesar su solicitud de reembolso de Maunent Creative ya que han pasado más de 7 días desde su pago por la suscripción. Tenga en cuenta que las solicitudes de reembolso solo se aceptan dentro de los 7 días posteriores al pago.",
      l_de: "Wir bedauern, aber wir können Ihre Rückerstattungsanfrage für Maunent Creative nicht bearbeiten, da seit Ihrer Zahlung für das Abonnement mehr als 7 Tage vergangen sind. Bitte beachten Sie, dass Rückerstattungsanfragen nur innerhalb von 7 Tagen nach der Zahlung angenommen werden.",
      l_cn: "很抱歉，由于您购买订阅的Maunent Creative已经超过7天，我们无法处理您的退款请求。请注意，只有在支付后7天内的退款请求才会被接受。",
      l_fr: "Nous sommes désolés, mais nous ne pouvons pas traiter votre demande de remboursement pour Maunent Creative car cela fait plus de 7 jours que vous avez payé pour l'abonnement. Veuillez noter que les demandes de remboursement ne sont acceptées que dans les 7 jours suivant le paiement."
    }
  },
  msg_couponUser: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰 사용자는 환불이 불가능 합니다.",
      l_us: "Refunds are not available for coupon users.",
      l_gb: "Refunds are not applicable for coupon users.",
      l_ca: "Refunds are not available for coupon users.",
      l_ru: "Возврат средств для пользователей с купонами недоступен.",
      l_jp: "クーポン利用者は返金ができません。",
      l_it: "I rimborsi non sono disponibili per gli utenti con coupon.",
      l_es: "No se admiten reembolsos para los usuarios con cupones.",
      l_de: "Rückerstattungen sind für Gutscheinnutzer nicht verfügbar.",
      l_cn: "优惠券用户无法退款。",
      l_fr: "Les remboursements ne sont pas disponibles pour les utilisateurs de coupons."
    }
  },
  msg_cookieConsentRequest: {
    text: {
      temp_comment: "",
      l_kr: "사이트 작동에 필요한 쿠키를 사용합니다. 또한 사이트 사용 방법을 측정하여 개선하는 데 도움이 되는 분석 쿠키를 설정하고자 합니다. 이러한 쿠키는 사용자가 수락할 경우에만 설정됩니다.",
      l_us: "We use necessary cookies to make our site work. We'd also like to set analytics cookies that help us make improvements by measuring how you use the site. These will be set only if you accept.",
      l_gb: "We use necessary cookies to make our site work. We'd also like to set analytics cookies that help us make improvements by measuring how you use the site. These will be set only if you accept.",
      l_ca: "We use necessary cookies to make our site work. We'd also like to set analytics cookies that help us make improvements by measuring how you use the site. These will be set only if you accept.",
      l_ru: "Мы используем необходимые файлы cookie для работы нашего сайта. Кроме того, мы хотели бы установить ана литические файлы cookie, которые помогут нам улучшить сайт, измеряя вашу активность. Они будут установлены только при вашем согласии.",
      l_jp: "当社では、サイトの動作に必要なクッキーを使用しています。また、サイトの利用状況を測定して改善するために、アナリティクスクッキーも設定したいと考えています。これらは、ご承諾いただいた場合にのみ設定されます。",
      l_it: "Utilizziamo i cookie necessari per far funzionare il nostro sito. Vorremmo anche impostare dei cookie di analisi che ci aiutano a migliorare misurando come utilizzi il sito. Questi verranno impostati solo se accetti.",
      l_es: "Utilizamos cookies necesarias para que nuestro sitio funcione. También nos gustaría establecer cookies de análisis que nos ayuden a realizar mejoras midiendo cómo utilizas el sitio. Estas solo se establecerán si las aceptas.",
      l_de: "Wir verwenden notwendige Cookies, um unsere Website zum Laufen zu bringen. Wir möchten auch Analyse-Cookies setzen, die uns helfen, Verbesserungen vorzunehmen, indem wir messen, wie du die Website nutzt. Diese werden nur gesetzt, wenn du zustimmst.",
      l_cn: "我们使用必要的 cookie 使我们的网站正常运行。我们还希望设置分析 cookie，通过测量您对网站的使用情况来帮助我们改进。只有在您同意的情况下才会设置这些 cookie。",
      l_fr: "Nous utilisons des cookies nécessaires pour faire fonctionner notre site. Nous aimerions également configurer des cookies d'analyse qui nous aident à apporter des améliorations en mesurant votre utilisation du site. Ceux-ci ne seront configurés que si vous les acceptez."
    }
  },
  btnSnackbar_acceptAllCookies: {
    text: {
      temp_comment: "",
      l_kr: "모든 쿠키 허용",
      l_us: "Accept all cookies",
      l_gb: "Accept all cookies",
      l_ca: "Accept all cookies",
      l_ru: "Принять все файлы cookie",
      l_jp: "すべてのクッキーを受け入れる",
      l_it: "Accetta tutti i cookie",
      l_es: "Aceptar todas las cookies",
      l_de: "Alle Cookies akzeptieren",
      l_cn: "接受所有 cookie",
      l_fr: "Accepter tous les cookies"
    }
  },
  btnSnackbar_rejectAllCookies: {
    text: {
      temp_comment: "",
      l_kr: "모든 쿠키 거부",
      l_us: "Reject all cookies",
      l_gb: "Reject all cookies",
      l_ca: "Reject all cookies",
      l_ru: "Отклонить все файлы cookie",
      l_jp: "すべてのクッキーを拒否する",
      l_it: "Rifiuta tutti i cookie",
      l_es: "Rechazar todas las cookies",
      l_de: "Alle Cookies ablehnen",
      l_cn: "拒绝所有 cookie",
      l_fr: "Refuser tous les cookies"
    }
  },
  btnSnackbar_customizeCookies: {
    text: {
      temp_comment: "",
      l_kr: "사용자 정의",
      l_us: "Customize",
      l_gb: "Customize",
      l_ca: "Customize",
      l_ru: "Настроить",
      l_jp: "カスタマイズ",
      l_it: "Personalizza",
      l_es: "Personalizar",
      l_de: "Anpassen",
      l_cn: "自定义",
      l_fr: "Personnaliser"
    }
  },
  titleModal_cookieCustom: {
    text: {
      temp_comment: "",
      l_kr: "쿠키 환경설정 업데이트",
      l_us: "Update cookie preferences",
      l_gb: "Update cookie preferences",
      l_ca: "Update cookie preferences",
      l_ru: "Обновить параметры для файлов cookie",
      l_jp: "Cookie 設定を更新する",
      l_it: "Aggiorna preferenze sui cookie",
      l_es: "Actualizar preferencias de cookies",
      l_de: "Cookie-Einstellungen aktualisieren",
      l_cn: "更新 Cookie 首选项",
      l_fr: "Mise à jour des préférences concernant les cookies"
    }
  },
  msg_necessaryCookieMajor: {
    text: {
      temp_comment: "",
      l_kr: "필수 쿠키",
      l_us: "Strictly Necessary Cookies",
      l_gb: "Strictly Necessary Cookies",
      l_ca: "Strictly Necessary Cookies",
      l_ru: "Строго необходимые файлы cookie",
      l_jp: "厳密に必要なクッキー",
      l_it: "Cookie strettamente necessari",
      l_es: "Cookies estrictamente necesarias",
      l_de: "Unbedingt erforderliche Cookies",
      l_cn: "严格必要的 cookie",
      l_fr: "Cookies strictement nécessaires"
    }
  },
  msg_necessaryCookieMinor: {
    text: {
      temp_comment: "",
      l_kr: "보안, 네트워크 관리 및 접근성과 같은 기본 기능을 활성화합니다. 브라우저 설정을 변경하여 이를 비활성화할 수 있지만 웹 사이트 기능에 영향을 줄 수 있습니다.",
      l_us: "Necessary cookies enable core functionality such as security, network management, and accessibility. You may disable these by changing your browser settings, but this may affect how the website functions.",
      l_gb: "Necessary cookies enable core functionality such as security, network management, and accessibility. You may disable these by changing your browser settings, but this may affect how the website functions.",
      l_ca: "Necessary cookies enable core functionality such as security, network management, and accessibility. You may disable these by changing your browser settings, but this may affect how the website functions.",
      l_ru: "Необходимые файлы cookie обеспечивают основные функции, такие как безопасность, управление сетью и доступность. Вы можете отключить их, изменяя настройки вашего браузера, но это может повлиять на функциональность сайта.",
      l_jp: "必要なクッキーは、セキュリティ、ネットワーク管理、アクセシビリティなどの基本機能を有効にします。ブラウザの設定を変更することでこれらを無効にすることもできますが、それによりウェブサイトの機能に影響が出る場合があります。",
      l_it: "I cookie necessari consentono funzionalità di base come la sicurezza, la gestione della rete e l'accessibilità. È possibile disabilitarli modificando le impostazioni del browser, ma ciò potrebbe influire sulle funzioni del sito web.",
      l_es: "Las cookies necesarias permiten la funcionalidad básica como la seguridad, la gestión de la red y la accesibilidad. Puedes desactivarlas cambiando la configuración de tu navegador, pero esto puede afectar cómo funciona el sitio web.",
      l_de: "Notwendige Cookies ermöglichen Kernfunktionen wie Sicherheit, Netzwerkmanagement und Zugänglichkeit. Du kannst diese durch Änderung deiner Browsereinstellungen deaktivieren, aber dies kann sich auf die Funktionsweise der Website auswirken.",
      l_cn: "必要的 cookie 可以启用核心功能，如安全性、网络管理和可访问性。您可以通过更改浏览器设置来禁用这些 cookie，但这可能会影响网站的功能。",
      l_fr: "Les cookies nécessaires permettent de garantir des fonctionnalités de base telles que la sécurité, la gestion du réseau et l'accessibilité. Vous pouvez les désactiver en modifiant les paramètres de votre navigateur, mais cela peut affecter le fonctionnement du site web."
    }
  },
  msg_analyticsCookieMajor: {
    text: {
      temp_comment: "",
      l_kr: "분석 쿠키",
      l_us: "Analytics cookies",
      l_gb: "Analytics cookies",
      l_ca: "Analytics cookies",
      l_ru: "Аналитические файлы cookie",
      l_jp: "アナリティクスクッキー",
      l_it: "Cookie di analisi",
      l_es: "Cookies de análisis",
      l_de: "Analyse-Cookies",
      l_cn: "分析 cookie",
      l_fr: "Cookies d'analyse"
    }
  },
  msg_analyticsCookieMinor: {
    text: {
      temp_comment: "",
      l_kr: "웹 사이트 개선을 위해 Google Analytics를 사용하여 웹 사이트 분석 정보를 수집하고자 합니다. 이를 위해 Google Analytics 쿠키를 장치에 설정하여 사용자의 사이트 상호 작용 방식에 대한 데이터를 수집합니다. 이 데이터는 직접적으로 개인을 식별할 수 없는 방식으로 수집됩니다.",
      l_us: "We'd like to collect website analytics information using Google Analytics to help us improve the website. We collect this data by setting Google Analytics cookies on your device, which collect data about how you have interacted with our site. The data is collected in a way that does not directly identify anyone.",
      l_gb: "We'd like to collect website analytics information using Google Analytics to help us improve the website. We collect this data by setting Google Analytics cookies on your device, which collect data about how you have interacted with our site. The data is collected in a way that does not directly identify anyone.",
      l_ca: "We'd like to collect website analytics information using Google Analytics to help us improve the website. We collect this data by setting Google Analytics cookies on your device, which collect data about how you have interacted with our site. The data is collected in a way that does not directly identify anyone.",
      l_ru: "Мы хотели бы собирать информацию об аналитике сайта с помощью Google Analytics, чтобы помочь нам улучшить сайт. Мы собираем эти данные, устанавливая файлы cookie Google Analytics на вашем устройстве, которые собирают данные о вашей активности на сайте. Эти данные собираются таким образом, что они не позволяют непосредственно идентифицировать кого-либо.",
      l_jp: "ウェブサイトの改善を目的としてGoogle Analyticsを使用してウェブサイトの分析情報を収集したいと考えています。当社は、お使いのデバイスにGoogle Analyticsクッキーを設定してデータを収集し、当社のサイトの利用状況に関するデータを収集します。このデータは直接誰かを特定することのできない方法で収集されます。",
      l_it: "Vorremmo raccogliere informazioni sull'analisi del sito web utilizzando Google Analytics per aiutarci a migliorare il sito. Raccogliamo questi dati impostando i cookie di Google Analytics sul tuo dispositivo, che raccolgono dati su come hai interagito con il nostro sito. I dati vengono raccolti in modo da non identificare direttamente nessuno.",
      l_es: "Nos gustaría recopilar información de análisis del sitio web utilizando Google Analytics para ayudarnos a mejorar el sitio. Recopilamos estos datos mediante el establecimiento de cookies de Google Analytics en tu dispositivo, que recopilan datos sobre cómo has interactuado con nuestro sitio. Los datos se recopilan de una manera que no identifica directamente a nadie.",
      l_de: "Wir möchten Website-Analysedaten mit Google Analytics sammeln, um uns bei der Verbesserung der Website zu unterstützen. Wir sammeln diese Daten, indem wir Google Analytics-Cookies auf deinem Gerät setzen, die Daten darüber sammeln, wie du mit unserer Website interagiert hast. Die Daten werden auf eine Weise gesammelt, die niemanden direkt identifiziert.",
      l_cn: "我们希望使用 Google Analytics 收集网站分析信息，以帮助我们改进网站。我们通过在您的设备上设置 Google Analytics cookie 来收集这些数据，该 cookie 收集有关您与我们的网站的互动方式的数据。这些数据以不直接识别任何人的方式进行收集。",
      l_fr: "Nous aimerions collecter des informations d'analyse du site web à l'aide de Google Analytics pour nous aider à améliorer le site web. Nous collectons ces données en configurant des cookies Google Analytics sur votre appareil, qui collectent des données sur votre interaction avec notre site. Les données sont collectées de manière à ne pas identifier directement qui que ce soit."
    }
  },
  btnModal_saveMyCookieAndExit: {
    text: {
      temp_comment: "",
      l_kr: "저장 및 닫기",
      l_us: "Save and close",
      l_gb: "Save and close",
      l_ca: "Save and close",
      l_ru: "Сохранить и закрыть",
      l_jp: "保存して閉じる",
      l_it: "Salva e chiudi",
      l_es: "Guardar y cerrar",
      l_de: "Speichern und schließen",
      l_cn: "保存并关闭",
      l_fr: "Enregistrer et fermer"
    }
  },
  btnModal_acceptAllCookies: {
    text: {
      temp_comment: "",
      l_kr: "전체 허용",
      l_us: "Accept all",
      l_gb: "Accept all",
      l_ca: "Accept all",
      l_ru: "Принять все",
      l_jp: "すべてを受け入れる",
      l_it: "Accetta tutto",
      l_es: "Aceptar todas",
      l_de: "Alles akzeptieren",
      l_cn: "全部接受",
      l_fr: "Tout accepter"
    }
  },
  titleSection_coupon: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰",
      l_us: "Coupon",
      l_gb: "Coupon",
      l_ca: "Coupon",
      l_ru: "Купон",
      l_jp: "クーポン",
      l_it: "Coupon",
      l_es: "Cupón",
      l_de: "Gutschein",
      l_cn: "优惠券",
      l_fr: "Coupon"
    }
  },
  msg_couponDescMsg1: {
    text: {
      temp_comment: "",
      l_kr: "친구를 초대하고 특별한 혜택을 받아보세요.",
      l_us: "Invite friends and unlock exclusive benefits",
      l_gb: "Invite friends and unlock exclusive benefits",
      l_ca: "Invite friends and unlock exclusive benefits",
      l_ru: "Приглашайте друзей и получайте эксклюзивные преимущества",
      l_jp: "友達を招待して特別な特典を手に入れよう",
      l_it: "Invita amici e sblocca vantaggi esclusivi",
      l_es: "Invita amigos y desbloquea beneficios exclusivos",
      l_de: "Lade Freunde ein und erhalte exklusive Vorteile",
      l_cn: "邀请好友，解锁专属福利",
      l_fr: "Invitez des amis et débloquez des avantages exclusifs"
    }
  },
  msg_myCouponInfo: {
    text: {
      temp_comment: "",
      l_kr: "내 쿠폰 정보",
      l_us: "My Coupon Info",
      l_gb: "My Coupon Info",
      l_ca: "My Coupon Info",
      l_ru: "Информация о моих купонах",
      l_jp: "マイクーポン情報",
      l_it: "Informazioni sui Miei Coupon",
      l_es: "Información de Mis Cupones",
      l_de: "Meine Gutschein-Informationen",
      l_cn: "我的优惠券信息",
      l_fr: "Informations sur Mes Coupons"
    }
  },
  msg_referralSummary: {
    text: {
      temp_comment: "",
      l_kr: "친구 초대 내역",
      l_us: "Referral Summary",
      l_gb: "Referral Summary",
      l_ca: "Referral Summary",
      l_ru: "Сводка по рефералам",
      l_jp: "紹介履歴",
      l_it: "Riepilogo Referral",
      l_es: "Resumen de Referencias",
      l_de: "Empfehlungsübersicht",
      l_cn: "推荐记录",
      l_fr: "Résumé des Parrainages"
    }
  },
  msg_friendsInvited: {
    text: {
      temp_comment: "",
      l_kr: "초대한 친구 : <<numUsed>>",
      l_us: "Friends Invited : <<numUsed>>",
      l_gb: "Friends Invited : <<numUsed>>",
      l_ca: "Friends Invited : <<numUsed>>",
      l_ru: "Приглашено друзей : <<numUsed>>",
      l_jp: "招待した友達 : <<numUsed>>",
      l_it: "Amici Invitati : <<numUsed>>",
      l_es: "Amigos Invitados : <<numUsed>>",
      l_de: "Eingeladene Freunde : <<numUsed>>",
      l_cn: "已邀请好友 : <<numUsed>>",
      l_fr: "Amis Invités : <<numUsed>>"
    }
  },
  msg_friendsWhoStartedMC: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative를 시작한 친구 : <<numUsed>>",
      l_us: "Friends Who Started Maunent Creative : <<numUsed>>",
      l_gb: "Friends Who Started Maunent Creative : <<numUsed>>",
      l_ca: "Friends Who Started Maunent Creative : <<numUsed>>",
      l_ru: "Друзья, начавшие Maunent Creative : <<numUsed>>",
      l_jp: "Maunent Creativeを開始した友達 : <<numUsed>>",
      l_it: "Amici che Hanno Iniziato Maunent Creative : <<numUsed>>",
      l_es: "Amigos que Comenzaron Maunent Creative : <<numUsed>>",
      l_de: "Freunde, die Maunent Creative gestartet haben : <<numUsed>>",
      l_cn: "已开始Maunent Creative的好友 : <<numUsed>>",
      l_fr: "Amis Ayant Commencé Maunent Creative : <<numUsed>>"
    }
  },
  msg_couponsEarned: {
    text: {
      temp_comment: "",
      l_kr: "발급받은 쿠폰 : <<numUsed>>",
      l_us: "Coupons Earned : <<numUsed>>",
      l_gb: "Coupons Earned : <<numUsed>>",
      l_ca: "Coupons Earned : <<numUsed>>",
      l_ru: "Полученные купоны : <<numUsed>>",
      l_jp: "獲得したクーポン : <<numUsed>>",
      l_it: "Coupon Ottenuti : <<numUsed>>",
      l_es: "Cupones Obtenidos : <<numUsed>>",
      l_de: "Erhaltene Gutscheine : <<numUsed>>",
      l_cn: "已获得优惠券 : <<numUsed>>",
      l_fr: "Coupons Obtenus : <<numUsed>>"
    }
  },
  msg_couponBalance: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰 발급 내역",
      l_us: "Coupon Balance",
      l_gb: "Coupon Balance",
      l_ca: "Coupon Balance",
      l_ru: "Баланс купонов",
      l_jp: "クーポン残高",
      l_it: "Saldo Coupon",
      l_es: "Saldo de Cupones",
      l_de: "Gutschein-Guthaben",
      l_cn: "优惠券余额",
      l_fr: "Solde des Coupons"
    }
  },
  msg_couponCount: {
    text: {
      temp_comment: "",
      l_kr: "수량",
      l_us: "Count",
      l_gb: "Count",
      l_ca: "Count",
      l_ru: "Количество",
      l_jp: "数量",
      l_it: "Quantità",
      l_es: "Cantidad",
      l_de: "Anzahl",
      l_cn: "数量",
      l_fr: "Quantité"
    }
  },
  msg_coupons: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰",
      l_us: "Coupons",
      l_gb: "Coupons",
      l_ca: "Coupons",
      l_ru: "Купоны",
      l_jp: "クーポン",
      l_it: "Coupon",
      l_es: "Cupones",
      l_de: "Gutscheine",
      l_cn: "优惠券",
      l_fr: "Coupons"
    }
  },
  msg_promotionalCoupons: {
    text: {
      temp_comment: "",
      l_kr: "프로모션 쿠폰",
      l_us: "Promotional Coupons",
      l_gb: "Promotional Coupons",
      l_ca: "Promotional Coupons",
      l_ru: "Промокупоны",
      l_jp: "プロモーションクーポン",
      l_it: "Coupon Promozionali",
      l_es: "Cupones Promocionales",
      l_de: "Aktionsgutscheine",
      l_cn: "促销优惠券",
      l_fr: "Coupons Promotionnels"
    }
  },
  msg_couponsUsed: {
    text: {
      temp_comment: "",
      l_kr: "사용한 쿠폰",
      l_us: "Coupons Used",
      l_gb: "Coupons Used",
      l_ca: "Coupons Used",
      l_ru: "Использованные купоны",
      l_jp: "使用済みクーポン",
      l_it: "Coupon Utilizzati",
      l_es: "Cupones Utilizados",
      l_de: "Verwendete Gutscheine",
      l_cn: "已使用优惠券",
      l_fr: "Coupons Utilisés"
    }
  },
  msg_availableCoupons: {
    text: {
      temp_comment: "",
      l_kr: "사용 가능한 쿠폰",
      l_us: "Available Coupons",
      l_gb: "Available Coupons",
      l_ca: "Available Coupons",
      l_ru: "Доступные купоны",
      l_jp: "利用可能なクーポン",
      l_it: "Coupon Disponibili",
      l_es: "Cupones Disponibles",
      l_de: "Verfügbare Gutscheine",
      l_cn: "可用优惠券",
      l_fr: "Coupons Disponibles"
    }
  },
  msg_couponBenefitsOverview: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰 혜택",
      l_us: "Coupon Benefits",
      l_gb: "Coupon Benefits",
      l_ca: "Coupon Benefits",
      l_ru: "Преимущества купонов",
      l_jp: "クーポン特典",
      l_it: "Vantaggi dei Coupon",
      l_es: "Beneficios de los Cupones",
      l_de: "Gutschein-Vorteile",
      l_cn: "优惠券福利",
      l_fr: "Avantages des Coupons"
    }
  },
  msg_couponBenefitsOverviewDesc1: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰 1개 = 한 달 Maunent Creative 무료",
      l_us: "1 Coupon = 1 Month of Maunent Creative Free",
      l_gb: "1 Coupon = 1 Month of Maunent Creative Free",
      l_ca: "1 Coupon = 1 Month of Maunent Creative Free",
      l_ru: "1 купон = 1 месяц Maunent Creative бесплатно",
      l_jp: "クーポン1枚 = Maunent Creative 1ヶ月無料",
      l_it: "1 Coupon = 1 Mese di Maunent Creative Gratis",
      l_es: "1 Cupón = 1 Mes de Maunent Creative Gratis",
      l_de: "1 Gutschein = 1 Monat Maunent Creative kostenlos",
      l_cn: "1张优惠券 = Maunent Creative免费1个月",
      l_fr: "1 Coupon = 1 Mois de Maunent Creative Gratuit"
    }
  },
  msg_couponBenefitsOverviewDesc2: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰 5개 = ",
      l_us: "5 Coupons = ",
      l_gb: "5 Coupons = ",
      l_ca: "5 Coupons = ",
      l_ru: "5 купонов = ",
      l_jp: "クーポン5枚 = ",
      l_it: "5 Coupon = ",
      l_es: "5 Cupones = ",
      l_de: "5 Gutscheine = ",
      l_cn: "5张优惠券 = ",
      l_fr: "5 Coupons = "
    }
  },
  msg_couponBenefitsOverviewDesc2_2: {
    text: {
      temp_comment: "",
      l_kr: "투표 등록 무제한",
      l_us: "Unlimited Poll Creation",
      l_gb: "Unlimited Poll Creation",
      l_ca: "Unlimited Poll Creation",
      l_ru: "неограниченное создание опросов",
      l_jp: "投票作成無制限",
      l_it: "Creazione Sondaggi Illimitata",
      l_es: "Creación de Encuestas Ilimitada",
      l_de: "Unbegrenzte Umfrageerstellung",
      l_cn: "无限创建投票",
      l_fr: "Création de Sondages Illimitée"
    }
  },
  msg_couponBenefitsOverviewDesc3: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰 10개 = ",
      l_us: "10 Coupons = ",
      l_gb: "10 Coupons = ",
      l_ca: "10 Coupons = ",
      l_ru: "10 купонов = ",
      l_jp: "クーポン10枚 = ",
      l_it: "10 Coupon = ",
      l_es: "10 Cupones = ",
      l_de: "10 Gutscheine = ",
      l_cn: "10张优惠券 = ",
      l_fr: "10 Coupons = "
    }
  },
  msg_couponBenefitsOverviewDesc3_2: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative 평생무료",
      l_us: "Maunent Creative Free Forever",
      l_gb: "Maunent Creative Free Forever",
      l_ca: "Maunent Creative Free Forever",
      l_ru: "Maunent Creative бесплатно навсегда",
      l_jp: "Maunent Creative 永久無料",
      l_it: "Maunent Creative Gratis per Sempre",
      l_es: "Maunent Creative Gratis para Siempre",
      l_de: "Maunent Creative für immer kostenlos",
      l_cn: "Maunent Creative永久免费",
      l_fr: "Maunent Creative Gratuit à Vie"
    }
  },
  msg_couponRewards: {
    text: {
      temp_comment: "",
      l_kr: "혜택",
      l_us: "Rewards",
      l_gb: "Rewards",
      l_ca: "Rewards",
      l_ru: "Награды",
      l_jp: "特典",
      l_it: "Ricompense",
      l_es: "Recompensas",
      l_de: "Belohnungen",
      l_cn: "奖励",
      l_fr: "Récompenses"
    }
  },
  msg_couponRewardsDesc1: {
    text: {
      temp_comment: "",
      l_kr: "보유한 쿠폰 개수만큼 Maunent Creative를 무료로 이용하세요.",
      l_us: "Use your coupons to enjoy Maunent Creative free for as many months as you have coupons.",
      l_gb: "Use your coupons to enjoy Maunent Creative free for as many months as you have coupons.",
      l_ca: "Use your coupons to enjoy Maunent Creative free for as many months as you have coupons.",
      l_ru: "Используйте купоны, чтобы пользоваться Maunent Creative бесплатно столько месяцев, сколько у вас купонов.",
      l_jp: "保有しているクーポンの枚数分、Maunent Creativeを無料でご利用いただけます。",
      l_it: "Usa i tuoi coupon per godere di Maunent Creative gratuitamente per tutti i mesi corrispondenti ai coupon che possiedi.",
      l_es: "Usa tus cupones para disfrutar de Maunent Creative gratis durante tantos meses como cupones tengas.",
      l_de: "Nutze deine Gutscheine, um Maunent Creative so viele Monate kostenlos zu genießen, wie du Gutscheine hast.",
      l_cn: "使用优惠券，即可免费享受与优惠券数量相等月数的Maunent Creative。",
      l_fr: "Utilisez vos coupons pour profiter de Maunent Creative gratuitement pendant autant de mois que vous avez de coupons."
    }
  },
  msg_couponRewardsDesc2: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰 5개 달성 시 투표 등록 무제한, 10개 달성 시 Maunent Creative 평생 무료 혜택이 제공됩니다.",
      l_us: "Earn 5 coupons for unlimited poll creation, or 10 coupons for lifetime free access to Maunent Creative.",
      l_gb: "Earn 5 coupons for unlimited poll creation, or 10 coupons for lifetime free access to Maunent Creative.",
      l_ca: "Earn 5 coupons for unlimited poll creation, or 10 coupons for lifetime free access to Maunent Creative.",
      l_ru: "Получите 5 купонов для неограниченного создания опросов или 10 купонов для пожизненного бесплатного доступа к Maunent Creative.",
      l_jp: "クーポン5枚で投票作成無制限、10枚でMaunent Creative永久無料特典が提供されます。",
      l_it: "Ottieni 5 coupon per la creazione illimitata di sondaggi o 10 coupon per l'accesso gratuito a vita a Maunent Creative.",
      l_es: "Gana 5 cupones para la creación ilimitada de encuestas o 10 cupones para acceso gratuito de por vida a Maunent Creative.",
      l_de: "Erhalte 5 Gutscheine für unbegrenzte Umfrageerstellung oder 10 Gutscheine für lebenslangen kostenlosen Zugang zu Maunent Creative.",
      l_cn: "获得5张优惠券可无限创建投票，获得10张优惠券可永久免费使用Maunent Creative。",
      l_fr: "Gagnez 5 coupons pour une création de sondages illimitée ou 10 coupons pour un accès gratuit à vie à Maunent Creative."
    }
  },
  msg_couponRewardsDesc3: {
    text: {
      temp_comment: "",
      l_kr: "(단 프로모션 쿠폰은 제외)",
      l_us: "(Promotional coupons excluded)",
      l_gb: "(Promotional coupons excluded)",
      l_ca: "(Promotional coupons excluded)",
      l_ru: "(Промокупоны не учитываются)",
      l_jp: "(プロモーションクーポンは除く)",
      l_it: "(Coupon promozionali esclusi)",
      l_es: "(Cupones promocionales excluidos)",
      l_de: "(Aktionsgutscheine ausgenommen)",
      l_cn: "(促销优惠券除外)",
      l_fr: "(Coupons promotionnels exclus)"
    }
  },
  msg_couponProgress: {
    text: {
      temp_comment: "",
      l_kr: "달성률",
      l_us: "Progress",
      l_gb: "Progress",
      l_ca: "Progress",
      l_ru: "Прогресс",
      l_jp: "達成率",
      l_it: "Progresso",
      l_es: "Progreso",
      l_de: "Fortschritt",
      l_cn: "进度",
      l_fr: "Progression"
    }
  },
  msg_msg_couponProgressUnlimitedVoting: {
    text: {
      temp_comment: "",
      l_kr: "투표 등록 무제한 : <<progressStr>>",
      l_us: "Unlimited Poll Creation : <<progressStr>>",
      l_gb: "Unlimited Poll Creation : <<progressStr>>",
      l_ca: "Unlimited Poll Creation : <<progressStr>>",
      l_ru: "Неограниченное создание опросов : <<progressStr>>",
      l_jp: "投票作成無制限 : <<progressStr>>",
      l_it: "Creazione Sondaggi Illimitata : <<progressStr>>",
      l_es: "Creación de Encuestas Ilimitada : <<progressStr>>",
      l_de: "Unbegrenzte Umfrageerstellung : <<progressStr>>",
      l_cn: "无限创建投票 : <<progressStr>>",
      l_fr: "Création de Sondages Illimitée : <<progressStr>>"
    }
  },
  msg_msg_couponProgressMembershipFree: {
    text: {
      temp_comment: "",
      l_kr: "Maunent Creative 평생 무료 : <<progressStr>>",
      l_us: "Maunent Creative Free Forever : <<progressStr>>",
      l_gb: "Maunent Creative Free Forever : <<progressStr>>",
      l_ca: "Maunent Creative Free Forever : <<progressStr>>",
      l_ru: "Maunent Creative бесплатно навсегда : <<progressStr>>",
      l_jp: "Maunent Creative 永久無料 : <<progressStr>>",
      l_it: "Maunent Creative Gratis per Sempre : <<progressStr>>",
      l_es: "Maunent Creative Gratis para Siempre : <<progressStr>>",
      l_de: "Maunent Creative für immer kostenlos : <<progressStr>>",
      l_cn: "Maunent Creative永久免费 : <<progressStr>>",
      l_fr: "Maunent Creative Gratuit à Vie : <<progressStr>>"
    }
  },
  titleMembSection_howToGetCouponDesc: {
    text: {
      temp_comment: "",
      l_kr: "획득 방법",
      l_us: "How to Get",
      l_gb: "How to Get",
      l_ca: "How to Get",
      l_ru: "Как получить",
      l_jp: "取得方法",
      l_it: "Come Ottenere",
      l_es: "Cómo obtener",
      l_de: "Wie man bekommt",
      l_cn: "获取方法",
      l_fr: "Comment obtenir"
    }
  },
  msg_howToGetCouponDesc: {
    text: {
      temp_comment: "",
      l_kr: "링크를 공유하고, 친구가 Maunent Creative 멤버십을 시작할 때마다 쿠폰을 받으세요.",
      l_us: "Share your link, and receive a coupon every time your friend starts a Maunent Creative.",
      l_gb: "Share your link, and receive a coupon every time your friend starts a Maunent Creative.",
      l_ca: "Share your link, and receive a coupon every time your friend starts a Maunent Creative.",
      l_ru: "Поделитесь своей ссылкой, и получайте купон каждый раз, когда ваш друг начинает Maunent Creative.",
      l_jp: "リンクを共有して、友達がMaunent Creativeを始めるたびにクーポンをもらおう。",
      l_it: "Condividi il tuo link e ricevi un coupon ogni volta che un tuo amico inizia su Maunent Creative.",
      l_es: "Comparte tu enlace y recibe un cupón cada vez que tu amigo comience en Maunent Creative.",
      l_de: "Teile deinen Link und erhalte jedes Mal einen Gutschein, wenn dein Freund Maunent Creative startet.",
      l_cn: "分享您的链接，每当您的朋友开始使用Maunent Creative时，您就可以收到一张优惠券。",
      l_fr: "Partagez votre lien et recevez un coupon chaque fois que votre ami commence à utiliser Maunent Creative."
    }
  },
  titleMembSection_howToUseCouponDesc: {
    text: {
      temp_comment: "",
      l_kr: "사용 방법",
      l_us: "How to Use",
      l_gb: "How to Use",
      l_ca: "How to Use",
      l_ru: "Как использовать",
      l_jp: "使用方法",
      l_it: "Come Utilizzare",
      l_es: "Cómo usar",
      l_de: "Wie man benutzt",
      l_cn: "使用方法",
      l_fr: "Comment utiliser"
    }
  },
  msg_howToUseCouponDesc: {
    text: {
      temp_comment: "",
      l_kr: "만일 Maunent Creative를 이용중이라면 쿠폰은 매달 자동 사용됩니다.",
      l_us: "If you are using Maunent Creative, a coupon is automatically used every month.",
      l_gb: "If you are using Maunent Creative, a coupon is automatically used every month.",
      l_ca: "If you are using Maunent Creative, a coupon is automatically used every month.",
      l_ru: "Если вы используете Maunent Creative, каждый месяц автоматически используется купон.",
      l_jp: "Maunent Creativeを利用中の場合、クーポンは毎月自動的に使用されます。",
      l_it: "Se stai utilizzando Maunent Creative, un coupon viene utilizzato automaticamente ogni mese.",
      l_es: "Si estás utilizando Maunent Creative, se utilizará un cupón automáticamente cada mes.",
      l_de: "Wenn Sie Maunent Creative verwenden, wird jeden Monat automatisch ein Gutschein verwendet.",
      l_cn: "如果您正在使用Maunent Creative，每个月会自动使用优惠券。",
      l_fr: "Si vous utilisez Maunent Creative, un coupon est automatiquement utilisé chaque mois."
    }
  },
  btnViewMore_moreCouponInfo: {
    text: {
      temp_comment: "",
      l_kr: "자세히 알아보기",
      l_us: "Learn more",
      l_gb: "Learn more",
      l_ca: "Learn more",
      l_ru: "Подробнее",
      l_jp: "詳細",
      l_it: "Scopri di più",
      l_es: "Más información",
      l_de: "Mehr erfahren",
      l_cn: "了解详情",
      l_fr: "En savoir plus"
    }
  },
  msg_howToGetCouponModalContent1: {
    text: {
      temp_comment: "",
      l_kr: "포트폴리오 또는 아웃핏의 링크를 복사하세요.",
      l_us: "Copy link to Portfolio or Outfit.",
      l_gb: "Copy link to Portfolio or Outfit.",
      l_ca: "Copy link to Portfolio or Outfit.",
      l_ru: "Скопируйте ссылку на Портфолио или Аутфит.",
      l_jp: "ポートフォリオやコーデへのリンクをコピーします。",
      l_it: "Copia il link al Portfolio o all'Outfit.",
      l_es: "Copia el enlace al Portfolio o al Outfit.",
      l_de: "Link zu Portfolio oder Outfit kopieren.",
      l_cn: "将链接复制到穿搭日记或穿搭页面。",
      l_fr: "Copier le lien vers portfolio ou tenue."
    }
  },
  msg_howToGetCouponModalContent2: {
    text: {
      temp_comment: "",
      l_kr: "포트폴리오 : 포트폴리오에서 <<moreBtn>> > <<copyLinkBtn>>",
      l_us: "Portfolio: In the portfolio, tap <<moreBtn>> > <<copyLinkBtn>>",
      l_gb: "Portfolio: In the portfolio, tap <<moreBtn>> > <<copyLinkBtn>>",
      l_ca: "Portfolio: In the portfolio, tap <<moreBtn>> > <<copyLinkBtn>>",
      l_ru: "Портфолио: В портфолио коснитесь <<moreBtn>> > <<copyLinkBtn>>",
      l_jp: "ポートフォリオ: ポートフォリオページで、<<moreBtn>> > <<copyLinkBtn>>をタップしてください。",
      l_it: "Portfolio: Nel portfolio, tocca su <<moreBtn>> > <<copyLinkBtn>>",
      l_es: "Portfolio: En el portfolio, toca en <<moreBtn>> > <<copyLinkBtn>>",
      l_de: "Portfolio: Im Portfolio tippen Sie auf <<moreBtn>> > <<copyLinkBtn>>",
      l_cn: "穿搭日记：在穿搭日记页面，轻点<<moreBtn>> > <<copyLinkBtn>>",
      l_fr: "Portfolio : Dans le portfolio, touchez <<moreBtn>> > <<copyLinkBtn>>"
    }
  },
  msg_howToGetCouponModalContent3: {
    text: {
      temp_comment: "",
      l_kr: "아웃핏 : 아웃핏에서 <<moreBtn>> > <<copyLinkBtn>>",
      l_us: "Outfit: In the outfit, tap <<moreBtn>> > <<copyLinkBtn>>",
      l_gb: "Outfit: In the outfit, tap <<moreBtn>> > <<copyLinkBtn>>",
      l_ca: "Outfit: In the outfit, tap <<moreBtn>> > <<copyLinkBtn>>",
      l_ru: "Аутфит: В аутфите коснитесь <<moreBtn>> > <<copyLinkBtn>>",
      l_jp: "コーデ: コーデページで、<<moreBtn>> > <<copyLinkBtn>>をタップしてください。",
      l_it: "Outfit: Nell'outfit, tocca su <<moreBtn>> > <<copyLinkBtn>>",
      l_es: "Outfit: En el outfit, toca en <<moreBtn>> > <<copyLinkBtn>>",
      l_de: "Outfit: Im Outfit tippen Sie auf <<moreBtn>> > <<copyLinkBtn>>",
      l_cn: "穿搭：在穿搭页面，轻点<<moreBtn>> > <<copyLinkBtn>>",
      l_fr: "Tenue : Dans la tenue, touchez <<moreBtn>> > <<copyLinkBtn>>"
    }
  },
  msg_howToGetCouponModalContent4: {
    text: {
      temp_comment: "",
      l_kr: "링크를 친구들에게 공유하세요.",
      l_us: "Share the link with your friends.",
      l_gb: "Share the link with your friends.",
      l_ca: "Share the link with your friends.",
      l_ru: "Поделитесь ссылкой с друзьями.",
      l_jp: "そのリンクを友達と共有してください",
      l_it: "Condividi il link con i tuoi amici.",
      l_es: "Comparte el enlace con tus amigos.",
      l_de: "Teilen Sie den Link mit Ihren Freunden.",
      l_cn: "将链接分享给您的朋友。",
      l_fr: "Partagez le lien avec vos amis."
    }
  },
  msg_howToGetCouponModalContent5: {
    text: {
      temp_comment: "",
      l_kr: "인스타그램, 유튜브, 페이스북과 같은 소셜 미디어 플랫폼 프로필에 링크를 추가하세요.",
      l_us: "Add your link to the profile of social media platforms like Instagram, YouTube, or Facebook.",
      l_gb: "Add your link to the profile of social media platforms like Instagram, YouTube, or Facebook.",
      l_ca: "Add your link to the profile of social media platforms like Instagram, YouTube, or Facebook.",
      l_ru: "Добавьте вашу ссылку в профиль на платформах социальных сетей, таких как Instagram, YouTube или Facebook.",
      l_jp: "Instagram、YouTube、Facebookなどのソーシャルメディアプラットフォームのプロファイルにリンクを追加してください。",
      l_it: "Aggiungi il tuo link al profilo su piattaforme di social media come Instagram, YouTube o Facebook.",
      l_es: "Añade tu enlace al perfil en plataformas de redes sociales como Instagram, YouTube o Facebook.",
      l_de: "Fügen Sie Ihren Link zum Profil auf Social-Media-Plattformen wie Instagram, YouTube oder Facebook hinzu.",
      l_cn: "在Instagram、YouTube或Facebook等社交媒体平台的个人资料中添加您的链接。",
      l_fr: "Ajoutez votre lien au profil sur des plateformes de médias sociaux comme Instagram, YouTube ou Facebook."
    }
  },
  msg_howToGetCouponModalContent6: {
    text: {
      temp_comment: "",
      l_kr: "링크를 통해 가입한 친구가 Maunent Creative를 시작하면, 즉시 나에게 쿠폰이 생성됩니다.",
      l_us: "If your friend signs up through the link and starts Maunent Creative, a coupon will be generated for you immediately.",
      l_gb: "If your friend signs up through the link and starts Maunent Creative, a coupon will be generated for you immediately.",
      l_ca: "If your friend signs up through the link and starts Maunent Creative, a coupon will be generated for you immediately.",
      l_ru: "Если ваш друг зарегистрируется по ссылке и начнет использовать Maunent Creative, купон будет сгенерирован для вас немедленно.",
      l_jp: "リンクを通じて友達が登録し、Maunent Creativeを開始すると、すぐにクーポンが発行されます。",
      l_it: "Se il tuo amico si registra tramite il link e inizia Maunent Creative, verrà generato immediatamente un coupon per te.",
      l_es: "Si tu amigo se registra a través del enlace e inicia Maunent Creative, se generará un cupón para ti inmediatamente.",
      l_de: "Wenn sich Ihr Freund über den Link anmeldet und Maunent Creative beginnt, wird sofort ein Gutschein für Sie generiert.",
      l_cn: "如果您的朋友通过链接注册并开始使用Maunent Creative，您将立即获得一张优惠券。",
      l_fr: "Si votre ami s'inscrit via le lien et commence Maunent Creative, un coupon sera généré pour vous immédiatement."
    }
  },
  msg_howToUseCouponModalContent1: {
    text: {
      temp_comment: "",
      l_kr: "아무것도 할 필요가 없습니다.",
      l_us: "You don't need to do anything.",
      l_gb: "You don't need to do anything.",
      l_ca: "You don't need to do anything.",
      l_ru: "Вам ничего не нужно делать.",
      l_jp: "何もする必要はありません。",
      l_it: "Non devi fare nulla.",
      l_es: "No necesitas hacer nada.",
      l_de: "Sie müssen nichts tun.",
      l_cn: "您无需做任何事情。",
      l_fr: "Vous n'avez rien à faire."
    }
  },
  msg_howToUseCouponModalContent2: {
    text: {
      temp_comment: "",
      l_kr: "만일 쿠폰을 보유하고 있다면 멤버십 결제 대신 쿠폰이 사용됩니다.",
      l_us: "If you have a coupon, it will be used instead of the membership payment.",
      l_gb: "If you have a coupon, it will be used instead of the membership payment.",
      l_ca: "If you have a coupon, it will be used instead of the membership payment.",
      l_ru: "Если у вас есть купон, он будет использован вместо оплаты членства.",
      l_jp: "もしクーポンを保有している場合、メンバーシップの支払いの代わりにクーポンが使用されます。",
      l_it: "Se hai un coupon, verrà utilizzato al posto del pagamento dell'iscrizione.",
      l_es: "Si tienes un cupón, se utilizará en lugar del pago de la membresía.",
      l_de: "Wenn Sie einen Gutschein haben, wird dieser anstelle der Mitgliedschaftszahlung verwendet.",
      l_cn: "如果您有优惠券，将代替会员付款使用。",
      l_fr: "Si vous avez un coupon, il sera utilisé à la place du paiement de l'adhésion."
    }
  },
  msg_howToUseCouponModalContent3: {
    text: {
      temp_comment: "",
      l_kr: "쿠폰이 있지만 아직 Maunent Creative 멤버십을 시작하지 않으셨다면, 멤버십 시작 1개월 후에 쿠폰이 자동으로 사용됩니다.",
      l_us: "If you have a coupon but haven't started your Maunent Creative membership yet, the coupon will be automatically used one month after you begin your subscription.",
      l_gb: "If you have a coupon but haven't started your Maunent Creative membership yet, the coupon will be automatically used one month after you begin your subscription.",
      l_ca: "If you have a coupon but haven't started your Maunent Creative membership yet, the coupon will be automatically used one month after you begin your subscription.",
      l_ru: "Если у вас есть купон, но вы еще не начали пользоваться членством Maunent Creative, купон будет автоматически использован через один месяц после начала вашей подписки.",
      l_jp: "クーポンをお持ちですが、まだMaunent Creativeのメンバーシップを開始していない場合、メンバーシップ開始1ヶ月後にクーポンが自動的に使用されます。",
      l_it: "Se hai un coupon ma non hai ancora iniziato il tuo abbonamento a Maunent Creative, il coupon verrà utilizzato automaticamente un mese dopo aver iniziato il tuo abbonamento.",
      l_es: "Si tienes un cupón pero aún no has comenzado tu membresía de Maunent Creative, el cupón se utilizará automáticamente un mes después de que comiences tu suscripción.",
      l_de: "Wenn Sie einen Gutschein haben, aber Ihre Maunent Creative-Mitgliedschaft noch nicht begonnen haben, wird der Gutschein einen Monat nach Beginn Ihres Abonnements automatisch eingelöst.",
      l_cn: "如果您有优惠券但尚未开始您的Maunent Creative会员资格,则在您开始订阅后一个月内该优惠券将自动使用。",
      l_fr: "Si vous avez un coupon mais n'avez pas encore commencé votre abonnement Maunent Creative, le coupon sera automatiquement utilisé un mois après le début de votre abonnement."
    }
  },
  btnFooter_termsOfUse: {
    text: {
      temp_comment: "",
      l_kr: "이용약관",
      l_us: "Terms of Use",
      l_gb: "Terms of Use",
      l_ca: "Terms of Use",
      l_ru: "Условия использования",
      l_jp: "利用規約",
      l_it: "Condizioni d'uso",
      l_es: "Condiciones de uso",
      l_de: "Nutzungsbedingungen",
      l_cn: "使用条款",
      l_fr: "Conditions d’utilisation"
    }
  },
  btnFooter_privacyPolicy: {
    text: {
      temp_comment: "",
      l_kr: "개인정보처리방침",
      l_us: "Privacy Policy",
      l_gb: "Privacy Policy",
      l_ca: "Privacy Policy",
      l_ru: "Политика конфиденциальности",
      l_jp: "プライバシーポリシー",
      l_it: "Informativa sulla privacy",
      l_es: "Política de privacidad",
      l_de: "Datenschutzrichtlinie",
      l_cn: "隐私权政策",
      l_fr: "Politique de Confidentialité"
    }
  },
  btnModal_downloadImage: {
    text: {
      temp_comment: "",
      l_kr: "이미지 다운로드",
      l_us: "Download Image",
      l_gb: "Download Image",
      l_ca: "Download Image",
      l_ru: "Скачать изображение",
      l_jp: "画像をダウンロード",
      l_it: "Scarica l'immagine",
      l_es: "Descargar imagen",
      l_de: "Bild herunterladen",
      l_cn: "下载照片",
      l_fr: "Télécharger l'image"
    }
  },
  msg_tooltipClickItemTagsOfItemDetail: {
    text: {
      temp_comment: "",
      l_kr: "태그를 탭하여 아이템을 검색하세요.",
      l_us: "Tap tags to search items.",
      l_gb: "Tap tags to search items.",
      l_ca: "Tap tags to search items.",
      l_ru: "Коснитесь на теги, чтобы найти Вещи.",
      l_jp: "タグをタップしてアイテムを検索する。",
      l_it: "Tocca sui tag per cercare Articoli.",
      l_es: "Toca en las etiquetas para buscar Artículos.",
      l_de: "Tippen Sie auf Tags, um Artikel zu suchen.",
      l_cn: "轻点标签搜索物品。",
      l_fr: "Touchez les tags pour rechercher des Objets."
    }
  },
  msg_emptyListOutfitWithItem: {
    text: {
      temp_comment: "",
      l_kr: "이 아이템을 사용한 아웃핏이 없습니다.",
      l_us: "There are no outfits that use this item.",
      l_gb: "There are no outfits that use this item.",
      l_ca: "There are no outfits that use this item.",
      l_ru: "Нет аутфитов, использующих эту вещь.",
      l_jp: "このアイテムを使ったコーデはありません。",
      l_it: "Non ci sono outfit che utilizzano questo articolo.",
      l_es: "No hay outfits que usen este artículo.",
      l_de: "Es gibt keine Outfits, die diesen Artikel verwenden.",
      l_cn: "没有使用这个物品的穿搭。",
      l_fr: "Il n'y a pas de tenues qui utilisent cet objet."
    }
  },
  msg_tooltipClickSearchCriteria: {
    text: {
      temp_comment: "",
      l_kr: "탭하여 원하는 아이템을 착용한 아웃핏을 검색하세요.",
      l_us: "Tap to search for outfits featuring the items you want.",
      l_gb: "Tap to search for outfits featuring the items you want.",
      l_ca: "Tap to search for outfits featuring the items you want.",
      l_ru: "Нажмите, чтобы найти аутфиты с нужными вещами.",
      l_jp: "タップして、お望みのアイテムを使用したコーデを検索できます。",
      l_it: "Tocca per cercare outfit con gli articoli che desideri.",
      l_es: "Toca para buscar outfits con los artículos que quieres.",
      l_de: "Tippen Sie, um Outfits mit den gewünschten Artikeln zu suchen.",
      l_cn: "点击搜索包含所需物品的穿搭。",
      l_fr: "Appuyez pour rechercher des tenues avec les objets souhaités."
    }
  },
  msg_tooltipClickItemUnit: {
    text: {
      temp_comment: "아마 미사용 상태",
      l_kr: "아이템 이미지를 탭하세요.",
      l_us: "Tap the item image.",
      l_gb: "Tap the item image.",
      l_ca: "Tap the item image.",
      l_ru: "Коснитесь изображения вещи.",
      l_jp: "アイテム画像をタップしてください。",
      l_it: "Tocca l'immagine dell'articolo.",
      l_es: "Toca la imagen del artículo.",
      l_de: "Tippen Sie auf das Artikelbild.",
      l_cn: "请轻点物品图片。",
      l_fr: "Touchez l'image de l'objet."
    }
  },
  msg_tooltipClickNormalBtn: {
    text: {
      temp_comment: "",
      l_kr: "탭하세요",
      l_us: "Tap here",
      l_gb: "Tap here",
      l_ca: "Tap here",
      l_ru: "Нажмите здесь",
      l_jp: "タップ",
      l_it: "Tocca qui",
      l_es: "Toca aquí",
      l_de: "Hier tippen",
      l_cn: "点击这里",
      l_fr: "Appuyez ici"
    }
  },
  msg_tooltipIntroduceDownloadImage: {
    text: {
      temp_comment: "",
      l_kr: "Instagram에 최적화된 4:5 비율의 이미지 형식.",
      l_us: "Instagram-optimized image in 4:5 aspect ratio.",
      l_gb: "Instagram-optimized image in 4:5 aspect ratio.",
      l_ca: "Instagram-optimized image in 4:5 aspect ratio.",
      l_ru: "Оптимизированное для Instagram изображение с соотношением сторон 4:5.",
      l_jp: "Instagram向けに最適化された4:5アスペクト比の画像形式。",
      l_it: "Immagine ottimizzata per Instagram con rapporto d'aspetto 4:5.",
      l_es: "Imagen optimizada para Instagram con relación de aspecto 4:5.",
      l_de: "Für Instagram optimiertes Bild im Seitenverhältnis 4:5.",
      l_cn: "专为Instagram优化的4:5比例图片格式。",
      l_fr: "Image optimisée pour Instagram au format 4:5."
    }
  },
  msg_tooltipScrollDown: {
    text: {
      temp_comment: "",
      l_kr: "화면을 아래로 스크롤하세요",
      l_us: "Scroll the screen down",
      l_gb: "Scroll the screen down",
      l_ca: "Scroll the screen down",
      l_ru: "Прокрутите экран вниз",
      l_jp: "画面を下にスクロールしてください",
      l_it: "Scorri lo schermo verso il basso",
      l_es: "Desplácese hacia abajo en la pantalla",
      l_de: "Scrollen Sie den Bildschirm nach unten",
      l_cn: "向下滚动屏幕",
      l_fr: "Faites défiler l'écran vers le bas"
    }
  },
  titleModal_findUsers: {
    text: {
      temp_comment: "",
      l_kr: "사용자 찾기",
      l_us: "Find Users",
      l_gb: "Find Users",
      l_ca: "Find Users",
      l_ru: "Найти пользователей",
      l_jp: "ユーザーを探す",
      l_it: "Trova utenti",
      l_es: "Buscar usuarios",
      l_de: "Benutzer finden",
      l_cn: "查找用户",
      l_fr: "Trouver des utilisateurs"
    }
  },
  wordPlaceholder_calendarDate: {
    text: {
      temp_comment: "",
      l_kr: "날짜",
      l_us: "Date",
      l_gb: "Date",
      l_ca: "Date",
      l_ru: "Дата",
      l_jp: "日付",
      l_it: "Data",
      l_es: "Fecha",
      l_de: "Datum",
      l_cn: "日期",
      l_fr: "Date"
    }
  },
  msg_displayCalendarChkbox: {
    text: {
      temp_comment: "",
      l_kr: "캘린더에 표시",
      l_us: "Display on calendar",
      l_gb: "Display on calendar",
      l_ca: "Display on calendar",
      l_ru: "Показать в календаре",
      l_jp: "カレンダーに表示",
      l_it: "Mostra nel calendario",
      l_es: "Mostrar en calendario",
      l_de: "Im Kalender anzeigen",
      l_cn: "在日历中显示",
      l_fr: "Afficher dans le calendrier"
    }
  },
  msg_displayCalendar: {
    text: {
      temp_comment: "",
      l_kr: "캘린더에 표시",
      l_us: "Display on calendar",
      l_gb: "Display on calendar",
      l_ca: "Display on calendar",
      l_ru: "Показать в календаре",
      l_jp: "カレンダーに表示",
      l_it: "Mostra nel calendario",
      l_es: "Mostrar en calendario",
      l_de: "Im Kalender anzeigen",
      l_cn: "在日历中显示",
      l_fr: "Afficher dans le calendrier"
    }
  },
  msg_allOutfitOfDropdown: {
    text: {
      temp_comment: "",
      l_kr: "모든 아웃핏",
      l_us: "All Outfits",
      l_gb: "All Outfits",
      l_ca: "All Outfits",
      l_ru: "Все аутфиты",
      l_jp: "すべてのコーデ",
      l_it: "Tutti gli outfit",
      l_es: "Todos los outfits",
      l_de: "Alle Outfits",
      l_cn: "所有穿搭",
      l_fr: "Toutes les tenues"
    }
  },
  btnSelect_folder: {
    text: {
      temp_comment: "",
      l_kr: "폴더",
      l_us: "Folder",
      l_gb: "Folder",
      l_ca: "Folder",
      l_ru: "Папка",
      l_jp: "フォルダ",
      l_it: "Cartella",
      l_es: "Carpeta",
      l_de: "Ordner",
      l_cn: "文件夹",
      l_fr: "Dossier"
    }
  },
  btnList_createFolder: {
    text: {
      temp_comment: "",
      l_kr: "폴더 생성",
      l_us: "Create Folder",
      l_gb: "Create Folder",
      l_ca: "Create Folder",
      l_ru: "Создать папку",
      l_jp: "フォルダを作成",
      l_it: "Crea cartella",
      l_es: "Crear carpeta",
      l_de: "Ordner erstellen",
      l_cn: "创建文件夹",
      l_fr: "Créer dossier"
    }
  },
  btnList_editFolderName: {
    text: {
      temp_comment: "",
      l_kr: "폴더 “<<folderName>>” 수정",
      l_us: "Edit Folder “<<folderName>>”",
      l_gb: "Edit Folder “<<folderName>>”",
      l_ca: "Edit Folder “<<folderName>>”",
      l_ru: "Редактировать папку «<<folderName>>»",
      l_jp: "フォルダ「<<folderName>>」を編集",
      l_it: "Modifica cartella “<<folderName>>”",
      l_es: "Editar carpeta “<<folderName>>”",
      l_de: "Ordner „<<folderName>>“ bearbeiten",
      l_cn: "编辑文件夹“<<folderName>>”",
      l_fr: "Modifier dossier « <<folderName>> »"
    }
  },
  btnList_removeFolder: {
    text: {
      temp_comment: "",
      l_kr: "폴더 “<<folderName>>” 삭제",
      l_us: "Delete Folder “<<folderName>>”",
      l_gb: "Delete Folder “<<folderName>>”",
      l_ca: "Delete Folder “<<folderName>>”",
      l_ru: "Удалить папку «<<folderName>>»",
      l_jp: "フォルダ「<<folderName>>」を削除",
      l_it: "Elimina cartella “<<folderName>>”",
      l_es: "Eliminar carpeta “<<folderName>>”",
      l_de: "Ordner „<<folderName>>“ löschen",
      l_cn: "删除文件夹“<<folderName>>”",
      l_fr: "Supprimer dossier « <<folderName>> »"
    }
  },
  titleModal_createFolder: {
    text: {
      temp_comment: "",
      l_kr: "폴더 생성",
      l_us: "Create Folder",
      l_gb: "Create Folder",
      l_ca: "Create Folder",
      l_ru: "Создать папку",
      l_jp: "フォルダを作成",
      l_it: "Crea cartella",
      l_es: "Crear carpeta",
      l_de: "Ordner erstellen",
      l_cn: "创建文件夹",
      l_fr: "Créer dossier"
    }
  },
  titleModal_editFolderName: {
    text: {
      temp_comment: "",
      l_kr: "폴더 “<<folderName>>” 수정",
      l_us: "Edit Folder “<<folderName>>”",
      l_gb: "Edit Folder “<<folderName>>”",
      l_ca: "Edit Folder “<<folderName>>”",
      l_ru: "Редактировать папку «<<folderName>>»",
      l_jp: "フォルダ「<<folderName>>」を編集",
      l_it: "Modifica cartella “<<folderName>>”",
      l_es: "Editar carpeta “<<folderName>>”",
      l_de: "Ordner „<<folderName>>“ bearbeiten",
      l_cn: "编辑文件夹“<<folderName>>”",
      l_fr: "Modifier dossier « <<folderName>> »"
    }
  },
  titleModal_removeFolder: {
    text: {
      temp_comment: "",
      l_kr: "폴더 “<<folderName>>” 삭제",
      l_us: "Delete Folder “<<folderName>>”",
      l_gb: "Delete Folder “<<folderName>>”",
      l_ca: "Delete Folder “<<folderName>>”",
      l_ru: "Удалить папку «<<folderName>>»",
      l_jp: "フォルダ「<<folderName>>」を削除",
      l_it: "Elimina cartella “<<folderName>>”",
      l_es: "Eliminar carpeta “<<folderName>>”",
      l_de: "Ordner „<<folderName>>“ löschen",
      l_cn: "删除文件夹“<<folderName>>”",
      l_fr: "Supprimer dossier « <<folderName>> »"
    }
  },
  msg_deleteFolder: {
    text: {
      temp_comment: "",
      l_kr: "정말 이 폴더를 삭제하시겠습니까?",
      l_us: "Are you sure you want to delete this folder?",
      l_gb: "Are you sure you want to delete this folder?",
      l_ca: "Are you sure you want to delete this folder?",
      l_ru: "Вы уверены, что хотите удалить эту папку?",
      l_jp: "本当にこのフォルダを削�しますか？",
      l_it: "Sei sicuro di voler eliminare questa cartella?",
      l_es: "¿Está seguro de eliminar esta carpeta?",
      l_de: "Möchtest du diesen Ordner wirklich löschen?",
      l_cn: "您确定要删除此文件夹吗？",
      l_fr: "Êtes-vous sûr de vouloir supprimer ce dossier ?"
    }
  },
  titleModal_bookmarkList: {
    text: {
      temp_comment: "",
      l_kr: "아이디어 컬렉션",
      l_us: "Inspo Collection",
      l_gb: "Inspo Collection",
      l_ca: "Inspo Collection",
      l_ru: "Коллекция Вдохновения",
      l_jp: "インスピレーションコレクション",
      l_it: "Collezione Ispirazioni",
      l_es: "Colección de Inspiración",
      l_de: "Inspiration Kollektion",
      l_cn: "灵感合集",
      l_fr: "Collection Inspiration"
    }
  },
  titleModal_pickList: {
    text: {
      temp_comment: "",
      l_kr: "나의 엄선된 아웃핏",
      l_us: "My Signature Outfits",
      l_gb: "My Signature Outfits",
      l_ca: "My Signature Outfits",
      l_ru: "Мои уникальные аутфиты",
      l_jp: "私のこだわりコーデ",
      l_it: "I miei outfit esclusivi",
      l_es: "Mis outfits únicos",
      l_de: "Meine einzigartigen Outfits",
      l_cn: "我的特别穿搭",
      l_fr: "Mes tenues uniques"
    }
  },
  msg_doNotSavePassword: {
    text: {
      temp_comment: "",
      l_kr: "데이터는 안전하게 암호화되어 저장되며 비공개로 처리되어 본인 이외에는 확인할 수 없습니다. 하지만 비밀번호, 금융정보 등 민감한 정보는 저장하지 마세요.",
      l_us: "Your data is securely encrypted and kept private—only you can access it. However, please do not store sensitive information such as passwords or financial details.",
      l_gb: "Your data is securely encrypted and kept private—only you can access it. However, please do not store sensitive information such as passwords or financial details.",
      l_ca: "Your data is securely encrypted and kept private—only you can access it. However, please do not store sensitive information such as passwords or financial details.",
      l_ru: "Ваши данные надежно шифруются и хранятся конфиденциально—только вы можете получить к ним доступ. Однако не сохраняйте здесь пароли, финансовую информацию и другие конфиденциальные данные.",
      l_jp: "データは安全に暗号化され、非公開として扱われます。ご本人様以外は閲覧できません。ただし、パスワードや金融情報などの機密情報は保存しないでください。",
      l_it: "I tuoi dati vengono crittografati in modo sicuro e trattati in modo privato—solo tu puoi accedervi. Tuttavia, non memorizzare informazioni sensibili come password o dati finanziari.",
      l_es: "Tus datos se cifran de forma segura y se mantienen privados—solo tú puedes acceder a ellos. Sin embargo, no guardes información sensible como contraseñas o datos financieros.",
      l_de: "Ihre Daten werden sicher verschlüsselt und vertraulich behandelt—nur Sie können darauf zugreifen. Bitte speichern Sie jedoch keine sensiblen Informationen wie Passwörter oder Finanzdaten.",
      l_cn: "您的数据经过安全加密并以私密方式处理,仅您本人可以访问。但请勿保存密码、财务信息等敏感信息。",
      l_fr: "Vos données sont chiffrées en toute sécurité et traitées de manière privée—seul vous pouvez y accéder. Cependant, n'enregistrez pas d'informations sensibles telles que des mots de passe ou des données financières."
    }
  },
  wordPlaceholder_itemName: {
    text: {
      temp_comment: "",
      l_kr: "닉네임",
      l_us: "Nickname",
      l_gb: "Nickname",
      l_ca: "Nickname",
      l_ru: "Никнейм",
      l_jp: "ニックネーム",
      l_it: "Nickname",
      l_es: "Apodo",
      l_de: "Spitzname",
      l_cn: "昵称",
      l_fr: "Surnom"
    }
  },
  wordPlaceholder_itemLocation: {
    text: {
      temp_comment: "",
      l_kr: "보관 위치",
      l_us: "Storage Location",
      l_gb: "Storage Location",
      l_ca: "Storage Location",
      l_ru: "Место хранения",
      l_jp: "保管場所",
      l_it: "Posizione di conservazione",
      l_es: "Ubicación de almacenamiento",
      l_de: "Aufbewahrungsort",
      l_cn: "存放位置",
      l_fr: "Emplacement de stockage"
    }
  },
  wordPlaceholder_itemSize: {
    text: {
      temp_comment: "",
      l_kr: "사이즈",
      l_us: "Size",
      l_gb: "Size",
      l_ca: "Size",
      l_ru: "Размер",
      l_jp: "サイズ",
      l_it: "Taglia",
      l_es: "Talla",
      l_de: "Größe",
      l_cn: "尺码",
      l_fr: "Taille"
    }
  },
  wordPlaceholder_itemMemo: {
    text: {
      temp_comment: "",
      l_kr: "메모",
      l_us: "Note",
      l_gb: "Note",
      l_ca: "Note",
      l_ru: "Заметка",
      l_jp: "メモ",
      l_it: "Nota",
      l_es: "Nota",
      l_de: "Notiz",
      l_cn: "备注",
      l_fr: "Note"
    }
  },
  titleModal_writeItemMemo: {
    text: {
      temp_comment: "",
      l_kr: "아이템 정보 입력",
      l_us: "Enter Item Information",
      l_gb: "Enter Item Information",
      l_ca: "Enter Item Information",
      l_ru: "Ввод информации о вещи",
      l_jp: "アイテム情報入力",
      l_it: "Inserisci informazioni sull'articolo",
      l_es: "Introducir información del artículo",
      l_de: "Artikelinformation eingeben",
      l_cn: "输入物品信息",
      l_fr: "Saisir les informations sur l'objet"
    }
  },
  wordPlaceholder_outfitWho: {
    text: {
      temp_comment: "",
      l_kr: "누구와?",
      l_us: "With who?",
      l_gb: "With who?",
      l_ca: "With who?",
      l_ru: "С кем?",
      l_jp: "誰と?",
      l_it: "Con chi?",
      l_es: "¿Con quién?",
      l_de: "Mit wem?",
      l_cn: "和谁?",
      l_fr: "Avec qui ?"
    }
  },
  wordPlaceholder_outfitWhere: {
    text: {
      temp_comment: "",
      l_kr: "어디서?",
      l_us: "Where at?",
      l_gb: "Where at?",
      l_ca: "Where at?",
      l_ru: "Где?",
      l_jp: "どこで?",
      l_it: "Dove?",
      l_es: "¿Dónde?",
      l_de: "Wo?",
      l_cn: "在哪?",
      l_fr: "Où ?"
    }
  },
  wordPlaceholder_outfitWhat: {
    text: {
      temp_comment: "",
      l_kr: "무엇을?",
      l_us: "What did I do?",
      l_gb: "What did I do?",
      l_ca: "What did I do?",
      l_ru: "Что я делал?",
      l_jp: "何をした?",
      l_it: "Cosa ho fatto?",
      l_es: "¿Qué hice?",
      l_de: "Was habe ich gemacht?",
      l_cn: "做了什么?",
      l_fr: "Qu'ai-je fait ?"
    }
  },
  wordPlaceholder_outfitEtc: {
    text: {
      temp_comment: "",
      l_kr: "메모",
      l_us: "Note",
      l_gb: "Note",
      l_ca: "Note",
      l_ru: "Заметка",
      l_jp: "メモ",
      l_it: "Nota",
      l_es: "Nota",
      l_de: "Notiz",
      l_cn: "备注",
      l_fr: "Note"
    }
  },
  titleModal_writeOutfitMemo: {
    text: {
      temp_comment: "",
      l_kr: "하루 남기기",
      l_us: "Save My Day",
      l_gb: "Save My Day",
      l_ca: "Save My Day",
      l_ru: "Сохранить мой день",
      l_jp: "今日を記録",
      l_it: "Salva la mia giornata",
      l_es: "Guardar mi día",
      l_de: "Meinen Tag speichern",
      l_cn: "保存我的一天",
      l_fr: "Enregistrer ma journée"
    }
  },
  btnModal_save: {
    text: {
      temp_comment: "",
      l_kr: "저장",
      l_us: "Save",
      l_gb: "Save",
      l_ca: "Save",
      l_ru: "Сохранить",
      l_jp: "保存",
      l_it: "Salva",
      l_es: "Guardar",
      l_de: "Speichern",
      l_cn: "保存",
      l_fr: "Enregistrer"
    }
  },
  msg_inputTextTooLong: {
    text: {
      temp_comment: "",
      l_kr: "더 이상 텍스트를 입력할 수 없습니다.",
      l_us: "You can’t enter any more text.",
      l_gb: "You can’t enter any more text.",
      l_ca: "You can’t enter any more text.",
      l_ru: "Вы больше не можете вводить текст.",
      l_jp: "これ以上文字を入力できません。",
      l_it: "Non puoi inserire altro testo.",
      l_es: "No puedes ingresar más texto.",
      l_de: "Es kann kein weiterer Text eingegeben werden.",
      l_cn: "无法再输入更多文本。",
      l_fr: "Vous ne pouvez plus saisir de texte."
    }
  },
  btnTab_allStats: {
    text: {
      temp_comment: "",
      l_kr: "전체",
      l_us: "All",
      l_gb: "All",
      l_ca: "All",
      l_ru: "Все",
      l_jp: "すべて",
      l_it: "Tutti",
      l_es: "Todos",
      l_de: "Alle",
      l_cn: "全部",
      l_fr: "Tous"
    }
  },
  btnTab_maleStats: {
    text: {
      temp_comment: "",
      l_kr: "남성",
      l_us: "Men",
      l_gb: "Men",
      l_ca: "Men",
      l_ru: "Мужчины",
      l_jp: "男性",
      l_it: "Uomini",
      l_es: "Hombres",
      l_de: "Männer",
      l_cn: "男性",
      l_fr: "Hommes"
    }
  },
  btnTab_femaleStats: {
    text: {
      temp_comment: "",
      l_kr: "여성",
      l_us: "Women",
      l_gb: "Women",
      l_ca: "Women",
      l_ru: "Женщины",
      l_jp: "女性",
      l_it: "Donne",
      l_es: "Mujeres",
      l_de: "Frauen",
      l_cn: "女性",
      l_fr: "Femmes"
    }
  },
  msg_aboutPageFirstHeader: {
    text: {
      temp_comment: "",
      l_kr: "이제 나만의 스타일을 만들기 위해 여러 앱을 사용할 필요가 없습니다",
      l_us: "You No Longer Need Multiple Apps to Build Your Own Style",
      l_gb: "You No Longer Need Multiple Apps to Build Your Own Style",
      l_ca: "You No Longer Need Multiple Apps to Build Your Own Style",
      l_ru: "Теперь вам не нужно использовать несколько приложений, чтобы создать свой собственный стиль",
      l_jp: "自分だけのスタイルをつくるために、もう複数のアプリを使う必要はありません",
      l_it: "Non hai più bisogno di usare più app per costruire il tuo stile personale",
      l_es: "Ya no necesitas usar varias aplicaciones para construir tu propio estilo",
      l_de: "Du brauchst nicht länger mehrere Apps, um deinen eigenen Stil aufzubauen",
      l_cn: "打造属于自己的风格，无需再使用多个应用",
      l_fr: "Vous n’avez plus besoin d’utiliser plusieurs applications pour construire votre propre style"
    }
  },
  msg_aboutPageHeader1: {
    text: {
      temp_comment: "",
      l_kr: "1. 매일 입은 아웃핏을 사진으로 기록하는 스타일 다이어리",
      l_us: "1. A Style Diary That Captures What You Wore Today",
      l_gb: "1. A Style Diary That Captures What You Wore Today",
      l_ca: "1. A Style Diary That Captures What You Wore Today",
      l_ru: "1. Дневник стиля, который сохраняет ваш сегодняшний образ",
      l_jp: "1. 今日のコーデを写真で記録するスタイルダイアリー",
      l_it: "1. Un diario di stile che cattura ciò che hai indossato oggi",
      l_es: "1. Un diario de estilo que guarda lo que llevaste hoy",
      l_de: "1. Ein Stil‑Tagebuch, das festhält, was du heute getragen hast",
      l_cn: "1. 用照片记录今日穿搭的风格日记",
      l_fr: "1. Un journal de style qui capture ce que vous avez porté aujourd’hui"
    }
  },
  msg_aboutPageSub1: {
    text: {
      temp_comment: "",
      l_kr: "오늘 입은 옷을 사진 한 장으로 남겨보세요. 스쳐 지나가는 코디가 아닌, 시간이 쌓일수록 더 또렷해지는 나만의 취향 기록이 완성됩니다.",
      l_us: "Capture today’s outfit in a single photo. Instead of letting your looks drift away, build a personal archive that grows sharper and more distinctive with time.",
      l_gb: "Capture today’s outfit in a single photo. Instead of letting your looks drift away, build a personal archive that grows sharper and more distinctive with time.",
      l_ca: "Capture today’s outfit in a single photo. Instead of letting your looks drift away, build a personal archive that grows sharper and more distinctive with time.",
      l_ru: "Сохраните сегодняшний образ одним фото. Вместо того чтобы позволить ему исчезнуть, создайте личный архив, который со временем станет более чётким и выразительным.",
      l_jp: "今日のコーデを1枚の写真で残しましょう。流れていくスタイルではなく、時間とともにより鮮明になる自分だけの記録を作れます。",
      l_it: "Salva l’outfit di oggi con una sola foto. Invece di lasciarlo svanire, crea un archivio personale che diventa sempre più definito nel tempo.",
      l_es: "Guarda el outfit de hoy con una sola foto. En lugar de dejar que se pierda, crea un archivo personal que se vuelva más claro y definido con el tiempo.",
      l_de: "Halte dein heutiges Outfit mit nur einem Foto fest. Statt es verblassen zu lassen, baue ein persönliches Archiv auf, das mit der Zeit klarer und prägnanter wird.",
      l_cn: "用一张照片记录今天的穿搭。与其让它悄然消失，不如建立一个随着时间愈发清晰的个人风格档案。",
      l_fr: "Capturez votre tenue du jour en une seule photo. Au lieu de la laisser s’effacer, créez une archive personnelle qui gagne en clarté et en caractère avec le temps."
    }
  },
  msg_aboutPageHeader2: {
    text: {
      temp_comment: "",
      l_kr: "2. 내가 고른 나의 두 스타일, 어떤 쪽이 더 어울릴까요? 더이상 친구에게 물어보지 마세요",
      l_us: "2. My Two Outfits — Which One Suits Me Better? No Need to Ask Your Friends Anymore",
      l_gb: "2. My Two Outfits — Which One Suits Me Better? No Need to Ask Your Friends Anymore",
      l_ca: "2. My Two Outfits — Which One Suits Me Better? No Need to Ask Your Friends Anymore",
      l_ru: "2. Два моих образа — какой мне подходит больше? Больше не нужно спрашивать друзей",
      l_jp: "2. 自分で選んだ2つのコーデ、どちらがより似合う？もう友達に聞く必要はありません",
      l_it: "2. I miei due look — quale mi sta meglio? Non serve più chiedere agli amici",
      l_es: "2. Mis dos outfits — ¿cuál me queda mejor? Ya no necesitas preguntarle a tus amigos",
      l_de: "2. Meine zwei Outfits — welches steht mir besser? Kein Grund mehr, Freunde zu fragen",
      l_cn: "2. 我的两套穿搭——哪一套更适合我？不必再问朋友",
      l_fr: "2. Vos deux tenues — laquelle vous va le mieux ? Plus besoin de demander à vos amis"
    }
  },
  msg_aboutPageSub2: {
    text: {
      temp_comment: "",
      l_kr: "어떤 스타일이 더 나다운지 고민될 때, 투표 기능을 통해 객관적인 선택을 받아보세요. 물론, 국가별·성별별 모든 통계 결과는 오직 나만 확인할 수 있어요.",
      l_us: "When you’re torn between two outfits, let the voting feature offer a broader perspective. Detailed statistics by country and gender are provided — and the final results remain completely private to you.",
      l_gb: "When you’re torn between two outfits, let the voting feature offer a broader perspective. Detailed statistics by country and gender are provided — and the final results remain completely private to you.",
      l_ca: "When you’re torn between two outfits, let the voting feature offer a broader perspective. Detailed statistics by country and gender are provided — and the final results remain completely private to you.",
      l_ru: "Если вы сомневаетесь между двумя образами, воспользуйтесь голосованием, чтобы получить более объективный взгляд. Подробная статистика по странам и полу доступна — и результаты видите только вы.",
      l_jp: "2つのコーデで迷ったら、投票機能で客観的な視点を得ましょう。国別・性別ごとの詳細な統計も確認でき、結果は自分だけに表示されます。",
      l_it: "Se sei indeciso tra due outfit, usa la funzione di voto per ottenere una prospettiva più ampia. Le statistiche dettagliate per paese e genere sono disponibili — e i risultati restano completamente privati.",
      l_es: "Si dudas entre dos outfits, utiliza la función de votación para obtener una perspectiva más amplia. Las estadísticas detalladas por país y género están disponibles — y los resultados son totalmente privados.",
      l_de: "Wenn du zwischen zwei Outfits schwankst, nutze die Abstimmungsfunktion für eine breitere Perspektive. Detaillierte Statistiken nach Land und Geschlecht sind verfügbar — und die Ergebnisse bleiben vollständig privat.",
      l_cn: "当你在两套穿搭之间犹豫时，可通过投票功能获得更客观的视角。按国家和性别划分的详细统计数据均可查看，且结果仅你本人可见。",
      l_fr: "Si vous hésitez entre deux tenues, utilisez la fonction de vote pour obtenir une perspective plus large. Des statistiques détaillées par pays et par genre sont disponibles — et les résultats restent entièrement privés."
    }
  },
  msg_aboutPageHeader3: {
    text: {
      temp_comment: "",
      l_kr: "3. 나의 옷·신발·가방 전부를 한눈에 관리하는 나만의 디지털 옷장",
      l_us: "3. Your Personal Digital Wardrobe, Organized at a Glance",
      l_gb: "3. Your Personal Digital Wardrobe, Organized at a Glance",
      l_ca: "3. Your Personal Digital Wardrobe, Organized at a Glance",
      l_ru: "3. Ваш личный цифровой гардероб — всё на виду",
      l_jp: "3. 一目で管理できる、あなただけのデジタルクローゼット",
      l_it: "3. Il tuo guardaroba digitale personale, organizzato a colpo d’occhio",
      l_es: "3. Tu armario digital personal, organizado de un vistazo",
      l_de: "3. Dein persönlicher digitaler Kleiderschrank — alles auf einen Blick",
      l_cn: "3. 一目了然的个人数字衣橱",
      l_fr: "3. Votre garde‑robe numérique personnelle, organisée en un coup d’œil"
    }
  },
  msg_aboutPageSub3: {
    text: {
      temp_comment: "",
      l_kr: "나의 아이템을 클릭하면, 그 아이템을 착용한 모든 아웃핏을 바로 확인할 수 있어요. 또한 내가 소유한 내 옷장의 모든 아이템들을 한 화면에 정리할 수 있어요. Maunent가 체계적으로 관리해 드릴게요.",
      l_us: "Select any item to instantly see every outfit that includes it. See your full wardrobe at a glance and organize every piece in one place. Maunent keeps your wardrobe clearly structured and easy to manage.",
      l_gb: "Select any item to instantly see every outfit that includes it. See your full wardrobe at a glance and organize every piece in one place. Maunent keeps your wardrobe clearly structured and easy to manage.",
      l_ca: "Select any item to instantly see every outfit that includes it. See your full wardrobe at a glance and organize every piece in one place. Maunent keeps your wardrobe clearly structured and easy to manage.",
      l_ru: "Выберите любой предмет, чтобы сразу увидеть все образы с ним. Просматривайте весь свой гардероб на одном экране и организуйте каждую вещь в одном месте. Maunent помогает держать гардероб в порядке и легко им управлять.",
      l_jp: "アイテムを選択すると、そのアイテムを含むすべてのコーデをすぐに確認できます。衣類を一画面で整理し、効率的に管理できます。Maunentがあなたのクローゼットを分かりやすく整えます。",
      l_it: "Seleziona un capo per vedere subito tutti gli outfit che lo includono. Visualizza l’intero guardaroba su un’unica schermata e organizza ogni pezzo in un solo luogo. Maunent mantiene il tuo guardaroba ordinato e facile da gestire.",
      l_es: "Selecciona cualquier prenda para ver al instante todos los outfits que la incluyen. Visualiza todo tu armario en una sola pantalla y organiza cada pieza en un solo lugar. Maunent mantiene tu armario estructurado y fácil de gestionar.",
      l_de: "Wähle ein Teil aus und sieh sofort alle Outfits, in denen es enthalten ist. Überblicke deinen gesamten Kleiderschrank auf einem Bildschirm und organisiere jedes Stück an einem Ort. Maunent hält deinen Kleiderschrank übersichtlich und leicht verwaltbar.",
      l_cn: "选择任意单品，即可立即查看所有包含该单品的穿搭。在一个页面上浏览并整理你的全部衣橱。Maunent 让你的衣橱清晰有序、轻松管理。",
      l_fr: "Sélectionnez un article pour voir instantanément toutes les tenues qui l’incluent. Consultez l’ensemble de votre garde‑robe sur un seul écran et organisez chaque pièce au même endroit. Maunent maintient votre garde‑robe claire et facile à gérer."
    }
  },
  msg_aboutPageHeader4: {
    text: {
      temp_comment: "",
      l_kr: "4. 내 패션 아이템을 다른 사람은 어떻게 재해석했을까?",
      l_us: "4. How Have Others Styled Items Like Mine?",
      l_gb: "4. How Have Others Styled Items Like Mine?",
      l_ca: "4. How Have Others Styled Items Like Mine?",
      l_ru: "4. Как другие стилизовали такие же вещи, как у меня?",
      l_jp: "4. 自分と同じアイテムを、他の人はどうスタイリングしている？",
      l_it: "4. Come hanno abbinato gli altri gli stessi capi che possiedo?",
      l_es: "4. ¿Cómo han combinado otros las mismas prendas que tengo?",
      l_de: "4. Wie kombinieren andere dieselben Teile wie ich?",
      l_cn: "4. 别人是如何搭配和我相同的单品的？",
      l_fr: "4. Comment les autres ont‑ils stylisé les mêmes pièces que moi ?"
    }
  },
  msg_aboutPageSub4: {
    text: {
      temp_comment: "",
      l_kr: "동일한 아이템을 착용한 다른 사용자들의 아웃핏을 확인해보세요. 검색을 통해 내 옷의 다양한 스타일링 방법을 찾을 수 있어요.",
      l_us: "Discover how others styled the exact same items you own. Search and find fresh ways to wear the pieces already in your wardrobe.",
      l_gb: "Discover how others styled the exact same items you own. Search and find fresh ways to wear the pieces already in your wardrobe.",
      l_ca: "Discover how others styled the exact same items you own. Search and find fresh ways to wear the pieces already in your wardrobe.",
      l_ru: "Посмотрите, как другие стилизовали точно такие же вещи, как у вас. Используйте поиск, чтобы находить свежие способы носить вещи из вашего гардероба.",
      l_jp: "自分と同じアイテムを使った他のユーザーのコーデをチェックできます。検索機能で、今持っているアイテムの新しい着こなし方を見つけましょう。",
      l_it: "Scopri come altri hanno abbinato esattamente gli stessi capi che possiedi. Usa la ricerca per trovare nuovi modi di indossare i capi già presenti nel tuo guardaroba.",
      l_es: "Descubre cómo otros han estilizado exactamente las mismas prendas que posees. Usa la búsqueda para encontrar nuevas formas de llevar las prendas que ya están en tu armario.",
      l_de: "Entdecke, wie andere genau die gleichen Teile wie du kombiniert haben. Nutze die Suche, um neue Möglichkeiten zu finden, die Stücke aus deinem Kleiderschrank zu tragen.",
      l_cn: "查看他人如何搭配与你拥有的完全相同的单品。通过搜索，发现你衣橱中已有单品的更多穿搭方式。",
      l_fr: "Découvrez comment les autres ont stylisé exactement les mêmes pièces que vous possédez. Utilisez la recherche pour trouver de nouvelles façons de porter les pièces déjà présentes dans votre garde‑robe."
    }
  },
  msg_aboutPageLastHeader: {
    text: {
      temp_comment: "",
      l_kr: "패션을 사랑하는 사람들의 플레이그라운드",
      l_us: "A Playground For People Who Love Fashion",
      l_gb: "A Playground For People Who Love Fashion",
      l_ca: "A Playground For People Who Love Fashion",
      l_ru: "Площадка для тех, кто живёт модой",
      l_jp: "ファッションを愛する人のためのプレイグラウンド",
      l_it: "Un playground per chi ama la moda",
      l_es: "Un playground para los amantes de la moda",
      l_de: "Ein Playground für Menschen, die Mode lieben",
      l_cn: "为热爱时尚的人打造的创意空间",
      l_fr: "Un playground pour ceux qui aiment la mode"
    }
  },
  msg_aboutPageLastSub: {
    text: {
      temp_comment: "",
      l_kr: "Maunent는 패션을 좋아하는 사람들이 스타일을 기록하고, 시도하고, 나만의 스타일을 발견하는 공간입니다.",
      l_us: "Maunent is where fashion lovers gather to capture their looks, experiment boldly, and uncover a style that feels unmistakably their own.",
      l_gb: "Maunent is where fashion lovers gather to capture their looks, experiment boldly, and uncover a style that feels unmistakably their own.",
      l_ca: "Maunent is where fashion lovers gather to capture their looks, experiment boldly, and uncover a style that feels unmistakably their own.",
      l_ru: "Maunent — это место, где любители моды сохраняют свои образы, экспериментируют и находят стиль, который по‑настоящему отражает их самих.",
      l_jp: "Maunentは、ファッションを愛する人たちがコーデを記録し、挑戦しながら、自分らしいスタイルを見つけていく場所です。",
      l_it: "Maunent è il posto dove gli amanti della moda salvano i propri look, sperimentano e scoprono uno stile davvero personale.",
      l_es: "Maunent es el lugar donde los amantes de la moda guardan sus looks, experimentan y descubren un estilo verdaderamente propio.",
      l_de: "Maunent ist der Ort, an dem Modeliebhaber ihre Outfits festhalten, Neues ausprobieren und einen Stil entdecken, der wirklich zu ihnen passt.",
      l_cn: "Maunent 是热爱时尚的人们记录穿搭、尝试不同风格、发现真正属于自己风格的地方。",
      l_fr: "Maunent est l'endroit où les passionnés de mode enregistrent leurs looks, expérimentent et révèlent un style qui leur ressemble vraiment."
    }
  },
  msg_percentBarBestFit: {
    text: {
      temp_comment: "",
      l_kr: "잘 어울려요",
      l_us: "BEST FIT",
      l_gb: "BEST FIT",
      l_ca: "BEST FIT",
      l_ru: "Лучше сидит",
      l_jp: "似合う",
      l_it: "Sta meglio",
      l_es: "Queda mejor",
      l_de: "Passt besser",
      l_cn: "更好看",
      l_fr: "Va mieux"
    }
  },
  titleModal_chooseYourGender: {
    text: {
      temp_comment: "",
      l_kr: "당신의 성별을 알려주세요",
      l_us: "Tell us your gender",
      l_gb: "Tell us your gender",
      l_ca: "Tell us your gender",
      l_ru: "Расскажите нам о вашем поле",
      l_jp: "あなたの性別を教えてください",
      l_it: "Condividete il vostro genere",
      l_es: "Cuéntanos tu género",
      l_de: "Teilen Sie uns Ihr Geschlecht mit",
      l_cn: "请告诉我们你的性别",
      l_fr: "Parlez-nous de votre genre"
    }
  },
  msg_agreeTermsAndPolicyNotice: {
    text: {
      temp_comment: "",
      l_kr: "계속하면 <@이용약관|@|terms@> 및 <@개인정보처리방침|@|privacy@>에 동의하게 됩니다.",
      l_us: "By continuing, you agree to the <@Terms of Use|@|terms@> and <@Privacy Policy|@|privacy@>.",
      l_gb: "By continuing, you agree to the <@Terms of Use|@|terms@> and <@Privacy Policy|@|privacy@>.",
      l_ca: "By continuing, you agree to the <@Terms of Use|@|terms@> and <@Privacy Policy|@|privacy@>.",
      l_ru: "Продолжая, вы соглашаетесь с <@Условиями использования|@|terms@> и <@Политикой конфиденциальности|@|privacy@>.",
      l_jp: "続行すると、<@利用規約|@|terms@>と<@プライバシーポリシー|@|privacy@>に同意したことになります。",
      l_it: "Continuando, accetti le <@Condizioni d'uso|@|terms@> e l'<@Informativa sulla privacy|@|privacy@>.",
      l_es: "Al continuar, aceptas las <@Condiciones de uso|@|terms@> y la <@Política de privacidad|@|privacy@>.",
      l_de: "Wenn du fortfährst, stimmst du den <@Nutzungsbedingungen|@|terms@> und der <@Datenschutzrichtlinie|@|privacy@> zu.",
      l_cn: "继续即表示您同意<@使用条款|@|terms@>和<@隐私权政策|@|privacy@>。",
      l_fr: "En continuant, vous acceptez les <@Conditions d'utilisation|@|terms@> et la <@Politique de confidentialité|@|privacy@>."
    }
  },
  btnCommonContained_logInViaEmail: {
    text: {
      temp_comment: "",
      l_kr: "이메일로 계속하기",
      l_us: "Continue with email",
      l_gb: "Continue with email",
      l_ca: "Continue with email",
      l_ru: "Продолжить по электронной почте",
      l_jp: "メールで続ける",
      l_it: "Continua con l'email",
      l_es: "Continuar con el correo electrónico",
      l_de: "Mit E-Mail fortfahren",
      l_cn: "使用邮箱继续",
      l_fr: "Continuer avec l’e-mail"
    }
  },
  btnCommonContained_logInViaGoogle: {
    text: {
      temp_comment: "",
      l_kr: "Google로 계속하기",
      l_us: "Continue with Google",
      l_gb: "Continue with Google",
      l_ca: "Continue with Google",
      l_ru: "Продолжить через Google",
      l_jp: "Googleで続ける",
      l_it: "Continua con Google",
      l_es: "Continuar con Google",
      l_de: "Mit Google fortfahren",
      l_cn: "使用 Google 继续",
      l_fr: "Continuer avec Google"
    }
  },
  titlePanel_authLogin: {
    text: {
      temp_comment: "",
      l_kr: "지금부터 당신은 더 멋있어질 거에요",
      l_us: "You're going to look even better from here",
      l_gb: "You're going to look even better from here",
      l_ca: "You're going to look even better from here",
      l_ru: "Отсюда ты станешь ещё круче",
      l_jp: "着るたびに、もっとかっこよくなっていく",
      l_it: "Da qui in poi, puoi solo diventare più te stesso",
      l_es: "A partir de aquí, solo vas a mejorar",
      l_de: "Ab jetzt wirst du nur noch besser werden",
      l_cn: "从现在起，你会变得越来越好看",
      l_fr: "À partir d'ici, tu vas seulement t'améliorer"
    }
  },
  wordBadge_requiredInfo: {
    text: {
      temp_comment: "",
      l_kr: "필수",
      l_us: "Required",
      l_gb: "Required",
      l_ca: "Required",
      l_ru: "Обязательно",
      l_jp: "必須",
      l_it: "Obbligatorio",
      l_es: "Obligatorio",
      l_de: "Pflicht",
      l_cn: "必填",
      l_fr: "Obligatoire"
    }
  },
  btnCommonContained_linkItems: {
    text: {
      temp_comment: "",
      l_kr: "아이템 연결하기",
      l_us: "Link items",
      l_gb: "Link items",
      l_ca: "Link items",
      l_ru: "Связать вещи",
      l_jp: "アイテムを紐づける",
      l_it: "Collega gli articoli",
      l_es: "Vincular artículos",
      l_de: "Artikel verknüpfen",
      l_cn: "关联单品",
      l_fr: "Associer des articles"
    }
  },
  titleModal_setItemVisibility: {
    text: {
      temp_comment: "",
      l_kr: "아이템 공개 설정",
      l_us: "Item visibility",
      l_gb: "Item visibility",
      l_ca: "Item visibility",
      l_ru: "Настройка видимости",
      l_jp: "アイテム公開設定",
      l_it: "Visibilità articoli",
      l_es: "Visibilidad de artículos",
      l_de: "Sichtbarkeit der Artikel",
      l_cn: "物品公开设置",
      l_fr: "Visibilité des articles"
    }
  },
  msg_publicItem: {
    text: {
      temp_comment: "",
      l_kr: "공개",
      l_us: "Public",
      l_gb: "Public",
      l_ca: "Public",
      l_ru: "Открытый",
      l_jp: "公開",
      l_it: "Pubblico",
      l_es: "Público",
      l_de: "Öffentlich",
      l_cn: "公开",
      l_fr: "Public"
    }
  },
  msg_privateItem: {
    text: {
      temp_comment: "",
      l_kr: "비공개",
      l_us: "Private",
      l_gb: "Private",
      l_ca: "Private",
      l_ru: "Скрытый",
      l_jp: "非公開",
      l_it: "Privato",
      l_es: "Privado",
      l_de: "Privat",
      l_cn: "私密",
      l_fr: "Privé"
    }
  },
  msg_publicItemDetail: {
    text: {
      temp_comment: "",
      l_kr: "다른 사용자가 아이템 리스트를 볼 수 있음",
      l_us: "Other users can see your item list",
      l_gb: "Other users can see your item list",
      l_ca: "Other users can see your item list",
      l_ru: "Другие пользователи могут видеть ваш список предметов",
      l_jp: "他のユーザーがアイテムリストを見ることができます",
      l_it: "Gli altri utenti possono vedere la tua lista oggetti",
      l_es: "Otros usuarios pueden ver tu lista de objetos",
      l_de: "Andere Nutzer können deine Artikelliste sehen",
      l_cn: "其他用户可以查看你的物品列表",
      l_fr: "Les autres utilisateurs peuvent voir votre liste d'objets"
    }
  },
  msg_privateItemDetail: {
    text: {
      temp_comment: "",
      l_kr: "나만 아이템 리스트를 볼 수 있음",
      l_us: "Only you can see your item list",
      l_gb: "Only you can see your item list",
      l_ca: "Only you can see your item list",
      l_ru: "Только вы можете видеть свой список предметов",
      l_jp: "自分だけがアイテムリストを見ることができます",
      l_it: "Solo tu puoi vedere la tua lista oggetti",
      l_es: "Solo tú puedes ver tu lista de objetos",
      l_de: "Nur du kannst deine Artikelliste sehen",
      l_cn: "仅自己可以查看物品列表",
      l_fr: "Vous seul pouvez voir votre liste d'objets"
    }
  }
  // ,btnTab_feedback: {
  //   text: {
  //     temp_comment: "",
  //     l_kr: "피드백",
  //     l_us: "Feedback",
  //     l_gb: "Feedback",
  //     l_ca: "Feedback",
  //     l_ru: "Отзывы",
  //     l_jp: "フィードバック",
  //     l_it: "Feedback",
  //     l_es: "Feedback",
  //     l_de: "Feedback",
  //     l_cn: "反馈",
  //     l_fr: "Feedback"
  //   }
  // }
  // ,btnTab_calendar: {
  //   text: {
  //     temp_comment: "",
  //     l_kr: "캘린더",
  //     l_us: "Calendar",
  //     l_gb: "Calendar",
  //     l_ca: "Calendar",
  //     l_ru: "Календарь",
  //     l_jp: "カレンダー",
  //     l_it: "Calendario",
  //     l_es: "Calendario",
  //     l_de: "Kalender",
  //     l_cn: "日历",
  //     l_fr: "Calendrier"
  //   }
  // }
};
